// AUTO-GENERATED FILE. Do not edit by hand.
// Run `npm run build:games` after updating game-urls.txt or games-scraped.json.

const games = [
  {
    "id": "1d74e75b8da74767938d3310255b4bd3",
    "slug": "snow-rider-obby-parkour",
    "title": "Snow Rider Obby Parkour",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/1d74e75b8da74767938d3310255b4bd3-512x384.jpg",
    "description": "Snow Rider Obby Parkour is a fast-paced snowboard adventure where reflexes, timing, and control matter. Play solo or with a friend in split-screen mode and experience different snow challenges across multiple game modes. Whether you want to beat distance records, explore a massive open world, or race down dangerous mountains, this game offers a complete snowboarding experience.\\n\\nMaster your snowboard, perform double jumps, and unlock amazing gear to customize your character!",
    "publisher": "gameVgames",
    "languages": [
      "Arabic",
      "English",
      "German",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-02-11T07:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Player 1 \\nMovement: W, A, S, D\\nJump: Space (Double Jump available)\\nChange Camera: C\\nRespawn: R\\n\\nPlayer 2 \\nMovement: Arrow Keys\\nJump: K (Double Jump available)\\nChange Camera: L\\nRespawn: U\\n\\nOn mobile devices, the game supports single-player mode with intuitive touch controls designed for smooth snowboarding.",
    "sourceUrl": "https://gamedistribution.com/games/snow-rider-obby-parkour/"
  },
  {
    "id": "8748f54767044b99bc5373fc61596123",
    "slug": "police-traffic-racer",
    "title": "Police Traffic Racer",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/8748f54767044b99bc5373fc61596123-200x120.jpg",
    "description": "Skid the wheels of 6 awesome police cars with insane speed limits and drive them through 3 landscape highways without crashing. Show how well you can steer the wheels of these amazing cars with roaring engines and conquer 3 awesome game modes. Use replenishing nitro to overtake slow cars and drive in speed at all times. Customize and upgrade your cars with the best upgrades and get the most out of all the cars. Are you ready to show your driving skills? Prove yourself in Luxury Highway Cars!",
    "publisher": "Fuego! Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-02-10T08:10:55.422Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "W, A, S, D/ Arrow Keys: Drive/Steer/Brake , F: Nitro , C: Change Camera",
    "sourceUrl": "https://gamedistribution.com/games/police-traffic-racer/"
  },
  {
    "id": "58e78963f24c4305931be1bffa305a19",
    "slug": "thread-match-2",
    "title": "Thread Match 2",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/58e78963f24c4305931be1bffa305a19-512x384.jpg",
    "description": "Thread Match 2 is a satisfying logic puzzle game that combines color matching, layered challenges, and calming embroidery visuals.\\n\\nSolve clever thread puzzles by planning the correct order of moves and dismantling complex constructions. Each level challenges your brain with blocked and unlocked elements, where strategy and attention matter more than speed.",
    "publisher": "GameBerry Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-02-10T08:07:45.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Your goal is to fill the target spools in the center of the screen.\\n\\nAt the bottom, small spools are arranged inside layered constructions. You can only take spools that are unblocked — those not covered by other platforms. Select an available small spool and send it to the matching color target spool.\\n\\nWhen a target spool collects three matching spools, it is completed and the thread is automatically sent forward.\\n\\nClear all required target spools to complete the level.",
    "sourceUrl": "https://gamedistribution.com/games/thread-match-2/"
  },
  {
    "id": "a523b0c0ab444333b57347b6604f10c6",
    "slug": "daily-match",
    "title": "Daily Match",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/a523b0c0ab444333b57347b6604f10c6-512x512.jpg",
    "description": "Connect tiles with a great number of pictures in pairs within the limited time. As you crush all the tiles on the board, you can win the level! Become a tile master level by level! Play faster and faster to train your brain and exercise the link technology! ",
    "publisher": "Yizhiyuan Network Technology Co., Ltd.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForAndroid"
    ],
    "firstActiveDate": "2026-02-09T09:26:00.813Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "\\nFind two identical tiles without the block of other tiles!",
    "sourceUrl": "https://gamedistribution.com/games/daily-match/"
  },
  {
    "id": "9568a9db824f42229c2be496c362c143",
    "slug": "wood-block-puzzle-3",
    "title": "Wood Block Puzzle",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/9568a9db824f42229c2be496c362c143-512x384.jpeg",
    "description": "Blast the woodblocks and enjoy the relaxation and fun!\\nSimple and natural wood style interface.\\nNew fun from classic puzzle games.\\nPlay with your friends and beat their high scores\\nBeautiful graphics and satisfying sound effects.\\nA tactile game experience with realistic wood tile design.\\nFREE game! NO time limit!\\nFree wood block game for everyone.\\nA light, small game, no download, click and play game.",
    "publisher": "SUN.STUDIO",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2023-04-21T07:14:34.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Adults",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "How to play\\n? How to play this puzzle game?\\n? Tap the woodblocks to move them.\\n? Place wood blocks in a vertical or horizontal line to clear them.\\n? Make the score as high as you can and be the best block blaster.",
    "sourceUrl": "https://gamedistribution.com/games/wood-block-puzzle-3/"
  },
  {
    "id": "b57c15d037024b798c2e80efbca087cc",
    "slug": "two-stunt-supercars",
    "title": "Two Stunt Supercars",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/b57c15d037024b798c2e80efbca087cc-512x384.jpg",
    "description": "Skid the wheel of a stunning supercar through 3 awesome game modes and showcase your driving skills. Customize your car according to your taste and drive in style with the roaring engines. Feel the heat in 2 player mode where you go head to head with your friend in 2 amazing game modes! Are you ready to conquer the stunt city? Prove yourself with Two Stunt Racers!",
    "publisher": "Fuego! Games",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-02-03T07:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Player 1:\\nW,A,S,D: Drive/Steer/Brake\\n\\nPlayer 2:\\nArrow Keys: Drive/Steer/Brake",
    "sourceUrl": "https://gamedistribution.com/games/two-stunt-supercars/"
  },
  {
    "id": "cd86994bb8a44da48354779bdc56e8f8",
    "slug": "sudoku-brain-blocks",
    "title": "Sudoku Brain Blocks",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/cd86994bb8a44da48354779bdc56e8f8-512x384.jpg",
    "description": "Sudoku Brain Blocks is a relaxing yet addictive online puzzle game that blends classic Sudoku logic with block-fitting challenges (Tetris style). Drag and drop various shaped blocks onto a 9×9 grid to complete full rows, columns, or 3×3 squares to clear the board and earn high scores. Use strategy and planning to avoid running out of space and test your brain with every move!",
    "publisher": "BestGamesFreePlay.com",
    "languages": [
      "English",
      "French",
      "German",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-02-02T08:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Drag and drop the given blocks onto the 9×9 grid. Complete full rows, columns, or 3×3 squares to clear them and score points. Plan your moves carefully—once there’s no space left for the blocks, the game is over.",
    "sourceUrl": "https://gamedistribution.com/games/sudoku-brain-blocks/"
  },
  {
    "id": "6fb271b6c4164d22b10ab39e632c7747",
    "slug": "mojicon-love-connect",
    "title": "Mojicon Love Connect",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/6fb271b6c4164d22b10ab39e632c7747-512x384.jpg",
    "description": "2Million Games presents Mojicon Love Connect: the biggest Mojicon game to date! Match sweets, beat challenging levels and discover sweet moments in the animal kingdom!",
    "publisher": "2Million Games",
    "languages": [
      "Czech",
      "Dutch",
      "English",
      "French",
      "German",
      "Indonesian",
      "Italian",
      "Japanese",
      "Polish",
      "Portuguese",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-28T08:44:23.210Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Tap to merge 2 identical tiles",
    "sourceUrl": "https://gamedistribution.com/games/mojicon-love-connect/"
  },
  {
    "id": "f38d251c8d8a4477aabde9953d8ac971",
    "slug": "challenger-city-driver",
    "title": "Challenger City Driver",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/f38d251c8d8a4477aabde9953d8ac971-200x120.jpg",
    "description": "Get ready to skid the wheels of a stunning muscle through an expansive morning city map! Customize and upgrade your sports car with cool upgradables and become the best driver in the city. Take your dog with you in 3 driving challenges and conquer the missions together. Use nitro to beat slow traffic and beat all speed, stunt and drift triggers spread across the map. Are you ready to show your driving skills? Prove yourself!",
    "publisher": "Fuego! Games",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-27T07:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Car:\\nArrow Keys/W, A, S, D: Drive/Steer/Brake\\nC: Change Camera\\nF: Nitro\\n\\nCharacter:\\nArrow Keys/W,A,S,D: Move\\nMouse Orbit: Look Around",
    "sourceUrl": "https://gamedistribution.com/games/challenger-city-driver/"
  },
  {
    "id": "9ceb5732c253496e8589ac28574e0a81",
    "slug": "water-sort-collections",
    "title": "Water Sort - Collections",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/9ceb5732c253496e8589ac28574e0a81-512x384.jpg",
    "description": "Sort, pour, and relax! Complete each level by filling bottles and unlock beautiful collectible images. Test your logic, calm your mind, and build your own gallery as you master the art of sorting water!",
    "publisher": "Bofer Media (Twim Studio)",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-26T08:41:25.729Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Sort the water by color into separate bottles, fill 16 bottles to unlock a new image for your collection.",
    "sourceUrl": "https://gamedistribution.com/games/water-sort-collections/"
  },
  {
    "id": "dd2ab5adad664c508d3fa032bd19e8c8",
    "slug": "crazy-tunnel",
    "title": "Crazy Tunnel",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/dd2ab5adad664c508d3fa032bd19e8c8-200x120.jpg",
    "description": "Crazy Tunnel is a fast-paced, first-person arcade game. Navigate through the tunnel at breakneck speeds and aim for the longest distance possible.",
    "publisher": "Royale Gamers",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-26T08:39:19.512Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "move mouse",
    "sourceUrl": "https://gamedistribution.com/games/crazy-tunnel/"
  },
  {
    "id": "1a249236f03f474db586aeba1abafae0",
    "slug": "vegamix-da-vinci-puzzles",
    "title": "VegaMix Da Vinci Puzzles",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/1a249236f03f474db586aeba1abafae0-512x512.jpg",
    "description": "\\",
    "publisher": "Broccoli Games",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-26T08:38:31.958Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "How to play the match 3 puzzle:\\n\\n● Match 3 or more tiles in a line to explode them.\\n● Match 4 tiles in a line to create a rocket. The rocket explodes the entire line!\\n● Match 4 tiles in a square shape to create a spinner. The spinner destroys one of the targets!\\n● Match 5 tiles in a T shape to create a bomb. The bomb explodes a huge area of ​​the field!\\n● Match 5 tiles in a line to create a seven-color. The seven-color explodes tiles of the same color!",
    "sourceUrl": "https://gamedistribution.com/games/vegamix-da-vinci-puzzles/"
  },
  {
    "id": "5439e7734cf14dd082fe993be28b99db",
    "slug": "luxury-highway-cars",
    "title": "Luxury Highway Cars",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/5439e7734cf14dd082fe993be28b99db-512x512.jpg",
    "description": "Skid the wheels of 6 stunning luxury cars with insane speed limits and drive them through 3 landscape highways without crashing. Show how well you can steer the wheels of these amazing cars with roaring engines and conquer 3 awesome game modes. Use replenishing nitro to overtake slow cars and drive in speed at all times. Customize and upgrade your cars with the best upgrades and get the most out of all the cars. Are you ready to show your driving skills? Prove yourself in Luxury Highway Cars!",
    "publisher": "Fuego! Games",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-22T08:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "W, A, S, D/ Arrow Keys: Drive/Steer/Brake , F: Nitro , C: Change Camera",
    "sourceUrl": "https://gamedistribution.com/games/luxury-highway-cars/"
  },
  {
    "id": "0b024225d85c491fa77a271d46f64ca6",
    "slug": "zombie-survival-shooter",
    "title": "Zombie Survival Shooter",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/0b024225d85c491fa77a271d46f64ca6-512x384.jpeg",
    "description": "Zombies and zombie dog attack in modern city kill all zombie and save your city !!!\\n- More than 5 brand new Zombie missions to compete in and complete\\n- 8 Weapons (PISTOL, 9mm SILENCER, M16A4, SHOT GUN, MACHINE GUN, A400 SHOT GUN, MP44, HAND GRENADE)\\n- Armor And Grenade option\\n- Unique City MAPS TO CHOOSE\\n- REALISTIC SETTINGS FOR INTENSE BATTLES\\n- EASY TO LEARN GAMEPLAY",
    "publisher": "igroutka.ru",
    "languages": [],
    "mobile": [],
    "firstActiveDate": "2019-08-26T14:26:08.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Use mouse to play",
    "sourceUrl": "https://gamedistribution.com/games/zombie-survival-shooter/"
  },
  {
    "id": "27214a866f174c7ebdf0089d6b383d9f",
    "slug": "obby-toilet-line",
    "title": "Obby Toilet Line",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/27214a866f174c7ebdf0089d6b383d9f-512x384.jpg",
    "description": "Obby Toilet Line starts in the most chaotic place imaginable: a gas station restroom line. Around 30 different characters are already waiting, and the queue stretches all the way past the store entrance. Your goal is simple, but the situation is not: earn money while you wait, move up the line, and reach the mysterious toilet at the end.\\n\\nThis is not just a “stand still” queue. The game uses an idle-style progression system: the position you’re standing in determines how much you earn. ",
    "publisher": "gameVgames",
    "languages": [
      "Arabic",
      "English",
      "German",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-21T08:05:05.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Player 1\\nWASD: Move\\nSpace: Jump and line skip\\nE: Interact\\nF: Hit bugs\\nShift: Sprint\\n\\nPlayer 2\\nArrow Keys: Move\\nK: Line skip and interact\\nL: Jump and hit bugs\\nJ: Sprint",
    "sourceUrl": "https://gamedistribution.com/games/obby-toilet-line/"
  },
  {
    "id": "41fb9c32a74c4068acf0a04d08b36fd6",
    "slug": "valentines-hidden-alphawords",
    "title": "Valentines Hidden Alphawords",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/41fb9c32a74c4068acf0a04d08b36fd6-512x384.jpg",
    "description": "Valentines Hidden Alphawords is a charming and relaxing Valentine’s Day–themed puzzle game where love meets word discovery. Explore beautifully designed romantic scenes filled with hidden letters waiting to be found. Each completed level reveals a sweet and heartwarming caption that perfectly matches the image. With 30 engaging levels, increasing challenges, and a ticking clock with useful hints, the game keeps players entertained while celebrating the spirit of love. ",
    "publisher": "Lof Games",
    "languages": [
      "English",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-02-11T12:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use a mouse or touchpad to tap or click on the hidden letters to find and collect them.\\n",
    "sourceUrl": "https://gamedistribution.com/games/valentines-hidden-alphawords/"
  },
  {
    "id": "c1337d45912e45b5be9666f08ba81963",
    "slug": "tripeaks-solitaire-escapes",
    "title": "Tripeaks Solitaire Escapes",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/c1337d45912e45b5be9666f08ba81963-512x384.jpg",
    "description": "Play Solitaire TriPeaks Escapes, a relaxing card game with a warm summer vibe. Explore hundreds of unique solitaire levels featuring stunning graphics and vibrant beach landscapes. Master challenging card puzzles using powerful boosters, train your brain and sharpen your strategy. Dive into this colorful TriPeaks world and enjoy a soothing, slow-paced adventure. Escape the daily grind and find your zen in every hand you play!",
    "publisher": "Azerion Casual Games",
    "languages": [
      "Czech",
      "Dutch",
      "English",
      "French",
      "German",
      "Italian",
      "Japanese",
      "Polish",
      "Portuguese",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-02-11T08:41:29.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "A face-up card is shown at the bottom of the screen. Choose cards from the tableau that are one point higher or lower in value than the current card. If no moves are available, draw the next card from the deck. Your goal is to clear the entire layout. Plan your moves carefully and use helpful boosters to beat challenging levels.",
    "sourceUrl": "https://gamedistribution.com/games/tripeaks-solitaire-escapes/"
  },
  {
    "id": "24d7669bb0fe4da18c4c6ce661201ff4",
    "slug": "valentines-love-link",
    "title": "Valentines Love Link",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/24d7669bb0fe4da18c4c6ce661201ff4-512x384.jpg",
    "description": "Valentines Love Link is a cute and relaxing matching puzzle game full of hearts, roses, chocolates, and love symbols. Connect matching Valentines items with straight lines, allowing up to two turns. Beat the clock across 48 levels by collecting all tiles and enjoy a sweet romantic theme.",
    "publisher": "Lof Games",
    "languages": [
      "Arabic",
      "Bengali",
      "Chinese (Simplified)",
      "Czech",
      "Danish",
      "Dutch",
      "English",
      "Estonian",
      "Finnish",
      "French",
      "German",
      "Greek",
      "Hebrew",
      "Hindi",
      "Hungarian",
      "Indonesian",
      "Italian",
      "Japanese",
      "Korean",
      "Lithuanian",
      "Norwegian (Nynorsk)",
      "Polish",
      "Portuguese",
      "Romanian",
      "Russian",
      "Slovak",
      "Spanish",
      "Swedish",
      "Tagalog",
      "Thai",
      "Turkish",
      "Vietnamese"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-02-09T13:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use a mouse or touchpad to select tiles and match two same items by linking them with a straight line that can have up to two turns and no blocks in between. Clear all tiles before the time ends to finish the level.",
    "sourceUrl": "https://gamedistribution.com/games/valentines-love-link/"
  },
  {
    "id": "aff91273917349db8ae9a921954aae5c",
    "slug": "airport-security",
    "title": "Airport Security",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/aff91273917349db8ae9a921954aae5c-512x384.jpg",
    "description": "Airport Security is a casual simulation game that immerses you in the high-stakes world of airport safety, placing you in the role of a vigilant security officer dedicated to safeguarding a bustling terminal. Your mission is to maintain a secure environment by identifying suspicious passengers, spotting fake passports, and uncovering hidden contraband using cutting-edge X-ray machines. ",
    "publisher": "Kwalee",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForAndroid"
    ],
    "firstActiveDate": "2026-02-09T10:44:13.948Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Use the left mouse button on desktop or touch on mobile to play the game.",
    "sourceUrl": "https://gamedistribution.com/games/airport-security/"
  },
  {
    "id": "59d85983ebf14a37944e13672cb28b76",
    "slug": "penguin-farm-ice-merge",
    "title": "Penguin Farm - Ice Merge",
    "category": "Simulation",
    "thumbnail": "https://img.gamedistribution.com/59d85983ebf14a37944e13672cb28b76-512x384.jpg",
    "description": "Explore a world of frozen islands where penguins run their own farm. Collect resources, merge wood, build and upgrade buildings to open up new territories. Develop your settlement step by step, expand your glaciers, and watch your income grow.\\nTrain your penguins, improve production, and head to the ocean for rewards—there drift chests filled with valuable treasures. Upgrade each building, manage your resources, and turn your small island into a thriving icy farm.",
    "publisher": "Mirra Games",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-02-09T07:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Simulation",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Game Objective:\\nDevelop a penguin farm: combine resources, build and upgrade buildings, discover new glaciers, and collect income, turning the island into a thriving settlement.\\n\\nControls:\\nTouch / Left Click — select objects, combine resources, interact with buildings, and collect rewards.",
    "sourceUrl": "https://gamedistribution.com/games/penguin-farm-ice-merge/"
  },
  {
    "id": "58381eb3053846bc8d44cce5a7a5de88",
    "slug": "vr-world",
    "title": "VR World",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/58381eb3053846bc8d44cce5a7a5de88-512x512.jpg",
    "description": "If you seen VR games on TikTok where you can manipulate little people like puppets, and you like it, then this is the game for you.\\n\\n- In the game, you can fight with little people and drag and manipulate them like in a VR game.\\n- The game runs without any special VR equipment. All you need is a computer or smartphone. It's all in the browser, no downloads required!\\n- The game offers various jobs, such as police officer and ambulance driver!",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-02-07T14:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Controls:\\nW, A, S, D - Walking.\\nMouse - Camera.\\nE - Menu / Interaction Settings.\\nMouse buttons - Interaction.\\n\\nSmartphone controls: Use the stick to control the character, and use the camera controls on the right side of the screen. To interact with another character, click on the character or drag their limb, depending on the interaction mode. To change the mode, click on the mode change icon.",
    "sourceUrl": "https://gamedistribution.com/games/vr-world/"
  },
  {
    "id": "3c231026237f4b9db10cce6ef0914124",
    "slug": "nautilus-spaceship-escape",
    "title": "Nautilus Spaceship Escape",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/3c231026237f4b9db10cce6ef0914124-512x512.jpg",
    "description": "There is an eerie silence on the Nautilus, an intergalactic spaceship. You have just been asleep when the power goes out for a moment. An uneasy feeling creeps over you - something is wrong here. Could there have been an attack? Get up, explore the surroundings and find out what has happened!",
    "publisher": "playit-online",
    "languages": [
      "Chinese (Simplified)",
      "Czech",
      "Danish",
      "Dutch",
      "English",
      "Finnish",
      "French",
      "German",
      "Greek",
      "Hungarian",
      "Italian",
      "Japanese",
      "Korean",
      "Norwegian (Nynorsk)",
      "Polish",
      "Portuguese",
      "Russian",
      "Spanish",
      "Swedish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-02-07T07:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use mouse to take items and interact.",
    "sourceUrl": "https://gamedistribution.com/games/nautilus-spaceship-escape/"
  },
  {
    "id": "a0e71a6336ed4173b09cc76d1a3ef4a2",
    "slug": "superheroes-and-the-wand",
    "title": "Superheroes and the Wand",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/a0e71a6336ed4173b09cc76d1a3ef4a2-512x512.jpg",
    "description": "You will play as a Wand character who had a strange dream about a sorcerer. Soon, in reality, the sorcerer from Stickman dream appears in the city and begins to do evil. Wand, together with the Superheroes, decide to teach the sorcerer a lesson. But not everything is so easy to do. The following superheroes are waiting for you: Blushing, Green Man, Bobo, Cudgel, Bruise, Flyer, Captain Captain and others. Among the enemies will be the Wizard, Anrik, the Clown and others.",
    "publisher": "Starodymov Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-02-06T13:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use your computer mouse to control the game.\\nIf you have a mobile device, then use the stylus or your finger.\\nTo complete the game, you need to click on different buttons indicated on the screen in the game.\\nTo defeat the enemy, you need to quickly click on the sight.",
    "sourceUrl": "https://gamedistribution.com/games/superheroes-and-the-wand/"
  },
  {
    "id": "43a1c23743184ec8befbb7a221c87c93",
    "slug": "super-brain",
    "title": "Super Brain",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/43a1c23743184ec8befbb7a221c87c93-512x384.jpg",
    "description": "In the game, you'll control a character sprinting down a track, but your path is blocked by a series of \\",
    "publisher": "XMetaGame",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-02-06T13:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "- Swipe Left/Right : Move your character into the lane that represents the correct answer.\\n- Make your choice quickly, because your character never stops running!",
    "sourceUrl": "https://gamedistribution.com/games/super-brain/"
  },
  {
    "id": "d8819c05f45b46a7980cf7fce4114a02",
    "slug": "italian-animal-alchemy-brainrot",
    "title": "Italian Animal Alchemy - Brainrot",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/d8819c05f45b46a7980cf7fce4114a02-512x384.jpg",
    "description": "Dive into a world of crazy Italian creatures, where logic meets memes! Combine animals and objects to create the strangest and funniest Italian mutants!\\nA true meme zoo awaits you here, where creativity knows no bounds! Experiment, discover rare mutants, and share your results with friends to prove you have the most epic brainrot.\\n",
    "publisher": "Mirra Games",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-02-06T08:31:17.538Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Your goal is to collect the entire Brainrot collection and become a master of Italian madness. Each new fusion is a surprise, a burst of laughter, and a dose of absurdity that will make you unable to tear yourself away.",
    "sourceUrl": "https://gamedistribution.com/games/italian-animal-alchemy-brainrot/"
  },
  {
    "id": "1b51fe92070b442c94733486154b4ab5",
    "slug": "fruit-jam-master",
    "title": "Fruit Jam Master",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/1b51fe92070b442c94733486154b4ab5-512x384.jpg",
    "description": "Enter the juiciest and most addictive puzzle adventure ever. Enjoy a fun logic puzzle game in Fruit Jam Master. You need to help all the animals leave the grassland to win. Pay attention to the color of the food. Animals can only pass through when the food matches their own color.",
    "publisher": "YAD.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-02-05T08:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/fruit-jam-master/"
  },
  {
    "id": "5ec9e8ec63514f8482ddb37be8774851",
    "slug": "summon-tribe",
    "title": "Summon Tribe",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/5ec9e8ec63514f8482ddb37be8774851-512x384.jpg",
    "description": "Summon Tribe is a simple merge-and-defense game where you combine identical units to create stronger ones to stop enemies. It’s easy, mostly for passing time, and it also supports idle play.",
    "publisher": "Guangzhou Yomitoo Network Technology Co., Ltd.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-02-05T08:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Merge facilities, traps, and turrets to build the strongest defense. Plan carefully in limited space and defeat your enemies! Choose your skills to boost your defense and find the best combo to survive.",
    "sourceUrl": "https://gamedistribution.com/games/summon-tribe/"
  },
  {
    "id": "d6dda2e0655f45e98bd7863f68498f47",
    "slug": "besties-chinese-new-year-celebration",
    "title": "Besties Chinese New Year Celebration",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/d6dda2e0655f45e98bd7863f68498f47-512x384.jpg",
    "description": "Besties Chinese New Year Celebration invites you into a joyful world of color, tradition, and friendship as you help best friends prepare for the Lunar New Year. Dress them up in beautiful traditional outfits, elegant modern looks, and festive accessories inspired by Chinese New Year celebrations.",
    "publisher": "Cutedressup",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-02-05T08:15:06.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "Left mouse button click or Tap to play",
    "sourceUrl": "https://gamedistribution.com/games/besties-chinese-new-year-celebration/"
  },
  {
    "id": "79a0fe62ed874a58903a9bc33aab2136",
    "slug": "obby-prison-run",
    "title": "Obby Prison Run",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/79a0fe62ed874a58903a9bc33aab2136-512x384.jpg",
    "description": "Obby Prison Run is an intense obstacle course game where escape is the only option—and survival is everything. Sprint, leap, and dodge through deadly traps and twisted takes on classic childhood games. Outsmart your rivals and stay ahead in the race for freedom, where every second counts and only the sharpest make it out alive.",
    "publisher": "kiz10.com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-02-05T07:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Use the keyboard or buttons to move",
    "sourceUrl": "https://gamedistribution.com/games/obby-prison-run/"
  },
  {
    "id": "6cd9e7deccb74f84a53a78f02c94a028",
    "slug": "remove-the-blocks",
    "title": "Remove The Blocks",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/6cd9e7deccb74f84a53a78f02c94a028-512x512.jpg",
    "description": "Challenging 3D puzzle game where you strategically clear the blocks from complex formations. Click blocks to slide them out in their facing direction, but choose wisely - each move affects the entire structure. With increasingly difficult levels, time-based scoring, and smooth 3D graphics, test your spatial reasoning skills!",
    "publisher": "MarketJS",
    "languages": [
      "English",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-02-04T08:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Remove blocks by clicking them to slide out in their facing direction, clearing the entire structure to complete each level.",
    "sourceUrl": "https://gamedistribution.com/games/remove-the-blocks/"
  },
  {
    "id": "87f052f266fe4ebdb89c1841bc2c5ad6",
    "slug": "steal-brainrot-original-3d",
    "title": "Steal Brainrot Original 3D",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/87f052f266fe4ebdb89c1841bc2c5ad6-512x384.jpg",
    "description": "Buy rare animals—from the entry-level Nubini Pitzanini to Tralalelo Tralal and Los Tralaleritos. Place them in your base, create ideal conditions, and start earning! Each animal generates income ? and opens the door to new opportunities. Grow your collection, improve your infrastructure, experiment with your team composition, and increase your profits. Want more income? Buy new, rarer animals and build your financial empire.",
    "publisher": "Mirra Games",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-02-04T07:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "For PC:\\n\\n-Move using WASD or arrow keys ⬅️⬆️⬇️➡️\\n-Rotate the camera by moving the mouse while holding the right mouse button\\n-Interact with animals using the E key\\n-Jump with the Spacebar\\n\\nFor Mobile:\\n\\n-Move using the joystick on the left side of the screen\\n-Rotate the camera by swiping on the right side of the screen\\n-Interact with animals via the pop-up button above the animal\\n-Jump using the button on the right side of the screen",
    "sourceUrl": "https://gamedistribution.com/games/steal-brainrot-original-3d/"
  },
  {
    "id": "b1b399e2218a45a8b7550b8e91347ae3",
    "slug": "hook-pin-jam",
    "title": "Hook Pin Jam",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/b1b399e2218a45a8b7550b8e91347ae3-512x384.jpg",
    "description": "Hook Jam is an addictive puzzle game where you untangle and release hooks to clear the board and earn rewards. Each level challenges your logic and planning with increasingly complex layouts. Solve puzzles efficiently, unlock new stages, and test your problem-solving skills in this clever, satisfying brain game.",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-02-04T07:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Tap hooks to release and untangle them. Your goal is to clear all hooks using the fewest moves possible. Each level has a unique puzzle, with special challenges offering bonus rewards. Completing levels earns currency and unlocks harder stages. You have limited lives—wait or watch ads to continue when they run out.",
    "sourceUrl": "https://gamedistribution.com/games/hook-pin-jam/"
  },
  {
    "id": "7a301d8024744929b8e71eb961e1f356",
    "slug": "color-nuts",
    "title": "Color Nuts",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/7a301d8024744929b8e71eb961e1f356-1280x720.jpg",
    "description": "Color Nuts is a relaxing and addictive color-matching puzzle game where you place colorful nuts on the board and connect three or more of the same color to clear them.\\n\\nPlan your moves carefully, complete level objectives, and keep the board from filling up. Easy to learn and hard to master, Color Nuts is the perfect casual puzzle game for fans of match-3, block puzzles, and logic games.",
    "publisher": "GameBerry Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-02-03T09:12:10.515Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Each level has a specific objective — remove nuts of certain colors to complete the level.\\n\\nAt the bottom of the screen, you receive sets of colorful nuts. Drag and drop them onto the game board to place them in empty cells.\\n\\nWhen three or more nuts of the same color are placed next to each other, they disappear, freeing up space.\\n\\nIf none of the offered sets can be placed on the board, the level is lost.",
    "sourceUrl": "https://gamedistribution.com/games/color-nuts/"
  },
  {
    "id": "f3a9542e779b426799867918b11fd70b",
    "slug": "crazy-bar-brawl",
    "title": "Crazy Bar Brawl",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/f3a9542e779b426799867918b11fd70b-512x384.jpg",
    "description": "Crazy Bar Brawl ?? throws you straight into the most chaotic, hilarious, and action-packed bar battles ever! If you’ve ever wondered what would happen if you walked into a bar full of drunk troublemakers ?, flying bottles ?, wobbling chairs ?, and wild characters who can barely stand… well, now you can experience it ALL—safely, virtually, and with maximum comedy!",
    "publisher": "Ultra Games Entertainment Private limited",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-02-03T08:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Use Mouse/Touch to Aim click on the throw button to throw and smash",
    "sourceUrl": "https://gamedistribution.com/games/crazy-bar-brawl/"
  },
  {
    "id": "05a321e4c0324e64ad9b6d1ec02c65aa",
    "slug": "k-pop-hunters-valentine-style",
    "title": "K-Pop Hunters Valentine Style",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/05a321e4c0324e64ad9b6d1ec02c65aa-512x384.jpg",
    "description": "K-Pop Hunters Valentine Style brings romance, fashion, and K-pop glamour together in one stylish dress-up experience. Help your favorite K-pop hunters transform their looks for Valentine’s Day with stunning outfits, flawless makeup, and charming accessories.\\n",
    "publisher": "Cutedressup",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-02-03T08:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "Left mouse button click and Tap to play",
    "sourceUrl": "https://gamedistribution.com/games/k-pop-hunters-valentine-style/"
  },
  {
    "id": "6f599a127fc14957b282b0c1e594358a",
    "slug": "mojo-emoji",
    "title": "Mojo Emoji",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/6f599a127fc14957b282b0c1e594358a-512x384.jpg",
    "description": "Moji Emoji is a fun and clever word/emoji puzzle game where each level challenges you to guess the hidden word or phrase from a set of expressive emojis. Think fast, connect the clues, and test your emoji decoding skills across hundreds of creative puzzles.",
    "publisher": "Hyper Rabbit Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-02-01T15:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Click on the letter to place it the slot.",
    "sourceUrl": "https://gamedistribution.com/games/mojo-emoji/"
  },
  {
    "id": "be82b0f4cedc4f8aa41e186e90449296",
    "slug": "mahjong-solitaire-zodiac",
    "title": "Mahjong Solitaire Zodiac",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/be82b0f4cedc4f8aa41e186e90449296-512x384.jpg",
    "description": "Unwind and challenge your mind with Mahjong Solitaire Zodiac, a timeless puzzle game that blends strategy, focus, and relaxation. \\nMatch beautifully designed tiles, clear the board, and enjoy a calming gameplay experience anytime, anywhere.\\nPerfect for both beginners and seasoned players, Mahjong Solitaire Zodiac offers intuitive controls, elegant visuals, and satisfying puzzles that keep you coming back for more.",
    "publisher": "Anna Inc",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-02-01T15:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "1. Find two identical tiles that are open.\\n2. A tile is open if: no other tile on top of it and at least one side (left or right) free.\\n3. Tap two matching open tiles to remove them from the board.\\n4. Continue matching and removing tiles until the board i",
    "sourceUrl": "https://gamedistribution.com/games/mahjong-solitaire-zodiac/"
  },
  {
    "id": "3bfa9e2ebbab4259a9799be4b00a5dae",
    "slug": "cookie-monster",
    "title": "Cookie monster",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/3bfa9e2ebbab4259a9799be4b00a5dae-512x512.jpg",
    "description": "What more could you ask for?! Puzzle, brain teaser, monsters, snacks...wait what? That's right MONSTERS and SNACKS! Feed the hungry monsters snacks to pass the level! You have to make sure all the snacks get into the monster's mouth though or you will see a sad face! Let's keep these monsters happy! If you like the game, leave us a review! That will help us continue to bring you many more challenging levels, new monsters, maybe some new twizzler lines.",
    "publisher": "Starodymov Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-02-01T13:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "You need to draw lines in such a way as to get all the sweets straight into the monster's mouth.",
    "sourceUrl": "https://gamedistribution.com/games/cookie-monster/"
  },
  {
    "id": "c22dd33f66654986bf42e494c5934308",
    "slug": "jixora-jigsaw-solitaire-puzzle",
    "title": "Jixora – Jigsaw Solitaire Puzzle",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/c22dd33f66654986bf42e494c5934308-512x512.jpg",
    "description": "Jixora is a relaxing jigsaw solitaire puzzle game where you piece together beautiful artwork. Journey through 100 unique levels with increasing difficulty, or unlock Free Play mode to replay your favorites with custom grid sizes. Race against the clock to earn stars, use strategic power-ups like Hints and Time Freezes, and immerse yourself in a cinematic atmosphere with soothing music.",
    "publisher": "Bouraoui Game",
    "languages": [
      "Arabic",
      "English",
      "French",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-02-01T13:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Controls:\\nDesktop: Click and drag to move puzzle pieces.\\nMobile: Touch and drag to move pieces.\\nHow to Play:\\nDrag pieces to arrange them. Adjacent pieces that belong together will snap and lock.\\nComplete the full image before the timer runs out.\\nPower-ups:\\nHint (Lightbulb): Automatically moves a piece to its correct spot.\\nPeek (Eye): Shows the completed image for a few seconds.\\nFreeze (Snowflake): Pauses the timer for 10 seconds.",
    "sourceUrl": "https://gamedistribution.com/games/jixora-jigsaw-solitaire-puzzle/"
  },
  {
    "id": "bf627763f84546df90b07a3379ab6902",
    "slug": "fashion-stylist-salon-makeover",
    "title": "Fashion Stylist Salon Makeover",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/bf627763f84546df90b07a3379ab6902-512x384.jpg",
    "description": "Do you want to create your own fashion styles? Join our best hair salon simulator game and enjoy the utmost fun. You will act as a fashion stylist who does haircuts, hairstyling, and skin care. Welcome customers with different requirements and use your hairstyling skills to make them satisfied and happy!",
    "publisher": "Yiv.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-02-01T13:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/fashion-stylist-salon-makeover/"
  },
  {
    "id": "4584cc228f514e2d92af7c7c855f1c79",
    "slug": "russian-derby-crash",
    "title": "Russian Derby Crash",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/4584cc228f514e2d92af7c7c855f1c79-512x512.jpg",
    "description": "Russian Derby Crash is a thrilling game that immerses you in the atmosphere of spectacular car racing with elements of destruction. You'll control one of five Russian cars or a tank. Destroy cars on the training ground and unlock new ones!\\nThis game has a unique twist: in addition to cars, there's a tank on the training ground, from which you can shoot at other participants!",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-02-01T13:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "To unlock all the vehicles, you need to destroy them on the training ground!\\n\\nControls:\\nWASD - Drive.\\nC - Change camera.\\nSpace - Handbrake.\\nFire the tank - Left mouse button.\\nZoom in on the tank - Right mouse button.\\n\\nMobile controls:\\nUse the on-screen game interface.",
    "sourceUrl": "https://gamedistribution.com/games/russian-derby-crash/"
  },
  {
    "id": "cdadc98c441c4c5bbc017428d304d158",
    "slug": "tiny-farm",
    "title": "Tiny Farm",
    "category": "Simulation",
    "thumbnail": "https://img.gamedistribution.com/cdadc98c441c4c5bbc017428d304d158-512x384.jpg",
    "description": "Tiny Farm is a small, cozy farming game where everything grows at your pace.\\n\\nHarvest crops, collect goods from animals, and slowly upgrade your farm into something wonderful. Each upgrade brings visible progress, and each world unlocks exciting new possibilities.\\n\\nSit back, relax, and watch your tiny farm flourish.",
    "publisher": "Orenji Spark",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-02-01T11:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Simulation",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "- click on crops to harvest\\n- click on truck to sell and profit\\n- upgrade crops and unlock new animals\\n- collect star to unlock new farms",
    "sourceUrl": "https://gamedistribution.com/games/tiny-farm/"
  },
  {
    "id": "0e4a0810f7da40a79b01b4f040e7383b",
    "slug": "freecell",
    "title": "FreeCell",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/0e4a0810f7da40a79b01b4f040e7383b-512x384.jpeg",
    "description": "FreeCell Solitaire is fun addictive hyper casual cards game.It is fundamentally different from most solitaire games in that very few deals are unsolvable, and all cards are dealt face-up from the very beginning of the game.Free cell Solitaire Create stacks of cards from King to Ace and beat the game",
    "publisher": "Instant Games Studio",
    "languages": [],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2019-12-16T12:27:03.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use mouse to play the game.",
    "sourceUrl": "https://gamedistribution.com/games/freecell/"
  },
  {
    "id": "9101fea0805544d3aa15f794af37622b",
    "slug": "super-football-fever",
    "title": "Super Football Fever",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/9101fea0805544d3aa15f794af37622b-512x384.jpg",
    "description": "We bring you an unprecedentedly realistic soccer experience with smooth motion-captured animations and lifelike 3D graphics that make you feel like you're on a top-tier league field. Build your dream team, sign superstars, and win matches with precise tactical arrangements. Whether it's quick short passes or stunning long-range goals, you can do it all with ease at your fingertips. ",
    "publisher": "XMetaGame",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-02-01T10:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "- Use the virtual joystick to control player movement and dribbling.\\n- Tap buttons for short passes, long passes, and shooting.\\n- When defending, tap buttons to tackle or switch players.",
    "sourceUrl": "https://gamedistribution.com/games/super-football-fever/"
  },
  {
    "id": "1b50250704e04f2bad5717d2704e8535",
    "slug": "maze-escape-challenge",
    "title": "Maze Escape Challenge",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/1b50250704e04f2bad5717d2704e8535-512x384.jpg",
    "description": "Maze Escape Challenge is a fast-paced maze game where you must reach the exit as quickly as possible. Each level features a unique labyrinth with increasing difficulty, traps, and surprises. Some levels include Dark Mode, where you can see only a small light around the player. Earn stars by finishing mazes fast (1–3 stars), unlock new levels, beat your best times, and try to master every maze.",
    "publisher": "Reidga",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-02-01T10:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use your mouse or finger to move the player through the maze. Hold and drag to navigate in any direction. Avoid walls, find the exit as fast as possible, and collect stars by finishing levels quickly.",
    "sourceUrl": "https://gamedistribution.com/games/maze-escape-challenge/"
  },
  {
    "id": "84f7b1f56d9c49f79934e47a2464f388",
    "slug": "screw-color-sorting-master",
    "title": "Screw Color Sorting Master",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/84f7b1f56d9c49f79934e47a2464f388-512x384.jpg",
    "description": "Screw Color Sorting Master is a relaxing yet addictive puzzle game! Sort vibrant colored screws onto poles by moving them strategically—same colors must stack together. With simple controls, hundreds of challenging levels, and satisfying visuals, sharpen your brain and become the ultimate sorting master!",
    "publisher": "SecGame",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-02-01T09:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "- Tap/Click on the top screw to select and move it \\n- Tap/Click on another pole to place the screw (only possible on an empty pole or on top of a screw of the same color) \\n- Use the undo button to revert your last move \\n- Use the refresh button to restart the current level ",
    "sourceUrl": "https://gamedistribution.com/games/screw-color-sorting-master/"
  },
  {
    "id": "933b1b935b9e422b9ca4fd279455b924",
    "slug": "pickle-ball-clash",
    "title": "Pickle Ball Clash",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/933b1b935b9e422b9ca4fd279455b924-512x384.jpg",
    "description": "Step into the fast-paced world of Pickle Ball Clash — a thrilling sports game where every match is a battle of skill, speed, and strategy. Customize your character, unlock powerful paddles, and climb the competitive ranks from backyard brawls to pro-level leagues. Whether you're smashing winners or pulling off trick shots, the court is yours to conquer. Are you ready to clash?",
    "publisher": "Hyper Rabbit Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-31T15:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "The Game aims the direction automatically\\n\\nPC Controls\\n-Press W for Long Shots\\n-Press S for Short Shots\\n\\nMobile Controls\\n-Click on up arrow for Long Shots\\n-Click on down arrow for short Shots",
    "sourceUrl": "https://gamedistribution.com/games/pickle-ball-clash/"
  },
  {
    "id": "e540aa25578f40c6ba8b73614ddb7e5d",
    "slug": "happy-jump",
    "title": "Happy Jump",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/e540aa25578f40c6ba8b73614ddb7e5d-512x384.jpg",
    "description": "Bounce into blissful heights with Happy Jump! Guide the cute chicken on its springy pogo to leap skyward amid lush trees and fun obstacles. Smash your personal best, snag stars, and chase trophies in this addictive, one-tap thrill. Endless jumps, soaring scores—pure joy awaits!",
    "publisher": "SecGame",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-31T15:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Cocos"
    ],
    "instructions": "- Click to charge your pogo jump \\n- Drag and drop to aim trajectory \\n- Double-click to super boost \\n- Right-click to pause/restart ",
    "sourceUrl": "https://gamedistribution.com/games/happy-jump/"
  },
  {
    "id": "cbffbdc249f24f6486c7363fee067c71",
    "slug": "human-leap-evolution",
    "title": "Human Leap Evolution",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/cbffbdc249f24f6486c7363fee067c71-512x384.jpg",
    "description": "Want a wild evolution adventure from caveman to futuristic super warrior? Human Leap: Evolution is a high-energy action evolution puzzle game where every jump you make shapes your destiny. Choose wisely, evolve rapidly, and battle your enemies with unstoppable power!",
    "publisher": "bestgames.com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-31T13:50:06.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/human-leap-evolution/"
  },
  {
    "id": "83310a1bca264cfd8d1284b7d94b7adb",
    "slug": "little-bugs",
    "title": "Little Bugs",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/83310a1bca264cfd8d1284b7d94b7adb-512x384.jpg",
    "description": "you are the guardian of a group of lost beetles. At each stage, the beetles approach two pictures. One is a safe path forward, but the other is a trapdoor into the abyss. Your mission is to decipher the hint—a piece of a vegetable or an animal—to figure out which path is safe. If you misunderstand the clue, you won't be able to reach the finish line. Every choice matters in this charming world of clever puzzles. Are you ready to lead your little bugs to safety?",
    "publisher": "wavegame",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-31T13:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "- Observe the hint provided in the level (a vegetable or animal).\\n- Analyze the connection between the hint and the two pictures.\\n- Tap or click on the picture you believe represents the safe path.\\n- Once selected, the beetles will automatically proceed down your chosen route.",
    "sourceUrl": "https://gamedistribution.com/games/little-bugs/"
  },
  {
    "id": "a82b5b9d46604486b03d45e1363d72ea",
    "slug": "cozy-kitchen-merge",
    "title": "Cozy Kitchen Merge",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/a82b5b9d46604486b03d45e1363d72ea-512x384.jpg",
    "description": "This is an addictive cooking-themed merge game you won't be able to put down. Here, you'll become a kitchen master by merging identical ingredients and dishes to create new, more delicious cuisine. From simple vegetables to exotic feasts, continuously unlock tasty recipes from around the world. Fulfill customer orders to earn coins, and use them to upgrade and decorate your kitchen, transforming it from a humble diner into a dream culinary paradise. ",
    "publisher": "XMetaGame",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-31T10:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "- Use the left stick or arrow keys to move Nyah.\\n- Use the right stick or mouse to control the spirit light's flight.\\n- Hold a specific button (like a controller's trigger) to connect Nyah and her light, creating a beam to swing from.\\n- Release the button to let go, launching Nyah to new platforms.",
    "sourceUrl": "https://gamedistribution.com/games/cozy-kitchen-merge/"
  },
  {
    "id": "7c03475573ec4a31b3926cc32b29bff1",
    "slug": "obby-football-soccer-3d",
    "title": "Obby Football Soccer 3D",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/7c03475573ec4a31b3926cc32b29bff1-512x512.jpg",
    "description": "Online football / soccer and real sport — play with friends or random opponents.\\nPenalties and matches — score amazing goals, save shots, and become your team’s hero.\\nObby challenges — train your reaction and speed while passing football obstacles.\\nColorful 3D graphics and the atmosphere of a real stadium.\\n\\nGo from rookie to champion. Prove that you are the best player in the world of football and sport.",
    "publisher": "Welwise Studio",
    "languages": [
      "English",
      "Russian",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-31T10:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Controls (PC):\\nShift — acceleration (sprint)\\nQ — ball protection.\\nE — sliding tackle and ball tackling.\\nLMB — kick the ball (the force of the kick depends on the duration of pressing).\\n\\nControls (phone):\\nAll actions are performed via convenient buttons on the screen.",
    "sourceUrl": "https://gamedistribution.com/games/obby-football-soccer-3d/"
  },
  {
    "id": "87cb43c5492049b49b01491248d9ced1",
    "slug": "tap-it-away-3d",
    "title": "Tap It Away 3D",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/87cb43c5492049b49b01491248d9ced1-512x384.jpg",
    "description": "Tap It Away 3D is a fun and relaxing 3D block puzzle game. Tap the arrows to move and clear blocks, solve brain-teasing puzzles, and plan your moves carefully as blocks can block each other. Enjoy smooth, stress-free gameplay with no time limits. Play this free online puzzle game to relax, sharpen your logic, and train your brain anytime.",
    "publisher": "TopKeyGames",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-31T10:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Swipe to rotate the blocks.\\nTap a block to move it in the direction of the arrow.\\nClean the level to win!",
    "sourceUrl": "https://gamedistribution.com/games/tap-it-away-3d/"
  },
  {
    "id": "38380fc2f11e45a48c9b3809293438a5",
    "slug": "bouncy-bomb-buddies",
    "title": "Bouncy Bomb Buddies",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/38380fc2f11e45a48c9b3809293438a5-512x384.jpg",
    "description": "Bouncy Bomb Buddies is a high-energy, sugary-sweet 1v1 artillery platformer where cute characters battle it out in vibrant, candy-colored arenas. Your goal? Bounce around platforms, grab falling bombs, and launch them at your opponent to be the last buddy standing! It combines fast-paced movement with tactical throwing physics and a best-of-5 rounds system to crown the supreme champion.\\n",
    "publisher": "Hopeful Eye",
    "languages": [
      "English"
    ],
    "mobile": [],
    "firstActiveDate": "2026-01-31T09:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "HTML5",
      "Javascript"
    ],
    "instructions": "[Player 1 / Pinky]\\n- Move: [A] [D] keys\\n- Jump: [W] key\\n- Pick Up / Throw: [Spacebar] or [E]\\n\\n[Player 2 / Sky]\\n- Move: [Left Arrow] [Right Arrow]\\n- Jump: [Up Arrow]\\n- Pick Up / Throw: [Enter] or [L]\\n\\n[General]\\n- Pause/Menu: [ESC] or [P]",
    "sourceUrl": "https://gamedistribution.com/games/bouncy-bomb-buddies/"
  },
  {
    "id": "804c1f61fc954b56a6c436ed60441897",
    "slug": "transform-car-battle",
    "title": "Transform Car Battle",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/804c1f61fc954b56a6c436ed60441897-512x384.jpg",
    "description": "you'll control a futuristic vehicle that can transform in an instant, speeding down tracks filled with obstacles and enemies. You'll need to swipe flexibly to dodge deadly lasers and traps while collecting energy cubes. At critical moments, tap the screen to transform into battle mode to smash through barriers, or switch forms to pass through special gates. Constantly challenge your reflexes, unlock more cool cars with unique transformation abilities, and set new running records!",
    "publisher": "XMetaGame",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-30T16:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "- Swipe Left/Right : Move the vehicle left or right to dodge obstacles.\\n- Swipe Up : Jump to clear low barriers.\\n- Tap Screen : Switch between car and robot forms to handle different challenges.",
    "sourceUrl": "https://gamedistribution.com/games/transform-car-battle/"
  },
  {
    "id": "931dfd68632142c7b3e882009866d288",
    "slug": "goods-triple-match-3d",
    "title": "Goods Triple Match 3D",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/931dfd68632142c7b3e882009866d288-512x384.jpg",
    "description": "Begin a super satisfying match 3 puzzle challenge. Goods Triple Match 3D is a colorful and addictive casual logic game where all items appear in beautiful and realistic 3D. Your table is filled with tons of cute 3D drinks.",
    "publisher": "PuzzleGame.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-30T15:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/goods-triple-match-3d/"
  },
  {
    "id": "53960bf6471b4d1cb2a987b5d458a123",
    "slug": "food-jam",
    "title": "Food Jam",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/53960bf6471b4d1cb2a987b5d458a123-512x384.jpg",
    "description": "Food Jam is a fun and satisfying puzzle game where you sort fruits, veggies, and drinks into the right takeout carts. With over 500 juicy levels, unlock delicious new themes like desserts and juices! Use unique power-ups to clear tricky jams and keep your customers happy.",
    "publisher": "Hyper Rabbit Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-30T15:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "One-touch tap or Click on mouse controls perfect for casual play",
    "sourceUrl": "https://gamedistribution.com/games/food-jam/"
  },
  {
    "id": "7493d2deadd944e7a4c268203e29903d",
    "slug": "monster-slayers",
    "title": "Monster Slayers",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/7493d2deadd944e7a4c268203e29903d-512x384.jpg",
    "description": "Monster Slayers is a single‑player mobile roguelike RPG where you must survive endless waves of monsters all by yourself. Every run is a new chance to build the perfect hero, outplay growing hordes, and prove that one warrior can stand against an entire army.",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-30T13:11:51.680Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Move on mobile devices using virtual thumbsticks.\\nOn PC, use the keyboard: Arrow keys, WASD, Numpad 8‑4‑2‑6, or IJKL. You can also control the characters with the mouse.",
    "sourceUrl": "https://gamedistribution.com/games/monster-slayers/"
  },
  {
    "id": "1ae04723ea2f42bab930af8997f01e72",
    "slug": "xeno-defense-protocol",
    "title": "Xeno Defense Protocol",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/1ae04723ea2f42bab930af8997f01e72-512x512.jpg",
    "description": "Xeno Online combines high-octane top-down shooting with strategic tower defense and deep RPG progression. Your mission is simple: Establish a base, defend it against endless waves of insectoid horrors, and extract with your life.",
    "publisher": "FialaGames",
    "languages": [
      "English"
    ],
    "mobile": [],
    "firstActiveDate": "2026-01-30T13:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "YoungAdults",
      "Adults",
      "HTML5",
      "Javascript"
    ],
    "instructions": "WASD, Mouse, R, G, Mouse Wheel, Space",
    "sourceUrl": "https://gamedistribution.com/games/xeno-defense-protocol/"
  },
  {
    "id": "f26fa8d6c54345afa7fe11ddbdc1e270",
    "slug": "goo-slime-jump",
    "title": "Goo Slime Jump",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/f26fa8d6c54345afa7fe11ddbdc1e270-512x512.jpg",
    "description": "Goo Slime Jump is a fun and relaxing casual game, tap to make the slime jump and make sure it reaches the finish line, the relaxing music and calm gameplay make you addicted.",
    "publisher": "atupdev",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-30T08:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "touch for jump",
    "sourceUrl": "https://gamedistribution.com/games/goo-slime-jump/"
  },
  {
    "id": "c68deacab2474d72adeb8a1d7fb23828",
    "slug": "marshmallow-rush",
    "title": "Marshmallow Rush",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/c68deacab2474d72adeb8a1d7fb23828-512x384.jpg",
    "description": "Marshmallow Rush is a one-button runner where you tap at the right moment to stack fluffy marshmallows, weave through cute obstacles, and dash to the finish. Build the tallest, sweetest tower you can, snag boosters for extra points, and master the timing to clear tricky layouts. Simple to play, satisfying to perfect—how far can your marshmallow tower go?",
    "publisher": "Raccoon",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-30T07:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Mouse: Click to place/stack or perform actions\\nTouch: Tap to place/stack or perform actions",
    "sourceUrl": "https://gamedistribution.com/games/marshmallow-rush/"
  },
  {
    "id": "8f137bff27e24f159677fcba28b2d2f4",
    "slug": "clicker-hero",
    "title": "Clicker Hero",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/8f137bff27e24f159677fcba28b2d2f4-512x384.jpg",
    "description": "Click on the screen to defeat the monsters and earn gold in Clicker Hero. Spend your gold to buy and upgrade heroes that deal damage automatically. Then advance to fight tougher monsters that drop more gold. This game keeps going, even when you're offline, so come back later to earn and spend even more!",
    "publisher": "kiz10.com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-29T09:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Use the mouse or touch to play",
    "sourceUrl": "https://gamedistribution.com/games/clicker-hero/"
  },
  {
    "id": "bb3deebf6a6b43dd97ded3010fa16a00",
    "slug": "falling-dummy",
    "title": "Falling Dummy",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/bb3deebf6a6b43dd97ded3010fa16a00-512x384.jpg",
    "description": "Push the dummy off the roof of the tallest building on the construction site and watch it break all its bones. Control the body of the little man as he falls and break as many limbs as possible!\\n\\nDo you want to relax after a hard day? Then this game is made for you! In this anti-stress game, your main goal is to make the dummy break as many limbs as possible when falling from tall buildings!",
    "publisher": "Mirra Games",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Polish",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-29T08:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Teens",
      "YoungAdults",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "The goal of the game is to break as many bones as possible on the dummy by directing it into obstacles while falling from a height.",
    "sourceUrl": "https://gamedistribution.com/games/falling-dummy/"
  },
  {
    "id": "dd6edfff840a4c38ae69596cf0ce314e",
    "slug": "99-balls",
    "title": "99 Balls",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/dd6edfff840a4c38ae69596cf0ce314e-512x384.jpg",
    "description": "99 Balls 3D is an endless arcade game that mixes brick breaker and bubble shooter action in full 3D. Launch balls to smash numbered cylinders before they reach the bottom. Collect stars to unlock fun ball skins like sports balls, gems, or fruit. Simple to play, endlessly challenging, and highly addictive!",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [],
    "firstActiveDate": "2026-01-29T08:25:04.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Aim by dragging backward, then release to fire balls. Each cylinder needs hits equal to its number. Clear as many as possible before any reach the bottom line. Use the aiming guide to plan bounces, shoot through gaps for better angles, and fast-forward when the screen fills up. PC: click \\u0026 drag mouse. Mobile: tap \\u0026 drag, then release.",
    "sourceUrl": "https://gamedistribution.com/games/99-balls/"
  },
  {
    "id": "06fd414d2872472c976a4356740d8002",
    "slug": "polygon-space",
    "title": "Polygon Space",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/06fd414d2872472c976a4356740d8002-512x384.jpg",
    "description": "Polygon Space is an intense shooting challenge. Fly a laser cannon in space, battle attacking sci-fi shapes, keep firing, upgrade weapons with resources, destroy them all, and stay safe.",
    "publisher": "Guangzhou Yomitoo Network Technology Co., Ltd.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-29T07:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "1.Control your turret in endless missions.\\n2.Tap once and it auto-tracks targets, even idle.\\n3.Tap to pick targets and command the fight.",
    "sourceUrl": "https://gamedistribution.com/games/polygon-space/"
  },
  {
    "id": "0ed83e6a1e7846db9eb4b04d96146f6a",
    "slug": "dinosaur-rampage",
    "title": "Dinosaur Rampage",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/0ed83e6a1e7846db9eb4b04d96146f6a-512x384.jpg",
    "description": "When the rampage ends, you’ll compete against other dinosaurs in the same arena and get ranked based on your destruction performance. Unlock many different dinosaur types, collect cool skins in the shop, and prove you’re the ultimate king of chaos. Fast, satisfying, and perfect for stress relief—just stomp, smash, and climb the leaderboard!",
    "publisher": "Raccoon",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-28T08:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Desktop:\\nMouse click – Movement\\nAutomatic attack\\nMouse click – User interface buttons (Start, Shop, Skins)\\n\\nMobile:\\nVirtual joystick/Swipe drag – Movement\\nTap user interface – Shop, Skins, Start/Restart",
    "sourceUrl": "https://gamedistribution.com/games/dinosaur-rampage/"
  },
  {
    "id": "e00fde5e6256468f8abad8669c3f89f6",
    "slug": "sausage-man-shooting-adventure",
    "title": "Sausage Man Shooting Adventure",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/e00fde5e6256468f8abad8669c3f89f6-512x384.jpg",
    "description": "Dive into a hilarious and action-packed adventure. Sausage Man Shooting Adventure is a fast-paced side-scrolling shooting game where you control a crazy, energetic sausage hero and blast through waves of enemies. Run forward, dodge traps, jump platforms, and shoot enemies with nonstop excitement! Collect airdrops to increase your damage.",
    "publisher": "YAD.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-28T08:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/sausage-man-shooting-adventure/"
  },
  {
    "id": "003becedcaf14456879312d685937e17",
    "slug": "color-block-blast-3",
    "title": "Color Block Blast 3",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/003becedcaf14456879312d685937e17-200x120.jpg",
    "description": "Drag and drop the correct block into the grid. Match 3 or more tiles of the same colour to eliminate them.\\n\\nScore beautiful combos while earning bonus points and watching beautiful animations take shape.\\n\\nHow high can you score in this endless match 3 game?",
    "publisher": "MarketJS",
    "languages": [
      "English",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-28T08:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Drag and drop blocks to create beautiful match 3 combinations",
    "sourceUrl": "https://gamedistribution.com/games/color-block-blast-3/"
  },
  {
    "id": "e1308b7ecfe0461a864dc847e33d66f6",
    "slug": "sweet-dessert-hole",
    "title": "Sweet Dessert Hole",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/e1308b7ecfe0461a864dc847e33d66f6-512x384.jpg",
    "description": "Ready to make cute and tasty desserts? In Sweet Dessert Hole, you control a hole that sucks up various sweet toppings. Move the hole around to collect chocolate, cream, fruits, cookies, dan many more. Collect everything on the base before time runs out. Use your coins to upgrade the hole and make the gameplay faster and easier. After making one or more cakes, you can arrange them neatly on a tray. This game is simple, relaxing, and very satisfying to play.",
    "publisher": "iclickgames",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-28T07:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use MOUSE / WASD / ARROW to play the game.",
    "sourceUrl": "https://gamedistribution.com/games/sweet-dessert-hole/"
  },
  {
    "id": "9e6715da90154d94b29dbd21f8258873",
    "slug": "knit-rescue",
    "title": "Knit Rescue",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/9e6715da90154d94b29dbd21f8258873-512x384.jpg",
    "description": "Knit Rescue is an engaging and original puzzle game where you untangle a knitted dragon to save a frightened kitten.\\n\\nBut it’s not enough to simply tap the right spools. You must unlock the correct spools and move them in the right direction to stop the dragon in time.\\n\\nPlan your moves, follow the arrows, and solve each level using logic and strategy. Knit Rescue is the perfect casual puzzle game for fans of brain games, logic puzzles, and strategy games.",
    "publisher": "GameBerry Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-27T14:56:15.491Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Your goal is to untangle the dragon and rescue the kitten before the dragon reaches it.\\n\\nAt the bottom of the screen, you see spools with arrows. Only an open spool can be moved — one that can be pulled out of the group without obstruction (up, sideways, or down).\\n\\nThe arrows show the direction in which each spool can move. When the correct spools are activated, the thread is pulled tight and the dragon begins to shrink step by step.",
    "sourceUrl": "https://gamedistribution.com/games/knit-rescue/"
  },
  {
    "id": "6460bcafa273428b9afa49005b8c70f3",
    "slug": "ice-cream-inc",
    "title": "Ice Cream Inc.",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/6460bcafa273428b9afa49005b8c70f3-512x384.jpeg",
    "description": "If you like to eat ice cream, don't miss our new game Ice Cream Inc, you will find many different delicious ice creams here. You need to make an ice cream looking the same as the picture on the top place. Press the number button to make a sweet ice cream and eat it! Have a good time in Ice Cream Inc!",
    "publisher": "YAD.Com",
    "languages": [],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2020-04-10T13:21:53.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Press the number on the keyboard or tap on the screen to play",
    "sourceUrl": "https://gamedistribution.com/games/ice-cream-inc/"
  },
  {
    "id": "03f9b255d38b437081576c9ca4f7bb69",
    "slug": "dance-on-hotsteps-mobile",
    "title": "Dance On Hotsteps Mobile",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/03f9b255d38b437081576c9ca4f7bb69-512x384.jpg",
    "description": "Welcome to Dance On - Hotsteps Mobile, a modern dance game that you can play for free on H5games4u. Dress up your superstar in beautiful suits and dresses, follow the beats of the music, make perfect dance moves, and surprise the crowd in the dancing show!",
    "publisher": "Yiv.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-25T14:50:04.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/dance-on-hotsteps-mobile/"
  },
  {
    "id": "ead527ea936247fb991a0fb52499b2d7",
    "slug": "sacura-branch",
    "title": "Sacura Branch",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/ead527ea936247fb991a0fb52499b2d7-512x384.jpg",
    "description": "The \\",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-25T14:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Your goal is to put the pieces of the branch together to make it bloom.\\nAt the beginning of the game there is only one living piece of branch.\\nPress the pieces of branches to rotate them.\\nIf you combine the dry and the living, they both live.\\nGather the whole branch.\\nSome branches have flowers on them that will bloom when you get them right.",
    "sourceUrl": "https://gamedistribution.com/games/sacura-branch/"
  },
  {
    "id": "6ccf5ab92bf4469ea1988aafaba35ca2",
    "slug": "escape-again",
    "title": "Escape Again",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/6ccf5ab92bf4469ea1988aafaba35ca2-512x384.jpg",
    "description": "Together with the main character of the new online game Escape Again, you will go on a journey through the painted world in search of treasures and adventures. The location in which your hero will be will be visible on the screen in front of you. By controlling his actions you will have to move around the area. Overcoming various obstacles and traps, you will have to help the hero find special magic pins. With their help, he will be able to activate the portal leading to the next level.",
    "publisher": "New Kids Games",
    "languages": [
      "English",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-25T14:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Use Arrow keys and mouse to play.",
    "sourceUrl": "https://gamedistribution.com/games/escape-again/"
  },
  {
    "id": "8f07339e65ae4c739e1c406da7c51e26",
    "slug": "tetro-merge",
    "title": "Tetro Merge",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/8f07339e65ae4c739e1c406da7c51e26-512x384.jpg",
    "description": "Tetro Merge is a physics-based merge puzzle game where Tetromino blocks come to life.\\nYou’ll drop Tetrominoes of all shapes—classic, extended, and brand-new originals. When two matching pieces touch, they merge into a bigger, more complex block.\\nMaster the bounce, plan your stacks, and build powerful combos as the board slowly fills up.\\nWill you manage your space wisely… or let the blocks overflow?\\nA perfect blend of strategy, physics, and classic Tetris nostalgia.",
    "publisher": "Orenji Spark",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-25T11:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "move the block using mouse or drag, and drop the block by click or release.",
    "sourceUrl": "https://gamedistribution.com/games/tetro-merge/"
  },
  {
    "id": "c05104942f9c4ee399c428f9c16ab04d",
    "slug": "paint-pop-3d",
    "title": "Paint Pop D",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/c05104942f9c4ee399c428f9c16ab04d-1280x550.jpeg",
    "description": "Paint Pop D features levels fun gameplay",
    "publisher": "JulGames",
    "languages": [],
    "mobile": [],
    "firstActiveDate": "2019-03-11T08:27:08.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "HTML5",
      "WebGL"
    ],
    "instructions": "",
    "sourceUrl": "https://gamedistribution.com/games/paint-pop-3d/"
  },
  {
    "id": "d43ed595d14e47a1ac6a4ff7456fd3b5",
    "slug": "kaboom-miner",
    "title": "Kaboom Miner",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/d43ed595d14e47a1ac6a4ff7456fd3b5-512x512.jpg",
    "description": "A fast-paced logical arcade inspired by classic Boulder Dash, but taken to the next level with massive chain explosions.\\nYour goal is simple—but dangerous: destroy all 50 explosive crates. Use falling stones, carefully placed bombs, and clever terrain manipulation to trigger devastating chain reactions. Every move matters. Push stones, move crates, build bridges from bricks, and even trap the Ghost before finishing it off.",
    "publisher": "CoreCraft",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-25T08:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "On desktop: WASD directions, Q place bomb, SPACE place brick, P pause, ESC quit; on mobile: D-pad and buttons",
    "sourceUrl": "https://gamedistribution.com/games/kaboom-miner/"
  },
  {
    "id": "cf93ca785ae64b8e9d19444bd54e5976",
    "slug": "aim-ninja",
    "title": "Aim Ninja",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/cf93ca785ae64b8e9d19444bd54e5976-512x384.jpg",
    "description": "Aim Ninja is a fast-paced skill game that tests your timing and reflexes. \\nStop the moving needle at the perfect moment to score points and improve your accuracy. \\nSimple to play but hard to master, Aim Ninja delivers quick, satisfying gameplay sessions \\nfor players of all ages.",
    "publisher": "Siddhant Sharma",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-25T08:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "Click, tap, or press the spacebar to stop the needle at the right moment.",
    "sourceUrl": "https://gamedistribution.com/games/aim-ninja/"
  },
  {
    "id": "ab582ca4853b429ea9aa0b52b941e8e3",
    "slug": "move-emoji",
    "title": "Move Emoji",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/ab582ca4853b429ea9aa0b52b941e8e3-512x384.jpg",
    "description": "Move Emoji Match Puzzle is a fun and colorful brain game where you slide emoji boxes to match and clear them. Each level gives you a limited number of moves, so smart planning is key. Cute emojis, simple controls, and tricky puzzles make it perfect for quick, satisfying challenges.",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-25T08:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Swipe to move emoji boxes around the board. Match the same emojis to clear them and free up space. You must clear all emoji boxes using the limited number of moves given. If you run out of moves before finishing, the level fails. Plan carefully to advance to the next puzzle!",
    "sourceUrl": "https://gamedistribution.com/games/move-emoji/"
  },
  {
    "id": "1dec1cea731d4337a548b7c8eb8b5ddb",
    "slug": "english-checkers",
    "title": "English Checkers",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/1dec1cea731d4337a548b7c8eb8b5ddb-512x512.jpg",
    "description": "Immerse yourself in the exciting world of Checkers English, where every game is a test of your tactics and foresight! Also this game is known by name Draughts",
    "publisher": "GamePush",
    "languages": [
      "Arabic",
      "Chinese (Simplified)",
      "English",
      "French",
      "German",
      "Hindi",
      "Indonesian",
      "Italian",
      "Japanese",
      "Korean",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-18T14:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "The beginning of the game. Select the mode: against the computer, online, or together on the same screen.\\nMoves. A simple checker moves diagonally forward one square. The queen (king) can move back and forth one square.\\nIf your checker is next to the opponent's piece, and there is an empty square behind it, you must jump over and capture it.\\nChain captures. If a new capture opportunity opens after a jump, you continue to capture pieces within the same turn.",
    "sourceUrl": "https://gamedistribution.com/games/english-checkers/"
  },
  {
    "id": "d41e8014aea74629934290991b008c7a",
    "slug": "arrows-puzzle-escape",
    "title": "Arrows Puzzle Escape",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/d41e8014aea74629934290991b008c7a-512x384.jpg",
    "description": "Arrows – Puzzle Escape is an addictive puzzle game that combines deep logic challenges and a thrilling escape experience. Every level throws you into a jam-packed arrow maze where only smart planning can set you free. Arrows point in different directions, blocking each other and creating tricky jam situations.",
    "publisher": "PuzzleGame.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-17T14:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/arrows-puzzle-escape/"
  },
  {
    "id": "1733bf71bb4d4db0aca75e16ea034c8f",
    "slug": "classic-mahjong",
    "title": "Classic Mahjong",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/1733bf71bb4d4db0aca75e16ea034c8f-512x384.jpeg",
    "description": "This is the classic remake of one the most popular games in computer history. Apparently an easy game, it requires a lot of concentration and attention.",
    "publisher": "Restaurant Games",
    "languages": [],
    "mobile": [
      "ForAndroid"
    ],
    "firstActiveDate": "2020-09-18T15:07:43.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 2"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 2"
    ],
    "instructions": "All you have to do is remove pair of tiles until the board is empty.",
    "sourceUrl": "https://gamedistribution.com/games/classic-mahjong/"
  },
  {
    "id": "ea9a40f010ad4d9486290e8eb9c177a8",
    "slug": "heroic-knight",
    "title": "Heroic Knight",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/ea9a40f010ad4d9486290e8eb9c177a8-512x384.jpg",
    "description": "Guide the noble knight through peril and claim the treasure! In this exciting puzzle game, you'll shift barriers to clear a path to victory. Help the knight defeat enemies, avoid traps, and uncover hidden riches. Plan your moves carefully, as one wrong decision could cost you the treasure!",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-17T08:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "In order for the prince to save the princess or to reach the gold, you need to develop your strategy and pull the right sticks in time. Otherwise, the trolls may kill you or you may die in the lava.",
    "sourceUrl": "https://gamedistribution.com/games/heroic-knight/"
  },
  {
    "id": "6a739956a35f4584944baf5224e485a2",
    "slug": "forest-survivor-rougelike",
    "title": "Forest Survivor Rougelike",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/6a739956a35f4584944baf5224e485a2-512x384.jpg",
    "description": "Forest Survivor Roguelike is an addictive simulator adventure game that throws you into a dangerous forest. Only the strongest survivor can survive. From the very first moment, you must fight, explore, and adapt to stay alive in this intense roguelike world. Every step in the forest is a new challenge.",
    "publisher": "bestgames.com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-16T14:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/forest-survivor-rougelike/"
  },
  {
    "id": "bfbb177835c748c1a47579fa5604112c",
    "slug": "bolts-and-nuts-sorting",
    "title": "Bolts and Nuts - Sorting",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/bfbb177835c748c1a47579fa5604112c-512x512.jpg",
    "description": "Bolts and Nuts - Sorting is a captivating casual game where each level challenges your logic and attentiveness! Unscrew bolts, collect nuts, and solve puzzles to progress. Simple controls and intuitive gameplay make the game accessible to everyone, while gradually increasing difficulty keeps it exciting. ",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-16T14:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Choose a bolt with a nut screwed onto it. Click to unscrew the nut and move it. Keep track of the order of the nuts - unscrew them in the correct sequence! Simple controls - just one click! But with each level, the puzzles become trickier and more interesting.",
    "sourceUrl": "https://gamedistribution.com/games/bolts-and-nuts-sorting/"
  },
  {
    "id": "f83698cd4d6049509fd6ddfa0ef95780",
    "slug": "k-wedding-dream",
    "title": "K-Wedding Dream",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/f83698cd4d6049509fd6ddfa0ef95780-512x384.jpg",
    "description": "Immerse yourself in the atmosphere of Korean love with the heroes of this dressup-game. Become a part of a magical story where bright K-Pop stars are preparing for the most important day of their lives - Wedding day! Combine tradition and modern fashion by creating wedding looks for lovers. Choose the perfect makeup, hairstyle and jewelry to highlight their unique style and charm. Let each of your choices reflect the emotions and dreams of the characters, turning this day into a real fairy tale!",
    "publisher": "DL-studio",
    "languages": [
      "No Text"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-16T08:00:06.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Help the couple create a Korean-style wedding look. The most interesting images can be saved as a screenshot in PNG format. Depending on the gaming device, either a click of a computer mouse or a simple touch on touchscreens is used to control it.",
    "sourceUrl": "https://gamedistribution.com/games/k-wedding-dream/"
  },
  {
    "id": "811e6f9e6d864f5a93575c20cb0729ea",
    "slug": "free-hoops",
    "title": "Free Hoops",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/811e6f9e6d864f5a93575c20cb0729ea-512x512.jpg",
    "description": "Welcome to Free Hoops, the ultimate puzzle game that combines creativity, humor, and strategic problem-solving! Dive into a world of quirky challenges where your goal is to skillfully adjust iron bars and guide elastic bands into predetermined boxes. Once the bands are in place, use them to tie around objects and destroy them to advance to the next level.",
    "publisher": "Eyestorm Pte. LTD.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-16T07:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Playing Free Hoops is simple yet captivating. Adjust the iron bars to direct the elastic bands into the correct boxes. Once the bands are secured, use them to wrap around objects until they are destroyed. Each level presents a unique puzzle that requires quick thinking and precise movements.",
    "sourceUrl": "https://gamedistribution.com/games/free-hoops/"
  },
  {
    "id": "70f8d516928b48398399c23a2f55ecfc",
    "slug": "bus-color-jam",
    "title": "Bus Color Jam",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/70f8d516928b48398399c23a2f55ecfc-512x384.jpg",
    "description": "Welcome to Bus Color Jam, a lively and colorful online game that challenges your coordination and quick thinking. Guide passengers to the right buses by matching their colors and keeping the station running smoothly. Every level brings new challenges that test your timing and attention. It’s a fun mix of strategy and reflexes — easy to learn, satisfying to master, and completely free to play on both your phone and computer.",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-16T07:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Tap a passenger to send them toward the bus. If the passenger’s color matches the bus, they board immediately. If not, they wait in the empty tile(s) provided.\\nIf you run out of empty tiles and a mismatched passenger arrives, you'll fail the level.\\nYou must board all passengers correctly to finish the level. Successful completion rewards you with coins.",
    "sourceUrl": "https://gamedistribution.com/games/bus-color-jam/"
  },
  {
    "id": "64e5597f616e4d58960e3b263a286e15",
    "slug": "coin-stack-up",
    "title": "Coin Stack Up",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/64e5597f616e4d58960e3b263a286e15-512x512.jpg",
    "description": "Coin Stack Up is a colorful and satisfying puzzle game where strategy meets stacking fun!\\nConnect and stack coins of the same color to create powerful combinations and clear the board.\\nTo make a valid move, you must connect at least 3 coins of the same color. The bigger the stack, the better the results! Each level comes with specific goals shown at the top of the screen - plan your moves carefully to complete them before you run out of moves.",
    "publisher": "GameBerry Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-15T08:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Connect 3 coins of the same color by selecting and dragging a line. \\n",
    "sourceUrl": "https://gamedistribution.com/games/coin-stack-up/"
  },
  {
    "id": "a6523a16099543ec804ed4057be06c0e",
    "slug": "gear-wars",
    "title": "Gear Wars",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/a6523a16099543ec804ed4057be06c0e-512x384.jpg",
    "description": "\\n\\nDo you have the strategic skill to build a flawless factory, producing Brutes, Archers, and Grunts? Manage your budget wisely, crush every enemy, and claim victory! Get those gears spinning... it's time to WIN!",
    "publisher": "Yizhiyuan Network Technology Co., Ltd.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-14T13:45:38.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Drag and combine gears with soldiers to increase their spawn rate. Strategically assemble gears and soldiers to destroy the enemy base.",
    "sourceUrl": "https://gamedistribution.com/games/gear-wars/"
  },
  {
    "id": "95c32bbf9a834a17a6ddac3ef76d2b2e",
    "slug": "hotgear",
    "title": "HOTGEAR",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/95c32bbf9a834a17a6ddac3ef76d2b2e-512x384.jpg",
    "description": "Join HOTGEAR, a brand-new racing game where the thrill of the chase is just beginning. The pursuit is on, and it's time to put your skills to the test! The game offers a wide range of customization options, allowing you to create the car of your dreams and make every chase even more thrilling.\\nSo, what are you waiting for, racer? The pursuit has begun, and you're wanted! Time to get in the driver's seat, customize your car, and take on the streets!",
    "publisher": "LUCKY TRY",
    "languages": [
      "Arabic",
      "Chinese (Simplified)",
      "English",
      "French",
      "German",
      "Italian",
      "Japanese",
      "Korean",
      "Portuguese",
      "Russian",
      "Spanish",
      "Thai"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-14T09:26:11.626Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "- choose your car!\\n- select a mode!\\n- get ready to race!\\n- control your car: accelerate, steering, drifting, nitro boost!",
    "sourceUrl": "https://gamedistribution.com/games/hotgear/"
  },
  {
    "id": "0058833cabd24958945d843073257855",
    "slug": "idle-trade-routes",
    "title": "Idle Trade Routes",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/0058833cabd24958945d843073257855-512x384.jpg",
    "description": "Command a growing fleet of merchant ships across a shimmering ocean in Idle Trade Routes. Link bustling islands, auto‑dock at busy ports, and optimize trade lines to keep goods flowing. Unlock new ships, hire captains, and chase bigger contracts as your profits grow even while you’re away.",
    "publisher": "MarketJS",
    "languages": [
      "English",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-14T08:57:17.724Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Build efficient sea routes between islands, upgrade your fleet, and let automated ships earn gold for you in this relaxing idle trading game.",
    "sourceUrl": "https://gamedistribution.com/games/idle-trade-routes/"
  },
  {
    "id": "b085b22a85384f558238432316e5ba32",
    "slug": "mojicon-fruit-connect",
    "title": "Mojicon Fruit Connect",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/b085b22a85384f558238432316e5ba32-512x384.jpg",
    "description": "Match. Collect. Get Inspired! Dive into Mojicon Fruit Connect, the vibrant puzzle game where every match brings you closer to a new discovery. Connect colorful emoji tiles to clear the board, but watch out for shifting gravity and frozen that tiles will keep you on your toes!\\n\\nComplete levels to fill your Album with cute characters. Reveal meaningful quotes and daily inspiration with every unlock. Return to your Fruit Farm later to claim a basket full of free rewards. \\n\\nPlay anywhere you like!",
    "publisher": "2Million Games",
    "languages": [
      "Czech",
      "Dutch",
      "English",
      "French",
      "German",
      "Italian",
      "Japanese",
      "Polish",
      "Portuguese",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-14T08:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Tap or click two matching emoji tiles to connect them with a line and clear them from the board.\\nThe connection path can turn up to two times – plan your matches carefully!\\nClear the board before time runs out to win stars.\\nUse Hints or Shuffle power-ups when you’re stuck, and chase the highest combo streak!",
    "sourceUrl": "https://gamedistribution.com/games/mojicon-fruit-connect/"
  },
  {
    "id": "5dcc973d39bc454d94c8cb4da383f64e",
    "slug": "pet-doctor-business-tycoon-pet-care-game",
    "title": "Pet Doctor Business Tycoon-Pet care game",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/5dcc973d39bc454d94c8cb4da383f64e-512x384.jpg",
    "description": "Step into the world of animal care with Pet Doctor – Animal Hospital Simulator! Become a kind and skilled veterinarian as you treat adorable pets including cats, dogs, rabbits, and more. Use realistic medical tools to diagnose, clean wounds, check heartbeats, and perform surgeries. Each level brings new challenges where you must care for sick, injured, or pregnant animals in a friendly hospital environment. ",
    "publisher": "minigame",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-13T10:39:24.555Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "W / Arrow Up → Move Front\\nS / Arrow Down → Move Back \\nA / Arrow Left → Move Left\\nD / Arrow Right → Move Right\\n\\n- To click any button use mouse",
    "sourceUrl": "https://gamedistribution.com/games/pet-doctor-business-tycoon-pet-care-game/"
  },
  {
    "id": "e28bcc262b6245dc806dba3a43d057ce",
    "slug": "stickman-zombie-vs-stickman-hero",
    "title": "Stickman Zombie vs Stickman Hero",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/e28bcc262b6245dc806dba3a43d057ce-512x384.jpg",
    "description": "Stickman Zombie vs Stickman Hero is a stick war game about zombies, stickman, noob and pro who stole lucky block. The zombie boss is chasing them to bring the lucky block back to the roblox world, but the stickman hero escapes, resurrecting his allies along the way/\\n\\nGame Features:\\n- You run away from the zombie boss and then play as him against the animator\\n- Various zombie, baldi and stickman animations\\n- The game is similar in style to minecraft, stick war, roblox and noob vs p",
    "publisher": "Stickman vs Monster School Team",
    "languages": [
      "English",
      "Russian",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-13T10:40:22.084Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Your goal as a human stickman is to kill all the zombies and reach the end of the level.\\n\\nYour goal as zombies is to infect the stickmen and get to the end of the level.\\n\\nMove to virtual buttons or WASD.\\n\\nShoot by tapping the screen with your finger or the left mouse button.\\nInfect\\\\hit for zombie with a virtual button or F.",
    "sourceUrl": "https://gamedistribution.com/games/stickman-zombie-vs-stickman-hero/"
  },
  {
    "id": "585ee8758c024e32ad951704f7fd508a",
    "slug": "hide-me",
    "title": "Hide Me",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/585ee8758c024e32ad951704f7fd508a-512x384.jpg",
    "description": "Do you love the thrill of cat and mouse games? Are you ready to outsmart your pursuers and claim victory? Dive into \\",
    "publisher": "Eyestorm Pte. LTD.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-13T10:32:50.203Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "- Tap to Hide: Disappear into objects and avoid detection by your enemies.\\n- Survive the Chase: Stay hidden as long as possible to escape.\\n- Unlock Levels and Power-Ups: Explore new environments and use special abilities to gain the upper hand.",
    "sourceUrl": "https://gamedistribution.com/games/hide-me/"
  },
  {
    "id": "9a5b347e1e2243389462693e9854cdf1",
    "slug": "teacher-simulator",
    "title": "Teacher Simulator",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/9a5b347e1e2243389462693e9854cdf1-512x384.jpg",
    "description": "Teacher Simulator is a fun simulation game in which you play the role of a teacher. Mark exams and ensure the kids are on their best behavior. You may have been the student, but now you get to be the one in charge!",
    "publisher": "Kwalee",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-12T09:43:05.347Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Use the left mouse button on desktop or touch on mobile to play the game.",
    "sourceUrl": "https://gamedistribution.com/games/teacher-simulator/"
  },
  {
    "id": "15c88d1729174ebbae48fdd8e45d54e1",
    "slug": "kings-and-queens-match-3",
    "title": "Kings and Queens Match 3",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/15c88d1729174ebbae48fdd8e45d54e1-200x120.jpg",
    "description": "Step into Kings and Queens Match 3, the enchanting third chapter of the royal Match-3 adventure! Match jewels, crowns, and other royal artifacts to progress through exciting levels. Use powerful boosters like bombs, hammers, and royal blasts to clear challenging boards. Unlock new parts of the kingdom as you enjoy stunning visuals and a charming soundtrack. Join the royal quest and discover treasure, challenge, and endless fun!",
    "publisher": "SOFTGAMES – Mobile Entertainment Services GmbH",
    "languages": [
      "Dutch",
      "English",
      "French",
      "German",
      "Italian",
      "Polish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-12T09:41:10.239Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "Connect three or more items of the same type to remove them from the board. Every level has a goal that you have to achieve to proceed further. Focus on the goal and plan your moves carefully so that you don’t run out of them before completing the task! Use the Royal Bombs and Hammers to remove blockers and complete daily challenges for even more rewards.",
    "sourceUrl": "https://gamedistribution.com/games/kings-and-queens-match-3/"
  },
  {
    "id": "1135d8c4c0ee453895b0b0eeececbb92",
    "slug": "my-happy-farm",
    "title": "My Happy farm",
    "category": "Simulation",
    "thumbnail": "https://img.gamedistribution.com/1135d8c4c0ee453895b0b0eeececbb92-512x384.jpg",
    "description": "Welcome to farm land game – the ultimate farming adventure that brings the beauty of rural life, the challenge of resource management, and the excitement of running your very own farm straight to your browser. The game is not just about clicking and waiting; it’s about strategy, timing, and smart decisions. Do you invest in farms first or focus on crops? Should you expand your land or upgrade your equipment? Every choice matters.",
    "publisher": "minigame",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-09T07:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Simulation",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "W / Arrow Up → Move Front\\nS / Arrow Down → Move Back \\nA / Arrow Left → Move Left\\nD / Arrow Right → Move Right\\n\\n- To click any button use mouse",
    "sourceUrl": "https://gamedistribution.com/games/my-happy-farm/"
  },
  {
    "id": "e60b6dcfbc1e4027a11abc8dc3959669",
    "slug": "dino-idle-park",
    "title": "Dino Idle Park",
    "category": "Simulation",
    "thumbnail": "https://img.gamedistribution.com/e60b6dcfbc1e4027a11abc8dc3959669-512x512.jpg",
    "description": "Dino Idle Park is a relaxing leisure real estate tycoon where you create and develop a dinosaur amusement park. Expand plots, release and display dinosaurs, optimize queues and parks, hire staff, and upgrade investments to increase funds and income. Balance safety, visitor happiness, and research to keep the park thriving even when youre away.",
    "publisher": "Raccoon",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-08T14:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Simulation",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Desktop version: Click to move the character, touch to build\\nMobile phone: touch the screen to move the character, touch to build",
    "sourceUrl": "https://gamedistribution.com/games/dino-idle-park/"
  },
  {
    "id": "e07da43b39e443738d6a84a4a6255c32",
    "slug": "steal-brainrot-eggs",
    "title": "Steal Brainrot Eggs",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/e07da43b39e443738d6a84a4a6255c32-512x384.jpg",
    "description": "Steal Brainrot Eggs is a competitive action game playable in both 1 Player and 2 Player modes. Players buy eggs from a central conveyor, carry them to their Base, and hatch random Brainrot characters based on egg rarity. Characters generate coins over time, allowing access to higher-tier eggs. Defend your Base from thieves or steal eggs and characters from rivals, customize your character, raise evolving pets, and take part in timed events across the map.",
    "publisher": "gameVgames",
    "languages": [
      "Arabic",
      "English",
      "German",
      "Portuguese",
      "Russian",
      "Simple English",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-08T07:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "PLAYER 1:\\nMove: W, A, S, D\\nJump: Space\\nBuy or Steal: E\\nHit: F or Left Mouse\\nSprint: Left Shift\\n\\nPLAYER 2:\\nMove: Arrow Keys\\nJump: L\\nBuy or Steal: O\\nHit: K\\nSprint: J",
    "sourceUrl": "https://gamedistribution.com/games/steal-brainrot-eggs/"
  },
  {
    "id": "47a535b4456844f3896c42d7743827c9",
    "slug": "connect-puzzle-image",
    "title": "Connect Puzzle Image",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/47a535b4456844f3896c42d7743827c9-512x384.jpg",
    "description": "Step into the delightful world of Connect Puzzle Image, a game designed to tease your brain and sharpen your observation skills. Match and connect a variety of funny characters, tasty foods, and interesting objects as you progress through colorful levels. Easy to play yet delightfully challenging, this free online puzzle game offers hours of relaxing entertainment on both mobile and desktop devices.",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-07T11:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Tap and drag the puzzle pieces to connect or align them correctly.\\nOnce pieces are placed properly, the full picture be it a quirky character, delicious dish, or cool object—comes together.\\nFinish the level and either continue to the next or pause and resume anytime perfect for short bursts of play.",
    "sourceUrl": "https://gamedistribution.com/games/connect-puzzle-image/"
  },
  {
    "id": "4592e84523ad49a8b80986c3aa503429",
    "slug": "steal-brainrot-arena",
    "title": "Steal Brainrot Arena",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/4592e84523ad49a8b80986c3aa503429-512x384.jpg",
    "description": "Steal Brainrot Arena is a fast-paced collection and heist game where every match turns into a battle of wallets, wits, and sneaky steals. Play solo in 1 Player mode or team up and compete in 2 Player mode as you build the ultimate Brainrot lineup. With over 45+ brainrot characters to discover, your goal is simple: buy better Brainrots, earn more, and create the most stacked collection in the arena. ",
    "publisher": "CursoraLabs",
    "languages": [
      "Arabic",
      "English",
      "German",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-07T10:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Player 1\\nMove: W,A,S,D or ARROW KEYS (In 1 Player mode only)\\nJump: SPACE\\nSprint: L-SHIFT\\nHammer hit: F or LEFT-CLICK\\nBuy/Steal/Sell: E\\nMarket: R\\nTeleport to base: T\\nRebirt: Y\\nGift screens: G,H,J (In 1 Player mode only)\\n\\nPlayer 2\\nMove: ARROW KEYS\\nJump: L\\nSprint: K\\nBuy/Steal/Sell: M\\nMarket: I\\nTeleport to base: O\\nRebirth: P",
    "sourceUrl": "https://gamedistribution.com/games/steal-brainrot-arena/"
  },
  {
    "id": "212dcfed3c2b4568b0069fcc346ad421",
    "slug": "jump-dash",
    "title": "Jump Dash",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/212dcfed3c2b4568b0069fcc346ad421-512x384.jpg",
    "description": "Leap, soar, and survive in this fast-paced rhythm platformer!\\nStep into the intense world of Jump Dash, where every move must be perfectly timed. Test your reflexes as you jump, glide, and flip through treacherous levels packed with spikes, traps, and relentless obstacles.",
    "publisher": "GameBiz",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-06T10:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Tap/Space to jump",
    "sourceUrl": "https://gamedistribution.com/games/jump-dash/"
  },
  {
    "id": "2ec03a5bbb8e47b8bdb5b12ebad61ac5",
    "slug": "mission-santa:-deliver-the-gifts",
    "title": "Mission Santa: Deliver the Gifts",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/2ec03a5bbb8e47b8bdb5b12ebad61ac5-512x384.jpg",
    "description": "Santa must deliver gifts to children in time! There are many kids and only one Santa, so everything has to be done on the fly! Fly in a sleigh on Christmas night and throw gifts down chimneys to make children happy. \\n\\nThe game helps you feel the atmosphere of the approaching holiday and prepare for the most magical time of the year!",
    "publisher": "Garry'sGems",
    "languages": [
      "English",
      "French",
      "German",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-25T04:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "PC:\\nPress the Left Mouse Button or Spacebar to drop a gift.\\n\\nMobile phone / tablet (touch controls):\\nTap anywhere on the screen to drop a gift.\\n\\nHit the chimneys. The harder it is to land a gift in a chimney, the more points you earn. Set new records and unlock new gifts! They will help you achieve even more impressive scores.\\n\\nDeliver gifts without missing to build combos. The bigger the combo, the more points you get for each hit!",
    "sourceUrl": "https://gamedistribution.com/games/mission-santa:-deliver-the-gifts/"
  },
  {
    "id": "7f80acce2a524af9bc3dfa53eaaa8ff6",
    "slug": "anomaly-content-record",
    "title": "Anomaly Content Record",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/7f80acce2a524af9bc3dfa53eaaa8ff6-512x384.jpg",
    "description": "Welcome to Anomaly Content Record, a terrifying horror adventure where your only goal is to escape and survive. You’re a field investigator sent to explore a restricted research facility that went silent overnight.",
    "publisher": "PuzzleGame.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-24T14:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/anomaly-content-record/"
  },
  {
    "id": "0412d111bb7047e88ae28ca9b5ce764e",
    "slug": "magic-forest-merge-the-secrets",
    "title": "Magic Forest - Merge the Secrets",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/0412d111bb7047e88ae28ca9b5ce764e-512x384.jpg",
    "description": "The Magic Forest is full of amazing little places!\\nDo you want to take a walk here?\\nThen hurry and start your journey!\\nAnd to make it even more fun, you’ll have company - Masha, a young girl who loves discovering new and mysterious things.\\nEven if it sometimes means sneaking away from Grandma and missing lunch.",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-24T14:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": " A new item appears at the top of the screen every turn.\\n2. Move it left or right with your mouse cursor or your finger.\\n3. When you let go or tap, it will drop down.\\n4. Try to make it bump into another one just like it.\\n5. When two matching items connect, a new one appears.\\nSometimes you might run out of space for new items. When that happens, Masha will come to help you. You can give her the items she asks for, or you can keep going on your own. It’s your choice.",
    "sourceUrl": "https://gamedistribution.com/games/magic-forest-merge-the-secrets/"
  },
  {
    "id": "b19adff25c044cacb3accf8fbc02a5e5",
    "slug": "racing-master-3d",
    "title": "Racing Master 3D",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/b19adff25c044cacb3accf8fbc02a5e5-512x512.jpg",
    "description": "Racing Master 3D is a 3D racing driving simulation game that'll get your adrenaline pumping in seconds! Here, you'll drive ultra-cool cars at full throttle. Race through the fully immersive 3D tracks. Enjoy the realistic car driving simulation. Hit the nitro button and blast past every rival in seconds.",
    "publisher": "CarGames.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-24T14:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/racing-master-3d/"
  },
  {
    "id": "d6a79fd8e22c46498f2f876d87c474cf",
    "slug": "toy-rumble-3d",
    "title": "Toy Rumble 3d",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/d6a79fd8e22c46498f2f876d87c474cf-512x384.jpg",
    "description": "Begin an explosive toy adventure in Toy Rumble 3D. A 3D running and racing arcade game packed with action, speed, and strategy. Move your tank through chaotic obstacle courses, collect parts, assemble your cannon, and shoot your way to victory.",
    "publisher": "Online Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-24T13:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/toy-rumble-3d/"
  },
  {
    "id": "e96ffd86a913460b94768706f5a72dcd",
    "slug": "fruit-block-tetra-puzzle",
    "title": "Fruit Block Tetra Puzzle",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/e96ffd86a913460b94768706f5a72dcd-512x384.jpg",
    "description": "Fruit Block Tetra Puzzle is a fast and fun block puzzle game where you place fruit-shaped blocks to clear lines and collect target fruits before time runs out. Complete each fruit goal to level up and unlock new challenges. Easy to play, satisfying to master, and perfect for quick, brain-boosting fun! ",
    "publisher": "Lof Games",
    "languages": [
      "Arabic",
      "Bulgarian",
      "Chinese (Simplified)",
      "Czech",
      "Danish",
      "Dutch",
      "English",
      "Estonian",
      "Finnish",
      "French",
      "German",
      "Greek",
      "Hebrew",
      "Hindi",
      "Hungarian",
      "Indonesian",
      "Italian",
      "Japanese",
      "Korean",
      "Latvian",
      "Lithuanian",
      "Polish",
      "Portuguese",
      "Romanian",
      "Russian",
      "Serbian",
      "Simple English",
      "Slovak",
      "Spanish",
      "Swahili",
      "Swedish",
      "Tagalog",
      "Thai",
      "Turkish",
      "Ukrainian",
      "Vietnamese"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-24T13:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use your mouse or touchpad to drag fruit blocks into the grid, place them strategically, and clear lines to collect target fruits.",
    "sourceUrl": "https://gamedistribution.com/games/fruit-block-tetra-puzzle/"
  },
  {
    "id": "9df24d5f84454c13b6ff0c4b3f01f3aa",
    "slug": "dreams",
    "title": "Dreams",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/9df24d5f84454c13b6ff0c4b3f01f3aa-512x384.jpg",
    "description": "In the realm of slumber, dreams manifest as delicate tiles, each holding a fragment of imagination, memory, or longing. As a Dream Collector, your mission is to weave these ephemeral pieces together, creating a tapestry of wonder. Only by assembling the perfect dream can you unlock hidden secrets and awaken the Dream Oracle.",
    "publisher": "Noora",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-24T10:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Defold"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Portrait",
      "HTML5",
      "Defold"
    ],
    "instructions": "Rules:\\nYou can jump to an adjacent tile if it’s within range.\\nWalls block your path—no jumping over them!\\nSimple tiles beckon from two tiles away.\\nSticky tiles demand proximity—just one tile.\\nCanon tiles spin with each leap, challenging your strategy.\\nWin Condition:\\nCollect all dreams by stepping on the dream-containing tiles.\\nReach the special “End Tile” (distinguished by a different color) to complete the level.",
    "sourceUrl": "https://gamedistribution.com/games/dreams/"
  },
  {
    "id": "3696faedf5d14ccfa6abb23379f8a25b",
    "slug": "math-block",
    "title": "Math Block",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/3696faedf5d14ccfa6abb23379f8a25b-512x384.jpg",
    "description": "Math Block is a brain-teasing puzzle game where you slide numbered blocks and operators on a grid to form valid math equations. Match the target value using addition, subtraction, multiplication, and division to earn stars and progress through 500 challenging levels!",
    "publisher": "GameFiH",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-24T09:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Click/tap to slide blocks",
    "sourceUrl": "https://gamedistribution.com/games/math-block/"
  },
  {
    "id": "bc9e48b8a60142a79b44259398160d98",
    "slug": "rough-ball",
    "title": "Rough Ball",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/bc9e48b8a60142a79b44259398160d98-512x384.jpg",
    "description": "Bounce wildly in Rough Ball! Control your cute purple ball across wall-to-wall platforms, dodging spikes, skulls, and deadly drops. Collect shiny coins, unlock free burger skins, and conquer chaotic levels. Don't fall down—jump, roll, and thrive in pixel-perfect adventure! ",
    "publisher": "SecGame",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-24T09:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "- Click left side to bounce left \\n- Click right side to bounce right \\n- Double-click to reset level \\n- Right-click to open menu ",
    "sourceUrl": "https://gamedistribution.com/games/rough-ball/"
  },
  {
    "id": "7134bee45b7c4d7c859994458367d42e",
    "slug": "brainrot-bridge-race-3d",
    "title": "Brainrot Bridge Race 3D",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/7134bee45b7c4d7c859994458367d42e-512x384.jpg",
    "description": " This is not just a simple running and racing game. It’s a brainrot-style 3D battle where speed and strategy collide! Your goal is to collect as many bananas as possible while sprinting through hilarious obstacle courses. Collect more bananas to evolve your form.",
    "publisher": "bestgames.com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-23T15:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/brainrot-bridge-race-3d/"
  },
  {
    "id": "b207ec567c824d109249a0cd7c552275",
    "slug": "shell-strikers",
    "title": "Shell Strikers",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/b207ec567c824d109249a0cd7c552275-200x120.jpg",
    "description": "Shell Strikers is an exciting turn-based artillery combat game where strategy meets action. Lead your team of soldiers in intense battles across diverse battlefields including war-torn cities, scorching deserts, and peaceful meadows.\\n\\nEach turn, you must carefully aim your shots, account for wind conditions, and choose the right weapon from your arsenal. Available weapons include rockets, bombs, laser guns, airstrikes, and dynamite - each with unique properties and limited ammo.",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-23T15:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Controls:\\n- A/D or Arrow Keys: Move your soldier\\n- Mouse: Aim your weapon\\n- Space: Fire\\n- 1-5: Select weapons\\n\\nGameplay:\\n1. On your turn, position your soldier and aim at enemies\\n2. Watch the wind indicator - it affects projectile trajectory\\n3. Choose the right weapon for the situation\\n4. Fire and watch the destruction!\\n5. Eliminate all enemy soldiers to win",
    "sourceUrl": "https://gamedistribution.com/games/shell-strikers/"
  },
  {
    "id": "9d02893a1314432eaf578c18cc00c63a",
    "slug": "capybara-block-blast",
    "title": "Capybara Block Blast",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/9d02893a1314432eaf578c18cc00c63a-512x384.jpg",
    "description": "Capybara Block Blast is a cozy puzzle game where you blast blocks alongside the world’s chillest animal, the capybara! Match colorful block shapes, clear lines, and rack up points while enjoying adorable animations and relaxing vibes. Whether you’re chasing a high score or just unwinding, this game offers the perfect mix of challenge and comfort.",
    "publisher": "Orenji Spark",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-23T13:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Drag the left mouse button (PC) or finger (mobile) to move the block, and release to place it on the board.",
    "sourceUrl": "https://gamedistribution.com/games/capybara-block-blast/"
  },
  {
    "id": "3899157eb0094eba9624a41294624fe3",
    "slug": "arrow-out-and-linker",
    "title": "ARROW OUT AND LINKER",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/3899157eb0094eba9624a41294624fe3-512x512.jpg",
    "description": "ARROW OUT AND LINKER is a smart, direction-based puzzle game where every move counts. Your mission is to guide the arrow through intricate mazes and lead it to the exit.\\n\\nRotate tiles, shift paths, and think several steps ahead to build the perfect route. Each decision shapes the outcome, rewarding careful planning and sharp logic.",
    "publisher": "jimo game",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-23T13:14:33.231Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "easy to play. click on the arrows to move them and guide them out of the maze.\\nPlan your clicks carefully to find the correct path and reach the exit.",
    "sourceUrl": "https://gamedistribution.com/games/arrow-out-and-linker/"
  },
  {
    "id": "d6b4e05478464bdeb9f4f10f0f967165",
    "slug": "dear-island",
    "title": "Dear Island",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/d6b4e05478464bdeb9f4f10f0f967165-512x384.jpg",
    "description": "Collect two blocks that match the color of the Match Slot to clear them!\\nClear them all to finish the stage!\\nBlocks of different colors can be placed in the Stock.\\nIf the Stock gets full, it’s game over!",
    "publisher": "Synk Inc.",
    "languages": [
      "English",
      "Japanese"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-23T12:30:00.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Tap to move blocks.",
    "sourceUrl": "https://gamedistribution.com/games/dear-island/"
  },
  {
    "id": "41ced8bbf187495d81b565b663f94829",
    "slug": "basket-swap",
    "title": "Basket Swap",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/41ced8bbf187495d81b565b663f94829-512x512.jpg",
    "description": "Slide into the gray blocks to help you position the ball and grid correctly. If you're stuck, click on the arrow in the bottom left corner to undo your last move, or press R to restart the level.",
    "publisher": "kiz10.com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-23T08:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Use the mouse or touch to play",
    "sourceUrl": "https://gamedistribution.com/games/basket-swap/"
  },
  {
    "id": "6993cdc57b0f4255b17138325434c4ee",
    "slug": "coin-color-sort",
    "title": "Coin Color Sort",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/6993cdc57b0f4255b17138325434c4ee-512x384.jpg",
    "description": "Dive into the colorful world of Coin Color Sort, an addictive online puzzle game that puts your sorting skills to the test. Arrange and match coins by color to create perfect stacks and clear each level. With its relaxing yet challenging gameplay, this free game offers endless fun and mental exercise. Play anytime on your computer or phone and see how far your logic can take you!",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-23T08:25:00.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "- Tap and drag to move coins. You can only move coins of the same color. \\n- Only one color coin can be moved at one time.\\n- You can place a coin on top of another only if both are of the same color.\\n- Try to stack all coins of the same color together. \\n- Use your color matching skills to solve these fun logic puzzles.\\n- Enjoy thousands of levels for endless fun!",
    "sourceUrl": "https://gamedistribution.com/games/coin-color-sort/"
  },
  {
    "id": "c15832a0057346399182efb8bf29007c",
    "slug": "fruit-goals-match",
    "title": "Fruit Goals Match",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/c15832a0057346399182efb8bf29007c-512x384.jpg",
    "description": "Fruit Goals Match is a fun and strategic fruit-matching puzzle game where you collect specific fruits to complete each mission within limited moves. Every level brings a new challenge, rewards smart planning, and keeps the gameplay endless. Earn extra moves through reward ads and see how far you can progress.",
    "publisher": "Lof Games",
    "languages": [
      "Arabic",
      "Bulgarian",
      "Chinese (Simplified)",
      "Czech",
      "Danish",
      "Dutch",
      "English",
      "Estonian",
      "Finnish",
      "French",
      "German",
      "Greek",
      "Hebrew",
      "Hindi",
      "Hungarian",
      "Indonesian",
      "Italian",
      "Japanese",
      "Korean",
      "Latvian",
      "Lithuanian",
      "Polish",
      "Portuguese",
      "Romanian",
      "Russian",
      "Serbian",
      "Simple English",
      "Slovak",
      "Spanish",
      "Swahili",
      "Swedish",
      "Tagalog",
      "Thai",
      "Turkish",
      "Ukrainian",
      "Vietnamese"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-22T12:30:00.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use your mouse or touchpad to swap fruits and match three or more. Collect the target fruits within the given moves to complete the level and advance.",
    "sourceUrl": "https://gamedistribution.com/games/fruit-goals-match/"
  },
  {
    "id": "a34e900c52ba462e96c91fc7bc592bf4",
    "slug": "tap-away-block-puzzle-3d",
    "title": "Tap Away Block Puzzle 3D",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/a34e900c52ba462e96c91fc7bc592bf4-512x384.jpg",
    "description": "Challenge your mind with Tap Away Block Puzzle 3D! This relaxing logic game offers a satisfying brain teaser. Your mission: tap blocks to clear the screen. It's tricky blocks only move one way! Swipe to rotate the puzzle, find the right order, and watch them fly away. Puzzles get tougher as you go, perfect for training your brain. This free-to-play 3D puzzle is your ideal mental escape. Ready for the challenge? Start tapping now!",
    "publisher": "Mirra Games",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-22T08:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Swipe to rotate the puzzle.\\nTap blocks to send them away.\\nClear the board to win the level!\\nSolve puzzles to unlock new themes!\\nUse the Remover Power-up to instantly remove the block.",
    "sourceUrl": "https://gamedistribution.com/games/tap-away-block-puzzle-3d/"
  },
  {
    "id": "32cc670347b540758dfb363a4500023e",
    "slug": "melon-drop:-fruit-merge-master",
    "title": "Melon Drop: Fruit Merge Master",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/32cc670347b540758dfb363a4500023e-1280x720.jpg",
    "description": "Dive deep into the vibrant and enthralling world of fruit-matching with our exciting game, Fruit Merge: Juicy Drop Game! ??? When the same fruits collide, they merge into a larger fruit. Your mission is to smartly pair the same types of fruits to make the biggest possible fruits without letting them overflow from the container. However, as the fruits grow in size, space becomes a premium - managing it effectively is your key challenge. Can you strategize and solve this fruity puzzle?",
    "publisher": "Bravestars Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-22T08:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "? Challenge yourself and create a giant fruit! Start by merging two smaller fruits to eventually form a gigantic one. It’s a feat only 1% of players have achieved. Are you ready to join that elite group?",
    "sourceUrl": "https://gamedistribution.com/games/melon-drop:-fruit-merge-master/"
  },
  {
    "id": "ad01a468819748e7a9ce560dcfa4b5cf",
    "slug": "champions-fc",
    "title": "Champions FC",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/ad01a468819748e7a9ce560dcfa4b5cf-512x384.jpg",
    "description": "Champions FC is a fast-paced, bite-size soccer match where you dribble, pass, and time your kicks to break through defenders and score. Play two quick halves, react to turnovers, and keep the ball in bounds. Nail the perfect moment, hear the whistle, and become Champion.",
    "publisher": "MarketJS",
    "languages": [
      "English",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-21T08:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Quick-fire soccer game where you dribble, pass, and tap to kick at the perfect moment to score.",
    "sourceUrl": "https://gamedistribution.com/games/champions-fc/"
  },
  {
    "id": "326788adf09e40638bd55139a126ee09",
    "slug": "sweet-triple-mahjong",
    "title": "Sweet Triple Mahjong",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/326788adf09e40638bd55139a126ee09-512x384.jpg",
    "description": "Sweet Triple Mahjong is a relaxing yet challenging tile-matching puzzle game with a delicious candy theme. Match three identical tiles that are free on the left or right to collect them and clear the board. Each level introduces new tile layouts that test your observation and strategy skills. Easy to learn but hard to master, Sweet Triple Mahjong offers smooth gameplay, colorful visuals, and satisfying progression across multiple levels. ",
    "publisher": "Lof Games",
    "languages": [
      "Arabic",
      "Bulgarian",
      "Chinese (Simplified)",
      "Czech",
      "Danish",
      "Dutch",
      "English",
      "Estonian",
      "Finnish",
      "French",
      "German",
      "Greek",
      "Hebrew",
      "Hindi",
      "Hungarian",
      "Indonesian",
      "Italian",
      "Japanese",
      "Korean",
      "Latvian",
      "Lithuanian",
      "Polish",
      "Portuguese",
      "Romanian",
      "Russian",
      "Serbian",
      "Simple English",
      "Slovak",
      "Spanish",
      "Swahili",
      "Swedish",
      "Tagalog",
      "Thai",
      "Turkish",
      "Ukrainian",
      "Vietnamese"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-20T13:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Tap tiles that are free on the left or right and match three identical tiles to remove them from the board. Plan your moves carefully to avoid getting stuck and clear all tiles to finish the level and move to the next one.\\n\\n",
    "sourceUrl": "https://gamedistribution.com/games/sweet-triple-mahjong/"
  },
  {
    "id": "e29bfa7faaf1437b8808b83428b64f0a",
    "slug": "fishing-bear",
    "title": "Fishing Bear",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/e29bfa7faaf1437b8808b83428b64f0a-512x384.jpg",
    "description": "Tap to reel in your fishing line and catch as many fish as you can!\\nBut stay alert—mischievous creatures in the sea will try to get in your way.\\nAnd when you pick up a mysterious Treasure Shell… something exciting might happen!\\nEnjoy a simple and addictive fishing experience!",
    "publisher": "Synk Inc.",
    "languages": [
      "English",
      "Japanese"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-20T09:44:52.589Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Tap to reel in fishing line.",
    "sourceUrl": "https://gamedistribution.com/games/fishing-bear/"
  },
  {
    "id": "c07b3857103b41d5b3ca5ae0401027eb",
    "slug": "winter-maze",
    "title": "Winter Maze",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/c07b3857103b41d5b3ca5ae0401027eb-512x512.jpg",
    "description": "Step into a frosty puzzle adventure with Winter Maze! Explore icy, snow-covered mazes and guide your ball through slippery, twisty paths that fill up with every move. Each level challenges you to think ahead, plan your route and clear the entire field to unlock the next stage.\\nSimply swipe to roll the ball in any direction and watch the maze come to life beneath you. Your goal is clear: cover every tile and leave no space untouched. ",
    "publisher": "GameBerry Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-20T09:43:27.382Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Swipe the ball in any direction. Fill up every corner of the maze and leave no space untouched!",
    "sourceUrl": "https://gamedistribution.com/games/winter-maze/"
  },
  {
    "id": "62c37b5a4fb041d9a72e116d2ce90313",
    "slug": "try-to-count-the-boxes-brain-training",
    "title": "Try To Count The Boxes Brain Training",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/62c37b5a4fb041d9a72e116d2ce90313-512x384.jpg",
    "description": "Challenge your memory, speed and attention in \\",
    "publisher": "Mirra Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-20T08:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Watch a set of boxes appear briefly and memorize the total. When they vanish, tap to increase your guess or type the number, then press Done.\\n\\nSingle-player: beat your time and accuracy.\\nMultiplayer/local: play 20 rounds highest accuracy wins.\\n\\nSimple taps, short rounds, perfect for training memory, attention and reaction on desktop \\u0026 mobile.",
    "sourceUrl": "https://gamedistribution.com/games/try-to-count-the-boxes-brain-training/"
  },
  {
    "id": "401c33a42c214cb09ce67ac097426ef4",
    "slug": "funny-doctor-emergency",
    "title": "Funny Doctor Emergency",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/401c33a42c214cb09ce67ac097426ef4-512x384.jpg",
    "description": "Do you want to be a doctor? In Funny Doctor Emergency, you treat patients in cute and funny emergencies. Patients come in many ages and situations. Every patient needs a different treatment. Choose the correct tool from the options to treat each problem. Follow simple steps to help patients recover and smile again. Watch them feel better after treatment. This game is playful and easy to enjoy.",
    "publisher": "iclickgames",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-19T08:39:58.398Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use MOUSE to play the game.",
    "sourceUrl": "https://gamedistribution.com/games/funny-doctor-emergency/"
  },
  {
    "id": "7ce6f365c8d1433c862b2d6917d4c6b3",
    "slug": "going-balls-3d",
    "title": "Going Balls 3D",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/7ce6f365c8d1433c862b2d6917d4c6b3-512x384.jpg",
    "description": "Going Balls 3D is a relaxing 3D rolling game where smooth control and calm focus are the key to winning. Swipe to steer the wooden platform and guide the ball forward—no need to rush, just keep it steady and reach the finish line without falling.",
    "publisher": "Raccoon",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-19T08:38:02.450Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Desktop:\\nClick \\u0026 drag / Hold left mouse and move – Tilt/steer the platform to move the ball.\\nLeft click UI buttons – Start, restart, open shop, buy balls.\\nMobile / Touch:\\nSwipe / drag finger – Tilt/steer the platform to roll the ball.\\nTap – Use UI buttons, open shop, purchase balls.",
    "sourceUrl": "https://gamedistribution.com/games/going-balls-3d/"
  },
  {
    "id": "0f34626576354c7cb131c2e1fb4b8ae6",
    "slug": "wild-west-match-3",
    "title": "Wild West Match 3",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/0f34626576354c7cb131c2e1fb4b8ae6-1280x720.jpg",
    "description": "Saddle up for a Wild West adventure in Bubble Shooter Wild West! Join Sheriff Bonnie as you pop colorful bubbles to defend your frontier town. Travel through dusty deserts, lively saloons, and scenic canyons while enjoying toe-tapping country tunes. Track your progress with detailed stats showing your best, current, and previous scores across Novice, Expert, and Master modes. With its vibrant Western visuals and exciting challenges, this bubble shooter brings cowboy spirit to every pop!",
    "publisher": "SOFTGAMES – Mobile Entertainment Services GmbH",
    "languages": [
      "Dutch",
      "English",
      "French",
      "German",
      "Italian",
      "Polish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-19T08:36:30.729Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "Aim the cannon with the arrow and shoot bubbles to match 3 or more of the same color. The middle bubble shows your current shot, and the bottom-left bubble shows the next one. Clear bubbles to stop the stack from reaching the bottom. Missed shots add fouls, and new rows appear when grey bubbles run out. Use the Swap booster to change your current bubble, the Fireball to blast through obstacles, and rely on Second Chances and Last Chances to keep playing and reach higher scores!",
    "sourceUrl": "https://gamedistribution.com/games/wild-west-match-3/"
  },
  {
    "id": "8f816c3350d043b1ab2a2ac63edde2d9",
    "slug": "avatar-world-secrets",
    "title": "Avatar World Secrets",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/8f816c3350d043b1ab2a2ac63edde2d9-512x384.jpg",
    "description": "Dive into various cute items, design the room setting, dress up your avatar family, and make up a life story as you like. Enjoy the fun interaction with items and characters online.",
    "publisher": "Yiv.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-18T15:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Mouse click or tap to play",
    "sourceUrl": "https://gamedistribution.com/games/avatar-world-secrets/"
  },
  {
    "id": "e8e7f97933894e0c92422ec237d66d14",
    "slug": "bubble-shooter:-spinner-pop",
    "title": "Bubble Shooter: Spinner Pop",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/e8e7f97933894e0c92422ec237d66d14-512x512.jpg",
    "description": "Take the classic bubble shooter to a new level! Bubble Shooter: Spinner Pop features a rotating puzzle core that rewards smart aiming and chain reactions. \\nClear all bubbles to complete each level and earn up to 3 stars (10 pts per direct match, 20 pts for freed bubbles).\\nBeware the deadly Magma Vortex, and avoid fouls that add extra bubbles for missed matches!",
    "publisher": "Pictofun",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Portuguese",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-15T09:19:08.628Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Tap, click, or drag to aim and shoot bubbles. Match 3 or more of the same color to clear them!",
    "sourceUrl": "https://gamedistribution.com/games/bubble-shooter:-spinner-pop/"
  },
  {
    "id": "05017bab2dbe4802968bf84231e08e24",
    "slug": "mergeduel.io",
    "title": "MergeDuel.io",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/05017bab2dbe4802968bf84231e08e24-512x384.jpg",
    "description": "Merge Duel is a fast-paced 1v1 battle game where strategy and quick decisions lead to victory. Merge and upgrade your cannons to summon powerful units and counter your opponent in real time. Every match challenges your tactical skills as you adapt to new enemies and situations. Climb the ranks, dominate the leaderboard, and enjoy vibrant visuals, smooth controls, and intense duels from start to finish.",
    "publisher": "Mao Games",
    "languages": [
      "English",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-08T11:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Controls:\\nUse the left mouse button to interact with in-game buttons and drag the same-numbered cannon to merge them.",
    "sourceUrl": "https://gamedistribution.com/games/mergeduel.io/"
  },
  {
    "id": "63d4d52b56da44b1acaf2c957ee3d04f",
    "slug": "anna's-story:-dress-up-diy",
    "title": "Anna's Story: Dress Up DIY",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/63d4d52b56da44b1acaf2c957ee3d04f-1280x720.jpg",
    "description": "Style Anna’s outfits and bring her fairy tale story to life!\\n\\nAnna's Story: Dress Up DIY takes you into a magical world of creativity and fashion! In this charming paper doll game, you’ll help Anna dress up for a variety of occasions, from costume parties and romantic dates to festive holidays like Halloween and Christmas.",
    "publisher": "Bravestars Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-06T09:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Unleash your imagination and craft unique looks for Anna. Save your favorite designs and share them with friends to spread the fun!",
    "sourceUrl": "https://gamedistribution.com/games/anna's-story:-dress-up-diy/"
  },
  {
    "id": "0ea7b7e7316a47c38ac5c98ddd42ec4a",
    "slug": "color-water-puzzle",
    "title": "Color Water Puzzle",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/0ea7b7e7316a47c38ac5c98ddd42ec4a-512x384.jpg",
    "description": "Color Water Puzzle is a fun and addictive puzzle game! The goal is simple yet challenging: try to sort the colored water in the glasses until all colors are in the same glass.\\n\\nIt’s not just a game; it's a great way to relieve stress and exercise your logic. With vibrant colors and smooth pouring effects, this is the best choice to kill time and relax your mind.\\n\\nAre you smart enough to solve all the levels? Download now and find out!",
    "publisher": "Big Wave",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-06T06:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Tap any glass to pour water into another glass.\\nThe Rule: You can only pour the water if it is linked to the same color and there is enough space in the target glass.\\nDon't get stuck: Try not to get stuck - but don't worry, you can always restart the level at any time.\\nAdd a Glass: If the level is too hard, you can use a prop to add an extra glass to help you pass.",
    "sourceUrl": "https://gamedistribution.com/games/color-water-puzzle/"
  },
  {
    "id": "df5433fc3acb43f69dce225d7eb3b4fc",
    "slug": "woods-of-nevia:-forest-survival",
    "title": "Woods of Nevia: Forest Survival",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/df5433fc3acb43f69dce225d7eb3b4fc-512x384.jpg",
    "description": "Woods of Nevia: Forest Survival is a one-tap action adventure where you battle and survive in the wild. Wield your axe to fend off wolves, chop wood, and build shelter as you explore for resources and hidden chests. Level up, choose upgrades, and outlast growing dangers while managing hunger and health in this engaging forest challenge.",
    "publisher": "Mirra Games",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-05T10:22:07.928Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Controls\\nLeft mouse button = move or interact with the game UI \\nWASD or arrow keys = move ",
    "sourceUrl": "https://gamedistribution.com/games/woods-of-nevia:-forest-survival/"
  },
  {
    "id": "b51341f2f9ab4bc09b23312b5bff30cb",
    "slug": "ice-cube",
    "title": "Ice Cube",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/b51341f2f9ab4bc09b23312b5bff30cb-512x512.jpg",
    "description": "Ice Cubes is a Blast (or Collapse) type Match-3 game. Don't be fooled by its cool appearance... this game requires nerves of steel to achieve the best score in just 1 minute and 30 seconds.\\n\\n",
    "publisher": "StoreRider",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Japanese",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-05T10:21:04.405Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Break the ice cubes in groups of the same color of three or more! The more cubes you break at once, the more points you'll get. Be quick to fill the gauge at the bottom and trigger a multiplier bonus on the board. Collect them to multiply your score. Also, collect the bombs and line/column destructors power-ups to destroy even more cubes!\\n\\nYou'll be penalized if you click on a block that is not part of a group of three or more.",
    "sourceUrl": "https://gamedistribution.com/games/ice-cube/"
  },
  {
    "id": "ee57ac72ac07468cbefcfdde8ed90f12",
    "slug": "hidden-object:-emily's-case",
    "title": "Hidden Object: Emily's Case",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/ee57ac72ac07468cbefcfdde8ed90f12-512x512.jpg",
    "description": "A detective adventure set in Victorian London.\\n\\nSearch for hidden objects, uncover clues, and investigate the disappearance of a young girl. Solve puzzles, play mini-games, and step by step reveal the secrets of the old city.\\n",
    "publisher": "GamePush",
    "languages": [
      "Arabic",
      "Chinese (Simplified)",
      "English",
      "French",
      "German",
      "Hindi",
      "Indonesian",
      "Italian",
      "Japanese",
      "Korean",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-04T16:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Use the mouse wheel or touchscreen to zoom and move around the level\\nFind the objects listed in your objectives\\nFollow the on-screen hints\\nYou can skip a puzzle or highlight a hard-to-find item by watching an ad — just tap the lightbulb icon on the objectives panel",
    "sourceUrl": "https://gamedistribution.com/games/hidden-object:-emily's-case/"
  },
  {
    "id": "aae863521713496ea30d960e73ec2d0a",
    "slug": "running-in-foam",
    "title": "Running In Foam",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/aae863521713496ea30d960e73ec2d0a-512x384.jpg",
    "description": "Welcome to the wonderful world of \\",
    "publisher": "XMetaGame",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-04T14:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "- Swipe up to jump.\\n- Swipe down to slide.\\n- Swipe left or right to change lanes and dodge obstacles.",
    "sourceUrl": "https://gamedistribution.com/games/running-in-foam/"
  },
  {
    "id": "f36a6390bf564d399de011973bf87c9b",
    "slug": "idle-money-factory",
    "title": "Idle Money Factory",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/f36a6390bf564d399de011973bf87c9b-512x512.jpg",
    "description": "Money Factory is a fast-paced clicker game with strategic elements where you build and expand your financial empire by optimizing money production lines. Start with a simple setup and gradually grow by upgrading equipment, unlocking new production areas, and enhancing efficiency to skyrocket your profits.",
    "publisher": "TopKeyGames",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-04T11:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Upgrade Production Lines – Boost profit output with each upgrade.\\nEnhance Machines – Improve equipment to maximize efficiency.\\nUnlock New Sections – Expand your factory to increase production capacity.\\nCollect Profits – Tap the screen to gather money faster and trigger bonuses.",
    "sourceUrl": "https://gamedistribution.com/games/idle-money-factory/"
  },
  {
    "id": "8325076236e64adb85d71ee1a57dfb44",
    "slug": "cosmos-404",
    "title": "Cosmos 404",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/8325076236e64adb85d71ee1a57dfb44-512x512.jpg",
    "description": "Explore the galaxy in Cosmos 404! Run across procedurally generated tiny planets, collect coins, and dodge hostile aliens. Use power-ups like Speed Boost and Magnet to survive longer. How far can you go in this addictive low-poly space adventure?",
    "publisher": "LagShock",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-04T11:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Desktop: Use Arrow Keys or WASD to move.\\nMobile: Use the on-screen Joystick to run.\\nCollect coins to unlock new planets. Avoid enemies!",
    "sourceUrl": "https://gamedistribution.com/games/cosmos-404/"
  },
  {
    "id": "b44c79264a104857b02063703691ec58",
    "slug": "chicken-jump-:-a-tap-challenge",
    "title": "Chicken Jump : A Tap Challenge",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/b44c79264a104857b02063703691ec58-512x384.jpg",
    "description": "This is simple but addictive chicken jump game. You'll have lots of levels and you have to save your chicken but swiping on screen from bottom to up to make chicken jump so that it can avoid hurdles.",
    "publisher": "TheBottle",
    "languages": [
      "English"
    ],
    "mobile": [],
    "firstActiveDate": "2026-01-04T11:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "HTML5",
      "WebGL"
    ],
    "instructions": "You have to focus on the chicken because if you make the chicken jump on wrong time then it will fall on the hurdle.",
    "sourceUrl": "https://gamedistribution.com/games/chicken-jump-:-a-tap-challenge/"
  },
  {
    "id": "c9d8c01e381549ccb12942b0e9e96c18",
    "slug": "perfect-tidy",
    "title": "Perfect Tidy",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/c9d8c01e381549ccb12942b0e9e96c18-512x384.jpg",
    "description": "Welcome to Perfect Tidy, a simple and relaxing cleaning simulator game that you can play for free. Are you good at cleaning work? Searching for something that is stress-relieving? Join Perfect Tidy, where you can dive into multiple cleaning tasks: Car washing, skin care, teeth fixing, pet care, and more. Unlike cleaning in real life, all you have to do in the game is click, drag, and enjoy the present moment.",
    "publisher": "Yiv.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-04T11:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/perfect-tidy/"
  },
  {
    "id": "99b5f30d028d40df825363d98fa5831f",
    "slug": "craft-of-wars",
    "title": "Craft of Wars",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/99b5f30d028d40df825363d98fa5831f-1280x550.jpg",
    "description": "The war between the Reds and the Blues has never been more epic than in Craft of Wars! In this cubic game, you'll fight for strategic points on the map using a classic combat system similar to the one found in older versions of Minecraft. Prepare for intense sword and bow duels, TNT explosions, tactical use of potions, and the legendary golden apples that will help you survive the fiercest battles.",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-04T11:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "PC controls:\\nW, A, S, D - movement;\\nMouse - view;\\nleft mouse button - strike / shot / use.\\nright mouse button - defense.\\n1,2,3 - change weapons.\\nF - pick up an item.\\n\\nControl on a smartphone: use the stick to control the character, the camera control is on the right side of the screen, there are also buttons for aiming and changing weapons.",
    "sourceUrl": "https://gamedistribution.com/games/craft-of-wars/"
  },
  {
    "id": "71d6c5b55b404b1985086b70b8f58dc3",
    "slug": "3d-maze-control",
    "title": "3D Maze Control",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/71d6c5b55b404b1985086b70b8f58dc3-512x384.jpg",
    "description": "3D Maze Control is a casual and fun puzzle physics game. Your goal is to rotate the board to let the ball reach its goal. The ball always falls down due to gravity and beware of scary aliens on the way.",
    "publisher": "Fun Best Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-04T10:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use your mouse or tap the screen to rotate the board.",
    "sourceUrl": "https://gamedistribution.com/games/3d-maze-control/"
  },
  {
    "id": "b4a4ac342c814e08b1cb9cec42bffa24",
    "slug": "void-orbit",
    "title": "Void Orbit",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/b4a4ac342c814e08b1cb9cec42bffa24-512x512.jpg",
    "description": "Void Orbit is an addictive space arcade game where you orbit a central core and dodge incoming enemies. Tap to reverse direction and survive as long as possible! Unlock cool skins, dynamic themes, enjoy challenging modes like Echo Mirage and Tower Build. Multi-language support for global players. Free to play, endless fun!",
    "publisher": "Neloyann",
    "languages": [
      "English",
      "French",
      "German",
      "Japanese",
      "Korean",
      "Portuguese",
      "Russian",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-04T10:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Tap the screen to reverse your orbit direction, collect points by avoiding enemies. Use rewarded ads to revive or double your score. Explore the shop for skins and themes. Switch modes in the menu for new challenges.",
    "sourceUrl": "https://gamedistribution.com/games/void-orbit/"
  },
  {
    "id": "285373716433410bbd6ecf58c3fedefb",
    "slug": "grass-defense",
    "title": "Grass Defense",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/285373716433410bbd6ecf58c3fedefb-512x384.jpg",
    "description": "Grass Defense is a strategic tower defense where you must protect the wilderness from waves of fierce creatures. Build and upgrade powerful towers, manage resources, and adapt your tactics as enemies grow stronger. With dynamic environments, diverse foes, and challenging levels, you’ll test your strategy and skill to survive the untamed wilds and uncover hidden mysteries.",
    "publisher": "Ultra Games Entertainment Private limited",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-04T10:05:08.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Use the left mouse button to interact",
    "sourceUrl": "https://gamedistribution.com/games/grass-defense/"
  },
  {
    "id": "8e840dd0911d477285550601a87385b4",
    "slug": "animal-blocks",
    "title": "Animal Blocks",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/8e840dd0911d477285550601a87385b4-512x384.jpg",
    "description": "Enter the colorful and cheerful world of Animal Blocks, where adorable creatures bring classic block puzzles to life. Match three or more of the same animal blocks to clear the board, earn points, and climb to higher scores. Simple to play yet full of fun challenges, this free online game is perfect for both mobile and desktop players who enjoy relaxing, strategic gameplay and charming visuals.",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-04T10:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "- Match 3 or more animals to get points, when matching consecutive combinations, the points will be multiplied many times\\n- Animal theme: The blocks have cute animal designs, adding visual appeal to the classic block puzzle genre.\\n- Scoring and progression: Players earn points when matching 3 or more blocks, and the higher the score, the more difficult it is\\n",
    "sourceUrl": "https://gamedistribution.com/games/animal-blocks/"
  },
  {
    "id": "60cc69e078184c63bf3568d975c348a4",
    "slug": "parking-driver",
    "title": "Parking Driver",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/60cc69e078184c63bf3568d975c348a4-512x384.jpg",
    "description": "Ever struggled to find a parking spot? In \\",
    "publisher": "wavegame",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-03T14:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "- Use the steering wheel/virtual joystick to control the vehicle's direction.\\n- Tap the accelerator/brake pedals to control speed.\\n- Switch between Drive and Reverse gears to complete parking.",
    "sourceUrl": "https://gamedistribution.com/games/parking-driver/"
  },
  {
    "id": "adf4409718e84d05b69e0dcf31b7e916",
    "slug": "gold-miner-classic",
    "title": "Gold Miner Classic",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/adf4409718e84d05b69e0dcf31b7e916-512x384.jpeg",
    "description": "Go mining for gold Upgrade your skills so that you can make more money",
    "publisher": "DAB3Games",
    "languages": [],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2018-05-17T11:03:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 2"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "HTML5",
      "Construct 2"
    ],
    "instructions": "",
    "sourceUrl": "https://gamedistribution.com/games/gold-miner-classic/"
  },
  {
    "id": "a497f71f7ff64128bb9f3d4f7a58dddc",
    "slug": "stick-master-teleport",
    "title": "Stick Master Teleport",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/a497f71f7ff64128bb9f3d4f7a58dddc-512x512.jpg",
    "description": "Jump onto walls, throw knives, and teleport to your enemies ⚔️ to defeat them with a single strike.\\nProve your ninja reputation by eliminating bad guys before they even notice.\\nWalk the tough path of a ninja to become a true ninja assassin!",
    "publisher": "GamePush",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-03T10:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "PC Controls:\\nHold the left mouse button and move the mouse to aim;\\nRelease the left mouse button to shoot.\\n\\nMobile Controls:\\nHold your finger on the screen and move it to aim;\\nRelease your finger from the screen to shoot!",
    "sourceUrl": "https://gamedistribution.com/games/stick-master-teleport/"
  },
  {
    "id": "7a83d41c26c54898892c807492494f21",
    "slug": "aqua-sort:-water-color-puzzle",
    "title": "Aqua Sort: Water Color Puzzle",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/7a83d41c26c54898892c807492494f21-512x512.jpg",
    "description": "Dive into the relaxing world of Aqua Sort: Water Color Puzzle! Your goal is simple: sort the colored liquids into the flasks until each flask contains only one color. With over 1000 levels and unique modes like Color Fusion, Mystery, and Time Trial, this puzzle game will test your logic and patience. Unlock new themes and achievements as you play!",
    "publisher": "Bouraoui Game",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-03T10:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "1-Tap a flask to pick up the top liquid.\\n2-Tap another flask to pour it.\\n3-You can only pour liquid onto another liquid of the same color or into an empty flask.\\n4-Use \\",
    "sourceUrl": "https://gamedistribution.com/games/aqua-sort:-water-color-puzzle/"
  },
  {
    "id": "5ca38504001d4177bce9e5651d267a5d",
    "slug": "fruit-catcher",
    "title": "Fruit Catcher",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/5ca38504001d4177bce9e5651d267a5d-512x384.jpg",
    "description": "Catch as many fruits as you can before they fall! ?\\nMove your basket left and right to collect fresh fruits and avoid rotten ones. Each fruit gives you points — how high can your score go?\\nThis fun and colorful game tests your reflexes and speed. Perfect for kids and casual players who love simple but addictive gameplay!\\n",
    "publisher": "abdeljalilhaddo",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-03T10:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "? Instructions:\\n\\n?️ PC: Click on the basket and move your mouse to drag it left or right.\\n? Mobile: Tap and drag the basket with your finger to move and catch the fruits.\\n? Catch all the fruits — don’t miss any!",
    "sourceUrl": "https://gamedistribution.com/games/fruit-catcher/"
  },
  {
    "id": "88054792cbec475bbf405fc15a478369",
    "slug": "memory-lane",
    "title": "Memory Lane",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/88054792cbec475bbf405fc15a478369-512x512.jpg",
    "description": "Your goal in each level is to reach the Goal Platform. Levels are played in two phases.\\nA. Reveal Phase:\\nDuration: Short preview at the start of each level\\n•\\tAll platforms become visible.\\n•\\tStudy the layout, paths, traps, and pickups.\\nYour task: Remember what you see\\n\\nB. Action Phase:\\n•\\tAll memory phase platforms become invisible unless they are marked to stay visible.\\n•\\tTouching platforms reveals them permanently.\\nYour task: Reach the goal using your memory and reflexes.",
    "publisher": "Zenida Studios",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-03T09:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Movement\\n•\\tLeft / Right: A/D or Left/Right Arrow keys\\n•\\tJump: Tap space once to jump\\n•\\tHold space for a higher jump arc\\n•\\tDouble Jump available only when powered up\\nMobile Controls\\nTouch buttons appear automatically on mobile devices.",
    "sourceUrl": "https://gamedistribution.com/games/memory-lane/"
  },
  {
    "id": "ad85d363343e47b5b396d086b9087d82",
    "slug": "3d-kid-sliding-puzzle",
    "title": "3D Kid Sliding Puzzle",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/ad85d363343e47b5b396d086b9087d82-512x384.jpg",
    "description": "We've taken the classic sliding puzzle into a whole new 3D world. Kids will need to slide the scrambled blocks to rearrange them and complete adorable cartoon pictures, such as little animals, vehicles, and fairy-tale characters. The game features vibrant colors and lively 3D models that will immediately capture a child's attention. Not only does it provide hours of fun, but it also helps develop a child's logical thinking, spatial awareness, and problem-solving skills. ",
    "publisher": "wavegame",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-03T09:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "- Tap or drag the block you want to move into the empty space.\\n- Move all blocks to their correct positions to complete the puzzle.",
    "sourceUrl": "https://gamedistribution.com/games/3d-kid-sliding-puzzle/"
  },
  {
    "id": "ddc202e7d252451f8d1344f9f0e455ef",
    "slug": "the-zombie-house",
    "title": "The Zombie House",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/ddc202e7d252451f8d1344f9f0e455ef-512x384.jpg",
    "description": "Protect your home from endless waves of zombies!\\nDefeat zombies to collect coins and ability drops.\\nUse coins to upgrade both your player and your house.\\nEach level makes the zombies stronger.\\nHow long can you survive?",
    "publisher": "Nabil Smriti",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-03T09:35:05.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "PC : Move with WASD and click on zombies to shoot in that direction.\\n\\nMobile : Use the left joystick to move and the right joystick to aim \\u0026 shoot.",
    "sourceUrl": "https://gamedistribution.com/games/the-zombie-house/"
  },
  {
    "id": "7b052821764b406d83f41d3e416227ee",
    "slug": "color-sort:-impostor-edition",
    "title": "Color Sort: Impostor Edition",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/7b052821764b406d83f41d3e416227ee-512x384.jpg",
    "description": "Color Sort Impostor Edition is a fun and relaxing puzzle game that challenges your logic and focus. Sort the colorful characters into the correct tubes so that each tube contains only one color. The rules are simple, but the puzzles quickly become more challenging as new colors and obstacles appear. Plan your moves carefully, avoid mistakes, and enjoy a smooth, satisfying sorting experience designed for players of all ages.",
    "publisher": "HyHyGames",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-03T08:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Follow the game instructions!",
    "sourceUrl": "https://gamedistribution.com/games/color-sort:-impostor-edition/"
  },
  {
    "id": "8fa04f140aca416091796b743add1821",
    "slug": "draw-to-smash-zombie",
    "title": "Draw To Smash Zombie",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/8fa04f140aca416091796b743add1821-512x384.jpg",
    "description": "Draw To Smash Zombie is an exciting drawing logic puzzle game where your creativity becomes the ultimate weapon against waves of silly zombies.",
    "publisher": "PuzzleGame.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-02T14:10:09.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/draw-to-smash-zombie/"
  },
  {
    "id": "8d477a23de1743198aca29f1893c6be6",
    "slug": "snake-masters",
    "title": "Snake Masters",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/8d477a23de1743198aca29f1893c6be6-512x512.jpg",
    "description": "Control a small worm and get ready to reach the other side of the screen. Enjoy a puzzle inspired by the classic Snake, where you must guide the worm to the other side of the apple and escape safely. Will you be smart enough to beat all thirty levels?\\n\\nGame Features\\n- Special crawling mechanics.\\n- Challenge your brain.\\n- Tons of interesting puzzles.\\n- Easy controls. ",
    "publisher": "kiz10.com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-02T14:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Use the keyboard or touch to play",
    "sourceUrl": "https://gamedistribution.com/games/snake-masters/"
  },
  {
    "id": "1fbe41ffdb1f4a61a6d7ce03bb4ad02a",
    "slug": "card-solitaire:-word-game",
    "title": "Card Solitaire: Word Game",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/1fbe41ffdb1f4a61a6d7ce03bb4ad02a-1280x720.jpg",
    "description": "Train your brain in a fun new way with Card Solitaire: Word Game — a clever blend of card sorting, word puzzles, and logic challenges!\\nExplore the exciting world of word solitaire, packed with clever associations, tricky word sort levels, and fun topic sort puzzles.",
    "publisher": "Bravestars Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-02T13:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Your task is simple: sort every card into the right category before you run out of moves. Some cards show images, others words — find the connection and make the match! Each level tests your vocabulary, logic, and strategy in new ways.\\nThink carefully, plan ahead, and clear all the cards to become a true word sort master. Whether it’s fruits, animals, objects, or abstract ideas — every puzzle offers a fresh topic sort challenge.",
    "sourceUrl": "https://gamedistribution.com/games/card-solitaire:-word-game/"
  },
  {
    "id": "a1d4210845b540cd8736054c5232e454",
    "slug": "block-blast-jewel-puzzle",
    "title": "Block Blast Jewel Puzzle",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/a1d4210845b540cd8736054c5232e454-512x384.jpg",
    "description": "Block Blast: Jewel Puzzle is a vibrant block-stacking game that mixes calm strategy with thrilling speed. Fit jewel blocks to clear lines in Classic, Timer, or Level modes. Easy to start, tough to master, and super satisfying—compete worldwide and climb the leaderboard!",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-02T12:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Drag blocks into the grid to complete full rows or columns; completed lines vanish and you score. Keep space open and plan smart combos. In Timer mode, think fast before the clock hits zero; in Level mode, finish each stage goal. PC: mouse/touchpad. Mobile: tap \\u0026 drag.",
    "sourceUrl": "https://gamedistribution.com/games/block-blast-jewel-puzzle/"
  },
  {
    "id": "343ae1f841604180b7b4cf511da9ab5b",
    "slug": "crab-guards",
    "title": "Crab Guards",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/343ae1f841604180b7b4cf511da9ab5b-1280x720.jpg",
    "description": "Fight through waves of relentless crab-masked enforcers using a deep arsenal—from AKs and SMGs to sniper rifles, shotguns, pistols, flamethrowers, and melee. Master recoil, ADS zoom, and reload timing, earn cash, unlock new gear, and survive through the Crab Guards.",
    "publisher": "MarketJS",
    "languages": [
      "English",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-02T11:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Shoot your way past relentless crab-masked guards with a stacked arsenal in this fast-paced FPS game.",
    "sourceUrl": "https://gamedistribution.com/games/crab-guards/"
  },
  {
    "id": "0904d5fb5d0044fe9fddf1cd5834cff2",
    "slug": "coffee-color-blocks",
    "title": "Coffee Color Blocks",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/0904d5fb5d0044fe9fddf1cd5834cff2-512x512.jpg",
    "description": "Coffee Color Blocks is a bright and relaxing puzzle game where you move colored shapes around the board and guide them to gates of the matching color. Each correct connection fills the cups inside the shape — your goal is to fill the entire figure without blocking the path.",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-02T10:51:45.643Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Move the blocks. Tap and slide shapes across the board to bring them to gates of the same color.\\nMatch colors. A block fills only when it reaches its matching gate — this fills the cups inside.\\nFill the whole shape. Complete the level by filling every segment of the figure.\\nAvoid dead ends. Think ahead — some blocks can block others if moved carelessly.\\nProgress and unlock mechanics. Each level introduces new shapes, colors and puzzles to solve.",
    "sourceUrl": "https://gamedistribution.com/games/coffee-color-blocks/"
  },
  {
    "id": "1ee9ed26b53d494ba5f57defe225052e",
    "slug": "merge-smith",
    "title": "Merge Smith",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/1ee9ed26b53d494ba5f57defe225052e-1280x550.jpg",
    "description": "If you combine the same items, a higher level of items will be created.\\nMake legendary items and become the best blacksmith.",
    "publisher": "MOVISOFT.Co.,Ltd",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2026-01-02T09:59:51.191Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Combine two identical weapons to create a stronger weapon. The more powerful weapons you accumulate, the more money you can earn.",
    "sourceUrl": "https://gamedistribution.com/games/merge-smith/"
  },
  {
    "id": "f0c5b50ba79b45e7a415514697fd841c",
    "slug": "fish-master:-go-fish",
    "title": "Fish Master: Go Fish",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/f0c5b50ba79b45e7a415514697fd841c-512x512.jpg",
    "description": "You’d think that a game called Go Fish would be based on the classic card game, but you’d be wrong. Fish Master – Go Fish is all about taking your ship to the middle of the sea and fishing until your boat can’t hold any more fish!\\n\\nThere are dozens of different fish types in the sea, and it’s your job to reel them all in! As you catch fish, your library of fish types will fill up, so you’ll always know what’s left to catch. ",
    "publisher": "Bravestars Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-31T08:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": " In Fish Master, you actively hunt fish by throwing your spear at them. Don’t worry—no actual fish are harmed when you pull them out of their habitat to add to your collection!",
    "sourceUrl": "https://gamedistribution.com/games/fish-master:-go-fish/"
  },
  {
    "id": "bdb160e732fb44179c3691e5d934c6a2",
    "slug": "popcat-clicker",
    "title": "Popcat Clicker",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/bdb160e732fb44179c3691e5d934c6a2-512x384.jpg",
    "description": "Popcat Clicker is a fun idle clicker game where you tap a cute cat to earn coins, unlock upgrades, boost your income, and progress through different levels. \\nThe more you tap, the faster your cat grows and the more rewards you earn.\\nSimple, addictive and perfect for all ages!\\n",
    "publisher": "PCC",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-30T12:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Click on the cat to earn coins. \\nUse your coins to buy upgrades and boosters.\\nUnlock new features as you progress.\\n",
    "sourceUrl": "https://gamedistribution.com/games/popcat-clicker/"
  },
  {
    "id": "9cba53fc9a78499cb3b9558cd324f63a",
    "slug": "treasure-champion-chest-capture",
    "title": "Treasure Champion - Chest Capture",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/9cba53fc9a78499cb3b9558cd324f63a-512x384.jpg",
    "description": "Dive into the exciting world of stickmen in this exciting team game! Your task is to capture the chest in the center of the field and deliver it to the base together with your team, avoiding traps and tricky moves of your opponents. Each successfully delivered chest brings points, and the dynamics of the game keep you in suspense until the last second.",
    "publisher": "Mirra Games",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Polish",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-30T10:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Kids",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "The goal of the game is to capture the chest in the center of the field and deliver it to your base. If the chest remains at the base for 3 seconds, the team gets a point. You can also knock out chests from opponents and take them from the base.\\n\\nMobile device controls: touch/swipe.\\nDesktop controls: LMB.",
    "sourceUrl": "https://gamedistribution.com/games/treasure-champion-chest-capture/"
  },
  {
    "id": "057fc19997e5437f9f32f5ae0c172a4e",
    "slug": "elementz",
    "title": "Elementz",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/057fc19997e5437f9f32f5ae0c172a4e-512x384.jpg",
    "description": "ElementZ is a Match-3 game similar to Bejeweled or Candy Crush. Its particularity lies in giving each color its elemental power, allowing you to trigger different powers of fire (red), water (blue), earth (brown), plants (green), and electricity (yellow).",
    "publisher": "StoreRider",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Japanese",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-30T08:03:04.169Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Both",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Click in the space between adjacent orbs, or drag from one to another, to swap them. Make alignments of 3 orbs (or more) of the same color. ",
    "sourceUrl": "https://gamedistribution.com/games/elementz/"
  },
  {
    "id": "5cdec698c5ce4e66af14ea5b3968ef08",
    "slug": "pinball-vs-zombie",
    "title": "Pinball VS Zombie",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/5cdec698c5ce4e66af14ea5b3968ef08-512x384.jpg",
    "description": "Dive into Pinball Zombie Defense, the ultimate fusion of pinball chaos and zombie tower defense! Plant defensive flora to create a ricocheting battlefield where high-speed pinballs smash into plants, unleashing bullet barrages on undead waves. Auto-collect sunlight to grow stronger defenses and hold the line—don't let a single zombie reach your house!",
    "publisher": "Big Wave",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-30T07:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Tap to Plant: Spend sunlight to place plants on the grid.\\nAuto-Collect: Sunlight gathers automatically—watch your meter!",
    "sourceUrl": "https://gamedistribution.com/games/pinball-vs-zombie/"
  },
  {
    "id": "57e902262bb44868ac967456484ae4bb",
    "slug": "dalgona-game2",
    "title": "Dalgona Game2",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/57e902262bb44868ac967456484ae4bb-512x384.jpg",
    "description": "There's a cute shape on the dalgona, a snack from the past.\\nBe careful not to break the shape.\\nIt's complete if you take it out nicely in a pretty way to go!",
    "publisher": "MOVISOFT.Co.,Ltd",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-29T13:09:25.817Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Click the area outside the shape on the dalgona so the picture doesn’t crack and you can complete the shape.",
    "sourceUrl": "https://gamedistribution.com/games/dalgona-game2/"
  },
  {
    "id": "ac7c68ff82a9413197db6b99a8452c10",
    "slug": "frost-defense",
    "title": "Frost Defense",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/ac7c68ff82a9413197db6b99a8452c10-512x384.jpg",
    "description": "❄️ Embark on a thrilling journey through a frozen wilderness in Frost Defense, a strategic tower defense game that puts your tactical skills to the test! ??\\n\\nIn this action-packed adventure, you'll take on the role of a lone survivor ?‍♂️ battling against the relentless onslaught of arctic creatures ??‍❄️?.\\nThe enemy is merciless — only your ingenuity and strategic prowess can keep you alive in this harsh frozen world. ⚔️?️",
    "publisher": "Ultra Games Entertainment Private limited",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-29T12:58:57.408Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Use mouse to draw path and click on machine to upgrade",
    "sourceUrl": "https://gamedistribution.com/games/frost-defense/"
  },
  {
    "id": "0536c734e865499e835bd8e4df295df4",
    "slug": "eat-and-grow-fish",
    "title": "Eat And Grow Fish",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/0536c734e865499e835bd8e4df295df4-512x384.jpg",
    "description": "Welcome to Eat and Grow Fish, where survival is all about eating or being eaten! Start as a tiny fish and munch your way to the top of the food chain. Explore the levels in Story Mode, or challenge your friends in Duel Mode for two-player fun. Easy to play, fun to master! Are you ready to rule the sea?",
    "publisher": "iclickgames",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-29T09:48:41.679Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use WASD / ARROWS / MOUSE to play the game.",
    "sourceUrl": "https://gamedistribution.com/games/eat-and-grow-fish/"
  },
  {
    "id": "ac47a3b950d74509922e2c1724a4ed20",
    "slug": "catch-a-fish-obby",
    "title": "Catch a Fish Obby",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/ac47a3b950d74509922e2c1724a4ed20-512x384.jpg",
    "description": "Catch a Fish Obby is a chaotic collector raider set in a bright obby world full of Fish and Brainrot Fish characters. Build a money making base with your favorite sea creatures, sneak into rival bases to steal their fish, and protect your own tank from greedy bots and other players. ",
    "publisher": "gameVgames",
    "languages": [
      "English",
      "German",
      "Portuguese",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-29T09:49:50.031Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Player 1\\n\\nMove: W,A,S,D\\nJump: Space\\nBuy or Steal: E\\nHit: F or Left Mouse\\nSprint: Left Shift\\nPlayer 2\\n\\nMove: Arrow Keys\\nJump: L\\nBuy or Steal: O\\nHit: K\\nSprint: J\\n\\nOn mobile devices, all actions are mapped to touch buttons. Move with the virtual joystick, tap the action buttons to jump, steal and attack.",
    "sourceUrl": "https://gamedistribution.com/games/catch-a-fish-obby/"
  },
  {
    "id": "25fd01058dc34110a70b193f2f654a0b",
    "slug": "one-line-drawing",
    "title": "One Line Drawing",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/25fd01058dc34110a70b193f2f654a0b-512x384.jpg",
    "description": "Welcome to One Line Drawing, a game that brings together a variety of line drawing gameplays. You can relax through relaxing line drawing gameplay, or challenge yourself through puzzle-type line drawing gameplay.",
    "publisher": "Bravestars Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-29T09:47:49.216Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Through the easy one line drawing gameplay, you can relax your stress and experience a relaxing and enjoyable game time.",
    "sourceUrl": "https://gamedistribution.com/games/one-line-drawing/"
  },
  {
    "id": "c7af7f58929a4a3c891ccf1192223a6a",
    "slug": "skillful-finger",
    "title": "Skillful Finger",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/c7af7f58929a4a3c891ccf1192223a6a-512x384.jpg",
    "description": "Touch the screen and slide your finger along the glowing line without lifting it. Avoid barriers, stay clear of the edges, and react quickly as the speed increases. Customize your ball and tail, face dynamic obstacles, and enjoy endlessly generated paths that keep every run fast, challenging, and addictive.",
    "publisher": "GamesMrkt",
    "languages": [
      "Chinese (Simplified)",
      "Dutch",
      "English",
      "French",
      "German",
      "Hindi",
      "Indonesian",
      "Italian",
      "Japanese",
      "Korean",
      "Polish",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish",
      "Chinese (Traditional)"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-29T08:55:30.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "PC:\\nMouse Left-hold = Move\\n\\nMobile/Tablet (Touch):\\nTap \\u0026 hold to move; drag your finger to steer.",
    "sourceUrl": "https://gamedistribution.com/games/skillful-finger/"
  },
  {
    "id": "0ffd3e6b46874c5f955c20842ea3b45e",
    "slug": "capybara-jump",
    "title": "Capybara Jump",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/0ffd3e6b46874c5f955c20842ea3b45e-200x120.jpg",
    "description": "Bounce into a cute stacking challenge with Capybara Jump! Time your taps to leap as wooden blocks slide in from both sides, building a towering platform under your capybara. Land perfectly to chain combos, trigger sparkles, and push your score higher before a mistimed jump sends you tumbling down.",
    "publisher": "MarketJS",
    "languages": [
      "English",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-29T07:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Time your jumps to land on moving blocks and help a plump capybara climb an endless tower of hay.",
    "sourceUrl": "https://gamedistribution.com/games/capybara-jump/"
  },
  {
    "id": "1f056c4163394cdb8f0ff4b266eae0df",
    "slug": "capybara-mukbang-asmr",
    "title": "Capybara Mukbang ASMR",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/1f056c4163394cdb8f0ff4b266eae0df-512x384.jpg",
    "description": "Welcome to Capybara Mukbang ASMR, a casual cooking ASMR game that you can play for free. Dive into a delicious world where you cook hamburger, pizza, and ice cream recipes. Dress up and taste your dishes one by one. Share your food with the audience by eating and drinking in the Mukbang livestream, and see how many likes you can receive.",
    "publisher": "Yiv.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-28T14:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/capybara-mukbang-asmr/"
  },
  {
    "id": "28a87d97a0cc40f49226f63d844a89cd",
    "slug": "happy-fluffy-cubes",
    "title": "Happy Fluffy Cubes",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/28a87d97a0cc40f49226f63d844a89cd-512x512.jpg",
    "description": "Happy Fluffy Cubes is a bright and fun 3D runner with adorable cube heroes, tricky traps, and a collection system! Choose your Fluffy and fly through levels full of danger: fire, ice, lasers, and spinning saws! Simple one-touch control, but surviving takes focus and reflexes.",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-28T14:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Controls are super simple — hold the screen and move your finger up or down to guide your Fluffy. Avoid fire, ice, lasers, and spinning saws. Don’t crash and don’t lift your finger!\\n\\nCollect coins while flying — use them to buy chests. Chests may contain eggs that hatch into new Fluffies! Each one is a fluffy cube with its own style and charm. Some are rarer than others — build your full collection!",
    "sourceUrl": "https://gamedistribution.com/games/happy-fluffy-cubes/"
  },
  {
    "id": "8617ea5a6ce64ca78dc93c521ef8e9d3",
    "slug": "survival-on-raft-multiplayer",
    "title": "Survival On Raft Multiplayer",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/8617ea5a6ce64ca78dc93c521ef8e9d3-512x384.jpg",
    "description": "Begin an exciting survival adventure in Survival On Raft: Multiplayer. Have an addictive survival-adventure simulation on an island. Here, you'll be gathering various foods, stones, and other items. Collect ocean resources like wood, leaves and rare items. Sharks in the sea will attack your raft at any moment.",
    "publisher": "bestgames.com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-27T14:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/survival-on-raft-multiplayer/"
  },
  {
    "id": "4d1ff0a7d09b4efd8ef10adb9019db2e",
    "slug": "neon-gravity",
    "title": "Neon Gravity",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/4d1ff0a7d09b4efd8ef10adb9019db2e-1280x720.jpg",
    "description": "Defy gravity in this intense neon-soaked arcade runner! In Neon Gravity, your goal is to survive as long as possible by switching gravity to avoid deadly spikes, saws, and mines.\\n\\nMaster the timing to pass safely between rotating gears and trigger the \\",
    "publisher": "Half Blood Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-27T14:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Desktop: Press Spacebar or Click the left mouse button to switch gravity.\\n\\nMobile: Tap anywhere on the screen to switch gravity.\\n\\nGoal: Avoid all obstacles. Pass through the gap between rotating gears to score extra points. Survive as long as you can!",
    "sourceUrl": "https://gamedistribution.com/games/neon-gravity/"
  },
  {
    "id": "e040188f8179433b8923aef12c9bbeee",
    "slug": "pyramid-jewels",
    "title": "Pyramid Jewels",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/e040188f8179433b8923aef12c9bbeee-512x384.jpg",
    "description": "A fun and colorful puzzle game set in Ancient Egypt. Aim and shoot magical gems to match the same colors and make them disappear. \\nTests your aim and thinking as you clear the board and uncover the secrets of the pyramids.",
    "publisher": "BlackMoon Design",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-27T13:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Tap or click and aim. \\nRelease to shoot. ",
    "sourceUrl": "https://gamedistribution.com/games/pyramid-jewels/"
  },
  {
    "id": "e0592e6ecdf54ec7b3d67355b0e5a8d2",
    "slug": "mind-games:-math-crosswords",
    "title": "Mind Games: Math Crosswords",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/e0592e6ecdf54ec7b3d67355b0e5a8d2-512x512.jpg",
    "description": "Mind Games: Math Crosswords is a game to improve your math skills. It is a great way to spend your time. \\nThe player's mission is to save the planet from extinction. The aliens have destroyed all the plants on the planet. However, humans have found a solution. Engineers have built ships that convert brain activity into life-giving energy to grow plants. By solving mathematical problems, you are contributing to the restoration of plants and the regeneration of our planet.",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-27T11:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "How to play:\\n1. Fill in all the empty spaces with candidate numbers to make the equations right.\\n2. Start with examples with one unknown number.\\n3. Use the hints to complete the level if you get stuck.\\n4. You win if all the equations are right.",
    "sourceUrl": "https://gamedistribution.com/games/mind-games:-math-crosswords/"
  },
  {
    "id": "c38db02f08684023a70a16186c464e15",
    "slug": "sokoban-push-the-box",
    "title": "Sokoban Push The Box",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/c38db02f08684023a70a16186c464e15-512x384.jpg",
    "description": "Challenge your brain in Sokoban - Push The Box. This is a timeless classic puzzle game. Enter a clever maze full of crates, tight corners, and tricky layouts. Your task is simple but challenging. Push every box to the correct spot. Each level will test your logic, patience, and planning skills. One wrong move could block your path, so think carefully before every push. But keep an eye on your move count.",
    "publisher": "PuzzleGame.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-26T14:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/sokoban-push-the-box/"
  },
  {
    "id": "ccb9423ce3234ca9a033cf8c3476bdf8",
    "slug": "robbie:-stand-on-the-right-color!",
    "title": "Robbie: Stand on the Right Color!",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/ccb9423ce3234ca9a033cf8c3476bdf8-1280x550.jpg",
    "description": "Welcome to the vibrant world of speed and reaction!\\nYou are about to be tested on your attentiveness and lightning-fast decisions. Your task is simple but tricky: step on the right color before the floor disappears beneath your feet!\\nSuitable for anyone who loves fast, simple, and addictive games.\\nAre you ready to help Robbie stand his ground?",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-26T11:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "PC controls: WASD + Mouse\\nMobile controls: Joysticks + touch buttons\\n\\nWatch the color! A color will appear on the screen — you need to stand on it.\\nMove Robbie with the arrow keys or joystick (if playing on a phone).\\nBe quick! The platforms disappear after a few seconds — hesitate, and Robbie will fall!\\nBe the first to reach the finish line and set a new record!\\n\\nTip: train your reaction and attention — only the fastest will get far!",
    "sourceUrl": "https://gamedistribution.com/games/robbie:-stand-on-the-right-color!/"
  },
  {
    "id": "057dd7f60aa34e498092c4a92c640b9d",
    "slug": "pixel-destroyer",
    "title": "Pixel Destroyer",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/057dd7f60aa34e498092c4a92c640b9d-1280x720.jpg",
    "description": "Pixel Destroyer is an exciting physics-based arcade puzzle game where your goal is to destroy colorful pixel shapes using bouncing balls.\\n\\nDive into a world of pixel destruction! In this game, you’ll need to use your wits and precision. Each level features a unique shape made of pixel blocks. Your objective is to destroy them all using a limited number of shots. The balls follow the laws of physics, bouncing off walls and obstacles, allowing you to reach even the most hard-to-access blocks.",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-25T18:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Destroy all pixel blocks on the screen to complete the level.\\nTouch the screen and drag to aim.\\nRelease your finger or the mouse button to fire a burst of balls.\\n\\nUse the walls for ricochets to reach protected areas.\\n\\nYou have a limited number of moves for each level.\\nIf you run out of moves, you lose.",
    "sourceUrl": "https://gamedistribution.com/games/pixel-destroyer/"
  },
  {
    "id": "b677b7433216410c9de719c35fc14440",
    "slug": "oil-digging",
    "title": "Oil Digging",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/b677b7433216410c9de719c35fc14440-512x512.jpg",
    "description": "Oil Digging is a simulation game where you build and operate an oil rig. This game offers the experience of oil mining without the morning smell of oil! Dive into the world of oil drilling. Will your oil operation be a profitable masterpiece or an expensive mess? Start by finding an oil well, drilling it, and then building an efficient pipe system. Let's see if you can get rich!",
    "publisher": "Kwalee",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-24T10:31:51.227Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Use the left mouse button on desktop or touch on mobile to play the game.",
    "sourceUrl": "https://gamedistribution.com/games/oil-digging/"
  },
  {
    "id": "4f5403c2c71c40848305a962ec21aaac",
    "slug": "winter-tetrix-trails",
    "title": "Winter Tetrix Trails",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/4f5403c2c71c40848305a962ec21aaac-512x384.jpg",
    "description": "Winter Tetrix Trails is a relaxing shape-filling puzzle game set in a snowy world.\\nDrag and place colorful Tetris-style blocks to complete each unique silhouette — think carefully, fit perfectly, and enjoy the magic of winter puzzles!",
    "publisher": "Lof Games",
    "languages": [
      "Arabic",
      "Bulgarian",
      "Chinese (Simplified)",
      "Czech",
      "Danish",
      "Dutch",
      "English",
      "Estonian",
      "Finnish",
      "French",
      "German",
      "Greek",
      "Hebrew",
      "Hindi",
      "Hungarian",
      "Indonesian",
      "Italian",
      "Japanese",
      "Korean",
      "Latvian",
      "Lithuanian",
      "Polish",
      "Portuguese",
      "Romanian",
      "Russian",
      "Serbian",
      "Simple English",
      "Slovak",
      "Spanish",
      "Swahili",
      "Swedish",
      "Tagalog",
      "Thai",
      "Turkish",
      "Ukrainian",
      "Vietnamese"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-24T08:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Click, drag, and place the blocks with your mouse or touchpad — fill the silhouette to finish the level.",
    "sourceUrl": "https://gamedistribution.com/games/winter-tetrix-trails/"
  },
  {
    "id": "0946201a460c4fd191f32bd497ee6c2a",
    "slug": "impostor-among-us:-escape-from-prison",
    "title": "Impostor among us: Escape from prison",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/0946201a460c4fd191f32bd497ee6c2a-512x384.jpg",
    "description": "The traitor ended up in a space prison. But the impostor does not plan to stay there for long. You play as an impostor who must go through all the traps, solve puzzles and kill all the enemies on the level. Once the imposter has neutralized all the amogus, he will be able to break out of prison. But the evil among will not let you go into space so easily.\\n\\n- 100+ varied and colorful levels.\\n- To kill the enemy you need to approach him.\\n- Logic tasks and puzzles!\\n- Boss battles!",
    "publisher": "Stickman vs Monster School Team",
    "languages": [
      "English",
      "Russian",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-24T08:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "The goal of the game is to kill all the enemies and then the red lasers will be removed and open the way for you.\\n\\nPC controls: WASD or arrows\\nPhone\\\\tablet controls: virtual buttons",
    "sourceUrl": "https://gamedistribution.com/games/impostor-among-us:-escape-from-prison/"
  },
  {
    "id": "f2b313196a8a405bbb4a9307d444fd6d",
    "slug": "pixel-number-diy-coloring",
    "title": "Pixel Number - DIY Coloring",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/f2b313196a8a405bbb4a9307d444fd6d-512x512.jpg",
    "description": "Unleash your creativity with Pixel Number – DIY Coloring! Choose from a huge collection of pixel art images – from cute animals to cool patterns – and bring them to life with color.",
    "publisher": "Bravestars Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-24T07:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Every picture is divided into tiny squares, each marked with a number. Simply follow the numbers and fill in the right color to reveal a beautiful pixel masterpiece. Relax, tap, and enjoy the fun of creating art step by step.",
    "sourceUrl": "https://gamedistribution.com/games/pixel-number-diy-coloring/"
  },
  {
    "id": "0c249ace577243eebdef01ea2691cff5",
    "slug": "winter-hexa-stack",
    "title": "Winter Hexa Stack",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/0c249ace577243eebdef01ea2691cff5-512x384.jpg",
    "description": "Winter Hexa Stack is a cozy and addictive winter-themed puzzle game where you clear the board by stacking three matching hex tiles. Tap a tile to place it in an empty spot or on top of a similar tile. When you match three identical tiles, they disappear and free up valuable space. Be careful—if your holding slots fill up or the timer runs out, the level ends. Plan your moves, stay organized, and enjoy a relaxing winter atmosphere.",
    "publisher": "Lof Games",
    "languages": [
      "Arabic",
      "Bulgarian",
      "Chinese (Simplified)",
      "Czech",
      "Danish",
      "Dutch",
      "English",
      "Estonian",
      "Finnish",
      "French",
      "German",
      "Greek",
      "Hebrew",
      "Hindi",
      "Hungarian",
      "Indonesian",
      "Italian",
      "Japanese",
      "Korean",
      "Latvian",
      "Lithuanian",
      "Polish",
      "Portuguese",
      "Romanian",
      "Russian",
      "Serbian",
      "Simple English",
      "Slovak",
      "Spanish",
      "Swahili",
      "Swedish",
      "Tagalog",
      "Thai",
      "Turkish",
      "Ukrainian",
      "Vietnamese"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-23T09:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use a mouse or touchpad to place tiles and stack three identical ones to clear them. Plan wisely to keep the board from filling up.",
    "sourceUrl": "https://gamedistribution.com/games/winter-hexa-stack/"
  },
  {
    "id": "0c89181b9cfe4897afa41b0f94385da9",
    "slug": "crazy-bike-stunts-pvp",
    "title": "Crazy Bike Stunts PvP",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/0c89181b9cfe4897afa41b0f94385da9-512x384.jpg",
    "description": "Skid the wheel of a stunning muscle car through 2 awesome game modes and showcase your driving skills. Customize your car according to your taste and drive in style with the roaring engines. Feel the heat in 2 player mode where you go head to head with your friend in 2 amazing game modes! Are you ready to conquer the stunt city? Prove yourself with Crazy Bike Stunts PvP!",
    "publisher": "Fuego! Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-23T08:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Player 1:\\nW,A,S,D: Drive/Steer/Brake\\n\\nPlayer 2:\\nArrow Keys: Drive/Steer/Brake",
    "sourceUrl": "https://gamedistribution.com/games/crazy-bike-stunts-pvp/"
  },
  {
    "id": "9190c99d4aae4e0085a6059478ee3520",
    "slug": "plant-merge:-zombie-war",
    "title": "Plant Merge: Zombie War",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/9190c99d4aae4e0085a6059478ee3520-512x384.jpg",
    "description": "In the chaotic world of Merge Plant Zombie War, arm your garden with strategic merges to fend off relentless zombie hordes! Master upgrades, deploy special abilities, and outsmart waves of undead foes in this addictive merge-tower defense adventure. Will your botanical army prevail in the ultimate war for survival? Dive in and merge your way to victory!\\n",
    "publisher": "Big Wave",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-23T07:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Merge plants to crush zombie waves!",
    "sourceUrl": "https://gamedistribution.com/games/plant-merge:-zombie-war/"
  },
  {
    "id": "38ab3871c30c48a3a6a4b1e3e2ce802c",
    "slug": "1945-air-force-space-shooter",
    "title": "1945 Air Force Space Shooter",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/38ab3871c30c48a3a6a4b1e3e2ce802c-512x384.jpg",
    "description": "Prepare for nonstop action in 1945 Air Force: Space Shooter! Inspired by the classic shooter era, this game combines vintage visuals with thrilling bulletstorm gameplay that will test your reflexes and precision.Fly through endless waves of enemy aircraft. Avoid storms of bullets and unleash devastating firepower from your Force fighter.",
    "publisher": "YAD.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-23T07:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/1945-air-force-space-shooter/"
  },
  {
    "id": "0b18452cd7844e308b726bf05034fac2",
    "slug": "bubble-shooter-wild-west",
    "title": "Bubble Shooter Wild West",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/0b18452cd7844e308b726bf05034fac2-1280x550.jpg",
    "description": "Saddle up for a Wild West adventure in Bubble Shooter Wild West! Join Sheriff Bonnie as you pop colorful bubbles to defend your frontier town. Travel through dusty deserts, lively saloons, and scenic canyons while enjoying toe-tapping country tunes. Track your progress with detailed stats showing your best, current, and previous scores across Novice, Expert, and Master modes. With its vibrant Western visuals and exciting challenges, this bubble shooter brings cowboy spirit to every pop!",
    "publisher": "SOFTGAMES – Mobile Entertainment Services GmbH",
    "languages": [
      "Dutch",
      "English",
      "German",
      "Italian",
      "Polish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-22T08:47:28.850Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "Aim the cannon with the arrow and shoot bubbles to match 3 or more of the same color. The middle bubble shows your current shot, and the bottom-left bubble shows the next one. Clear bubbles to stop the stack from reaching the bottom. Missed shots add fouls, and new rows appear when grey bubbles run out. Use the Swap booster to change your current bubble, the Fireball to blast through obstacles, and rely on Second Chances and Last Chances to keep playing and reach higher scores!",
    "sourceUrl": "https://gamedistribution.com/games/bubble-shooter-wild-west/"
  },
  {
    "id": "fe29c32ceb394329b64e8fe0ec54bc7e",
    "slug": "exo-observation",
    "title": "Exo Observation",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/fe29c32ceb394329b64e8fe0ec54bc7e-512x384.jpg",
    "description": "Exo Observation is a space exploration incremental game where you uncover alien worlds and study mysterious lifeforms. You’ll collect resources, build advanced orbital science facilities, and manage them efficiently to progress. Each discovery pushes you closer to unlocking warp gates, letting you expand across the galaxy, and continue your quest for knowledge among distant stars.",
    "publisher": "Super Turbo Society",
    "languages": [
      "English",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-22T08:46:31.683Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Click on the planet to start researching. Continue to click on different areas to maximize your output of various resources.",
    "sourceUrl": "https://gamedistribution.com/games/exo-observation/"
  },
  {
    "id": "fa7ff4503743437681835a0a4ad62c7e",
    "slug": "crowd-evolution!",
    "title": "Crowd Evolution!",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/fa7ff4503743437681835a0a4ad62c7e-512x384.jpg",
    "description": "you start as a single person and grow your team by running through the city and gathering people of the same color. Your goal is to build a massive army that no one can stop! Chase down and absorb smaller crowds, but be careful, as larger crowds will try to absorb you. Use strategy and quick reflexes to become the biggest crowd on the map before time runs out!",
    "publisher": "XMetaGame",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-21T13:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use your mouse or finger to swipe on the screen to control the direction of your crowd's movement.",
    "sourceUrl": "https://gamedistribution.com/games/crowd-evolution!/"
  },
  {
    "id": "dc5da1baa34c4adfa4d1387effbee219",
    "slug": "love-colors",
    "title": "Love Colors",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/dc5da1baa34c4adfa4d1387effbee219-512x384.jpg",
    "description": "Dive into Love Colors, the ultimate relaxing coloring app! Transform this elegant Art Nouveau portrait of a graceful woman—adorned with swirling leaves and blooms—using lush reds, pinks, and light pinks. Effortless tools: zoom, undo, redo, and instant download. Unleash creativity, melt stress away!",
    "publisher": "SecGame",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-21T13:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "* Click to select a color from the palette and fill intricate details in the artwork.\\n* Drag and drop to smoothly color large areas or blend shades effortlessly.\\n* Double-click to zoom in for precise shading on swirling leaves and floral patterns.\\n* Right-click to undo the last stroke and perfect your masterpiece.",
    "sourceUrl": "https://gamedistribution.com/games/love-colors/"
  },
  {
    "id": "badd134e3ffd442c83170d909f6b8f6c",
    "slug": "floof-my-pet-house",
    "title": "Floof My Pet House",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/badd134e3ffd442c83170d909f6b8f6c-1280x720.jpg",
    "description": "Welcome to Floof - My Pet House, a casual pet simulation game for kids online. If you love playing with cats and dogs, or are looking for lovely and relaxing games online, do not hesitate to join H5games4u's best animal care game. You will take care of a puppy or a cute cat, feed them, dress them up, and play minigames with them. Earn enough coins to upgrade your pet house and buy more furniture.",
    "publisher": "Yiv.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-21T13:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Mouse click or tap to play",
    "sourceUrl": "https://gamedistribution.com/games/floof-my-pet-house/"
  },
  {
    "id": "7b5a23ec82874487868deee0b7afbbfa",
    "slug": "hill-racing-egg-drop!",
    "title": "Hill Racing - Egg drop!",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/7b5a23ec82874487868deee0b7afbbfa-512x384.jpg",
    "description": "Press down to accelerate your car. Go as fast as you can carrying an egg while collection coins. \\n\\nUpgrade your cars and levels with coins.\\n\\n",
    "publisher": "PHATCAT Games Ltd",
    "languages": [
      "Arabic",
      "Chinese (Simplified)",
      "Danish",
      "English",
      "French",
      "German",
      "Greek",
      "Hindi",
      "Italian",
      "Persian",
      "Polish",
      "Portuguese",
      "Romanian",
      "Russian",
      "Spanish",
      "Swedish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-21T12:55:05.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Press / Click to accelerate the car. Release to stop.",
    "sourceUrl": "https://gamedistribution.com/games/hill-racing-egg-drop!/"
  },
  {
    "id": "d53bac1ebd0d41bb8a2709ad48f790ec",
    "slug": "gothic-knife",
    "title": "Gothic Knife",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/d53bac1ebd0d41bb8a2709ad48f790ec-512x512.jpg",
    "description": "Test your skills in this classic knife-throwing arcade game. Your goal is to stick all knives into the rotating target without hitting the ones already there. The target spins faster and more unpredictably with each level. Every 3 levels, a unique boss battle awaits you! Master the combo system to get high scores and enjoy Gothic",
    "publisher": "PixelRaccoon",
    "languages": [
      "English",
      "Russian",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-20T13:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Tap the screen or click your mouse to throw a knife. Time your throws carefully to hit empty spots on the target. Avoid hitting other knives or obstacles. Defeat the boss every 3 stages to unlock new challenges!",
    "sourceUrl": "https://gamedistribution.com/games/gothic-knife/"
  },
  {
    "id": "a930dd4779394614ba4c0b0d8275e252",
    "slug": "brainrot-mob-clash-3d",
    "title": "Brainrot Mob Clash 3D",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/a930dd4779394614ba4c0b0d8275e252-512x384.jpg",
    "description": "Welcome to the wild and chaotic world of Brainrot Mob Clash 3D. It’s a full-blown racing and fighting adventure. Dash through 3D obstacle courses, avoid deadly traps like spikes and spinning saws. Match and merge your stickman army. Crush enemy mobs in exciting action-packed battles. As you run, collect brainrot characters to increase your numbers and merge them to form powerful units.",
    "publisher": "bestgames.com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-20T13:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/brainrot-mob-clash-3d/"
  },
  {
    "id": "a2b0f885254f4c69a1958cfc5f06c833",
    "slug": "animal-bus-traffic-jam",
    "title": "Animal Bus Traffic Jam",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/a2b0f885254f4c69a1958cfc5f06c833-512x384.jpg",
    "description": "All aboard for the cutest puzzle ride ever in Animal Bus Traffic Jam. This clever match-3 sort puzzle and casual logic game challenges you to help adorable animal passengers find their correct buses. Each level is a traffic jam of colorful buses filled with cats, dogs, pandas, and more. Your mission is to sort the animals by type or color, match them into the right buses, and clear the jam with smart moves.",
    "publisher": "PuzzleGame.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-20T13:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/animal-bus-traffic-jam/"
  },
  {
    "id": "4857071352d449b383886bcf8627a231",
    "slug": "association-connect-word",
    "title": "Association - Connect Word",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/4857071352d449b383886bcf8627a231-512x512.jpg",
    "description": "Dive into the world of word puzzles and associations! In this game, you need to find hidden connections between words and group them logically. Each level offers new themes, new words, and increasingly challenging tasks. The game develops thinking, expands vocabulary, and trains attention. Intuition and logic will help you complete dozens of levels, from easy to hard, and become a true master of associations. Play at your own pace without time limits and use hints if needed. ",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-20T12:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Each level presents a set of words;\\nFind meaningful connections and group them;\\nUse logic and knowledge to solve all associations;\\nUse hints if stuck;\\nProgress through levels and unlock new themes and challenges.",
    "sourceUrl": "https://gamedistribution.com/games/association-connect-word/"
  },
  {
    "id": "fc84a63fc1db4ebabc334521c2cb3c68",
    "slug": "bubble-pop-fairyland",
    "title": "Bubble Pop Fairyland",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/fc84a63fc1db4ebabc334521c2cb3c68-1280x720.jpg",
    "description": "Bubble Pop Fairyland is an exciting bubble shooter game that’s very highly addictive!\\nAim, shoot \\u0026 pop all the color bubbles using epic blasters to clear the board and win coins!\\n\\nBubble Pop Fairyland is a fun and relaxing puzzle game designed to keep your mind sharp at any age.\\nIt also is a perfect brain training and fast solution making game\\nYou will have hours of fun shooting \\u0026 matching the same colored bubbles!",
    "publisher": "Anna Inc",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-20T10:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Aim: Move your mouse (or swipe on mobile) to point the shooter in the direction you want to fire.\\n\\nShoot: Click (or tap) to launch the bubble.\\n\\nWhen your bubble hits a group of at least three bubbles of the same color, they pop and disappear.",
    "sourceUrl": "https://gamedistribution.com/games/bubble-pop-fairyland/"
  },
  {
    "id": "42e24ffddcfe4c01a7f53ba146ef4375",
    "slug": "bubble-shooter-aura",
    "title": "Bubble Shooter Aura",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/42e24ffddcfe4c01a7f53ba146ef4375-200x120.jpg",
    "description": "Bubble Shooter Aura brings a fresh, glowing twist to the classic bubble-shooting experience.\\nEnter a world of soft colors, smooth animations, and relaxing “aura” effects as you match and pop bubbles to clear levels and reach high scores.\\n\\nPerfect for both casual players and bubble shooter fans, this game offers intuitive controls, satisfying gameplay, and a modern look that feels calm, fun, and addictive.",
    "publisher": "Skilli",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-19T13:47:16.650Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "? How to Play\\n• Aim the shooter and match 3 bubbles of the same color.\\n• Pop bubbles, clear the board, and complete each level’s goal.\\n• Bounce shots off the walls for tricky angles and combos.\\n• Create chain reactions to activate glowing aura effects and earn extra points.\\n• Play strategically — Level Mode has limited moves, while Endless Mode keeps dropping new rows.",
    "sourceUrl": "https://gamedistribution.com/games/bubble-shooter-aura/"
  },
  {
    "id": "63db3ede64e343c8a9fb4f91e29b7b08",
    "slug": "fly-and-shoot-1.-italian-bosses",
    "title": "Fly and shoot 1. Italian Bosses",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/63db3ede64e343c8a9fb4f91e29b7b08-1280x720.jpg",
    "description": "Nostalgia for 8-bit games. A classic arcade shooter with leveling elements and character selection. Fly and shoot, take down enemies, and blow up and destroy everything in your path. Defeat the boss at the end of each level. Save Laba and earn bonuses for doing so. Each difficulty level is slightly different. Enemies become more aggressive, and the speed increases.",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-19T12:53:45.762Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "On a computer: WASD - controls, - Spacebar -shoot , Mouse - navigate , \\n\\nUse the following keyboard shortcuts: \\nSkill 1 - \\",
    "sourceUrl": "https://gamedistribution.com/games/fly-and-shoot-1.-italian-bosses/"
  },
  {
    "id": "a60b670196384d8db35fab193cc80297",
    "slug": "celebrities-get-ready-for-christmas",
    "title": "Celebrities Get Ready For Christmas",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/a60b670196384d8db35fab193cc80297-512x384.jpg",
    "description": "Step into the world of ‘Celebrities Get Ready for Christmas’! Join your favorite stars as they prepare for the festive season. Explore dazzling holiday outfits, glamorous decorations, and witness the magic of Christmas through the eyes of celebrities. Get ready for a star-studded holiday celebration! Play and have fun!",
    "publisher": "Cutedressup",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-19T07:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "Left Mouse Button Click",
    "sourceUrl": "https://gamedistribution.com/games/celebrities-get-ready-for-christmas/"
  },
  {
    "id": "9166d21893d94e31bcc714829d27bef3",
    "slug": "toytopia",
    "title": "Toytopia",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/9166d21893d94e31bcc714829d27bef3-512x384.jpg",
    "description": "Toytopia is a cozy merge-and-repair adventure where you combine art items to craft materials and restore broken toys. Every toy has its own look and challenge, so you’ll keep unlocking new fixes and surprises. Relaxing, creative, and gently strategic.",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-19T07:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Drag and drop matching art items onto the board to merge them into higher-level materials. Keep merging until you create the exact supplies needed to fix each toy’s broken parts. Desktop: use your mouse to drag items. Mobile: tap and drag with your finger.",
    "sourceUrl": "https://gamedistribution.com/games/toytopia/"
  },
  {
    "id": "9520342c66da4ea9ad470dd2b2103c6a",
    "slug": "color-sand-puzzle",
    "title": "Color Sand Puzzle",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/9520342c66da4ea9ad470dd2b2103c6a-1280x720.jpg",
    "description": "Welcome to Color Sand Puzzle! Relax and unwind with Color Sand Puzzle, a refreshing take on the classic block puzzle game! Your mission is simple yet fun—fill the grid with matching colors of sand to clear and control the lines. As colorful sand blocks fall from the top, you’ll need to strategically arrange them to form complete horizontal rows. When the sand lines up from left to right, they disappear, and you earn points!",
    "publisher": "Bravestars Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-18T10:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "- Tetris-Style Gameplay: Manipulate falling sand blocks and arrange them to form complete rows.\\n- Clear the Grid: Complete horizontal lines to clear sand and keep the grid from filling up!\\n- Combo Streaks: Create multiple combos to score big and keep the fun going!",
    "sourceUrl": "https://gamedistribution.com/games/color-sand-puzzle/"
  },
  {
    "id": "071109cf20074a11a45baa3301f41b5a",
    "slug": "cut-in-half",
    "title": "Cut In Half",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/071109cf20074a11a45baa3301f41b5a-512x384.jpg",
    "description": "Cut obstacles in the way with knives or characters.\\nIf you touch a red block or fall into a valley, it's a game over.\\nCollect the goods as much as you cut the obstacles to unlock new characters!",
    "publisher": "MOVISOFT.Co.,Ltd",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-18T09:27:32.165Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Cocos"
    ],
    "instructions": "When you tap the screen, the knife spins and jumps. Slice objects with the knife or dodge dangerous obstacles as you make your way to the finish line.",
    "sourceUrl": "https://gamedistribution.com/games/cut-in-half/"
  },
  {
    "id": "9e025535bdda42b584e24aa0a503e7d3",
    "slug": "popping-candies",
    "title": "Popping Candies",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/9e025535bdda42b584e24aa0a503e7d3-512x384.jpg",
    "description": "Match and crush candies to achieve goals in this addictive puzzle game! Swap adjacent candies to form rows of three or more and clear the board. Create special candies like striped, wrapped, or color bombs to enhance your progress. Overcome obstacles like chocolate and blockers while completing each level's unique objectives. Be mindful of your limited moves! Use boosters for extra assistance and advance through challenging levels to unlock new stages.",
    "publisher": "Playgama",
    "languages": [
      "English",
      "Russian",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-18T08:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Match candies to complete objectives within limited moves! Swap adjacent candies to create rows of 3+ to clear them. Use special candies like striped, wrapped, or color bombs to clear more candies. Each level has goals like reaching a score or clearing obstacles. Watch your moves and use boosters to help. Complete levels to progress and unlock new challenges!",
    "sourceUrl": "https://gamedistribution.com/games/popping-candies/"
  },
  {
    "id": "048f19bd125e46e2a2312fadcde3d518",
    "slug": "knock-and-run.-100-doors-escape",
    "title": "Knock and Run. 100 Doors Escape",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/048f19bd125e46e2a2312fadcde3d518-512x384.jpg",
    "description": "Become the fastest and most daring stickman in this fun arcade game! Your goal is to race through the corridors of the hotel, ring the doors, knock and slam them, arranging epic pranks. The main thing is not to get caught! Residents' reactions are unpredictable, and danger can lurk around every corner.",
    "publisher": "Mirra Games",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Polish",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-17T10:22:20.073Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Control your character through touch, cursor or WASD to move and always run! Run to the end of the level to win this game!",
    "sourceUrl": "https://gamedistribution.com/games/knock-and-run.-100-doors-escape/"
  },
  {
    "id": "c3fcad02e12544c486b1ce510ddebb16",
    "slug": "crazy-traffic-racer",
    "title": "Crazy Traffic Racer",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/c3fcad02e12544c486b1ce510ddebb16-512x384.jpeg",
    "description": "Introducing an adrenaline-pumping car driving game that will push your driving skills to the limit. Powered by a cutting-edge 3D game engine, this game delivers a realistic and immersive experience like no other.\\",
    "publisher": "Affrica",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2023-08-30T23:00:05.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Controls Desktop:\\nW or up arrow key - accelerate\\nA or left arrow key - turn left\\nD or right arrow key - turn right\\nS or down arrow key - brake \\n\\nControls Mobile, Tablet:\\nLeft button - turn left\\nRight button - turn right\\nTwo buttons - brake",
    "sourceUrl": "https://gamedistribution.com/games/crazy-traffic-racer/"
  },
  {
    "id": "6bfd6b77827c418eb5dc2d33be6bc911",
    "slug": "ninjaroof",
    "title": "NinjaRoof",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/6bfd6b77827c418eb5dc2d33be6bc911-512x384.jpg",
    "description": "NinjaRoof is a fast-paced and addictive arcade game where players control a nimble character jumping from rooftop to rooftop while avoiding deadly obstacles and aiming for the highest score. Test your timing, precision, and reflexes in this endless jumping adventure built with smooth physics and clean visuals.",
    "publisher": "kiz10.com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-17T08:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Use the keyboard or touch to play",
    "sourceUrl": "https://gamedistribution.com/games/ninjaroof/"
  },
  {
    "id": "2960d96103f24b299416f71650acaf18",
    "slug": "barry-prison-christmas-adventure",
    "title": "Barry Prison Christmas Adventure",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/2960d96103f24b299416f71650acaf18-512x384.jpg",
    "description": "Want the craziest Christmas escape adventure ever? Barry Prison Christmas Adventure is an exciting role-playing simulator. Enter chase mode or evade mode. Here, you will play the role of either the hider or the seeker. Select your preferred scenario to begin the challenge. Find a hidden spot to start hiding and evade your pursuers.",
    "publisher": "YAD.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-17T07:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/barry-prison-christmas-adventure/"
  },
  {
    "id": "8ad34dac8faa4221b32ed16ef6d4ce39",
    "slug": "mahjong-tile-club",
    "title": "Mahjong Tile Club",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/8ad34dac8faa4221b32ed16ef6d4ce39-512x512.jpg",
    "description": "Step into the relaxing world of Mahjong Tile Club, where timeless tile-matching meets innovative gameplay! This solitaire-style mahjong game is perfect for anyone looking for a calm yet engaging puzzle experience. With simple rules and soothing gameplay, it’s easy to pick up and hard to put down. Match identical tiles, clear the board, and enjoy a satisfying sense of accomplishment. ",
    "publisher": "Bravestars Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-16T10:44:05.792Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Match Tiles – Simply tap to match identical tiles. Clear all tiles to win the level!\\nUse Boosters – Need help? Use hints to find matches or shuffle the tiles for a fresh start.\\nRelax \\u0026 Focus – Play at your own pace, unwind, and keep your mind active with each level.",
    "sourceUrl": "https://gamedistribution.com/games/mahjong-tile-club/"
  },
  {
    "id": "51766065cf2a4b7487640fa295b80a99",
    "slug": "drunk-but-not-wasted-knight",
    "title": "Drunk But Not Wasted Knight",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/51766065cf2a4b7487640fa295b80a99-512x384.jpg",
    "description": "Stumble into a moonlit alley and befriend a tipsy yet oddly wise knight in this comedic medieval visual novel. Banter, make choices, and nudge affection as you chase stories, dodge trouble, and unlock quirky endings. ",
    "publisher": "MarketJS",
    "languages": [
      "English",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-16T10:35:33.024Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "A comedic medieval visual novel where your choices with a drunk (but not wasted) knight shape affection and lead to eight quirky endings.",
    "sourceUrl": "https://gamedistribution.com/games/drunk-but-not-wasted-knight/"
  },
  {
    "id": "50d154abb6c5483b847cbeea848e73ff",
    "slug": "wave-dash",
    "title": "Wave Dash",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/50d154abb6c5483b847cbeea848e73ff-512x384.jpg",
    "description": "Ride the wave in Wave Dash, a rhythm platformer where each tap steers your arrow through tight corridors. Read patterns in waves, time jumps to music, and beat brutal stages. Build routes with the level editor, share creations, unlock icons, chase ranks, and perfect speed runs. Simple controls, fast restarts—pure focus and flow. Inspired by classic geometry platformers, tuned for dash mastery.",
    "publisher": "GameBiz",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-16T10:17:19.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Tap/Space - Jump",
    "sourceUrl": "https://gamedistribution.com/games/wave-dash/"
  },
  {
    "id": "02f08cc990244f37abf63a95140af6dd",
    "slug": "monster-school-2",
    "title": "Monster School 2",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/02f08cc990244f37abf63a95140af6dd-512x384.jpg",
    "description": "Monsters from minecraft are trained at the monster school by Herobrin's teacher. Take the tests, find out who is a Noob and who is a real pro in Bottle Flip challenge, parkour and roller coaster!",
    "publisher": "Stickman vs Monster School Team",
    "languages": [
      "English",
      "Russian",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-16T08:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Click the left mouse button to start passing the tests and become the best in the monster school, where the main teacher is Herobrin.",
    "sourceUrl": "https://gamedistribution.com/games/monster-school-2/"
  },
  {
    "id": "a5587c8977f2437ea437337509704356",
    "slug": "lingo-dreams",
    "title": "Lingo Dreams",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/a5587c8977f2437ea437337509704356-512x512.jpg",
    "description": "Learn English while playing\\nLingo Dreams is a fun and relaxing puzzle game that helps you memorize English words through matching exercises. Find the correct pairs between your native language and English to complete each level.\\n\\nPerfect for beginners, kids, or anyone who wants to expand their vocabulary while having fun.",
    "publisher": "tinyDream",
    "languages": [
      "English",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-15T08:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Match the words.",
    "sourceUrl": "https://gamedistribution.com/games/lingo-dreams/"
  },
  {
    "id": "57de0fa8b9fb4df783e7eb8248ac5e5a",
    "slug": "obby-rainbow-tower",
    "title": "Obby Rainbow Tower",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/57de0fa8b9fb4df783e7eb8248ac5e5a-512x384.jpg",
    "description": "Obby Rainbow Tower is a fast, winter-themed tower race where every second and every jump matters. Each floor is packed with moving platforms, icy tiles, spinning lava bars, surprise snowstorms and snowball portals that try to knock you into the void. You can replay the tower as many times as you like, trying to beat your own best time or racing a friend side by side in 2 player mode.\\n\\n\\n\\n",
    "publisher": "gameVgames",
    "languages": [
      "Arabic",
      "English",
      "German",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-15T08:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Player 1: Move W A S D, Sprint Shift, Jump Space, Double Jump Space+Space\\nPlayer 2: Move Arrows, Sprint K, Jump L, Double Jump L+L\\nMobile: On-screen buttons.",
    "sourceUrl": "https://gamedistribution.com/games/obby-rainbow-tower/"
  },
  {
    "id": "49994d4fd8aa4a218b8d3ed8837a4700",
    "slug": "paper-wars:-battles-and-upgrades",
    "title": "Paper Wars: Battles and Upgrades",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/49994d4fd8aa4a218b8d3ed8837a4700-1280x720.jpg",
    "description": "Real battle on a sheet of paper! Choose your troops, aim, and destroy the enemy. Play with a friend or against AI. Unlock new fighters and upgrade your attacks!",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-14T15:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Preparing for Battle:\\nAt the beginning of the game, select soldiers from those available in your arsenal. The number and types of soldiers depend on your squad's upgrades.\\n\\nCombat System:\\nWhen your attack is charged, select a firing point on your half of the field. The system will automatically determine the mirrored point on the enemy's side — that's where the projectile will land. Some soldiers accelerate the recharge of specific attacks — use this advantage.",
    "sourceUrl": "https://gamedistribution.com/games/paper-wars:-battles-and-upgrades/"
  },
  {
    "id": "cefe943a827f456dbc65f68669ce5f53",
    "slug": "christmas-blind-box",
    "title": "Christmas Blind Box‌",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/cefe943a827f456dbc65f68669ce5f53-512x384.jpg",
    "description": "This is a Christmas toy blind box opening game! Click the \\",
    "publisher": "Puppy Yolk Studio",
    "languages": [
      "English",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-14T14:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Click the \\",
    "sourceUrl": "https://gamedistribution.com/games/christmas-blind-box/"
  },
  {
    "id": "5b143b4172204a238238038e229e5cc3",
    "slug": "magic-beauty-makeup",
    "title": "Magic Beauty Makeup",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/5b143b4172204a238238038e229e5cc3-512x384.jpg",
    "description": "Welcome to Magic Beauty Makeup, a casual and relaxing girl makeover game on H5games4u. The girl is in trouble with her appearance. Help her return to her original beauty with skin care and makeup methods. You will act as a makeover artist who does skin care, applies facial makeup, and designs a perfect look in the virtual fashion salon. And the best part? All the makeup procedures are done just by clicking and dragging.",
    "publisher": "Yiv.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-14T13:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/magic-beauty-makeup/"
  },
  {
    "id": "3cb2c3b36dca4446b037be38ddc12379",
    "slug": "screw-masters-3d-puzzle",
    "title": "Screw Masters 3D Puzzle",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/3cb2c3b36dca4446b037be38ddc12379-200x120.jpg",
    "description": "Collect screws, take apart complex objects piece by piece, and test your puzzle-solving skills! Work your way through exciting levels, dismantle items down to the tiniest parts, and earn amazing rewards along the way. Use powerful bonuses to advance faster, beat challenging stages, and reach new heights.\\nPlay, win, and share your best results with friends!",
    "publisher": "Caner",
    "languages": [
      "English"
    ],
    "mobile": [],
    "firstActiveDate": "2025-12-14T10:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Collect screws, take apart complex objects piece by piece",
    "sourceUrl": "https://gamedistribution.com/games/screw-masters-3d-puzzle/"
  },
  {
    "id": "44aca4c22c6b424c9fa55a80fe1f58f9",
    "slug": "fashionista-christmas-eve-party",
    "title": "Fashionista Christmas Eve Party",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/44aca4c22c6b424c9fa55a80fe1f58f9-512x384.jpg",
    "description": "Indulge in the Fashionista Christmas Eve Party extravaganza! Discover glamorous holiday ensembles, festive accessories, and the perfect blend of chic for a stylish celebration. Join the fashion-forward festivities and elevate your Christmas Eve style to new heights. Unwrap the magic of the season with Fashionista, where every outfit is a statement and every moment is a fashion triumph. Let the glamour of Christmas Eve unfold.",
    "publisher": "Cutedressup",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-14T07:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "Left Mouse Button Click or Tap to Play",
    "sourceUrl": "https://gamedistribution.com/games/fashionista-christmas-eve-party/"
  },
  {
    "id": "5f87666d15ca4544a4238bd2d7a6d995",
    "slug": "connect-clues-the-missing-professor",
    "title": "Connect Clues - The Missing Professor",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/5f87666d15ca4544a4238bd2d7a6d995-512x512.jpg",
    "description": "A tangled detective story is about to unfold.\\n\\nInspector Hale and Detective Crane are on the trail of a mysteriously vanished professor of history and archaeology — who also happens to be Crane’s old friend.\\nProfessor Eldridge was always a touch eccentric, but disappearing without a word and leaving his office turned upside down was never part of his habits. He’s clearly in trouble — and in need of help.",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-13T15:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "First things first — check your Investigation log. It keeps a record of your entire adventure. You can open it anytime by clicking the book icon at the top of the screen.\\n\\nAt the top of the screen, a new clue will appear each turn.\\nMove it left or right using your mouse or finger.\\nWhen you release it, the clue will fall down.\\nTry to make it collide with another of the same kind.\\nWhen two identical clues meet, they combine into a new one.",
    "sourceUrl": "https://gamedistribution.com/games/connect-clues-the-missing-professor/"
  },
  {
    "id": "31a8ddc1eef34b94a4347cd324970878",
    "slug": "save-little-red-hood",
    "title": "Save little red hood",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/31a8ddc1eef34b94a4347cd324970878-512x384.jpg",
    "description": "Match-3 puzzles combined with physics-based gameplay: eliminate blocks to make stones fall and become Little Red Riding Hood's weapons, which she then uses to attack the wolf.\\nPlan your elimination route carefully, utilizing gravity to make the stones fall and become weapons—that's the ultimate goal. Various power-ups can also help you.",
    "publisher": "Cannedfish Game",
    "languages": [
      "Chinese (Simplified)",
      "English",
      "Japanese",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-13T14:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "\\nEliminate blocks to make stones fall and become Little Red Riding Hood's weapons, which she then uses to attack the wolf.",
    "sourceUrl": "https://gamedistribution.com/games/save-little-red-hood/"
  },
  {
    "id": "d436deb6a98e4bd789dbac2d80e8e9cf",
    "slug": "brainrot-cleaning",
    "title": "Brainrot Cleaning",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/d436deb6a98e4bd789dbac2d80e8e9cf-512x384.jpg",
    "description": "Welcome to Brainrot Cleaning, the weirdly satisfying cleaning simulation that turns chaos into calm. In this fun and quirky casual game, your job is to scrub away the mess caused by the wild world of brainrot characters and their hilarious antics! In the Cleaning Italian Brainrot or the Underwater mode, you will finish various cleaning tasks.",
    "publisher": "bestgames.com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-13T13:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/brainrot-cleaning/"
  },
  {
    "id": "33a41fb522c441da90d1b7172ee94b8b",
    "slug": "flower-fairy-adventure-story",
    "title": "Flower Fairy Adventure Story",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/33a41fb522c441da90d1b7172ee94b8b-512x512.jpg",
    "description": "Welcome to Flower Fairy Adventure Story, a casual puzzle game that you can play for free. Flower Fairy lost her wings! Embark on an adventure where you solve each tiny jigsaw, dress up your girl in pretty clothes, and pave the way for the Flower Fairy. Practice your observation, logical thinking, and hands-on ability while enjoying the relaxing and captivating puzzle game.",
    "publisher": "PuzzleGame.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-13T13:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/flower-fairy-adventure-story/"
  },
  {
    "id": "677bcfca4e2244679b94671edc176e66",
    "slug": "cupid-unchained",
    "title": "Cupid Unchained",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/677bcfca4e2244679b94671edc176e66-512x384.jpg",
    "description": "Take aim, shoot true, and break the chains of fate!\\nRescue trapped souls using your trusty bow as you solve clever physics puzzles, shatter chains, and free everyone before time runs out!",
    "publisher": "Orenji Spark",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-13T10:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "- tap and drag to aim\\n- release to shot arrow\\n- free everyone before time runs out",
    "sourceUrl": "https://gamedistribution.com/games/cupid-unchained/"
  },
  {
    "id": "c4bd0be492324609a8a8f0b57ca0807e",
    "slug": "c.a.p.",
    "title": "C.A.P.",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/c4bd0be492324609a8a8f0b57ca0807e-512x384.jpg",
    "description": "Take to the skies and protect the carrier in this shooter inspired by WW2 dogfights. \\nDodge enemy fighters, protect your aircraft carrier, and blast through waves of incoming planes. \\nRemember to come back to the carrier to refuel!\\nWith crisp pixel-art 3D visuals and one-touch controls, this shooter delivers satisfying action perfect for short play.",
    "publisher": "BlackMoon Design",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-13T10:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Use the arrow keys or tap on the screen to turn the plane left and right. \\nShooting is automatic. \\nFly over the carrier to refuel.",
    "sourceUrl": "https://gamedistribution.com/games/c.a.p./"
  },
  {
    "id": "289c76b93595447ab9a7d9a70afac4ac",
    "slug": "ocean-pop",
    "title": "Ocean Pop",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/289c76b93595447ab9a7d9a70afac4ac-512x384.jpg",
    "description": "Ocean Pop is a lively underwater puzzle game where real 2D bubbles float, bounce, and cluster with natural physics. Pop matching bubbles, trigger chain reactions, and enjoy dynamic, ever-shifting puzzles. Its colorful ocean setting, smooth mechanics, and playful movement create a relaxing yet engaging experience that’s easy to learn and satisfying to master.",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-13T08:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Tap or click matching bubbles to pop them, create combos, and clear the floating clusters.",
    "sourceUrl": "https://gamedistribution.com/games/ocean-pop/"
  },
  {
    "id": "dbc504babec040ae805e6cdb7c19e4e3",
    "slug": "prism-match-3d",
    "title": "Prism Match 3D",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/dbc504babec040ae805e6cdb7c19e4e3-512x384.jpg",
    "description": "Enter a dazzling 3D world of colorful prism cubes and test your mind like never before. \\n Immersive 3D Graphics – Rotate, zoom, and explore beautifully crafted levels full of hidden tiles.\\n Addictive \\u0026 Relaxing – Easy to learn, hard to master. Balance logic, timing, and focus to win.\\n Endless Challenges – Progress through creative stages that keep the fun fresh and engaging.\\n Think \\u0026 Unwind – Relax your mind while sharpening memory, observation, and problem-solving skills.",
    "publisher": "AI Gate Labs",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-13T07:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Your goal is clear: clear every tile from the board!\\n\\nOBSERVE: Rotate the 3D structure to inspect stacked layers. Note: only tiles that are not covered by others can be selected.\\n\\nSELECT \\u0026 COLLECT: Tap an eligible tile. It will drop and be added to the tray at the bottom of the screen.\\n\\nMATCH 3 \\u0026 CLEAR: When three identical tiles are in the tray, they automatically merge and vanish, freeing up space. Keep going until the board is empty!\\n\\nBut be careful — your tray holds only 7 slots.",
    "sourceUrl": "https://gamedistribution.com/games/prism-match-3d/"
  },
  {
    "id": "6b91889aa08e40ffbc1c09be1a8e81ce",
    "slug": "dig-out-of-prison",
    "title": "Dig out of Prison",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/6b91889aa08e40ffbc1c09be1a8e81ce-512x384.jpg",
    "description": "You are a prisoner determined to break free. Dig tunnels with a spoon, shovel, or anything you can find. Discover valuables, trade with fellow inmates and even the guards, and earn the prison’s top currency — toilet paper.\\n\\nUpgrade your digging and trading skills, unlock better tools, and speed up your escape. But be careful — plan your moves and avoid drawing attention, because freedom is the prize only for the most cunning.",
    "publisher": "IncrediGames",
    "languages": [
      "English",
      "German",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-13T07:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "You’ll dig through the ground, extract valuable resources, and then sell them. With the money you earn, you can buy upgrades from other inmates.\\nRemember — the main thing is not to get caught by the guard. Don’t let him catch you outside your cell, find your tunnel, or discover your tools.",
    "sourceUrl": "https://gamedistribution.com/games/dig-out-of-prison/"
  },
  {
    "id": "3372368cc9fb461b8470cba307a9087b",
    "slug": "associations",
    "title": "Associations",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/3372368cc9fb461b8470cba307a9087b-512x512.jpg",
    "description": "Find Associations between words!\\n\\nThere are many different levels waiting for you with no time limit. No rush, just an exciting game that will help you relax and unwind.\\n\\nThis game is suitable for those who want to test their wits in this interesting puzzle game!\\n\\nThe game will definitely interest you if you like \\",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-12T15:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "It's very easy to play:\\n\\nFind words that relate to the same topic.\\n\\nClick \\",
    "sourceUrl": "https://gamedistribution.com/games/associations/"
  },
  {
    "id": "6656f428f5d74feb820fdd707ba9a629",
    "slug": "what-a-walk",
    "title": "What a walk",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/6656f428f5d74feb820fdd707ba9a629-1280x550.jpg",
    "description": "Whatawalk! silly walking with wobbly legsWhatawalk! is a highly addictive classical game. Even if you've never heard of it before, play it just once and you'll be hooked.",
    "publisher": "Eyestorm Pte. LTD.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-12T07:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Pull back and release to launch your silly, floppy legs. Walk across short and wide gaps. Just be careful you don't fall in the water!\\nHit the flags to get a checkpoint. Keep going and see what level you can make it to.",
    "sourceUrl": "https://gamedistribution.com/games/what-a-walk/"
  },
  {
    "id": "53fc51e1231447d5b5b85e03c2829e47",
    "slug": "conquer.io",
    "title": "Conquer.io",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/53fc51e1231447d5b5b85e03c2829e47-512x384.jpg",
    "description": "Expand your zone and assert your dominance over every territory on the map. Plan your moves to outmaneuver opponents and gain as much space as possible. But beware, your rivals will stop at nothing to thwart your plans. Are you ready to claim your space?\\n",
    "publisher": "Inlogic Software",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Portuguese",
      "Russian",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-12T07:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Conquer all the territories on the map to advance to the next level. Your rivals can steal your conquered areas and erase your progress, but you can also take what belongs to them. Think strategically, use the speed booster to expand faster and eliminate your opponents.\\n",
    "sourceUrl": "https://gamedistribution.com/games/conquer.io/"
  },
  {
    "id": "d3b2230575e14473823dcb3db1029329",
    "slug": "ellie-and-ben-christmas-eve",
    "title": "Ellie and Ben Christmas Eve",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/d3b2230575e14473823dcb3db1029329-512x384.jpg",
    "description": "Celebrate the magic of the holiday season with Ellie and Ben Christmas Eve, a delightful game where players join Ellie and Ben as they prepare for the most wonderful night of the year. From decorating the tree to picking the perfect outfits, this game brings the charm of Christmas to life in a fun and interactive way.",
    "publisher": "Cutedressup",
    "languages": [
      "No Text"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-12T07:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "Left Mouse Button Click",
    "sourceUrl": "https://gamedistribution.com/games/ellie-and-ben-christmas-eve/"
  },
  {
    "id": "2164c0f43b21402a900136688bdf3b6c",
    "slug": "spider-solitaire",
    "title": "Spider Solitaire",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/2164c0f43b21402a900136688bdf3b6c-512x384.jpg",
    "description": "Test your skills in this classic Spider Solitaire online game. Stack the cards from King to Ace This card game from Agame includes multiple game modes, like spider solitaire 2 suit and 4 suit. For beginners or those looking for a relaxing card game, we recommend the 1 suit mode. ",
    "publisher": "Agame",
    "languages": [],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2017-04-24T10:13:48.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use the mouse to click and drag the cards to the correct place. Stack from King to Ace.",
    "sourceUrl": "https://gamedistribution.com/games/spider-solitaire/"
  },
  {
    "id": "0a8a63b842d543d692fe61cbd27ebaf2",
    "slug": "cube-drop-puzzle",
    "title": "Cube Drop Puzzle",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/0a8a63b842d543d692fe61cbd27ebaf2-512x512.jpg",
    "description": "Colorful bears are waiting to splash water!\\n\\nWelcome to Cube Drop Puzzle!\\n\\nAre you ready to start puzzle solving? Play Cube Drop Puzzle now and make a splash!",
    "publisher": "Bravestars Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-11T08:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Immerse yourself in the ultimate underwater adventure with colorful bears! In Cube Drop Puzzle, your mission is to match colorful bears with holes of the same color so that they can all jump into the lake. As you level up, the space becomes more cramped and the puzzles become more complicated. Are you ready to test your strategic skills in this exciting challenge?",
    "sourceUrl": "https://gamedistribution.com/games/cube-drop-puzzle/"
  },
  {
    "id": "4625c660923c42b8a5c8e4d2fbdc98ee",
    "slug": "2-player-battle",
    "title": "2 Player Battle",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/4625c660923c42b8a5c8e4d2fbdc98ee-512x384.jpg",
    "description": "Seeking an exciting way to spend time with friends and family is most significant. Look no further than Party Battle, the ultimate 2-4 player game! With 30 different games, this exciting collection has something for everyone.",
    "publisher": "Yizhiyuan Network Technology Co., Ltd.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-11T07:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Cocos"
    ],
    "instructions": " if you want to play with your friends on the same device, this game is a great choice!If you don't have friends to play multiplayer on a single device, play against the AI alone!",
    "sourceUrl": "https://gamedistribution.com/games/2-player-battle/"
  },
  {
    "id": "f85ae7d577624125bf748bbb5bb53645",
    "slug": "butterfly-sort-puzzle",
    "title": "Butterfly Sort Puzzle",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/f85ae7d577624125bf748bbb5bb53645-512x384.jpg",
    "description": "Various kinds of butterflies sitting on leaves.\\nShy butterflies can only fly next to friends of the same kind.\\nBring its friends to one leaf and fly them together~",
    "publisher": "MOVISOFT.Co.,Ltd",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-11T08:00:07.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Let's guide various types of butterflies by clicking them and arrange all the butterflies so that four butterflies of the same type gather on a single stem.",
    "sourceUrl": "https://gamedistribution.com/games/butterfly-sort-puzzle/"
  },
  {
    "id": "cd71a6d56b514239b279f07f7cb7694f",
    "slug": "magic-christmas-tree-match-3",
    "title": "Magic Christmas Tree Match-3",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/cd71a6d56b514239b279f07f7cb7694f-512x384.jpg",
    "description": "Magic Christmas Tree Match-3 is a free New Year's match-3 game where you'll complete vibrant levels, create combinations of three or more, earn bonuses, and help the heroes decorate the festive town. Solve match-3 puzzles, combine elements, use power-ups, explosions, and super combos to complete tasks faster and advance the story.",
    "publisher": "Broccoli Games",
    "languages": [
      "English",
      "German",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-10T09:06:49.737Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "How to play match-3 puzzle:\\n\\n● Match 3 or more pieces in a line to explode them.\\n● Match 4 pieces to create the Rocket. The Rocket blows up the whole line!\\n● Match 4 pieces to form a square to create the Spinner. The Spinner destroys one of the targets!\\n● Make a T-shaped match of 5 pieces to create the Bomb. The Bomb makes a massive explosion on the board!\\n● Match 5 pieces in a line to create the Rainbow Flower. The Rainbow Flower explodes pieces of the same color!",
    "sourceUrl": "https://gamedistribution.com/games/magic-christmas-tree-match-3/"
  },
  {
    "id": "a79b2815388140bb8481afced44f2f27",
    "slug": "teacher-simulator-christmas-exam",
    "title": "Teacher Simulator Christmas Exam",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/a79b2815388140bb8481afced44f2f27-512x384.jpg",
    "description": "Welcome to the funniest and busiest Christmas classroom ever! Teacher Simulator: Christmas Exam is a charming and playful teacher class simulator where you act as a holiday teacher. Manage orders, hand out exam papers, grade tests, etc. Different classes are scheduled on different days of the week, such as art class, geography class, math class, and so on.",
    "publisher": "YAD.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-10T08:55:41.140Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/teacher-simulator-christmas-exam/"
  },
  {
    "id": "cfe752f3ab0742bbaa481bd558591c48",
    "slug": "pool-master",
    "title": "Pool Master",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/cfe752f3ab0742bbaa481bd558591c48-512x384.jpg",
    "description": "From a rookie with a cue to a legend of the table, journey through 100 challenging levels with closed pockets, special balls to clear and more. Unlock custom gear, gain special boosts and rule the table with precision and power.\\n",
    "publisher": "Inlogic Software",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Russian",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-10T08:51:08.881Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use directional controls to aim your cue and take shots. Clear all balls by pocketing them, while navigating closed pockets and special balls that require clearing the area. Collect coins to upgrade cues and spin the Lucky Wheel for power-ups.\\n",
    "sourceUrl": "https://gamedistribution.com/games/pool-master/"
  },
  {
    "id": "a328bd1f75004f8b912aa34dc451fb4c",
    "slug": "urus-city-driver",
    "title": "Urus City Driver",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/a328bd1f75004f8b912aa34dc451fb4c-200x120.jpg",
    "description": "Get ready to skid the wheels of a stunning sports SUV through an expansive morning city map! Customize and upgrade your sports car with cool upgradables and become the best driver in the city. Take your dog with you in 3 driving challenges and conquer the missions together. Use nitro to beat slow traffic and beat all speed, stunt and drift triggers spread across the map. Are you ready to show your driving skills? Prove yourself!",
    "publisher": "Fuego! Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-10T08:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Car:\\nArrow Keys/W, A, S, D: Drive/Steer/Brake\\nC: Change Camera\\nF: Nitro\\n\\nCharacter:\\nArrow Keys/W,A,S,D: Move\\nMouse Orbit: Look Around",
    "sourceUrl": "https://gamedistribution.com/games/urus-city-driver/"
  },
  {
    "id": "17f04fa59cb34bdcad6e19639002824c",
    "slug": "kiss-o-neck",
    "title": "Kiss O Neck",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/17f04fa59cb34bdcad6e19639002824c-1280x550.jpg",
    "description": "Kiss O Neck: Stretch, Kiss, and Laugh Out Loud\\nEach level brings a new, funny, and totally unexpected situation.\\nYou never know what’s going to happen when you stretch that neck a little further",
    "publisher": "Eyestorm Pte. LTD.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-10T07:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Kiss O Neck is a super simple yet insanely addictive game!\\nYour mission is easy: stretch your character’s neck to kiss the right target.\\nIt sounds simple, but things can get hilarious, chaotic, and totally out of control.",
    "sourceUrl": "https://gamedistribution.com/games/kiss-o-neck/"
  },
  {
    "id": "47d8f1df35d149d894509585085a9733",
    "slug": "matching-puzzle",
    "title": "Matching Puzzle",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/47d8f1df35d149d894509585085a9733-512x384.jpg",
    "description": "Paintings blocks fall from the sky.\\nWhen you touch the ground, the pictures are covered, remember that picture and guess the same picture.\\nIf you match the picture quickly, you can get additional points as a combo.",
    "publisher": "MOVISOFT.Co.,Ltd",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-09T10:01:13.037Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Click two matching pictures to remove the circles. Since some pictures may be hidden, you’ll need to use your memory.",
    "sourceUrl": "https://gamedistribution.com/games/matching-puzzle/"
  },
  {
    "id": "99423a2819a14804a12f30557091d567",
    "slug": "geometry-vibes-x-arrow",
    "title": "Geometry Vibes X-Arrow",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/99423a2819a14804a12f30557091d567-512x384.jpg",
    "description": "Geometry Vibes X Arrow is the newest evolution of the Geometry Vibes series, offering the most refined, competitive and customizable arrow experience so far. The goal is simple but demanding: guide your arrow through dangerous geometric paths, survive increasingly difficult patterns and reach the portal at the end of each route without touching anything.\\n",
    "publisher": "gameVgames",
    "languages": [
      "Arabic",
      "English",
      "German",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-09T09:59:39.860Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Click MOUSE Left Click or press SPACE to accelerate upward.\\nRelease the button to move downward.\\nIn multiplayer, the additional players use H, L and the Up Arrow.\\nTouch controls are supported on phones and tablets.",
    "sourceUrl": "https://gamedistribution.com/games/geometry-vibes-x-arrow/"
  },
  {
    "id": "8d958e45c13a46c38e62805648e7d801",
    "slug": "my-garden-journey",
    "title": "My Garden Journey",
    "category": "Simulation",
    "thumbnail": "https://img.gamedistribution.com/8d958e45c13a46c38e62805648e7d801-512x512.jpg",
    "description": "Grow your dream garden, raise animals, and enjoy peaceful farm life!\\n\\nWelcome to My Garden Journey! ?? Start your peaceful farming adventure in My Garden Journey, the ultimate relaxing farming simulator!",
    "publisher": "Bravestars Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-09T09:57:44.173Z",
    "lastUpdated": "",
    "genres": [
      "Simulation",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Grow Your Dream Garden – Plant a variety of seeds, water them, and watch your garden bloom into a colorful paradise. ?\\nRaise Adorable Animals – Take care of cute animals like chickens, cows, and more. Watch them thrive and help your farm grow! ?\\nCustomize Your 3D Garden – Personalize every part of your garden with various decorations, plants, and layouts to make it uniquely yours. ?",
    "sourceUrl": "https://gamedistribution.com/games/my-garden-journey/"
  },
  {
    "id": "8e09904258a5423bbf7fab0831ba5820",
    "slug": "merge-tower-hero",
    "title": "Merge Tower Hero",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/8e09904258a5423bbf7fab0831ba5820-512x384.jpg",
    "description": "Dive into Merge Tower Hero, an exhilarating online puzzle - Merge game that sharpens your mathematical thinking while exhilaratingly combining action, strategy, and combat. Assemble your team and tackle challenging battles that require not only strength but clever gameplay strategies to prevail!",
    "publisher": "kiz10.com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-09T07:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Use the mouse or touch to merge the characters",
    "sourceUrl": "https://gamedistribution.com/games/merge-tower-hero/"
  },
  {
    "id": "46faa9ffc990467088b2197ef067044b",
    "slug": "mojicon-winter-connect",
    "title": "Mojicon Winter Connect",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/46faa9ffc990467088b2197ef067044b-512x384.jpg",
    "description": "The Mojicon series returns for the holidays! Match festive tiles, break the new Ice Sheet blockers, and enjoy a relaxing winter puzzle adventure. ❄️\\nMojicon Winter Connect takes the classic Onet matching fun you love and covers it in a layer of fresh snow. Immerse yourself in a cozy holiday atmosphere, connecting festive icons like reindeer, gingerbread men, and happy snowmen.\\nFast, satisfying, and full of seasonal charm – it’s the perfect winter puzzle for all ages. ✨✨✨",
    "publisher": "2Million Games",
    "languages": [
      "Czech",
      "Dutch",
      "English",
      "French",
      "German",
      "Italian",
      "Japanese",
      "Polish",
      "Portuguese",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-08T09:19:34.349Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Tap or click two matching emoji tiles to connect them with a line and clear them from the board.\\nThe connection path can turn up to two times – plan your matches carefully!\\nClear the board before time runs out to win stars.\\nUse Hints or Shuffle power-ups when you’re stuck, and chase the highest combo streak!",
    "sourceUrl": "https://gamedistribution.com/games/mojicon-winter-connect/"
  },
  {
    "id": "ebe47e4a2ba74df39ab40cb9f0d09705",
    "slug": "radical-rappelling",
    "title": "Radical Rappelling",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/ebe47e4a2ba74df39ab40cb9f0d09705-512x512.jpg",
    "description": "Feel the rush and hold on tight as Radical Rappelling is back!\\n\\nJoin Rip and Roxy as you rappel down mountains at breakneck speed using your rapid reflexes.\\n\\nPull off death-defying tricks by ricocheting between launch pads, riding rainbows and rocketing over obstacles in the most redonkulous adventure ever.\\n\\nRack up coins and complete rockin’ missions to unlock sweet new gear for Rip and Roxy, the most fearless risk-takers on the planet.\\n",
    "publisher": "Yes2Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-08T08:58:55.388Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Tap to jump to the opposite cliff face, time your movement to avoid obstacles.",
    "sourceUrl": "https://gamedistribution.com/games/radical-rappelling/"
  },
  {
    "id": "6416456afd5147b489069f061ea00699",
    "slug": "royal-garden-match-2",
    "title": "Royal Garden Match 2",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/6416456afd5147b489069f061ea00699-512x384.jpg",
    "description": "Royal Garden Match 2 is here! Join Aria as she tends the kingdom’s most prestigious Royal Garden. Restore it to its former glory by completing fun match-3 puzzles! Match royal flowers, fruits, and plants across hundreds of levels packed with daily missions and challenges. Enjoy a magical journey full of beauty, strategy, and rewards. Play Royal Garden Match 2 now and bring the Royal Garden back to life!",
    "publisher": "SOFTGAMES – Mobile Entertainment Services GmbH",
    "languages": [
      "Dutch",
      "English",
      "French",
      "German",
      "Italian",
      "Polish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-08T09:00:01.453Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "Match three or more identical icons in this exciting tile-matching game! Swap flowers, fruits, and plants by dragging them to switch places—each move must form a valid match. Keep an eye on the panel to see which items to collect and how many moves you have. Match 4 or 5 pieces to unleash powerful line bursts, cross bursts, and color boosters. Merge boosters for even bigger effects! Strategize your moves, create stunning combos, and complete levels with dazzling garden magic!",
    "sourceUrl": "https://gamedistribution.com/games/royal-garden-match-2/"
  },
  {
    "id": "3c25a8f0c83b46e19bf2358c01a0c699",
    "slug": "merge-christmas",
    "title": "Merge Christmas",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/3c25a8f0c83b46e19bf2358c01a0c699-512x384.jpg",
    "description": "Merge Christmas is a festive puzzle game where you combine matching snowballs to create new character / bigger snowballs, and unlock a cozy Christmas world. Relax and merge Christmas-themed snowballs in a cheerful winter atmosphere perfect for the holiday season.",
    "publisher": "BestGamesFreePlay.com",
    "languages": [
      "English",
      "Russian",
      "Simple English",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-08T08:57:36.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Desktop: Move mouse to move the snowball, then release to drop it.\\nMobile: Tap and drag to move the snowball, then release to drop it.\\nDrop snowballs into the box to merge two or more identical ones to create new character / bigger snowballs.",
    "sourceUrl": "https://gamedistribution.com/games/merge-christmas/"
  },
  {
    "id": "67b7fb2c6f594ef3a4fcb241e902ce1d",
    "slug": "rescue-sharp-turn",
    "title": "Rescue Sharp Turn",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/67b7fb2c6f594ef3a4fcb241e902ce1d-512x384.jpg",
    "description": "Rescue Puzzle 3D is a lightweight 3D fun puzzle game. You need to click on the correct objects in the small three-dimensional scene to trigger mechanisms, remove obstacles or form a chain reaction to meet the level conditions and rescue the injured character. The levels are short but full of ingenuity: turn off the power switch, move rocks, release water to extinguish fire, synthesize props...",
    "publisher": "Raccoon",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-07T15:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "PC:Left Click to interact\\nMobile:Tap interaction\\nRetry button to reopen this switch with one click",
    "sourceUrl": "https://gamedistribution.com/games/rescue-sharp-turn/"
  },
  {
    "id": "9ece082e461e4216a0d7b2a38f0a95ad",
    "slug": "steal-brainrot-monsters!",
    "title": "Steal Brainrot Monsters!",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/9ece082e461e4216a0d7b2a38f0a95ad-1280x720.jpg",
    "description": "Step into a world of fun, charm, and Italian flair with Buy Cute and Funny Animals! From the tiny and delightful Nubini Pizzanini to the rare and majestic Tralalelo Tralala and the playful Los Tralalelitos, there’s no shortage of adorable creatures to collect.\\n\\nBuild your very own cozy base, place your animals in it, and make them feel right at home. In return, they’ll reward you with coins, which you can use to unlock even more animals and exciting upgrades.",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-07T14:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "For computers:\\n\\n- Move using the arrow keys\\n\\n- Rotate the camera using mouse movements\\n\\n- Interact with animals using the U key\\n\\n- Jump using the space bar\\n\\nFor phones:\\n\\n- Move using the joystick on the left side of the screen\\n\\n- Rotate the camera using the right side of the screen\\n\\n- Interact with monsters using the pop-up window above the monster\\n\\n- Jump using the button on the right side of the screen\\n\\nTranslated with DeepL.com (free version)",
    "sourceUrl": "https://gamedistribution.com/games/steal-brainrot-monsters!/"
  },
  {
    "id": "623a520854894d7baf1f34fb9e86cda9",
    "slug": "ball-craze-sort",
    "title": "Ball Craze Sort",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/623a520854894d7baf1f34fb9e86cda9-512x384.jpg",
    "description": "Ball Craze Sort is a fun, relaxing, and addictive puzzle game where your goal is to sort colorful balls into the correct order. What starts as a simple task quickly turns into a brain-teasing challenge as more colors and tubes are introduced.\\nBall Craze Sort is the perfect game to unwind or mentally recharge. Whether you’re looking to relax for a few minutes or challenge your logic skills for hours, this game offers the ideal balance between fun and focus.",
    "publisher": "minigame",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-07T12:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Tap on a tube to pick up the top ball\\n\\nTap another tube to drop the ball\\n\\nYou can only place a ball onto another of the same color or an empty tube\\n\\nSort all balls so that each tube contains only one color\\n\\nUse strategy and planning to avoid getting stuck as levels get harder!\\n\\nTip: If you run out of moves, you can restart the level or use a hint to help find the next step.",
    "sourceUrl": "https://gamedistribution.com/games/ball-craze-sort/"
  },
  {
    "id": "65bd69abf7024736ac2fa7b528abd21e",
    "slug": "nine-cards-of-winter",
    "title": "Nine Cards Of Winter",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/65bd69abf7024736ac2fa7b528abd21e-512x384.jpg",
    "description": "Get into the holiday spirit with Nine Cards of Winter, a fun and relaxing tile-matching game!\\nPick up to 9 Christmas tiles and match 3 of the same to clear them. Watch out — if your stack fills up, the game is over!\\nUse smart moves to uncover hidden tiles, solve tricky puzzles, and enjoy cute holiday designs.It’s easy to play, relaxing to enjoy, and full of winter charm!",
    "publisher": "Lof Games",
    "languages": [
      "Arabic",
      "Bulgarian",
      "Chinese (Simplified)",
      "Czech",
      "Danish",
      "Dutch",
      "English",
      "Estonian",
      "Finnish",
      "French",
      "German",
      "Greek",
      "Hebrew",
      "Hindi",
      "Hungarian",
      "Indonesian",
      "Italian",
      "Japanese",
      "Korean",
      "Latvian",
      "Lithuanian",
      "Polish",
      "Portuguese",
      "Romanian",
      "Russian",
      "Serbian",
      "Simple English",
      "Slovak",
      "Spanish",
      "Swahili",
      "Swedish",
      "Tagalog",
      "Thai",
      "Turkish",
      "Ukrainian",
      "Vietnamese"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-07T09:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use your mouse or touchpad to tap tiles and match three of the same to clear them.",
    "sourceUrl": "https://gamedistribution.com/games/nine-cards-of-winter/"
  },
  {
    "id": "9addb82d5ce74fb5b2eab726f8524cac",
    "slug": "darts-jam",
    "title": "Darts Jam",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/9addb82d5ce74fb5b2eab726f8524cac-512x384.jpg",
    "description": "This is a casual game of shooting balloons with darts.\\n\\nWhen all the darts are pulled out, the board will also fall. When all the boards fall, the game is won.\\n\\nThe game is easy and simple to play, and the difficulty is getting stronger and stronger, which is challenging",
    "publisher": "HeiTie",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-06T14:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Click on the dart, and the balloon of the same color as the dart will be shot.\\n\\nIf there is no balloon of the same color, the dart will be temporarily placed.\\n\\nOnly the dart that can be seen completely can be clicked.\\n\\nAs the game progresses, the colors of the darts and balloons will increase, and the difficulty will also increase.\\n",
    "sourceUrl": "https://gamedistribution.com/games/darts-jam/"
  },
  {
    "id": "2397418fd5a443fc948a60bd7784d7b6",
    "slug": "cube-king",
    "title": "CUBE KING",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/2397418fd5a443fc948a60bd7784d7b6-512x384.jpg",
    "description": "Show them who's the real King here!\\n\\nNew cubes appear from the portals at the bottom. Your task is to connect cubes with the same numbers by moving them from one stack to another!\\n\\nYou get coins for every merge. Use them wisely:\\nUpgrade a selected cube!\\nUnlock new portals with cubes!\\nIncrease the starting level of cubes!\\nExtinguish burning cubes or instantly shatter the ice on all frozen cubes!\\n\\nBut be careful: if a stack overflows, the game ends!",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-06T14:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Every 15 seconds, cubes appear on the rods.\\nMove them between rods to connect cubes with the same number!\\n\\nIf a stack overflows, the game ends.\\n\\n1 Tap a cube to select it.\\n2 Tap another cube where you want to place it.\\n3 You get coins for merging cubes.\\n\\nWhen a cube with a number divisible by 5 (5, 10, 15, 20, 25) appears, you get a random boost.\\nBoosts can be good or bad :)\\nGood ones:\\nExtra coins!\\nUpgrade random cubes!\\nBad ones:\\nFire Arrows - burning cubes lose 1 index every 5 seconds!",
    "sourceUrl": "https://gamedistribution.com/games/cube-king/"
  },
  {
    "id": "a3889875d26547899d96b0364d6473f5",
    "slug": "magic-sort",
    "title": "Magic Sort",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/a3889875d26547899d96b0364d6473f5-512x384.jpg",
    "description": "Welcome to Magic Sort! — a relaxing and satisfying color-sorting puzzle with a cute cat café twist!\\nYour job is to organize colorful water layers inside multiple bottles. Each bottle contains mixed colors, and you must pour them carefully to sort every color correctly. Remember:\\nYou can only pour when the top layers are the same color.\\nOnce a bottle is perfectly sorted and filled with a single color, it magically transforms into a finished drink for your adorable cat customers!",
    "publisher": "QiGame",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-06T08:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Female",
      "YoungAdults",
      "Portrait",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Use left mouse button to play the game.",
    "sourceUrl": "https://gamedistribution.com/games/magic-sort/"
  },
  {
    "id": "9962fb2d0d6c4cc0b87b314d9db3d0e4",
    "slug": "roller-coaster-3d",
    "title": "Roller Coaster 3D",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/9962fb2d0d6c4cc0b87b314d9db3d0e4-200x120.jpg",
    "description": "Go through this roller coaster, pick up more passengers along the way and have more fun!\\nCan you pass all the obstacles and enjoy all the crazy loops?\\nEnjoy the ride!\\nUnlocks all the different mechanics and many levels!",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-05T13:52:48.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "The gameplay is simple:\\n\\njust swipe left or right\\ntry to collect as much money as possible\\nand also try to attract more people to you and avoid obstacles",
    "sourceUrl": "https://gamedistribution.com/games/roller-coaster-3d/"
  },
  {
    "id": "eb75ff08712148498a298d9a8e0defb0",
    "slug": "blast-cubes",
    "title": "Blast Cubes",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/eb75ff08712148498a298d9a8e0defb0-512x384.jpg",
    "description": "Blast Cubes is an addictive puzzle game where players strategically place cubes on a grid. When cubes align in horizontal or vertical rows, they explode, triggering an exciting chain reaction! After the explosion, characters of the same color as the exploded cube emerge and move towards vehicles of the same color waiting at the top. Once the vehicles are filled, new ones appear, continuing the cycle. ",
    "publisher": "minigame",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-05T11:35:00.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "1. Place Cubes on the Grid\\n\\n2. Create Matches to Blast Cubes\\n\\n3. Watch Characters Rush Out\\n\\n4. Fill the Vehicles\\n\\n5. Complete the Level Goal\\n\\n6. Think Ahead\\n",
    "sourceUrl": "https://gamedistribution.com/games/blast-cubes/"
  },
  {
    "id": "c743d2205548425eb70d6f3d71433518",
    "slug": "stickman-weapon-master",
    "title": "Stickman Weapon Master",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/c743d2205548425eb70d6f3d71433518-1280x550.jpg",
    "description": "Fight as a lone brave stickman against the tyranny and Evil\\nFight as a lone brave stickman against the tyranny and evil Lord in the land of Stickman Weapon Master.",
    "publisher": "Eyestorm Pte. LTD.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-05T08:00:00.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Experience the deep and satisfying combat system, packed with numerous weapons and different play style for you to master. Feel the thrill after every swing and the glory after every kill.",
    "sourceUrl": "https://gamedistribution.com/games/stickman-weapon-master/"
  },
  {
    "id": "9f6470d2e9ca4e588d5d6d684ae97535",
    "slug": "furry-wedding-proposal",
    "title": "Furry Wedding Proposal",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/9f6470d2e9ca4e588d5d6d684ae97535-512x384.jpg",
    "description": "Hi, young stylist! You will find a very unusual couple in love - a brutal fox and a feminine bunny - who are preparing for their future wedding. They dream of looking stunning on this holiday and you will become their main assistant in this exciting adventure! You have to dress the characters in beautiful wedding dresses, choose stylish hairstyles for them and apply light makeup. Create, fantasize and create a fairy tale!",
    "publisher": "DL-studio",
    "languages": [
      "No Text"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-05T07:50:06.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "This game takes you to a fictional world of anthropomorphic animals, where you will create vivid wedding images for a very unusual couple of lovers. The most interesting wedding images can be saved as a screenshot in PNG format. Depending on the gaming device, either a click of a computer mouse or a simple touch on touchscreens is used to control it.",
    "sourceUrl": "https://gamedistribution.com/games/furry-wedding-proposal/"
  },
  {
    "id": "f197078cca5e419799f5bd6132911061",
    "slug": "marble-blast",
    "title": "Marble Blast",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/f197078cca5e419799f5bd6132911061.jpg",
    "description": "TapClick the marble to blast and clean the screen Be careful though because you only have a limited number of moves",
    "publisher": "Arwin Margallo",
    "languages": [],
    "mobile": [],
    "firstActiveDate": "2017-12-06T05:55:21.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Phaser3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "HTML5",
      "Phaser3"
    ],
    "instructions": "",
    "sourceUrl": "https://gamedistribution.com/games/marble-blast/"
  },
  {
    "id": "8c7b4c26a7784cacbda79f8510c6256d",
    "slug": "road-of-fury-4",
    "title": "Road Of Fury 4",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/8c7b4c26a7784cacbda79f8510c6256d-512x384.jpg",
    "description": "Road Of Fury 4 is a scroller shooter game set in a world of post-apocalypse. Team-up with other nomads, upgrade cars, guns and super-powers and use your skills to fight through 30 levels and 3 bosses.",
    "publisher": "IriySoft",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-04T09:42:43.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Kids",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use mouse/finger to aim the guns.\\n\\n1, 2, 3 to activate super-powers.",
    "sourceUrl": "https://gamedistribution.com/games/road-of-fury-4/"
  },
  {
    "id": "22083d0b3576411caa671156a9fe4052",
    "slug": "stick-vs-monster-school-2",
    "title": "Stick vs Monster School 2",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/22083d0b3576411caa671156a9fe4052-512x384.jpg",
    "description": "Stick vs Monster School 2 is now fighting zombies!\\n\\nHe's in for fights and epic battles in the world during the zombie apocalypse!\\n\\nGame features:\\n- Make cool shot\\n- Buy guns\\n- Fight zombies and bosses!\\n\\nDid you like the game \\",
    "publisher": "Stickman vs Monster School Team",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-04T08:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Arrows - move.\\nSpace \\\\ E - attack.\\nDefeat all enemies on the level to move to the next one.\\nCollect coins and upgrade your stickman!",
    "sourceUrl": "https://gamedistribution.com/games/stick-vs-monster-school-2/"
  },
  {
    "id": "8d998b803efd44069ae1d2da6f13e04a",
    "slug": "word-clash",
    "title": "Word Clash",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/8d998b803efd44069ae1d2da6f13e04a-512x384.jpg",
    "description": "Words are the key to progress. With a massive number of levels to explore, you will improve your vocabulary. Use hints when needed and stay hooked for hours. Keep solving, keep learning and see how many challenges you can conquer along the way.\\n",
    "publisher": "Inlogic Software",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Portuguese",
      "Russian",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-04T08:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Letters are randomly placed on the board. The goal is to form words. The number of empty spaces above indicates how many words need to be created. Hints can be used for tough spots, while relaxing backgrounds change as you progress.\\n",
    "sourceUrl": "https://gamedistribution.com/games/word-clash/"
  },
  {
    "id": "9de57f3906034545b9d539588be77914",
    "slug": "nuwpy's-adventure",
    "title": "Nuwpy's Adventure",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/9de57f3906034545b9d539588be77914-512x384.jpg",
    "description": "Nuwpy’s Adventure is a classic pixel-art platformer inspired by retro arcade games!\\nHelp Nuwpy explore colorful worlds, collect coins, jump over enemies, and avoid traps.\\nEach level offers new challenges, hidden secrets, and a fast-paced journey full of charm and nostalgia.\\nDive into the pixel world and enjoy simple yet addictive gameplay!",
    "publisher": "GameBerry Studio",
    "languages": [
      "English",
      "French"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-04T07:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Use the arrow keys to move left or right.\\nPress Space to jump.\\nCollect coins, avoid enemies, and reach the end of the level to win.\\nBe careful — just a few mistakes, and you’ll have to start again!",
    "sourceUrl": "https://gamedistribution.com/games/nuwpy's-adventure/"
  },
  {
    "id": "5dddc7c662d64008b4ba338bb73c4df4",
    "slug": "tailor-stylist:-fashion-diary",
    "title": "Tailor Stylist: Fashion Diary",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/5dddc7c662d64008b4ba338bb73c4df4-512x512.jpg",
    "description": "Welcome to Tailor Stylist: Fashion Diary – the place where your style dreams come to life! Step into the shoes of a talented fashion designer, build your own boutique, and create stunning outfits that dazzle the world. From fabric to final look, you’re in charge of every stitch! ",
    "publisher": "Bravestars Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-03T08:48:02.816Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Cut, sew, and style beautiful clothes for your fashion-loving clients. Whether it's a red carpet gown, a chic office outfit, or a cute casual set, you can make it all! Mix and match trendy fabrics, add sparkly accessories, and create personalized looks that fit every occasion.",
    "sourceUrl": "https://gamedistribution.com/games/tailor-stylist:-fashion-diary/"
  },
  {
    "id": "53e41110ad824e5e964553586f8db71d",
    "slug": "hexa-stack-christmas",
    "title": "Hexa Stack Christmas",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/53e41110ad824e5e964553586f8db71d-512x384.jpg",
    "description": "Get into the holiday spirit with Hexa Stack Christmas: a festive twist on the classic hexagon-stacking puzzle game. Place the Christmas-themed hexagon tiles stacks onto the board and sort the same color tiles to collect them. The game combines a light puzzle that requires attention and logic — perfect for relaxing while stimulating your brain. 2 game modes, infinite levels, a user-friendly interface, and save support let you play anytime without losing progress.",
    "publisher": "BestGamesFreePlay.com",
    "languages": [
      "English",
      "French",
      "German",
      "Russian",
      "Simple English",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-03T08:49:16.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Tap to select a stack of hexagonal tiles.\\nDrag to move it onto the board. Release to place it.\\nSame color tiles will be auto-sorted (stacked).\\nTiles are collected once at least 10 tiles having the same color are sorted.",
    "sourceUrl": "https://gamedistribution.com/games/hexa-stack-christmas/"
  },
  {
    "id": "22ec0631463941b88ce8c3ab2fd60199",
    "slug": "pet-me-maze",
    "title": "Pet Me Maze",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/22ec0631463941b88ce8c3ab2fd60199-1280x550.jpg",
    "description": "Welcome to Pet Me Maze, the most hilarious and addictive maze puzzle game that combines humor, challenge, and adorable pets\\nAre you ready to test your wits and reflexes in a maze full of surprises, traps, and funny moments",
    "publisher": "Eyestorm Pte. LTD.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-03T08:43:39.370Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Pet Me Maze brings the joy of solving puzzles to everyone. Just tap to guide your pet’s head through colorful mazes, dodge dangerous traps, and collect hidden treasures along the way. It sounds easy but each level introduces new twists that keep the challenge fresh and fun every time you play",
    "sourceUrl": "https://gamedistribution.com/games/pet-me-maze/"
  },
  {
    "id": "a75b82d28b4b4083bbc8ad4394570d97",
    "slug": "epic-stunts-pvp-3d",
    "title": "Epic Stunts PvP 3D",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/a75b82d28b4b4083bbc8ad4394570d97-200x120.jpg",
    "description": "Skid the wheel of a stunning muscle car through 3 awesome game modes and showcase your driving skills. Customize your car according to your taste and drive in style with the roaring engines. Feel the heat in 2 player mode where you go head to head with your friend in 2 amazing game modes! Are you ready to conquer the stunt city? Prove yourself with Two Stunt Racers!",
    "publisher": "Fuego! Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-03T08:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Player 1:\\nW,A,S,D: Drive/Steer/Brake\\n\\nPlayer 2:\\nArrow Keys: Drive/Steer/Brake",
    "sourceUrl": "https://gamedistribution.com/games/epic-stunts-pvp-3d/"
  },
  {
    "id": "e8b63ec491bd4950a0bf2247aeb20898",
    "slug": "hexa-tap-away",
    "title": "Hexa Tap Away",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/e8b63ec491bd4950a0bf2247aeb20898-512x512.jpg",
    "description": "Hexa Tap Away is a sleek one-direction hex puzzle. Drag tiles to move them in the only direction they can travel, create space, and clear the board. Each level adds trickier layouts, blockers, and tight corridors that demand planning ahead. Short, snackable stages, smooth controls, and a clean look make it easy to start and hard to stop. Stuck? Try a hint or rethink your route and there’s always a smarter move!",
    "publisher": "CursoraLabs",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-03T07:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "On Desktop: MOUSE and LEFT-CLICK\\nOn Mobile: Touch Controls",
    "sourceUrl": "https://gamedistribution.com/games/hexa-tap-away/"
  },
  {
    "id": "faf82d1dacfa46529b8511e50fee6768",
    "slug": "card-quest:-10-minute-adventure",
    "title": "Card Quest: 10 Minute Adventure",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/faf82d1dacfa46529b8511e50fee6768-512x384.jpg",
    "description": "Embark on an exhilarating journey with Card Quest: 10 Minute Adventure, where quick thinking and strategy collide in an exciting online card challenge. Build your deck, make smart moves, and face thrilling encounters that test your skills and timing. Designed for both desktop and mobile players, this free-to-play adventure delivers fast, tactical gameplay and endless replayability. Every decision shapes your path — can you conquer the quest in just ten minutes?",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-03T07:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "• Deck Building: Before starting a match, create your deck using cards you’ve collected. Customize your deck based on strategy—focus on attack-heavy units, healing abilities, or powerful spells. \\n• Winning Conditions: Outlast your opponent by maintaining stronger forces, controlling key areas, and dealing consistent damage. ",
    "sourceUrl": "https://gamedistribution.com/games/card-quest:-10-minute-adventure/"
  },
  {
    "id": "7cc0378d15b34bcea94a051b0aab0de9",
    "slug": "cinema-business-idle-games",
    "title": "Cinema Business - Idle Games",
    "category": "Simulation",
    "thumbnail": "https://img.gamedistribution.com/7cc0378d15b34bcea94a051b0aab0de9-512x384.jpg",
    "description": "Build and manage your own cinema empire! \\nUnlock movie rooms, snack and burger corners to attract more customers.\\nHire staff, upgrade facilities, and keep your theater running smoothly.\\nEarn cash even while you’re offline and grow your business.\\nBecome the ultimate cinema tycoon in this fun idle arcade game!",
    "publisher": "TapNation",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-02T09:17:42.013Z",
    "lastUpdated": "",
    "genres": [
      "Simulation",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Unlock movie rooms, snack corners, and expand your theater to attract more customers.\\nHire staff, serve popcorn, and become the ultimate cinema tycoon in this fun idle arcade game!",
    "sourceUrl": "https://gamedistribution.com/games/cinema-business-idle-games/"
  },
  {
    "id": "2541c94a787f4c58b94636a38c3aa060",
    "slug": "epic-racing-descent-on-cars",
    "title": "Epic Racing - Descent on Cars",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/2541c94a787f4c58b94636a38c3aa060-512x384.jpg",
    "description": "To tear yourself and your neighbor to shreds, but to reach the finish line first is an \\",
    "publisher": "Mirra Games",
    "languages": [
      "English",
      "Russian",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-02T08:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Controls:\\nMovement: W (forward), S (backward), A (left), D (right).\\nEverything else is done through the game interface.\\n\\nFor mobile devices, use the game interface.\\n\\nObjective: Be the first to reach the finish line!",
    "sourceUrl": "https://gamedistribution.com/games/epic-racing-descent-on-cars/"
  },
  {
    "id": "40ec584436da4841b9b80e9d649112e2",
    "slug": "chain-puzzle",
    "title": "Chain Puzzle",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/40ec584436da4841b9b80e9d649112e2-1280x550.jpg",
    "description": "Chain Puzzle is a relaxing logic game where you carefully untangle intricate chained constructions. Each construction is a single system of two same-colored balls connected by a chain. Every move changes the shape of the structure: the chain can automatically shorten, opening new ways to solve the puzzle. Observe, adjust positions, and find the right sequence of actions to completely unravel the knot.",
    "publisher": "GameBerry Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-02T07:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "In front of you are balls connected by chains and bolts around which the chain can get tangled. Drag the balls to change the position of the entire construction and gradually free it from twists. Make sure the chain doesn’t wrap around bolts — your goal is to fully untangle the structure and keep the chain straight and free. Think ahead and choose the right movement paths to solve the puzzle.",
    "sourceUrl": "https://gamedistribution.com/games/chain-puzzle/"
  },
  {
    "id": "86206438f9f6400b872db8ad472d6ee0",
    "slug": "sort-game-toy-sort",
    "title": "Sort Game Toy Sort",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/86206438f9f6400b872db8ad472d6ee0-512x384.jpg",
    "description": "Enjoy some adorable sorting fun in Sort Game: Toy Sort. This delightful match 3 puzzle and casual sort game challenges you to organize colorful dolls and toys. Match and eliminate all dolls within the limited time. When you encounter difficulties, use items to help you quickly clear the level. Such as Convert, Eliminate, Refresh or Break.",
    "publisher": "YAD.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-02T07:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/sort-game-toy-sort/"
  },
  {
    "id": "76c614d8563843d1853f7628eabf69b3",
    "slug": "winter-wonderland-mahjong",
    "title": "Winter Wonderland Mahjong",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/76c614d8563843d1853f7628eabf69b3-1280x550.jpg",
    "description": "Escape into a cozy Winter Wonderland filled with snowflakes, penguins, and festive cheer! Relax with calming music as you match beautifully crafted tiles in this soothing Mahjong puzzle game. Unlock charming new backgrounds and unique tile designs as you progress, each adding warmth and wonder to your journey. Perfect for unwinding, celebrating the holidays, and discovering the magic of winter—one match at a time.",
    "publisher": "SOFTGAMES – Mobile Entertainment Services GmbH",
    "languages": [
      "Dutch",
      "English",
      "French",
      "German",
      "Italian",
      "Japanese",
      "Polish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-01T09:11:44.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Find and match identical winter-themed tiles, making sure each one is free on at least one side to clear it from the snowy board. Remove all tiles to complete each frosty layout and bring harmony to the Winter Wonderland! Use Shuffle, Hint, or Undo if you get stuck, and earn stars as you journey through endless cozy puzzles. Relax and enjoy the serene beauty of the snow-covered world in this heartwarming Mahjong adventure!",
    "sourceUrl": "https://gamedistribution.com/games/winter-wonderland-mahjong/"
  },
  {
    "id": "516d6908fbc848bdb89e65a58a43a7dc",
    "slug": "basketball-stars-2026",
    "title": "Basketball Stars 2026",
    "category": "Sports",
    "thumbnail": "https://img.gamedistribution.com/516d6908fbc848bdb89e65a58a43a7dc-512x384.jpg",
    "description": "Basketball Stars is a cool 2 player basketball game by MadPuffers. Prepared for the 2025 basketball season. Choose your team and enter a challenging tournament. Control your player to perform awesome dunks and 3-pointers to win the game. Feel free to block and slap your opponent to knock him out and get the ball, and pay attention to the supershot bar on the top of the screen. Once fully loaded, you can use the hot special dunk from wherever you stand; it never fails. Be the best player!",
    "publisher": "MadPuffers",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-01T09:10:13.884Z",
    "lastUpdated": "",
    "genres": [
      "Sports",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Male",
      "Kids",
      "Teens",
      "Landscape",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "1 player controls\\nWASD or arrow keys to move\\nX/L to shoot/steal\\nS to pump/block\\nA+A or D+D or left/right arrow twice to dash\\nK/Z to super shot\\n\\n2 player controls\\nTo move, player 1 use the WASD keys and player 2 use arrow keys\\nTo shoot/steal, player 1 use B and player 2 use L\\nTo pump, player 1 use S and player 2 use down arrow\\nTo dash, player 1 use A/D twice and player 2 use left/right arrow twice\\nK to super shot",
    "sourceUrl": "https://gamedistribution.com/games/basketball-stars-2026/"
  },
  {
    "id": "69b2f560952c40de9fe5cc459eb02bfa",
    "slug": "winter-solitaire-tripeaks",
    "title": "Winter Solitaire TriPeaks",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/69b2f560952c40de9fe5cc459eb02bfa-1280x550.jpg",
    "description": "Take a break from the holiday bustle and unwind with Winter Solitaire TriPeaks!\\nPlay over 500 frosty levels and clear shimmering, ice-covered tableaus. Escape into a peaceful winter wonderland filled with enchanting scenes that evolve as you build magical locations throughout the game. From a cozy cottage to a snow-dusted palace, every setting is a feast for the eyes.\\n\\nDiscover the most heart-warming Solitaire experience of the season — and let the snowflakes guide your cards to victory!",
    "publisher": "Mad Data",
    "languages": [
      "English",
      "French",
      "German",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-01T09:10:55.844Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Remove all cards from the tableau by playing any face-up card that is one higher or lower than the stock card. When stuck, flip the next stock card. The game ends when the tableau is cleared or no moves remain.",
    "sourceUrl": "https://gamedistribution.com/games/winter-solitaire-tripeaks/"
  },
  {
    "id": "1b392a6ff2514ce48a70c90b349e5de5",
    "slug": "word-connect-puzzle",
    "title": "Word Connect Puzzle",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/1b392a6ff2514ce48a70c90b349e5de5-200x120.jpg",
    "description": "Word Connect Puzzle is a relaxing yet brain-boosting word game. Swipe letters to form hidden words, unlock new packs, and watch the difficulty rise as your vocabulary grows. Earn stars, complete daily challenges, and use hints when you’re stuck. Play offline anytime, enjoy clean visuals and smooth controls, and chase streak bonuses for higher scores. Perfect for quick sessions or long puzzle runs—smart, simple, and satisfying for all ages.",
    "publisher": "CursoraLabs",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-12-01T07:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "On Desktop:\\nMOUSE and LEFT-CLICK\\n\\nOn Mobile Devices:\\nTouch Controls",
    "sourceUrl": "https://gamedistribution.com/games/word-connect-puzzle/"
  },
  {
    "id": "675852fa01924aa2bc4f2723c1349d05",
    "slug": "bubble-trouble-2:-rebubbled",
    "title": "Bubble Trouble 2: Rebubbled",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/675852fa01924aa2bc4f2723c1349d05-512x384.jpg",
    "description": "A classic arcade bubble shooter where you play as a devil in a trench coat, armed with a harpoon gun to tackle dangerous bouncing bubbles. Each bubble you shoot splits into smaller ones until they're completely destroyed. Navigate through levels with platforms and power-ups while avoiding contact with any bubble.\\n\\nHow to play:\\n- Clear all bubbles from each level to progress\\n- Avoid getting touched by bubbles - or lose a life\\n- Features single-player and cooperative multiplayer modes",
    "publisher": "Aditon Inc",
    "languages": [
      "English",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-30T15:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Avoid and pop the bubbles.\\nSPACE to shoot, ARROW KEYS to move.",
    "sourceUrl": "https://gamedistribution.com/games/bubble-trouble-2:-rebubbled/"
  },
  {
    "id": "fc03dd1d102445f682db4f25284ac990",
    "slug": "duo-family-santa",
    "title": "Duo Family Santa",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/fc03dd1d102445f682db4f25284ac990-512x384.jpg",
    "description": "Steve and Alex need to race against each other. The one who holds the Lucky Block wins the game. Hold onto the Lucky Block until the time runs out to win the game. You can earn money by collecting socks and you can also earn money by defeating your friend. You must be very careful; steal the Lucky Block from your friend and keep it until the time is up.",
    "publisher": "FBK",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-30T15:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "*Use the WASD and Arrow keys to move.\\n*The player holding the Lucky Block when the time runs out wins the game.\\n*Playable on both mobile and PC.",
    "sourceUrl": "https://gamedistribution.com/games/duo-family-santa/"
  },
  {
    "id": "b64c9ff2281d4c4c8a5c8c0c9e2da004",
    "slug": "ping-pong-air",
    "title": "Ping Pong Air",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/b64c9ff2281d4c4c8a5c8c0c9e2da004-512x512.jpg",
    "description": "Table tennis, also known as ping pong, is an easy and enjoyable arcade game in which you control the bat as simply as in life: with the mouse or the movement of your finger. Several modes await you to suit every taste. In classic mode, you go through worlds, earn cups and unlock new opportunities. In Halloween mode, you have to banish spirits for a while, improving your reaction. In Career mode, you move up the tournament ladder, taking part in games against increasingly stronger opponents.",
    "publisher": "GamePush",
    "languages": [
      "English",
      "French",
      "German",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-30T14:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Control the bat with your mouse or finger, bouncing the ball like in real table tennis.\\nIn the classic mode, defeat opponents and earn trophies.\\nIn the Halloween mode, banish spirits in a limited time.\\nIn the career, go from beginner to champion, and in the challenge, hit the targets without missing. Earn crystal orbs, unlock new bats and get achievements.",
    "sourceUrl": "https://gamedistribution.com/games/ping-pong-air/"
  },
  {
    "id": "b73efc1f47194a4cbb5d0af8b492187b",
    "slug": "coe-snake",
    "title": "Coe Snake",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/b73efc1f47194a4cbb5d0af8b492187b-512x384.jpg",
    "description": "Coe Snake brings the classic snake game with new challenges! Collect fruits, dodge meteors, walls, bombs, and balls that move like ping pong. Multiple modes, scenarios, and fruits to choose from. Fast-paced, colorful, and addictive — how far can you go?",
    "publisher": "Newness Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-30T08:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Desktop:\\n\\nW / Up Arrow Key = Move to up\\nA / Left Arrow Key = Move to Left\\nS / Down Arrow Key = Move to down\\nD / Right Arrow Key = Move to right\\n\\nMobile:\\n\\nTouch Up Arrow = Move to up\\nTouch Left Arrow = Move to Left\\nTouch Down Arrow = Move to down\\nTouch Right Arrow = Move to right\\n\\n",
    "sourceUrl": "https://gamedistribution.com/games/coe-snake/"
  },
  {
    "id": "6ac6e13850ad46cdad8f1dce303c34a5",
    "slug": "gift-merge-santa-world-tour",
    "title": "Gift Merge Santa World Tour",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/6ac6e13850ad46cdad8f1dce303c34a5-512x384.jpg",
    "description": "Gift Merge: Santa World Tour\\n\\nHelp Santa spread Christmas joy across the globe!\\nTap to generate gifts, merge identical items to craft new toys, and fulfill children’s wishes to raise each country’s happiness. Travel from snowy towns to sunny beaches, unlocking new festive destinations. Merge, match, and make magic — the more joy you spread, the closer Santa gets to completing his world tour!",
    "publisher": "Orenji Spark",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-30T08:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "use mouse or tap to interact with in game elements.",
    "sourceUrl": "https://gamedistribution.com/games/gift-merge-santa-world-tour/"
  },
  {
    "id": "c5d8e68694434595a8a2c367bc3a4fdb",
    "slug": "pipe-connect",
    "title": "Pipe Connect",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/c5d8e68694434595a8a2c367bc3a4fdb-512x384.jpg",
    "description": "Pipe Connect is a brilliant puzzle solver with an acute attention to detail and a sharp mind. Their function is to join dispersed pipe segments on a grid to provide a continuous water flow path from beginning to end. They must rotate and position pipes of different shapes, such as straight lines, elbows, and T-junctions, within a set amount of time or space as the puzzles get harder. Obstacles such as various sources, restricted routes, or challenging layouts are specific to each level. ",
    "publisher": "Pidomtech",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-29T13:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Mouse click or swipe to play",
    "sourceUrl": "https://gamedistribution.com/games/pipe-connect/"
  },
  {
    "id": "87bbcb69848e4c5d840dabc0d3f3e1b0",
    "slug": "rocket-fest",
    "title": "Rocket Fest",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/87bbcb69848e4c5d840dabc0d3f3e1b0-512x384.jpeg",
    "description": "Rocket Fest is a fun rocket runner arcade game. Slide to collect more rockets and pass the number high lane to have more rockets. You have to have enough rockets to destroy the last tank for you to win, otherwise, you have to start again. Take the challenge and enjoy a great game moment!",
    "publisher": "YAD.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2022-08-18T06:01:50.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Slide to play",
    "sourceUrl": "https://gamedistribution.com/games/rocket-fest/"
  },
  {
    "id": "eb4c40ddc3dd4524b003890b96fb0790",
    "slug": "barbee-black-friday-fashion",
    "title": "Barbee Black Friday Fashion",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/eb4c40ddc3dd4524b003890b96fb0790-512x384.jpg",
    "description": "Get ready for a fashion-filled shopping day with Barbee Black Friday Fashion, the ultimate dress-up experience for style lovers! Barbee is hitting the mall for the biggest sale of the year, and she needs your expert fashion sense to shine. Explore chic winterwear, cozy sweaters, stylish boots, and dazzling accessories. ",
    "publisher": "Cutedressup",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-29T10:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "Left Mouse Button Click",
    "sourceUrl": "https://gamedistribution.com/games/barbee-black-friday-fashion/"
  },
  {
    "id": "1c49dc059eb248369dc39f45a14846e7",
    "slug": "car-out-jam",
    "title": "Car Out Jam",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/1c49dc059eb248369dc39f45a14846e7-512x512.jpg",
    "description": "Car Parking. A puzzle game with cars and passengers.\\nComplete interesting levels with various mechanics!\\nThe game will be interesting for both who want to relax leisurely and for those who like to unravel complex moves.\\nEasy levels are combined with more difficult ones. And some will be a real challenge for your brain!",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-29T10:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Left mouse button - click on the selected car. When you tap, the car rides to the parking place. If the car's color matches the color of the first passengers, they board the car. When all passengers board, the car rides away.\\nTo make your task easier, you can use boosters:\\n- Sorting passengers,\\n- Sorting the queue,\\n- VIP parking.",
    "sourceUrl": "https://gamedistribution.com/games/car-out-jam/"
  },
  {
    "id": "fabcc8c4576844fb8cea4a916621cbe2",
    "slug": "the-kulka",
    "title": "THE KULKA",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/fabcc8c4576844fb8cea4a916621cbe2-512x384.jpg",
    "description": "THE KULKA is a one-button bullet-heaven arcade game where your single shot evolves into chaos. Inspired by Flappy Birds, Vampire Survivor and Pattern Survivors: Bullet Hell. \\n\\nMUTATE YOUR BULLET. FLAP, EVOLVE, SURVIVE. ",
    "publisher": "Airem",
    "languages": [
      "Afrikaans",
      "Albanian",
      "Alemannic",
      "Amharic",
      "Arabic",
      "Aragonese",
      "Armenian",
      "Aromanian",
      "Asturian",
      "Azerbaijani",
      "Basque",
      "Belarusian",
      "Belarusian (TaraÅ¡kievica)",
      "Bengali",
      "Bishnupriya Manipuri",
      "Bosnian",
      "Breton",
      "Buginese",
      "Bulgarian",
      "Burmese",
      "Cantonese",
      "Catalan",
      "Cebuano",
      "Chinese (Simplified)",
      "Chuvash",
      "Croatian",
      "Czech",
      "Danish",
      "Dutch",
      "English",
      "Esperanto",
      "Estonian",
      "Finnish",
      "French",
      "Galician",
      "Georgian",
      "German",
      "Greek",
      "Gujarati",
      "Haitian",
      "Hebrew",
      "Hindi",
      "Hungarian",
      "Icelandic",
      "Ido",
      "Indonesian",
      "Interlingua",
      "Irish",
      "Italian",
      "Japanese",
      "Javanese",
      "Kannada",
      "Kazakh",
      "Korean",
      "Kurdish",
      "Latin",
      "Latvian",
      "Lithuanian",
      "Lombard",
      "Low Saxon",
      "Luxembourgish",
      "Macedonian",
      "Malagasy",
      "Malay",
      "Malayalam",
      "Marathi",
      "Neapolitan",
      "Nepali",
      "Newar / Nepal Bhasa",
      "Norwegian (Bokmål)",
      "Norwegian (Nynorsk)",
      "Occitan",
      "Persian",
      "Piedmontese",
      "Polish",
      "Portuguese",
      "Quechua",
      "Romanian",
      "Russian",
      "Samogitian",
      "Serbian",
      "Serbo-Croatian",
      "Sicilian",
      "Simple English",
      "Slovak",
      "Slovenian",
      "Spanish",
      "Sundanese",
      "Swahili",
      "Swedish",
      "Tagalog",
      "Tamil",
      "Tatar",
      "Telugu",
      "Thai",
      "Turkish",
      "Ukrainian",
      "Urdu",
      "Vietnamese",
      "VolapÃ¼k",
      "Walloon",
      "Waray-Waray",
      "Welsh",
      "West Frisian",
      "Western Panjabi",
      "Yoruba",
      "Zazaki",
      "Chinese (Traditional)"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-29T09:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "1. Click or tap to flap and dodge.\\n2. Collect XP gems from destroyed enemies.\\n3. Choose an upgrade when you level up.\\n4. Survive as long as possible!",
    "sourceUrl": "https://gamedistribution.com/games/the-kulka/"
  },
  {
    "id": "63dd731e83704e13b300deff8109f39a",
    "slug": "burger-empire",
    "title": "Burger Empire",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/63dd731e83704e13b300deff8109f39a-512x384.jpg",
    "description": "Welcome to Burger \\u0026 Beans Cafe, the ultimate restaurant-management game where you cook juicy burgers, brew the perfect coffee, and build the eatery of your dreams!\\n\\n• Serve Delicious Orders: Flip patties and pour lattes for hungry customers—fast!\\n• Earn \\u0026 Upgrade: Collect coins to unlock chic new tables, comfy booths, and vibrant dining areas.\\n• Customize Your Space: Choose décor, layout, and special menu items to keep guests coming back.",
    "publisher": "NovaSky",
    "languages": [
      "Czech",
      "English",
      "French",
      "German",
      "Italian",
      "Russian",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-28T15:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Press W / A / S / D or push the joystick to navigate your character.",
    "sourceUrl": "https://gamedistribution.com/games/burger-empire/"
  },
  {
    "id": "2307b3227c9d4e74a9d7091a392ed1c0",
    "slug": "cs:-upgrade-gun",
    "title": "CS: Upgrade Gun",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/2307b3227c9d4e74a9d7091a392ed1c0-512x512.jpg",
    "description": "The weapon is alive and ready to go hunting! In this fast-paced launcher, you control a cannon that runs itself and shoots at targets. Collect boosters, improve their performance and last as long as possible. The further you go, the more action and explosions!",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [],
    "firstActiveDate": "2025-11-28T14:42:27.876Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Control on PC:\\nHold your mouse in the direction you want to move the player\\n\\nControl on mobile devices:\\nHold your finger in the direction you want to move the player.",
    "sourceUrl": "https://gamedistribution.com/games/cs:-upgrade-gun/"
  },
  {
    "id": "194bceb65bc3475e8407d6f9354c8e3b",
    "slug": "hidden-objects:-lost-island-2",
    "title": "Hidden objects: Lost Island 2",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/194bceb65bc3475e8407d6f9354c8e3b-200x120.jpg",
    "description": "Discover an immersive adventure on a lost island full of secrets, mysteries, and ancient artifacts. Together with a charismatic explorer, you’ll find yourself deep in tropical jungles where a forgotten temple of an ancient civilization lies hidden beneath overgrown vines and trees. Every location is a handcrafted scene packed with hidden objects, puzzles, and clues about the mysterious past.",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-28T14:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "You can freely move left and right across the location and use zoom to find hidden objects.\\n\\nThe game is available on both computers and mobile devices, allowing you to play anytime, anywhere.",
    "sourceUrl": "https://gamedistribution.com/games/hidden-objects:-lost-island-2/"
  },
  {
    "id": "e5dcd09e91004a5c8d1b7d473a572bcf",
    "slug": "celebrity-thanksgiving-prep",
    "title": "Celebrity Thanksgiving Prep",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/e5dcd09e91004a5c8d1b7d473a572bcf-512x384.jpg",
    "description": "It’s Thanksgiving, and the celebrities are getting ready for the big day! In Celebrity Thanksgiving Prep, you’ll help your favorite stars get glammed up for the holiday dinner. Start by creating stunning makeup looks, styling hair, and choosing the perfect fall outfit. Then, join them in the kitchen for some festive cooking fun! From cozy sweaters to chic party dresses, show off your fashion taste and creativity in this delightful seasonal makeover game.",
    "publisher": "Cutedressup",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-28T10:52:05.588Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "Left Mouse Button Click",
    "sourceUrl": "https://gamedistribution.com/games/celebrity-thanksgiving-prep/"
  },
  {
    "id": "16e9f5a12cb245669bd36eed0698e108",
    "slug": "money-maker",
    "title": "Money Maker",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/16e9f5a12cb245669bd36eed0698e108-512x384.jpg",
    "description": "Money Maker is an addictive strategy and idle game that lets you build your fortune from the ground up. Combine smart investments with clever upgrades to grow your virtual empire. Merge pins, upgrade your Money Machine, and watch your income skyrocket as you master the art of wealth creation. With its vibrant visuals and satisfying progression system, Money Maker turns every click into profit!",
    "publisher": "Playgama",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Polish",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-28T08:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Drag pins onto the board to start generating income.\\nMerge two pins of the same tier to create a higher-value one and boost your profits.\\nUpgrade your Money Machine regularly to increase the value of your earnings.\\nPlan your merges strategically — efficiency and timing are key to building a thriving financial empire.",
    "sourceUrl": "https://gamedistribution.com/games/money-maker/"
  },
  {
    "id": "851373725cf54ad4a00588e580346512",
    "slug": "2248-blast",
    "title": "2248 Blast",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/851373725cf54ad4a00588e580346512-512x384.jpg",
    "description": "Are you ready to train your brain while having fun? 2248 Blast is a highly addictive number-connecting puzzle game designed to relax your mind and sharpen your logic skills! With simple swipe controls and engaging gameplay, this game is perfect for puzzle lovers of all ages.",
    "publisher": "Albayoo",
    "languages": [
      "English",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-28T07:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "- Swipe to connect matching numbers in any direction: up, down, left, right, or diagonally.\\n- Merge the numbers to create a larger one.\\n- Keep going and challenge yourself to reach 2248 or even higher!\\n- No time limit – play at your own pace and enjoy the challenge!",
    "sourceUrl": "https://gamedistribution.com/games/2248-blast/"
  },
  {
    "id": "c04f402aeb1d43eb8636799451f873b8",
    "slug": "inspector-cat",
    "title": "Inspector Cat",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/c04f402aeb1d43eb8636799451f873b8-512x384.jpg",
    "description": "Inspector Cat is a competitive hidden object game where you play as a sharp-eyed cat inspector racing against other feline players!\\nEach round challenges you to find specific items on a crowded board full of objects. Be faster and more accurate than the other cats to earn points and climb the ranking.\\nStay focused, react quickly, and prove you’re the best inspector in the pack!",
    "publisher": "GameBerry Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-27T08:59:20.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Check the yellow column on the right — these are the items your cat must find.\\nTap the matching objects on the board as fast as you can before the timer runs out.\\nThe quicker you complete your list, the more points you earn compared to the other inspector cats.\\nFinish your list to move to the next round — and beat your rivals with your speed and attention!",
    "sourceUrl": "https://gamedistribution.com/games/inspector-cat/"
  },
  {
    "id": "1b5315fd207a446daf4cbf9df971e5b0",
    "slug": "chiron-city-driver",
    "title": "Chiron City Driver",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/1b5315fd207a446daf4cbf9df971e5b0-512x512.jpg",
    "description": "Get ready to skid the wheels of a stunning sports car through an expansive morning city map! Customize and upgrade your sports car with cool upgradables and become the best driver in the city. Take your dog with you in 3 driving challenges and conquer the missions together. Use nitro to beat slow traffic and beat all speed, stunt and drift triggers spread across the map. Are you ready to show your driving skills? Prove yourself!",
    "publisher": "Fuego! Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-27T08:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Car:\\nArrow Keys/W, A, S, D: Drive/Steer/Brake\\nC: Change Camera\\nF: Nitro\\n\\nCharacter:\\nArrow Keys/W,A,S,D: Move\\nMouse Orbit: Look Around",
    "sourceUrl": "https://gamedistribution.com/games/chiron-city-driver/"
  },
  {
    "id": "9ff4c1c62da64af98d32fe1a1b44ac0a",
    "slug": "mega-shark",
    "title": "Mega Shark",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/9ff4c1c62da64af98d32fe1a1b44ac0a-512x384.jpg",
    "description": "One shark and a sea full of delicious fish. How hungry are you? You’ve got 60 seconds to prove it! Feed nonstop, survive the deepest waters and rely on your shark’s speed, strength and invincibility to complete each hunt. Collect coins and trophies to unlock and explore new stages.\\n",
    "publisher": "Inlogic Software",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Portuguese",
      "Russian",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-27T07:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Hunt and eat as many fish as possible before time runs out! Watch out, not all fish are the same. Survive to earn unique rewards. Use coins to boost your shark’s skills. The more trophies you collect, the more stages you unlock. How far can you go?\\n",
    "sourceUrl": "https://gamedistribution.com/games/mega-shark/"
  },
  {
    "id": "1a09e82198a8432da4f0a9c103187f7e",
    "slug": "capybara-xmas-merge",
    "title": "Capybara Xmas Merge",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/1a09e82198a8432da4f0a9c103187f7e-200x120.jpg",
    "description": "Capybara Xmas Merge is a cute and cozy holiday game where you combine adorable Christmas capybaras!\\nDrop festive capybaras into the box, watch them roll and bump into each other, and merge into bigger, funnier holiday characters.\\nCreate giant capybaras, score points, and enjoy the warm winter atmosphere.",
    "publisher": "GameBerry Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-27T07:55:05.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Tap to drop a capybara into the jar.\\nWhen two identical capybaras touch, they merge into a larger one.\\nPlan your moves carefully — the jar fills up quickly!\\nBuild the biggest capybara you can and earn the highest score before you run out of space.",
    "sourceUrl": "https://gamedistribution.com/games/capybara-xmas-merge/"
  },
  {
    "id": "5472c20853064b7b866a0d2629f2513d",
    "slug": "snake-puzzle:-slither-to-eat!",
    "title": "Snake Puzzle: Slither to Eat!",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/5472c20853064b7b866a0d2629f2513d-512x512.jpg",
    "description": "Snake Puzzle: Slither to Eat is an exciting and relaxing puzzle game that will test your strategic thinking and planning skills! ",
    "publisher": "Bravestars Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-27T07:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Guide your snake ? through simple yet tricky puzzles ? as you eat apples ? to grow longer. Your goal is to make the snake long enough to reach the teleportation portal ?. Every apple you eat adds a new piece to your snake, and with each move, you’ll need to carefully plan your path ? to ensure your snake grows and reaches the portal.",
    "sourceUrl": "https://gamedistribution.com/games/snake-puzzle:-slither-to-eat!/"
  },
  {
    "id": "f79ec8ef8c0c4f13955eb0dc9017dc65",
    "slug": "puppy-treat-sorting",
    "title": "Puppy Treat Sorting",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/f79ec8ef8c0c4f13955eb0dc9017dc65-512x384.jpg",
    "description": "Puppy Treat Sorting is a Sorting game where you must grab and sort identical bones to create a new and bigger one. Puppies will fall automatically into the arena; what you must do is drag the puppies around and choose them into identical ones. ",
    "publisher": "kiz10.com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-27T07:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Use the mouse or touch to play",
    "sourceUrl": "https://gamedistribution.com/games/puppy-treat-sorting/"
  },
  {
    "id": "a0ca95e726b241f2817b028bdb32ea2a",
    "slug": "blox-fruits",
    "title": "Blox Fruits",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/a0ca95e726b241f2817b028bdb32ea2a-512x384.jpg",
    "description": "Embark on an epic adventure across the seas in Blox Fruits, a Roblox MMORPG inspired by the world of One Piece. Choose your path as a Pirate or Marine, master powerful abilities granted by mystical Blox Fruits, and strive to become the strongest player in the game",
    "publisher": "2Play",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-26T08:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "1. Train and Level Up: Defeat enemies, complete quests, and explore various islands to gain experience and level up your character.\\n2. Acquire Blox Fruits: Obtain Blox Fruits through dealers, random spawns, or trading. Each fruit grants unique abilities, but at the cost of losing the ability to swim.",
    "sourceUrl": "https://gamedistribution.com/games/blox-fruits/"
  },
  {
    "id": "31724ff3e3554daf8359c719aa4304d6",
    "slug": "car-crash-test:-abandoned-city",
    "title": "Car Crash Test: Abandoned City",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/31724ff3e3554daf8359c719aa4304d6-512x384.jpg",
    "description": "Car Crash Test: Abandoned City throws you into a thrilling sandbox of chaos and destruction. Explore a vast, deserted city where every street is your testing ground. Drive, crash, and experiment with powerful vehicles while mastering realistic physics and dynamic crash effects. Whether you’re speeding down empty highways or performing daring stunts, this game lets you push every car — and your reflexes — to the limit.",
    "publisher": "Playgama",
    "languages": [
      "English",
      "German",
      "Indonesian",
      "Italian",
      "Portuguese",
      "Russian",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-26T08:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Choose your vehicle and hit the abandoned streets.\\nUse WASD to steer, Space to brake, and Shift for a nitro boost.\\nSwitch camera views with C, repair your car with K, and reset with R.\\nTry slowing time with B for cinematic crash moments.\\nExplore freely, experiment with speed, and create your own unforgettable crash scenes.",
    "sourceUrl": "https://gamedistribution.com/games/car-crash-test:-abandoned-city/"
  },
  {
    "id": "1b4197feadd84f789b63664d439e81f6",
    "slug": "noob:-skyblock-survival",
    "title": "Noob: Skyblock Survival",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/1b4197feadd84f789b63664d439e81f6-512x384.jpg",
    "description": "Welcome to the game Noob: Skyblock Survival!\\n\\nNoob: Skyblock Survival is a sandbox survival game on an island in the style of Minecraft, where you need to dig blocks.\\n\\nFeatures of the game:\\n- Dig blocks\\n- Plant trees and wheat\\n- Survive on a cube island\\n- Expand your island, and then fight zombies!\\n\\nRemember, you are a cool cube digger and you must survive!\\n\\nIf you liked our game \\",
    "publisher": "Stickman vs Monster School Team",
    "languages": [
      "English",
      "Russian",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-26T08:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Controls:\\nUse the arrows on the keyboard to control the noob (for a computer) or the virtual buttons on the left (for a phone\\\\tablet) to walk.\\n\\nUse your mouse (for PC) or move your finger along the right side of the screen (for phone/tablet) to dig or pick up objects.\\n\\nGame objective:\\nPlant seedlings in the ground to grow a tree. Combine lava and water to get stone.\\nDevelop and expand your island, build a cool house and survive in these harsh conditions on a flying island!",
    "sourceUrl": "https://gamedistribution.com/games/noob:-skyblock-survival/"
  },
  {
    "id": "0c2785563e704830971b3ad7c9a7ea34",
    "slug": "murder-stone-age",
    "title": "Murder Stone Age",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/0c2785563e704830971b3ad7c9a7ea34-512x384.jpg",
    "description": "Test your instincts in Murder Stone Age, a suspenseful tap-based thriller. Watch your back as mysterious figures follow you. One of them may mean harm. Tap to glance behind just in time: guess wrong and it's over. Can you outwit the stalker and survive?",
    "publisher": "iclickgames",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-26T08:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use MOUSE to play the game.",
    "sourceUrl": "https://gamedistribution.com/games/murder-stone-age/"
  },
  {
    "id": "e3f4448cc0514fbaa84f157982da157d",
    "slug": "steal-car-duel",
    "title": "Steal Car Duel",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/e3f4448cc0514fbaa84f157982da157d-512x384.jpg",
    "description": "Step into a high-energy world of engines, rivalry, and fast reflexes. Steal Car Duel is a competitive action game that evolves the idea of Steal a Brainrot into a car-based experience filled with duels, rare collectibles, and endless upgrades!\\n\\nRace, collide, and steal your way to the top. Build your own garage, earn coins and tickets, and outsmart rivals to prove who rules the arena. Each match combines skill, timing, and strategy as you fight for dominance in Solo or 2 Player mode.",
    "publisher": "gameVgames",
    "languages": [
      "No Text"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-26T07:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Player 1\\n\\nMove: W A S D\\nJump: Space\\nSteal / Buy: E\\nHit: F or Left Mouse\\nSprint: Left Shift\\nPlayer 2\\n\\nMove: Arrow Keys\\nJump: L\\nSteal / Buy: O\\nHit: K\\nSprint: J",
    "sourceUrl": "https://gamedistribution.com/games/steal-car-duel/"
  },
  {
    "id": "919c1421052643c8b73a692e9f0a0c28",
    "slug": "gomu-goman",
    "title": "Gomu Goman",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/919c1421052643c8b73a692e9f0a0c28-1280x550.jpg",
    "description": "With simple tap-and-drag gameplay, Gomu Goman offers hundreds of challenging and laugh-out-loud levels. Each level is a unique puzzle that demands creativity—and a certain degree of spicy humor from you.",
    "publisher": "Eyestorm Pte. LTD.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-26T07:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "omu Goman is a humorous puzzle game where you control a character with a body that can stretch like rubber. Use your long neck to kiss a girl upstairs, stretch your arm across the street to steal a cake, or extend your leg to kick the bad guys—anything is possible, as long as your brain is twisted enough to figure it out.",
    "sourceUrl": "https://gamedistribution.com/games/gomu-goman/"
  },
  {
    "id": "a508edbaeb1d4213aecebbe4115670c2",
    "slug": "sorting-xmas-balls",
    "title": "Sorting Xmas Balls",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/a508edbaeb1d4213aecebbe4115670c2-200x120.jpg",
    "description": "Sorting Xmas Balls is a cozy winter puzzle game where you sort colorful Christmas ornaments into their correct tubes. Move the balls, group matching colors together, and enjoy calm, festive gameplay.\\n\\nAs you progress, the puzzles become more challenging with more tubes and more colors to organize. Bright graphics and a cheerful holiday theme make every level relaxing and satisfying to complete.",
    "publisher": "GameBerry Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-25T07:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Tap a tube to pick up the top ball, then tap another tube to place it there. You can move a ball only onto the same color or into an empty tube.\\n\\nKeep sorting until every tube contains balls of a single color — that’s when the level is complete. Think ahead, plan your moves, and enjoy the warm Christmas atmosphere!",
    "sourceUrl": "https://gamedistribution.com/games/sorting-xmas-balls/"
  },
  {
    "id": "ebf99bc25c484933a7fb73110c41cda8",
    "slug": "help-me:-tricky-brain-puzzles",
    "title": "Help Me: Tricky Brain Puzzles",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/ebf99bc25c484933a7fb73110c41cda8-512x384.jpg",
    "description": "Put your mind to the test in this fun and challenging brain puzzle game! ?\\nSolve tricky riddles, make tough decisions, and uncover mysteries in each level. From saving lives to solving absurd situations, every case challenges your logic and creativity.",
    "publisher": "TapNation",
    "languages": [
      "Arabic",
      "Chinese (Simplified)",
      "English",
      "Hebrew",
      "Hindi",
      "Italian",
      "Japanese",
      "Korean",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-24T09:27:04.833Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Controls:\\nTouch, swipe, and drag to find clues and solve puzzles.",
    "sourceUrl": "https://gamedistribution.com/games/help-me:-tricky-brain-puzzles/"
  },
  {
    "id": "f40ba42bcff94b8fba97d06ddda74155",
    "slug": "christmas-blocks-sort",
    "title": "Christmas Blocks Sort",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/f40ba42bcff94b8fba97d06ddda74155-512x384.jpg",
    "description": "Blocks Sort Christmas Edition brings a cozy holiday twist to the classic sorting puzzle. All the blocks have turned into festive Christmas colors like bright red, pine green, frosty blue, and warm gold. They start mixed together in different columns, and your job is to sort them so each column ends up with just one color. The rules are simple, but the challenge is still satisfying. Think ahead, plan your moves, and slowly bring order to the holiday chaos. ",
    "publisher": "GameBerry Studio",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Japanese",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-24T08:39:09.625Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Both",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Drag a block into any empty spot on the grid. Match all blocks by color to complete the level successfully.",
    "sourceUrl": "https://gamedistribution.com/games/christmas-blocks-sort/"
  },
  {
    "id": "4d700fb4689d48e2ad0f5072300cdb11",
    "slug": "athena-match-2",
    "title": "Athena Match 2",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/4d700fb4689d48e2ad0f5072300cdb11-512x384.jpg",
    "description": "Athena Match 2 - the epic sequel returns! Join the goddess Athena on a new mythical journey through ancient Greece. Match 3 or more legendary artifacts to restore temples and unlock the secrets of the gods. Enjoy stunning visuals, immersive sound, and hundreds of new levels packed with daily missions and challenges. Step into the world of Greek mythology and prove your match-3 skills in this divine adventure!",
    "publisher": "SOFTGAMES – Mobile Entertainment Services GmbH",
    "languages": [
      "Dutch",
      "English",
      "French",
      "German",
      "Italian",
      "Polish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-24T08:29:57.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "Match three or more identical artifacts to clear them from the board. Each level has a specific goal, such as collecting certain artifacts or clearing obstacles. You have a limited number of moves to complete the task, so plan carefully! Use special boosters and Athena's guidance to help you overcome tough challenges. Keep an eye out for unique obstacles inspired by Greek mythology. Match wisely and progress through levels to unlock more of the legendary world!",
    "sourceUrl": "https://gamedistribution.com/games/athena-match-2/"
  },
  {
    "id": "e5dcbebf386c46899035f042f40982d5",
    "slug": "we-are-in-a-simulation-simulator",
    "title": "We Are In A Simulation Simulator",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/e5dcbebf386c46899035f042f40982d5-512x384.jpg",
    "description": "We Are In A Simulation Simulator challenges you to question nothing and mimic everything. Blend in by copying the actions of others to survive in a strange digital world where free will doesn’t exist. Stay alert, follow the crowd, and don’t get caught acting out of sync. Play for free online on mobile or desktop and test your ability to conform in this mysterious simulation!",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-23T14:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use WASD to move through the simulated world, Space to jump, and C to crouch. Observe other characters closely and copy their actions to blend in. Any hesitation or mistake may reveal you as an outsider. Stay calm, follow the crowd, and adapt quickly to survive each scenario. The goal: act like everyone else—or face elimination from the simulation.",
    "sourceUrl": "https://gamedistribution.com/games/we-are-in-a-simulation-simulator/"
  },
  {
    "id": "8f2e6ad8b8814dc6880a8c52b7e25e30",
    "slug": "worm:-apple-quest",
    "title": "Worm: Apple Quest",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/8f2e6ad8b8814dc6880a8c52b7e25e30-1280x720.jpg",
    "description": "Get Ready for Challenging Puzzles in Worm: Apple Quest!\\n\\nIn this captivating puzzle platformer, guide your worm to the legendary Golden Apple while navigating devious obstacles and perilous chasms. The secret to success? Mastering your worm's growing length.\\n\\nEvery apple you collect makes your worm longer, unlocking new paths - but beware! With greater length comes tougher control. One wrong turn and you might get stuck, ending your run.",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-23T14:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Use WASD or arrows or on-screen buttons to move the worm!",
    "sourceUrl": "https://gamedistribution.com/games/worm:-apple-quest/"
  },
  {
    "id": "6134a1778c0f4929a68bf7dc9cd51398",
    "slug": "blue-hedgehog-hill-dash-ride",
    "title": "Blue Hedgehog Hill Dash Ride",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/6134a1778c0f4929a68bf7dc9cd51398-512x384.jpg",
    "description": "Join a daring blue hedgehog on an epic uphill racing adventure! Race through challenging terrains—from rugged lands to moon hills—using simple controls to speed, jump, and perform stunts. With smooth physics and exciting levels, you’ll climb impossible hills and chase victory. Perfect for fans of racing, stunts, and adventure!",
    "publisher": "Todos For Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-23T09:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Arrow Up / W – Accelerate\\n\\nArrow Down / S – Brake / Reverse\\n\\nArrow Left / A – Lean Backward\\n\\nArrow Right / D – Lean Forward",
    "sourceUrl": "https://gamedistribution.com/games/blue-hedgehog-hill-dash-ride/"
  },
  {
    "id": "20e2362cc0ba43eb89fdb0a60f7a7640",
    "slug": "latutu-holiday-gift-hunt",
    "title": "Latutu Holiday Gift Hunt",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/20e2362cc0ba43eb89fdb0a60f7a7640-512x384.jpg",
    "description": "Latutu’s Holiday Gift Hunt is a cheerful matching game where you search through a pile of cute holiday toys and gifts to find three identical items. Drag each match into your slots to create a trio and clear space for more. With its cozy holiday theme, adorable Latutu characters, and satisfying match-and-clear gameplay, this game offers a relaxing yet exciting experience for all ages. Perfect for short sessions or high-score chasing during the festive season.",
    "publisher": "Orenji Spark",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-23T07:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Cocos"
    ],
    "instructions": "- Tap or click on any item to move it into one of your slots.\\n- Match 3 identical items in the slots to clear them and score points.\\n- Keep making trios to free up space—the game ends if all slots are full or time runs out.",
    "sourceUrl": "https://gamedistribution.com/games/latutu-holiday-gift-hunt/"
  },
  {
    "id": "eb3160e4ebf3451a9d2b508f6d905074",
    "slug": "mega-jump",
    "title": "Mega Jump",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/eb3160e4ebf3451a9d2b508f6d905074-512x384.jpg",
    "description": "Mega Jump is a fast-paced vertical arcade game where you leap from platform to platform, collect coins, and dodge hazards as you climb higher. Power-ups, shifting coins, and colorful boost stars keep every ascent exciting. With vibrant visuals and responsive movement, the challenge grows as you push for your highest score without missing a single platform.",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-22T14:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Use arrow keys to move, land on platforms, collect coins, and avoid falling or hitting obstacles.",
    "sourceUrl": "https://gamedistribution.com/games/mega-jump/"
  },
  {
    "id": "5aac1802c4a5449cb57aa14c55731faf",
    "slug": "quiz-10-seconds-math",
    "title": "Quiz 10 Seconds Math",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/5aac1802c4a5449cb57aa14c55731faf-512x384.jpg",
    "description": "Quiz 10 Seconds Math is a fun, fast-paced educational game that challenges your mental math skills! Race against the clock to solve addition, subtraction, multiplication, and division problems—each level gets harder as you progress. With only 10 seconds per question, every decision counts. Track your best score, compete with yourself, and boost your brainpower anytime, anywhere. Perfect for students, teachers, and math lovers who want to learn while playing! , no distractions",
    "publisher": "Maurus",
    "languages": [
      "Spanish"
    ],
    "mobile": [],
    "firstActiveDate": "2025-11-22T14:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Answer correctly before time runs out. You have 10 seconds per level!",
    "sourceUrl": "https://gamedistribution.com/games/quiz-10-seconds-math/"
  },
  {
    "id": "7f9a9989046a492cb2403be57b863cf2",
    "slug": "tile-hexa-sort",
    "title": "Tile Hexa Sort",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/7f9a9989046a492cb2403be57b863cf2-512x512.jpg",
    "description": "Dive into a world of colorful hexagons where every move requires careful planning. Your goal is to stack identical pieces into tall towers without mixing colors. The higher the tower, the more attention and strategic thinking is needed.\\n\\nWith each new level, more colors and towers appear, making move planning even more important. Think ahead to avoid mistakes and maintain order in the colorful chaos.",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-22T13:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Drag tiles from the bottom of the screen to empty squares on the board by color. You need to build a tower of 10 tiles of the same color to complete it",
    "sourceUrl": "https://gamedistribution.com/games/tile-hexa-sort/"
  },
  {
    "id": "6bdebda708724af98daf6256f572b0b8",
    "slug": "acox-runner",
    "title": "Acox Runner",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/6bdebda708724af98daf6256f572b0b8-512x384.jpg",
    "description": "Acox Runner is a casual game that tests your agility, running, jumping and sliding to avoid obstacles, beautiful music and relaxing but challenging levels make you addicted",
    "publisher": "atupdev",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-22T08:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "for mobile\\nSwipe Up for Jump\\nSwipe down for slide\\nfor deskop\\npress W for jump\\nPress S for slide",
    "sourceUrl": "https://gamedistribution.com/games/acox-runner/"
  },
  {
    "id": "03be85ef64034d6cb94956ae8511f2bc",
    "slug": "dolphin-dash",
    "title": "Dolphin Dash",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/03be85ef64034d6cb94956ae8511f2bc-512x384.jpg",
    "description": "Launch your dolphin out of the water and smash through obstacles in this fast-paced underwater adventure. Collect coins, defeat bosses, and explore colorful ocean worlds full of surprises!",
    "publisher": "dotekse",
    "languages": [
      "No Text"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-22T07:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Drag to aim in a direction to jump into.\\nRelease to jump!",
    "sourceUrl": "https://gamedistribution.com/games/dolphin-dash/"
  },
  {
    "id": "28881625e042417fa4428c960069ca46",
    "slug": "vibe-colouring",
    "title": "Vibe Colouring",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/28881625e042417fa4428c960069ca46-1280x550.jpg",
    "description": "Relax with your favorite color by number game! Paint hundreds of pictures — from funny memes to calm landscapes. Every drawing is a little story that comes to life with your colors. Over 100 levels already in the game, and the library keeps growing. All pictures are open and free — no limits or waiting. Hints will show you where uncolored areas are hiding. Check the leaderboard to see who colored the most areas.",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-21T14:20:50.886Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "1. Choose a level. Open the list of coloring pages and pick any — meme, landscape, or mystery level. \\n2. Pick a color. Tap a color from the palette at the bottom to activate it. \\n3. Color the areas. Find the matching numbered areas and tap to fill them. Watch your picture come to life! \\n4. Use the magnifier. Can’t find a spot? Tap the magnifier — it helps you quickly zoom in on the right area. ",
    "sourceUrl": "https://gamedistribution.com/games/vibe-colouring/"
  },
  {
    "id": "2fea6c7705d1412c96d86728dea13557",
    "slug": "screw-match",
    "title": "Screw Match",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/2fea6c7705d1412c96d86728dea13557-512x384.jpg",
    "description": "Screw Match is a colorful puzzle game that tests your logic and coordination. Match screws of different colors to their corresponding glass nut boxes. The rules are simple, but the challenge grows with every level. ",
    "publisher": "Playgama",
    "languages": [
      "Chinese (Simplified)",
      "Dutch",
      "English",
      "French",
      "German",
      "Hindi",
      "Indonesian",
      "Japanese",
      "Korean",
      "Polish",
      "Russian",
      "Spanish",
      "Vietnamese"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-21T08:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Drag each screw to the box with the matching color. Use your mouse on desktop or your finger on mobile to move the screws. Plan your moves carefully, as later levels require more attention and strategy to complete.",
    "sourceUrl": "https://gamedistribution.com/games/screw-match/"
  },
  {
    "id": "2f54e43a475543e0b05a5209e75a9d29",
    "slug": "brain-draw-line",
    "title": "Brain Draw Line",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/2f54e43a475543e0b05a5209e75a9d29-512x384.jpg",
    "description": "Brain Draw Line is a minimalist puzzle game where you must complete shapes using a single, continuous line. There are no timers or unnecessary distractions — the focus is purely on precision and planning. Each level presents a unique figure that you must finish without lifting your finger or mouse and without crossing the line twice.\\nThe experience is calm, strategic, and rewarding — ideal for players who enjoy logic-based challenges.",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-20T20:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Draw a single unbroken line to complete the displayed shape.\\nYou cannot stop midway, undo a movement, or retrace your path.\\nIf you overlap your line or break the continuity, the level fails and must be restarted.",
    "sourceUrl": "https://gamedistribution.com/games/brain-draw-line/"
  },
  {
    "id": "b71a9bdd6b004136a535029ee5f5a6df",
    "slug": "santa-go",
    "title": "Santa Go",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/b71a9bdd6b004136a535029ee5f5a6df-200x120.jpg",
    "description": "Santa Go is a cozy Christmas puzzle game where you help Santa reach his sleigh!\\nDraw a line for Santa to slide along and watch him glide under a cheerful holiday melody.\\nBe careful — with each level, more obstacles appear, and they can easily knock Santa down.\\nYour goal is to guide him into the sleigh and keep him there for 3 seconds to complete the level!",
    "publisher": "GameBerry Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-20T09:35:00.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Draw a path with your finger or mouse to set Santa’s movement.\\nHe will follow the exact line you create.\\nAvoid all obstacles — hitting any of them will make Santa fall, and you’ll have to restart.\\nReach the sleigh and keep Santa inside for 3 seconds to finish the level.\\nExperiment with different paths, find safe routes, and help Santa get back to his holiday mission!",
    "sourceUrl": "https://gamedistribution.com/games/santa-go/"
  },
  {
    "id": "388f01ff1f7242718e9d232681e32b3d",
    "slug": "paint-rush",
    "title": "Paint Rush",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/388f01ff1f7242718e9d232681e32b3d-512x384.jpg",
    "description": "White houses are boring. Bring the colors in and paint everything in seconds. Complete every level painting all white spaces. Swipe left, right, up and down and fill all the empty spots on Paint Rush",
    "publisher": "kiz10.com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-20T08:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Use the mouse or touch to play",
    "sourceUrl": "https://gamedistribution.com/games/paint-rush/"
  },
  {
    "id": "da10d1b90d9f4b0cb332359c9bd35968",
    "slug": "sushi-puzzle",
    "title": "Sushi Puzzle",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/da10d1b90d9f4b0cb332359c9bd35968-512x384.jpg",
    "description": "Welcome to a tasty brain teaser where every move counts! But be careful—space is limited ?️, so you’ll need to calculate each tap and plan your moves wisely.",
    "publisher": "Bravestars Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-20T07:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": " Your goal is simple: sort different kinds of sushi into the matching color trays ?. But be careful—space is limited ?️, so you’ll need to calculate each tap and plan your moves wisely.",
    "sourceUrl": "https://gamedistribution.com/games/sushi-puzzle/"
  },
  {
    "id": "d5234914629a4ec997cfda65b2ae24ea",
    "slug": "super-hero-tycoon",
    "title": "Super Hero Tycoon",
    "category": "Simulation",
    "thumbnail": "https://img.gamedistribution.com/d5234914629a4ec997cfda65b2ae24ea-512x384.jpg",
    "description": "Build your superhero empire and dominate the battlefield! In Super Hero Tycoon, choose from iconic heroes like Iron Man, Spider-Man, or The Hulk, and construct your base to generate income, unlock powerful gear, and engage in thrilling PvP combat. With over 2 billion visits, this game offers an immersive experience for fans of superheroes and tycoon-style gameplay.",
    "publisher": "2Play",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-19T10:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Simulation",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "1. Select Your Hero: Choose a superhero-themed base to begin your journey. Build Your \\n2. Base: Purchase droppers and upgraders to generate and collect cash. \\n3. Upgrade and Expand: Use your earnings to unlock new rooms, gear, and abilities.\\n4. Engage in Combat: Utilize your superhero powers and weapons to battle other players.\\n5. Collect Crates: Grab falling cash crates for bonus rewards and boost your progress.",
    "sourceUrl": "https://gamedistribution.com/games/super-hero-tycoon/"
  },
  {
    "id": "4a9c7ad53f7c48678b3b848390a62daa",
    "slug": "football-duel",
    "title": "Football Duel",
    "category": "Sports",
    "thumbnail": "https://img.gamedistribution.com/4a9c7ad53f7c48678b3b848390a62daa-200x120.jpg",
    "description": "Step into the arena in Football Duel! Take turns shooting and goalkeeping in this thrilling 3D penalty showdown. Swipe to score or defend — the first to 5 goals claims victory!",
    "publisher": "MarketJS",
    "languages": [
      "English",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-19T09:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Sports",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Swipe to aim and shoot when it’s your turn to attack. When defending, swipe in the direction of the incoming ball to block the shot.",
    "sourceUrl": "https://gamedistribution.com/games/football-duel/"
  },
  {
    "id": "e5e957d23d1247b48a4a9a315fc96249",
    "slug": "daily-solitaire-mahjong-classic",
    "title": "Daily Solitaire Mahjong Classic",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/e5e957d23d1247b48a4a9a315fc96249-1280x550.jpg",
    "description": "Daily Solitaire Mahjong Classic is a relaxing tile-matching puzzle game where you clear the board by pairing identical tiles. Play a new puzzle every day, unlock missed days with ads, and keep your weekly streak for exciting rewards! Track your progress in the Weekly Record, where you can challenge yourself to beat your All-Time Best Score. Enjoy smooth gameplay, balanced difficulty from easy to hard, and use helpful boosters like Hint, Shuffle, and Undo to master every layout.",
    "publisher": "SOFTGAMES – Mobile Entertainment Services GmbH",
    "languages": [
      "Dutch",
      "English",
      "French",
      "German",
      "Italian",
      "Japanese",
      "Polish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-19T09:34:12.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Find and match identical tiles to clear the board! Only free tiles can be selected, so plan your moves carefully. Use Hint to spot a match, Shuffle to mix tiles, Undo to correct mistakes, and Torch to highlight free tiles. Finish the layout before the timer runs out! Track your time each day, view your Weekly Record, and try to beat your All-Time Best in this relaxing and challenging Daily Solitaire Mahjong Classic! ",
    "sourceUrl": "https://gamedistribution.com/games/daily-solitaire-mahjong-classic/"
  },
  {
    "id": "45c5530f8d3f40cdbdf6c68a85e27685",
    "slug": "geometry-rush",
    "title": "Geometry Rush",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/45c5530f8d3f40cdbdf6c68a85e27685-1280x720.jpg",
    "description": "Geometry Rush will take you to a world of challenging and treacherous platforming. Are you ready to run through trap-filled passages, jump and dodge death? Learn from your mistakes, perfect your reflexes, master the path without a single slip and advance to the next level.\\n",
    "publisher": "Inlogic Software",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Portuguese",
      "Russian",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-19T08:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "You control a geometric figure that moves forward automatically. Your only goal is to jump to avoid spikes and other obstacles as you navigate dangerous passages. With each level, the difficulty ramps up, demanding quick reflexes and precise timing.\\n",
    "sourceUrl": "https://gamedistribution.com/games/geometry-rush/"
  },
  {
    "id": "8e2b594a7e3d4840bcf77441b9dd207b",
    "slug": "noob-archer-vs-stickman-zombie:-zombie-shooter",
    "title": "Noob archer vs Stickman Zombie: zombie shooter",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/8e2b594a7e3d4840bcf77441b9dd207b-512x384.jpg",
    "description": "A fun shooting game in the world of minecraft with stickmen \\",
    "publisher": "Stickman vs Monster School Team",
    "languages": [
      "English",
      "Russian",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-19T08:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Aim with your cursor and press the left mouse button to shoot. Defeat all the Zombie Stickmen on the level to become a real Pro!",
    "sourceUrl": "https://gamedistribution.com/games/noob-archer-vs-stickman-zombie:-zombie-shooter/"
  },
  {
    "id": "0dd20706c8074a9aa61586ca8ad31515",
    "slug": "stack-up",
    "title": "Stack Up",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/0dd20706c8074a9aa61586ca8ad31515-512x384.jpg",
    "description": "Stack Up is a vibrant puzzle game where strategy meets fun. Connect stacks of the same color to form long chains, reach level goals, and climb through increasingly challenging puzzles. With colorful visuals, smooth gameplay, and intuitive controls, Stack Up offers an addictive experience for players of all ages.",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-19T08:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Tap or click on a stack to select it, then connect it with others of the same color to form a chain. Create longer stacks to earn higher scores and complete level objectives. Plan each move carefully — your turns are limited!",
    "sourceUrl": "https://gamedistribution.com/games/stack-up/"
  },
  {
    "id": "334714f0c010454faf2248793ba893be",
    "slug": "stick-war-saga",
    "title": "Stick War Saga",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/334714f0c010454faf2248793ba893be-512x384.jpg",
    "description": "Prepare for an epic clash in Stick War: Saga, an exciting blend of fighting, action, strategy, and tower defense. Take command of your stickman army and lead them through nervous war campaigns. Mine resources, build your army, and unleash your strategic power to conquer enemy lands.",
    "publisher": "YAD.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-18T13:23:06.646Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/stick-war-saga/"
  },
  {
    "id": "c5be9cc2dc6146668cc23aa83bf1bd5b",
    "slug": "about-a-frog",
    "title": "About a Frog",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/c5be9cc2dc6146668cc23aa83bf1bd5b-512x384.jpg",
    "description": "Jump into the world of About a Frog, a fun and free online game where you play as a brave little frog. Explore colorful levels, dodge obstacles, and enjoy the adventure on your phone or computer. It’s a light and exciting challenge for players who love quick reflexes and cute characters.",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-18T10:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Desktop Controls:\\n↑ (Up Arrow) / W: Move upward.\\n↓ (Down Arrow) / S: Move downward.\\n← (Left Arrow) / A: Move left.\\n→ (Right Arrow) / D: Move right.\\nR: Restart.\\nQ: To Menu.\\nM: Mute.\\n\\nMobile Controls:\\nOn-screen Buttons",
    "sourceUrl": "https://gamedistribution.com/games/about-a-frog/"
  },
  {
    "id": "c1015c9b79ba490a8cd1c3943ed7bae2",
    "slug": "xmas-hexa-sort",
    "title": "Xmas Hexa Sort",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/c1015c9b79ba490a8cd1c3943ed7bae2-512x384.jpg",
    "description": "Xmas Hexa Sort is a festive twist on the classic hexagon puzzle!\\nMove and place colorful stacks of blocks on the board to create perfect combinations and clear space. Relax, think ahead, and enjoy the cozy holiday atmosphere as you solve each cheerful puzzle!",
    "publisher": "GameBerry Studio",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Japanese",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-18T09:38:34.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Drag hexagonal stacks of blocks onto the board to fill empty spaces. Matching hexagons merge, and when enough stacks are combined, they disappear, giving you more room to continue playing. Plan your moves carefully — the game ends when there’s no space left for new blocks.",
    "sourceUrl": "https://gamedistribution.com/games/xmas-hexa-sort/"
  },
  {
    "id": "9bde41f232834eff9ea81554ecee8279",
    "slug": "moto-traffic-rider",
    "title": "Moto Traffic Rider",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/9bde41f232834eff9ea81554ecee8279-512x384.jpg",
    "description": "Throttle the roaring engines of 6 awesome superbikes with insane speed limits and ride them through 3 landscape highways without crashing. Show how well you can ride and control these bikes and conquer 3 awesome game modes. Use replenishing nitro to overtake slow cars and drive in speed at all times. Upgrade your bikes with the best upgrades and get the most out of all the rides. Are you ready to show your bike riding skills? Prove yourself in Moto Traffic Rider",
    "publisher": "Fuego! Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-18T09:03:29.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "W, A, S, D/ Arrow Keys: Drive/Steer/Brake , F: Nitro , C: Change Camera",
    "sourceUrl": "https://gamedistribution.com/games/moto-traffic-rider/"
  },
  {
    "id": "20f32ac949c349b28e57c20ea6ddd12a",
    "slug": "tiny-baker-rainbow-buttercream-cake",
    "title": "Tiny Baker Rainbow Buttercream Cake",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/20f32ac949c349b28e57c20ea6ddd12a-1280x550.jpg",
    "description": "Whip up layers of color and sweetness in Tiny Baker Rainbow Buttercream Cake! Mix, bake, and frost your way to the perfect rainbow treat, then finish with cute decorations that make your cake sparkle with charm.",
    "publisher": "iclickgames",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-18T07:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use MOUSE to play games.",
    "sourceUrl": "https://gamedistribution.com/games/tiny-baker-rainbow-buttercream-cake/"
  },
  {
    "id": "061faa6d2cd34e89a507fd435d040946",
    "slug": "snow-ball-racing-mutliplayer",
    "title": "Snow Ball Racing Mutliplayer",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/061faa6d2cd34e89a507fd435d040946-512x512.jpg",
    "description": "Roll. Race. Win!\\n\\nBuild the biggest snowball you can — then launch it down the slope and watch it fly! The farther it rolls, the more wins you earn. Use wins to unlock new zones, collect pets, and climb the leaderboard.\\n\\nFast, satisfying, and endlessly replayable. Snowball Racing is perfect for players who love speed, upgrades, and competition.",
    "publisher": "2Play",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-17T11:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "1. Roll Your Snowball.\\n2. The larger your snowball, the faster and further it will travel during the race.\\n3. Once your snowball is big enough, race it down the slope, aiming to cover as much distance as possible.",
    "sourceUrl": "https://gamedistribution.com/games/snow-ball-racing-mutliplayer/"
  },
  {
    "id": "72b219a0450c465c81f3cd1ebdafb815",
    "slug": "merge-pixel",
    "title": "Merge Pixel",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/72b219a0450c465c81f3cd1ebdafb815-512x384.jpg",
    "description": "Attractive characters in dot, pixel style!\\nCombining the same characters creates a higher level of characters.\\nRepeat Merge to create a legendary character.",
    "publisher": "MOVISOFT.Co.,Ltd",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-17T09:54:04.112Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Move the character with touch or mouse,\\nand merge the same characters.",
    "sourceUrl": "https://gamedistribution.com/games/merge-pixel/"
  },
  {
    "id": "7916f8df34a64ee58e183d71815bdf71",
    "slug": "travel-story-match",
    "title": "Travel Story Match",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/7916f8df34a64ee58e183d71815bdf71-512x384.jpg",
    "description": "Embark on a global adventure with Travel Story Match! Match 3 identical travel items to complete exciting puzzles. Use powerful boosters to tackle tricky combinations, explore iconic destinations, and uncover hidden gems. Complete Daily Missions and Weekly Challenges, collect rewards, and enjoy hundreds of thrilling levels. Start your journey now and create your very own unforgettable travel story!",
    "publisher": "SOFTGAMES – Mobile Entertainment Services GmbH",
    "languages": [
      "Dutch",
      "English",
      "French",
      "German",
      "Italian",
      "Polish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-17T09:20:38.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "Connect three or more of the same travel items to clear them from the board. Each level has a goal you need to complete to move forward. Plan your moves carefully so you don’t run out before finishing the task! Use powerful boosters to remove blockers and tricky spots. Complete daily challenges and missions for extra rewards. Keep matching, explore new destinations, and enjoy the adventure!",
    "sourceUrl": "https://gamedistribution.com/games/travel-story-match/"
  },
  {
    "id": "e1f81419779746dbb38f289217ef58d4",
    "slug": "happy-bubbles",
    "title": "Happy Bubbles",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/e1f81419779746dbb38f289217ef58d4-512x384.jpg",
    "description": "Boom! Hear that pop? The bubbles are calling! This classic bubble shooter blends quick reflexes with clever strategy. Spin the Lucky Wheel for extra rewards, claim weekly bonus and dive into a bright, cute world that never runs out of fun.\\n",
    "publisher": "Inlogic Software",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Portuguese",
      "Russian",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-17T08:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Aim and tap to shoot bubbles. Match three or more of the same color to pop them and clear the board. Use powerful boosters like bombs, rockets, rainbows and duo-color balls to help in tricky situations. Fewer shots mean more stars — so plan every move!\\n",
    "sourceUrl": "https://gamedistribution.com/games/happy-bubbles/"
  },
  {
    "id": "dee3caf78302400c9c9252dddbadff31",
    "slug": "hidden-object-girl-and-cat",
    "title": "Hidden Object - Girl and Cat",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/dee3caf78302400c9c9252dddbadff31-512x512.jpg",
    "description": "You play as a sweet girl walking through the forest with her cat, Lassie.\\nOur girl was walking and everything was wonderful: the birds were singing, the flowers were a delight to the eye, and suddenly the cat meowed and ran off into the depths of the forest.\\nOur girl searched for her cat in the forest for a long time and didn't notice how night had fallen. Wandering through the forest, the girl came across an old house. What if our cat ran in there?",
    "publisher": "Starodymov Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-16T14:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "The goal of the game is to collect all the items and find the cat.\\nPC controls: left mouse button\\nMobile device controls: tap the screen",
    "sourceUrl": "https://gamedistribution.com/games/hidden-object-girl-and-cat/"
  },
  {
    "id": "2b0570c6eec14fd59e3815c3d8b0da85",
    "slug": "burger-day",
    "title": "Burger Day",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/2b0570c6eec14fd59e3815c3d8b0da85-512x512.jpg",
    "description": "Burger Day is a fun and fast-paced arcade game that puts you in charge of a busy burger kitchen. Stack ingredients to serve up tasty orders as quickly as possible. Your speed and decision-making skills are tested as customer demands increase. Satisfy hungry customers to unlock fresh challenges and advance through exciting levels.",
    "publisher": "TTWebGames",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-16T14:30:05.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Click or tap to pick ingredients and build burgers just the way customers want. Complete each order quickly to move ahead. Stay sharp as requests get trickier. Tackle the easy ones first to save time for the harder challenges. And don’t forget — the clock is ticking!",
    "sourceUrl": "https://gamedistribution.com/games/burger-day/"
  },
  {
    "id": "f9efa6a562ca44dfb5cf4558309beba7",
    "slug": "super-tank-wrestle",
    "title": "Super Tank Wrestle",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/f9efa6a562ca44dfb5cf4558309beba7-512x384.jpg",
    "description": "Welcome to the world of tank battles, where you can control tanks to fight with other enemies on different maps. There are also a wealth of tanks for you to choose from!",
    "publisher": "Raccoon",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-16T13:40:04.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "The keyboard wasd controls movement and space to shoot, or touch screen.",
    "sourceUrl": "https://gamedistribution.com/games/super-tank-wrestle/"
  },
  {
    "id": "2f97ba2d17f843a7962259524c6ebc71",
    "slug": "ball-sort:-color-puzzle",
    "title": "Ball Sort: Color Puzzle",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/2f97ba2d17f843a7962259524c6ebc71-512x512.jpg",
    "description": "An exciting and engaging puzzle game. Move the balls into the flasks to sort them and advance to the next level. The game has many levels, each more challenging than the last! Can you reach the end?",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-16T13:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Move the colored balls to match them according to color.",
    "sourceUrl": "https://gamedistribution.com/games/ball-sort:-color-puzzle/"
  },
  {
    "id": "5127152784ff400ebc8ef3656e7bdae3",
    "slug": "pesky-moles",
    "title": "Pesky Moles",
    "category": "Simulation",
    "thumbnail": "https://img.gamedistribution.com/5127152784ff400ebc8ef3656e7bdae3-512x384.jpg",
    "description": "An ordinary farmer lived a quiet life and grew vegetables, but at some point, moles began to attack his garden and eat the entire crop.\\nAfter the next harvest, he decides to take everything into his own hands and protect his garden.\\nIn Pesky Moles, you have to protect your garden from moles for a certain amount of time. The more pests you manage to neutralize and the more crops you save, the more coins you get. With the coins you earn, you can buy traps that will help you protect your garden.",
    "publisher": "Oblocze LLC",
    "languages": [
      "Czech",
      "English",
      "French",
      "German",
      "Italian",
      "Japanese",
      "Polish",
      "Russian",
      "Simple English",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-16T10:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Simulation",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Support screen touches and mouse, tap on moles, click on buttons",
    "sourceUrl": "https://gamedistribution.com/games/pesky-moles/"
  },
  {
    "id": "44b5b46832e5441fa97edfb3efc626f4",
    "slug": "car-collision-master",
    "title": "Car Collision Master",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/44b5b46832e5441fa97edfb3efc626f4-512x384.jpg",
    "description": "Rev up for Car Collision Master Jagged canyons frame your blue jeep versus orange-black rivals on a looping desert track. Smoke trails and starry arches amp the chaos—customize your rig, battle friends, and dominate leaderboards in this wheel-warping thrill ride. Feel the V8 roar; claim victory in dust and daring!",
    "publisher": "SecGame",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-16T09:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "- Click to accelerate your jeep and smash into rivals for bonus points.\\n- Drag and drop power-ups onto your rig to unleash turbo boosts or spike defenses.\\n- Double-click to execute a daring drift around the looping track, evading sand traps.\\n- Right-click to pause and tweak customizations mid-race, like swapping flame decals or jaw crushers.",
    "sourceUrl": "https://gamedistribution.com/games/car-collision-master/"
  },
  {
    "id": "851ce8fcc9704c8b9cec242fc3cfbb3d",
    "slug": "tricky-life",
    "title": "Tricky Life",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/851ce8fcc9704c8b9cec242fc3cfbb3d-1280x550.jpg",
    "description": "Welcome to Tricky Life, the funniest brain test puzzle game ever made!\\nHere, logic meets laughter every level is designed to make you giggle, think twice, and smile when you finally find the answer.\\n",
    "publisher": "Eyestorm Pte. LTD.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-16T07:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "- Tap, drag, and move objects to reveal silly secrets\\n- Find unexpected answers hidden in funny situations\\n- Think outside the box logic isn’t always right here",
    "sourceUrl": "https://gamedistribution.com/games/tricky-life/"
  },
  {
    "id": "ddb3686df59d4220b3830b10cf789b4a",
    "slug": "hoard-master-online",
    "title": "Hoard Master Online",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/ddb3686df59d4220b3830b10cf789b4a-512x384.jpg",
    "description": "This is an upgrade and construction simulation game in which Empty is the protagonist. Use it to devour everything you want in exchange for money. Build and upgrade your black holes and territories!",
    "publisher": "Raccoon",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-15T15:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Mouse slide control or touch",
    "sourceUrl": "https://gamedistribution.com/games/hoard-master-online/"
  },
  {
    "id": "1b57b789f55e4472af1646d75be4decc",
    "slug": "block-puzzle-king",
    "title": "Block Puzzle King",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/1b57b789f55e4472af1646d75be4decc-512x384.jpg",
    "description": "Smart Puzzle Block is a classic elimination game. Its adorable graphics prevent eye strain, and varied level difficulties keep it engaging. The game maintains freshness while offering abundant props for players to strategically use. ",
    "publisher": "Guangzhou Yomitoo Network Technology Co., Ltd.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-15T14:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "1.Drag the bottom blocks to fill the gaps on the board.\\n2.Complete a horizontal or vertical line to clear those blocks.\\n3.Clear all blocks to pass the level.",
    "sourceUrl": "https://gamedistribution.com/games/block-puzzle-king/"
  },
  {
    "id": "bca1da79a8744ca3bf90e5b8753b611d",
    "slug": "bbq-sort-puzzle",
    "title": "BBQ Sort Puzzle",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/bca1da79a8744ca3bf90e5b8753b611d-512x384.jpg",
    "description": "This is an interesting elimination puzzle game!\\n\\nYou need to put three identical items into the same grill to complete the grilling.\\n\\nThe difficulty of the game increases step by step. ",
    "publisher": "HeiTie",
    "languages": [
      "English",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-15T14:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Cocos"
    ],
    "instructions": "After all items on the shelf are taken away, the items on the plate behind will be displayed.\\n\\nThere may be sudden customer orders during the production process, remember to complete the orders first!\\n",
    "sourceUrl": "https://gamedistribution.com/games/bbq-sort-puzzle/"
  },
  {
    "id": "29a49b18e4d14b6299686b5f1412cd66",
    "slug": "basketball-fever",
    "title": "Basketball Fever",
    "category": "Sports",
    "thumbnail": "https://img.gamedistribution.com/29a49b18e4d14b6299686b5f1412cd66-512x384.jpeg",
    "description": "Be the best player on the basketball court. Shoot in the basket as many as you can and become the best player in town. Gather coins and unlock new balls. Destroy your competition and gain the title \\",
    "publisher": "Bofer Media (Twim Studio)",
    "languages": [],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2019-05-02T06:50:03.030Z",
    "lastUpdated": "",
    "genres": [
      "Sports",
      "HTML5",
      "Construct 2"
    ],
    "tags": [
      "Male",
      "Teens",
      "YoungAdults",
      "HTML5",
      "Construct 2"
    ],
    "instructions": "Click and hold to aim towards the basket. Release the ball when you fell ready to aim. Advance trough the baskets and be the best in the game.",
    "sourceUrl": "https://gamedistribution.com/games/basketball-fever/"
  },
  {
    "id": "500b319ce147450686184de6dd46856b",
    "slug": "strawberry-hero",
    "title": "Strawberry Hero",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/500b319ce147450686184de6dd46856b-512x384.jpg",
    "description": "Stick your fork and climb to the top! Hold down to keep sticking the fork continuously. If your fork hits a hero or an obstacle, it’s game over! Stick the fork just above the falling hero’s feet to trigger a Super Jump and earn a high score!",
    "publisher": "Synk Inc.",
    "languages": [
      "English",
      "Japanese"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-15T09:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Tap and hold to keep sticking the fork continuously.",
    "sourceUrl": "https://gamedistribution.com/games/strawberry-hero/"
  },
  {
    "id": "47fe523bf21d4eaa951e1e0998a1b96c",
    "slug": "counter-craft-sniper",
    "title": "Counter Craft Sniper",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/47fe523bf21d4eaa951e1e0998a1b96c-512x384.jpg",
    "description": "Counter Craft Sniper is a first-person shooter where you step into the boots of an elite sniper sent to protect a city invaded by Minecraft mobs. Creepers, skeletons, and zombies have appeared in the middle of downtown, and only your precision and quick reflexes can stop them before the chaos spreads. Armed with your trusty sniper rifle, you must take position on rooftops and high vantage points to eliminate every hostile target that threatens the civilians below.",
    "publisher": "G55.CO",
    "languages": [
      "English"
    ],
    "mobile": [],
    "firstActiveDate": "2025-11-15T07:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Kids",
      "Teens",
      "HTML5",
      "WebGL"
    ],
    "instructions": "WASD - Move. LMB - Shoot. RMB - Aim/Flashlight. R - Reload. F - Use. G - Grenade. H - Melee. C - Crouch. M - Mute. Space - Jump. Shift - Run. 1-9 - Select Weapon. TAB - Pause.",
    "sourceUrl": "https://gamedistribution.com/games/counter-craft-sniper/"
  },
  {
    "id": "5c94507ff7b14c0bbb60ae1c7a6f7647",
    "slug": "matrix-typer",
    "title": "Matrix Typer",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/5c94507ff7b14c0bbb60ae1c7a6f7647-200x120.jpg",
    "description": "Type like a hacker, train like a pro. Dodge incoming code, out-type digital attacks, and prove you can survive inside the system. Every word you type is a bullet dodged; every mistake, a strike you take.",
    "publisher": "Cassino.dev",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-15T07:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Type fast to neutralize the falling code before it reaches the system core.\\nAccuracy and speed are your only defenses — keep typing to survive the digital storm.",
    "sourceUrl": "https://gamedistribution.com/games/matrix-typer/"
  },
  {
    "id": "8b7bf0af0fdf462dba1ce0152c158b38",
    "slug": "block-cut-cleaner",
    "title": "Block Cut Cleaner",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/8b7bf0af0fdf462dba1ce0152c158b38-512x384.jpg",
    "description": "An original block puzzle where the field is filled with triangle blocks! Pull out your shapes and place them on the field to clear at 100%. But be careful: each piece you place can create new blocks! Use smart boosters to turn the tide: refresh your inventory, remove three random triangles or place a \\",
    "publisher": "Oblocze LLC",
    "languages": [
      "Czech",
      "English",
      "French",
      "German",
      "Italian",
      "Japanese",
      "Polish",
      "Russian",
      "Simple English",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-14T14:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Support screen touches and mouse, tap on shape, click on buttons",
    "sourceUrl": "https://gamedistribution.com/games/block-cut-cleaner/"
  },
  {
    "id": "ca12cc5666a1430aa557452c3fbb0039",
    "slug": "battle-zone-2d",
    "title": "Battle Zone 2D",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/ca12cc5666a1430aa557452c3fbb0039-512x512.jpg",
    "description": "Immerse yourself in a dynamic 2D top-down shooter. Fight on a vast map, search for weapons, ammo, and gear to survive epic battles. Use strategy, cover, and tactics to become the last survivor. Simple controls, fast-paced matches, and thrilling gameplay make the game accessible to everyone. Test your skills, defeat enemies, and prove that you are the best fighter!",
    "publisher": "GamePush",
    "languages": [
      "English",
      "French",
      "German",
      "Japanese",
      "Russian",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-14T14:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Choose a mode:\\n\\nLand on the map and start searching for weapons and supplies.\\n\\nControls:\\n\\nMovement: WASD (or arrow keys).\\n\\nShooting: Left mouse button.\\n\\nAiming: Move the cursor over the target.\\n\\nWeapon switching: Mouse wheel or numbers (1,2,3…).\\n\\nItem usage: E or F.\\n\\nObjective:\\n\\nEliminate enemies and be the last survivor.\\n\\nUse cover and strategy to win.\\n\\nTips:\\n\\nFind the best weapons and armor.\\n\\nKeep moving to avoid being an easy target.\\n\\nReady for battle? Show what you're capable of! ??",
    "sourceUrl": "https://gamedistribution.com/games/battle-zone-2d/"
  },
  {
    "id": "bd53636b47fc4e72b75a723b2693eb8e",
    "slug": "knit-bears",
    "title": "Knit Bears",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/bd53636b47fc4e72b75a723b2693eb8e-512x384.jpg",
    "description": "Knit Bears is a cozy and colorful puzzle game where you help adorable teddy bears come to life by knitting them from soft yarn. Choose a bear, place it in the center, and matching yarn balls will start wrapping it up. Each teddy bear needs three yarns to be fully knitted, so plan your moves carefully. If the board fills with unfinished bears that can’t be completed, the game ends.",
    "publisher": "GameBerry Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-14T13:44:07.043Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Both",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Select one of the available bears with an outline and place it in the center slot to begin knitting. Matching yarn balls from the bottom row will automatically start wrapping the bear. Bears without outlines are locked and can’t be selected until unlocked. The game ends when the center fills with unfinished bears that cannot be completed.",
    "sourceUrl": "https://gamedistribution.com/games/knit-bears/"
  },
  {
    "id": "72c0cadeea2a4d92a0b6dca8b018698d",
    "slug": "squarehead-hero",
    "title": "Squarehead Hero",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/72c0cadeea2a4d92a0b6dca8b018698d-512x384.jpg",
    "description": "Squarehead Hero is a fun, turn-based puzzle game where you help a brave, square-headed hero explore dangerous dungeons full of monsters and treasure.\\nPlan your moves carefully on a grid board — fight enemies, grab loot, and gear up for the next challenge.\\nThink you’ve got what it takes to lead Squarehead to victory? Jump in and find out!",
    "publisher": "BlackMoon Design",
    "languages": [
      "English",
      "French",
      "Polish",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-14T10:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Swipe or use the arrow keys to move. \\nBump into the enemies to attack them (if you have a weapon) or defend against them (if you don't). \\nTap on the inventory items (or use 1,2,3 keys) to use an item. \\nRoll-over (or tap and hold) over item or enemy to learn its features and perks. ",
    "sourceUrl": "https://gamedistribution.com/games/squarehead-hero/"
  },
  {
    "id": "777ff7ea90e8415cacadcfcfbd175cac",
    "slug": "eat-donuts",
    "title": "Eat Donuts",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/777ff7ea90e8415cacadcfcfbd175cac-512x384.jpg",
    "description": "Swap, rotate, and smash colorful donut rings in a vibrant 3x3 grid to create explosive matches and devour points like never before. Start with easy levels like our sunny beachside challenge—rack up scores to hit that juicy target of 800, earn shiny coins for power-ups like the mighty hammer smash or speedy rotates, and unlock endless waves of mouthwatering fun. ",
    "publisher": "SecGame",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-14T10:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "- Click to select a donut ring in the 3x3 grid\\n- Drag and drop to swap adjacent rings and create matches\\n- Double-click to rotate a selected ring for better alignments\\n- Right-click to activate power-ups like the hammer smash on stubborn clusters",
    "sourceUrl": "https://gamedistribution.com/games/eat-donuts/"
  },
  {
    "id": "80ddf44c832b44d69d72392d9453ca00",
    "slug": "celebrity-e-girl-vibes",
    "title": "Celebrity E-Girl Vibes",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/80ddf44c832b44d69d72392d9453ca00-512x384.jpg",
    "description": "Step into the world of edgy street style with Celebrity E-Girl Vibes! This game lets you dress up celebrities in the bold, trendy looks that define E-Girl fashion. Experiment with colorful hairstyles, graphic eyeliner, oversized hoodies, crop tops, ripped jeans, plaid skirts, chokers, and statement accessories. Pair each look with vibrant makeup and nail polish to complete the vibe.",
    "publisher": "Cutedressup",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-14T09:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "Left Mouse Button Click",
    "sourceUrl": "https://gamedistribution.com/games/celebrity-e-girl-vibes/"
  },
  {
    "id": "1fb2396a0f1240578629227a91380d31",
    "slug": "ball-sort",
    "title": "Ball Sort",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/1fb2396a0f1240578629227a91380d31-512x384.jpg",
    "description": "Ball Sort is a fun and addictive puzzle game where you sort colorful balls into tubes – can you solve the puzzle with fewer moves?",
    "publisher": "Albayoo",
    "languages": [
      "English",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-14T07:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "- Tap any bottle to pick up the top ball.\\n- Tap another bottle to move the ball into it, but only if it’s the same color and the bottle has space.\\n- Win the level by grouping all balls of the same color into one bottle.\\n- Use Undo to backtrack if you make a wrong move.\\n- Add a Bottle if you need more space to solve the puzzle.\\n- Restart any level at any time to try a new strategy.",
    "sourceUrl": "https://gamedistribution.com/games/ball-sort/"
  },
  {
    "id": "86f1dfbf141c4def9e69eb5497c89f03",
    "slug": "fireside-solitaire",
    "title": "Fireside Solitaire",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/86f1dfbf141c4def9e69eb5497c89f03-512x384.jpg",
    "description": "Fireside Solitaire is a cozy card puzzle that combines logic and relaxation by the warmth of a crackling fire.\\nPlace cards in sequence — one rank higher or lower than the current open card — to clear all columns.\\nThink ahead: once the draw pile runs out, it can’t be reshuffled, and the game ends.\\nEnjoy calm music, soft light, and the comforting atmosphere of a winter evening by the fireplace.",
    "publisher": "GameBerry Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-13T12:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Place cards from the tableau or draw pile onto the open card if they are one higher or one lower in value. Example: you can place a 5 or 7 on a 6.\\n\\nReveal and use cards from the tableau to free hidden ones underneath. If no moves are available, draw a new card from the pile.\\n\\nThe game ends when the pile is empty and no moves remain. Your goal is to clear all columns before the deck runs out.\\n",
    "sourceUrl": "https://gamedistribution.com/games/fireside-solitaire/"
  },
  {
    "id": "624086883e77443b80d3d851265339e9",
    "slug": "black-cat-stacking-pop",
    "title": "Black Cat Stacking POP",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/624086883e77443b80d3d851265339e9-512x384.jpg",
    "description": "Tap tiles to clear them! When you tap a tile, any same-colored tiles next to it will also connect and clear together. Clear a bunch of tiles at once, and a toy mouse will appear to help clear even more! Clear target tiles or tiles that add moves to increase your remaining moves. The game ends when you run out of moves.",
    "publisher": "Synk Inc.",
    "languages": [
      "English",
      "Japanese"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-13T09:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Tap to clear tiles",
    "sourceUrl": "https://gamedistribution.com/games/black-cat-stacking-pop/"
  },
  {
    "id": "2323dfd0bd98417db5ea368a58ba4ca7",
    "slug": "boyfriend-for-hire",
    "title": "Boyfriend For Hire",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/2323dfd0bd98417db5ea368a58ba4ca7-1280x550.jpg",
    "description": "Pushed by her mom to start dating, studious Amy hires charming transfer student Javier to pose as her boyfriend. Rival Christie, jealous rumors, and a flirty study partner turn the act into real complications. Choose outfits, make tough choices, and decide if this love is real—or just for show.",
    "publisher": "MarketJS",
    "languages": [
      "English",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-13T07:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Female",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Choose your own adventure in this teen girl romance series.",
    "sourceUrl": "https://gamedistribution.com/games/boyfriend-for-hire/"
  },
  {
    "id": "ecb0b16cbec642228f1eeaf148dc3dd4",
    "slug": "mma-super-fight",
    "title": "MMA Super Fight",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/ecb0b16cbec642228f1eeaf148dc3dd4-512x384.jpg",
    "description": "The crowd is roaring, the spotlight is on you. From rookie to legend — face endless fights, unlock unique fighters and upgrade power, defense, health and regeneration. With every match, the pressure rises. The ring never sleeps and neither can you.\\n",
    "publisher": "Inlogic Software",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Portuguese",
      "Russian",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-12T08:40:40.537Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use directional movement to navigate the ring and choose from two attacks and a block. Matches reward coins used for upgrades. As you progress, new fighter options become available and opponents grow more challenging.\\n",
    "sourceUrl": "https://gamedistribution.com/games/mma-super-fight/"
  },
  {
    "id": "fe54aa5a8e4b489a832015240d6a6461",
    "slug": "cocktailz",
    "title": "Cocktailz",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/fe54aa5a8e4b489a832015240d6a6461-512x384.jpg",
    "description": "Thirsty? Make all sorts of cocktails in this refreshing Match-3 game! Excessive alcohol consumption is harmful to health, but you can play this game without moderation.",
    "publisher": "StoreRider",
    "languages": [
      "English",
      "French"
    ],
    "mobile": [],
    "firstActiveDate": "2025-11-12T08:32:51.655Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Move and Remove ingredients forming groups of 3 or more. \\nThe more they disappear, the more points you earn.\\nFollow the cocktail recipes on the left of the screen,\\nRemove the requested items and get a bonus to improve your SCORE.\\nBe quick to fill the bottom gauge and activate the Super Wave!!!",
    "sourceUrl": "https://gamedistribution.com/games/cocktailz/"
  },
  {
    "id": "dcacac68daf14a53a1aced0ac68da5a2",
    "slug": "frost-land-snow-survival",
    "title": "Frost Land - Snow Survival",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/dcacac68daf14a53a1aced0ac68da5a2-1280x550.jpg",
    "description": "Frost Land - Snow Survival is a strategic base-building game where you battle the harsh cold to stay alive. You’ll wield a flamethrower to melt snow, uncover hidden resources, and expand your shelter. Every choice matters—manage supplies wisely and decide which frozen zones to explore as you carve out survival in a relentless winter.",
    "publisher": "Ultra Games Entertainment Private limited",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-12T08:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Desktop Controls:\\nW/↑ (Up Arrow): Move forward.\\nS/↓ (Down Arrow): Move backward.\\nA/← (Left Arrow): Move left.\\nD/→ (Right Arrow): Move right.\\n\\nMobile Controls:\\nOn-Screen Joystick: Move in all directions by dragging the joystick.",
    "sourceUrl": "https://gamedistribution.com/games/frost-land-snow-survival/"
  },
  {
    "id": "2a47f95c576b4a6ebdd29d73b372b8ad",
    "slug": "fire-ball-and-water-ball:-parkour-love-balls",
    "title": "Fire Ball and Water Ball: Parkour Love Balls",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/2a47f95c576b4a6ebdd29d73b372b8ad-512x384.jpg",
    "description": "Fire Ball and Water Ball: Parkour Love Balls is an interesting parkour adventure and addictive ball game in the platform genre where orange fire ball and blue water ball running races. \\n\\nHelp orange ball to get to the portal faster than the blue ball doing parkour tricks! The game is similar to mario.\\n\\nGame Features:\\n- Multiple levels with colorful balls\\n- Various biomes\\n- Secrets in the back\\n- Orange fire and blue water ball skins\\n- The water ball girl goes through the levels with you!",
    "publisher": "Stickman vs Monster School Team",
    "languages": [
      "English",
      "Russian",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-12T08:08:44.963Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "You can move and jump using the arrow keys, the WASD buttons (for PC) or by tapping the virtual buttons located on the screen (for smartphones and tablets).\\n\\nDon't fall into the pits and don't fall into the traps.\\nTo win, you need to get to the portal.\\nAt the same time, it is not necessary to overtake another ball, because you are friends, not rivals :)",
    "sourceUrl": "https://gamedistribution.com/games/fire-ball-and-water-ball:-parkour-love-balls/"
  },
  {
    "id": "2eb8260c11ae4628926d434548a81ec5",
    "slug": "backrooms",
    "title": "Backrooms",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/2eb8260c11ae4628926d434548a81ec5-512x384.jpg",
    "description": "Trapped in the eerie maze of the Backrooms, your only goal is to escape or survive, trying.\\nPlay solo or team up with friends in this online multiplayer horror experience. Explore surreal levels, avoid lurking entities, solve puzzles, and use proximity voice chat to stay connected… and stay alive.",
    "publisher": "2Play",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-11T15:15:00.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Explore – Navigate the endless, eerie Backrooms. Each level is unique and full of hidden threats.\\nSolve puzzles – Find keys, fix circuits, unlock escape routes. Teamwork can make the difference.\\nUse voice chat – Stay close to your teammates. Voice only works when you're nearby.\\nAvoid entities – Some things lurking in the dark will hunt you. Stay quiet, hide, and run if needed.",
    "sourceUrl": "https://gamedistribution.com/games/backrooms/"
  },
  {
    "id": "03e358cc3331480795d74a55e4283686",
    "slug": "bubble-shooter-hd-3",
    "title": "Bubble Shooter HD 3",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/03e358cc3331480795d74a55e4283686-512x384.jpg",
    "description": "Bubble Shooter HD 3 is the long-awaited third sequel to the the legendary Bubble Shooter game. Bubble Shooter HD 3 features the classic Bubble Shooter HD gameplay with a set of fresh new bubbles, the option to choose between the arrow vs pointer when shooting bubbles as well as the mighty BOMB feature that lets you blow up 15 bubbles at once. So what is the highest score you can achieve? Enjoy Bubble Shooter HD 3 now and break a new record!",
    "publisher": "SOFTGAMES – Mobile Entertainment Services GmbH",
    "languages": [
      "Dutch",
      "English",
      "French",
      "German",
      "Italian",
      "Japanese",
      "Polish",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-11T09:49:13.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Male",
      "Female",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "Pop all bubbles on the board, scoring as many points as possible. Use the mouse or your finger to aim and shoot. Pop two or more bubbles with a bubble of the same color. The more bubbles you pop in one shot, the more points you get. Failing to pop any bubbles will earn you a foul. After several fouls, a new line of bubbles will be added to the board as a penalty. Use the BOMB to pop 15 bubbles at the same time! Try new winning strategies and become a master!",
    "sourceUrl": "https://gamedistribution.com/games/bubble-shooter-hd-3/"
  },
  {
    "id": "68d223b2b98240a2a41d21b4144e6333",
    "slug": "plants-warfare",
    "title": "Plants Warfare",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/68d223b2b98240a2a41d21b4144e6333-512x384.jpg",
    "description": "Plants Warfare is a shooting game where you step into the shoes of the cute plants. Aim your projectiles, and take down the zombies with strategic aiming and precision shots. Use the environment to your advantage—ricochet bullets and eliminate multiple targets with the least shots possible! Collect stars, customize your look, and prove you’re the ultimate plant defense.",
    "publisher": "kiz10.com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-11T07:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Use the mouse or touch to aim and shoot",
    "sourceUrl": "https://gamedistribution.com/games/plants-warfare/"
  },
  {
    "id": "b7d13c213d1145b6a7b9c16d85937117",
    "slug": "dino-game",
    "title": "Dino Game",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/b7d13c213d1145b6a7b9c16d85937117-512x384.jpg",
    "description": "Play Dino Game online! An offline-style dinosaur run for 1–3 players. Jump cacti, dodge flyers, unlock dinos, and race for high scores. Dino Game brings the classic offline dinosaur run to life with fast, responsive gameplay and local multiplayer. Dash across an endless desert, jump over cacti, and duck under swooping dinos as the speed steadily climbs. Play solo to beat your personal best, or switch to 2-player and 3-player modes to race friends on the same device. ",
    "publisher": "CursoraLabs",
    "languages": [
      "Arabic",
      "English",
      "German",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-11T07:26:04.314Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Player 1: W or UP ARROW or SPACE or LEFT-CLICK (In 1P and 2P Modes Only)\\nPlayer 2: U or UP ARROW (In 2P Mode Only)\\nPlayer 3: UP ARROW",
    "sourceUrl": "https://gamedistribution.com/games/dino-game/"
  },
  {
    "id": "e92f1628cb724c31bf4bdf99477485da",
    "slug": "lion-family-sim-online",
    "title": "Lion Family Sim Online",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/e92f1628cb724c31bf4bdf99477485da-512x384.jpg",
    "description": "Step into the wild and rule the savannah in Lion Family Sim Online. It’s a full animal simulation adventure where you live the life of a mighty lion. Build and grow your own lion family, explore vast open landscapes, and face thrilling challenges. Hunt for food to survive, protect your territory, and lead your pride with strength and strategy. ",
    "publisher": "YAD.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-10T14:19:23.243Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/lion-family-sim-online/"
  },
  {
    "id": "31628f3b940847189cb0cea3d943abe0",
    "slug": "steal-brainrot-duel",
    "title": "Steal Brainrot Duel",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/31628f3b940847189cb0cea3d943abe0-512x384.jpg",
    "description": "Steal Brainrot Duel is a fast, competitive collector-raider where you hunt for the best brainrot characters, defend your base from thieves, and outsmart rivals in Solo or 2 Player mode. Start with simple picks like Noobini Pizzanini, then grind your economy to unlock rare and legendary favorites such as Tralalero Tralala, Cocofanto Elefanto, and Graipussi Medussi. Build income, raid others, protect your stash, and style your obby avatar with hats, glasses, backpacks, wings, outfits, and pets!",
    "publisher": "gameVgames",
    "languages": [
      "Arabic",
      "English",
      "German",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-10T08:33:56.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Player 1\\n\\nMove: W,A,S,D\\nJump: Space\\nBuy or Steal: E\\nHit: F or Left Mouse\\nSprint: Left Shift\\nPlayer 2\\n\\nMove: Arrow Keys\\nJump: L\\nBuy or Steal: O\\nHit: K\\nSprint: J",
    "sourceUrl": "https://gamedistribution.com/games/steal-brainrot-duel/"
  },
  {
    "id": "4b50e554c89f4d8c92432e15d8895238",
    "slug": "poppytile",
    "title": "PoppyTile",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/4b50e554c89f4d8c92432e15d8895238-512x384.jpg",
    "description": "PoppyTile is a soothing and delightful tile-matching puzzle game set in a peaceful, picturesque countryside farm full of charm!",
    "publisher": "LUCKY TRY",
    "languages": [
      "Arabic",
      "Chinese (Simplified)",
      "English",
      "French",
      "German",
      "Italian",
      "Japanese",
      "Korean",
      "Portuguese",
      "Russian",
      "Spanish",
      "Thai"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-10T08:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Tap 3 matching tiles to clear them and complete the board!",
    "sourceUrl": "https://gamedistribution.com/games/poppytile/"
  },
  {
    "id": "30909e6007a748539e41d75dfec483f4",
    "slug": "pew-pew-dose",
    "title": "Pew Pew Dose",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/30909e6007a748539e41d75dfec483f4-512x512.jpg",
    "description": "Build the weapon of your dreams and blast through hordes of cute… yet deadly zombie rascals!\\n\\nWelcome to a bright and crazy post-apocalypse where only the most creative weapon makers survive. In this arcade 3D mayhem, you start with a simple gun… and end up wielding a monster built from multiple barrels twisted together into insane contraptions!\\n\\nCraft without limits: attach barrel to barrel, add magazines, boost firepower, and create unique weapons that would make enemies run away…",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-09T13:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Controls:\\n· On mobile devices: swipe left or right on the screen to move your character and dodge enemies\\n· On PC: click and drag the mouse left or right, or use the arrow keys on the keyboard to move and dodge\\n\\nObjective: reach the end of the level, survive waves of cute but deadly zombie-critters, and defeat as many enemies as possible\\n\\nWorkshop: collect parts, merge identical components, and build unique weapons — from simple guns to crazy multi-barrel monstrosities",
    "sourceUrl": "https://gamedistribution.com/games/pew-pew-dose/"
  },
  {
    "id": "3d7e461fb28a47cab835037f8c024fae",
    "slug": "men-vs-gorillas",
    "title": "Men Vs Gorillas",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/3d7e461fb28a47cab835037f8c024fae-512x384.jpg",
    "description": "Men vs Gorilla – The Ultimate Evolution Battle!\\n\\nStep into the wild showdown of Man vs Gorilla!\\nUpgrade your human’s strength, damage, and health to survive the rising fury of the jungle’s strongest beast. ?\\n\\nEach level brings a tougher gorilla, smarter attacks, and intense battles but also bigger rewards!\\nUse your earnings to level up your power, evolve your fighter, and dominate every fight!",
    "publisher": "Kankane Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-09T12:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Use the left mouse button to upgrade and deploy humans",
    "sourceUrl": "https://gamedistribution.com/games/men-vs-gorillas/"
  },
  {
    "id": "d8294d669a97415e8d077a24ff636a57",
    "slug": "screw-puzzle",
    "title": "Screw Puzzle",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/d8294d669a97415e8d077a24ff636a57-512x512.jpg",
    "description": "In the game, players need to perform screw-driving challenges according to the level scenes. You need to choose different screw-driving skills according to different levels. There are many interesting gameplays for players to experience. Friends who like it, please come and play!",
    "publisher": "HolaStudio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2024-03-18T07:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "Portrait",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Click the screw to take it then click the hole to drop it down. Release all the metal plates.",
    "sourceUrl": "https://gamedistribution.com/games/screw-puzzle/"
  },
  {
    "id": "89a861e0c99e4503838de9bd6c0499f1",
    "slug": "find-the-frog-hidden-objects",
    "title": "Find the Frog - Hidden Objects",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/89a861e0c99e4503838de9bd6c0499f1-512x384.jpg",
    "description": "Go on a relaxing and magical adventure in Find the Frog - Hidden Objects. In this charming hidden object game, you’ll explore beautifully hand-drawn black-and-white scenes and try to spot frogs hiding in plain sight. With each click or tap, the world around you lights up in color, revealing hidden surprises and playful details. Play for free on both mobile and desktop, unlock new levels, and collect unique frogs from all around the world.",
    "publisher": "Playgama",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-09T09:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Search for hidden frogs across beautifully drawn black-and-white scenes! Simply tap them with your finger (on mobile) or click with your mouse (on PC) to reveal their vibrant colors. Find all frogs to complete each level, and finish entire worlds to add special location-themed frogs to your personal collection!\\n\\nStuck? Use our handy Magnifying Glass power-up! When those green tricksters hide too well, this helpful tool will reveal where they're lurking.\\n\\nGood luck and happy hunting - Ribbit!",
    "sourceUrl": "https://gamedistribution.com/games/find-the-frog-hidden-objects/"
  },
  {
    "id": "b660d10d6c124922babb5d9e7bf29133",
    "slug": "word-search-universe",
    "title": "Word Search Universe",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/b660d10d6c124922babb5d9e7bf29133-512x384.jpg",
    "description": "Word Search Universe is a fun and relaxing puzzle game where you search for hidden words in a grid. The game has 20 chapters, and each one comes with easy, medium, and hard levels to match your skill. In every level, you need to find 6 hidden words. If you get stuck, you can use a hint to help you out. It's a great way to have fun, improve your vocabulary, and keep your brain sharp!",
    "publisher": "Lof Games",
    "languages": [
      "No Text"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-09T09:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Tap and drag to highlight the hidden words in the grid. Use the hint button if you need help finding a word.",
    "sourceUrl": "https://gamedistribution.com/games/word-search-universe/"
  },
  {
    "id": "9b3289d868c942fab5ae19c0ae219f57",
    "slug": "robberies-3d",
    "title": "Robberies 3D",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/9b3289d868c942fab5ae19c0ae219f57-1280x550.jpg",
    "description": "Welcome to Robberies 3D, a fast-paced online shooter where you can don the mask of a real robber! Inspired by the legendary PAYDAY series, this game offers exciting gameplay: search for keys, break into vaults, use a drill, and steal whatever you can get your hands on.\\nChoose your style: engage in a loud battle with the police or operate stealthily like a shadow. But don't think it will be easy: each level is a test of your agility, strategy, and nerves.",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-08T13:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Your main goal is to rob a bank/vault/jewelry store. Look for the keys to the vaults, then open the locks, take the jewelry.\\nTo defend yourself from the guards, use the power of firearms!\\nTo complete the robbery, go to the phone and choose an escape plan, then get in a car or helicopter.\\n\\nPC control:\\nW, A, S, D - movement;\\nMouse shooting;\\n1,2,3 - change weapons.\\nF - take a weapon, ammunition, a key, or money; open the door lock; get on a vehicle to escape; use a phone.\\nSpace - jump; climb stairs",
    "sourceUrl": "https://gamedistribution.com/games/robberies-3d/"
  },
  {
    "id": "fa95daec9bea4cfdb5dea1711919947c",
    "slug": "backgammon-duel",
    "title": "Backgammon Duel",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/fa95daec9bea4cfdb5dea1711919947c-512x384.jpg",
    "description": "One of the oldest, most played and loved games, the classic backgammon game. \\n\\nAlso known as Tavli (Greece), Tawla (Egypt), and Takteh (Iranian), but whatever you call it you can download it now and challenge yourself.",
    "publisher": "PHATCAT Games Ltd",
    "languages": [
      "Arabic",
      "Chinese (Simplified)",
      "Danish",
      "French",
      "German",
      "Greek",
      "Hindi",
      "Italian",
      "Persian",
      "Polish",
      "Portuguese",
      "Romanian",
      "Russian",
      "Simple English",
      "Spanish",
      "Swedish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-08T13:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Roll the dice. Click on a piece on the board and click on a available space on the board to move it to. The player wins when all the pieces have been removed from the board.",
    "sourceUrl": "https://gamedistribution.com/games/backgammon-duel/"
  },
  {
    "id": "f730019a3aa645d3926fa54a9898cedf",
    "slug": "slime-farm!",
    "title": "Slime Farm!",
    "category": "Simulation",
    "thumbnail": "https://img.gamedistribution.com/f730019a3aa645d3926fa54a9898cedf-512x512.jpg",
    "description": "Farm Slime: Slime Farm Simulator is a relaxing yet addictive game where you drive a suction truck to vacuum up unruly slimes and turn them into cash. Cruise smoothly through gooey fields, slurp with satisfying precision, sell your haul to upgrade your truck and expand your farm into a thriving slime empire.",
    "publisher": "Qam Games",
    "languages": [
      "English"
    ],
    "mobile": [],
    "firstActiveDate": "2025-11-08T13:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Simulation",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Use WASD / arrow keys / drag the left mouse button to move around.",
    "sourceUrl": "https://gamedistribution.com/games/slime-farm!/"
  },
  {
    "id": "3b4ed5d8a4ac4ff9bdacda88d3c79045",
    "slug": "animal-basketball",
    "title": "Animal Basketball",
    "category": "Sports",
    "thumbnail": "https://img.gamedistribution.com/3b4ed5d8a4ac4ff9bdacda88d3c79045-512x384.jpg",
    "description": "Dive into Basketball: The Power of Moe! Team up with adorable animals, unlock over 100 magical balls, and enjoy physics-powered hoop action. Play through arcade, championship, and mission modes on dazzling courts in this fun and addictive basketball party!",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-08T09:30:05.030Z",
    "lastUpdated": "",
    "genres": [
      "Sports",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Desktop Controls:\\nMouse left button to drag and shoot.\\nMobile Controls:\\nTouch and move on screen to drag and shoot.",
    "sourceUrl": "https://gamedistribution.com/games/animal-basketball/"
  },
  {
    "id": "4cc746ade8b9417da554bd8aaf67333a",
    "slug": "delivery-now",
    "title": "Delivery Now",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/4cc746ade8b9417da554bd8aaf67333a-512x384.jpg",
    "description": "Delivery Now is an open world endless delivery game , which uses spectacular graphics and amazing audio effects to give a breathtaking game play experience.\\n\\nDelivery Now is a fast paced action and racing game in which you will have to race against time to deliver these cute things, making your way through city highway traffic racers. You can make your own path towards your goal.\\n\\nLet's enjoy it. What are you waiting for?",
    "publisher": "Tiny Castle Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-08T09:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Using mouse to move left or right to avoid obstacles",
    "sourceUrl": "https://gamedistribution.com/games/delivery-now/"
  },
  {
    "id": "45f8e712bb594235bc4e21ac023868aa",
    "slug": "color-nonogram-puzzle-2",
    "title": "Color Nonogram Puzzle 2",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/45f8e712bb594235bc4e21ac023868aa-512x384.jpg",
    "description": "Dive into Relaxing Color Nonogram – a vibrant logic puzzle where every grid hides a colorful surprise! Perfect for fans of Picross and nonogram games, this free puzzle blends color, calm, and clever brain challenges in one relaxing package.\\nWhether you’re searching for a “logic puzzle game”, “nonogram color puzzle”, or “free nonogram game”, this one’s your perfect pick.",
    "publisher": "GMG",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-08T07:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Each row and column has colored number clues that tell you how many blocks to paint and what colors to use. Use logic to fill in the grid correctly – no guessing required!\\n",
    "sourceUrl": "https://gamedistribution.com/games/color-nonogram-puzzle-2/"
  },
  {
    "id": "b40bcd08ddba4a649b7642d3804b2f01",
    "slug": "supermarket-simulator:-dream-store",
    "title": "Supermarket Simulator: Dream Store",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/b40bcd08ddba4a649b7642d3804b2f01-1280x720.jpg",
    "description": "Build and expand your shop: add shelves, displays, products, and decorations to attract more customers. Hire staff and manage their skills and motivation. Handle orders, discounts, and marketing campaigns. Every day, your store grows bigger and more profitable!",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-07T13:51:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Build your store from scratch: place shelves and products.\\n\\nHire staff and manage their skills.\\n\\nServe customers and keep them happy.\\n\\nManage finances: set prices, discounts, and promotions.\\n\\nExpand your store, open new departments, and upgrade decorations.",
    "sourceUrl": "https://gamedistribution.com/games/supermarket-simulator:-dream-store/"
  },
  {
    "id": "c051b0cae7fb4aa4a32b289ac8c775a4",
    "slug": "hidden-object-farm-adventure",
    "title": "Hidden Object Farm Adventure",
    "category": "Simulation",
    "thumbnail": "https://img.gamedistribution.com/c051b0cae7fb4aa4a32b289ac8c775a4-512x384.jpg",
    "description": "Play a fun hidden object game with 30 farm levels! each level, find 6 hidden things before time runs out. If you need help, use a hint! It's easy to play and full of colorful farm fun.",
    "publisher": "Lof Games",
    "languages": [
      "Arabic",
      "Bulgarian",
      "Chinese (Simplified)",
      "Czech",
      "Danish",
      "Dutch",
      "English",
      "Estonian",
      "Finnish",
      "French",
      "German",
      "Greek",
      "Hebrew",
      "Hindi",
      "Hungarian",
      "Indonesian",
      "Italian",
      "Japanese",
      "Korean",
      "Latvian",
      "Lithuanian",
      "Polish",
      "Portuguese",
      "Romanian",
      "Russian",
      "Serbian",
      "Simple English",
      "Slovak",
      "Spanish",
      "Swahili",
      "Swedish",
      "Tagalog",
      "Thai",
      "Turkish",
      "Ukrainian",
      "Vietnamese"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-07T10:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Simulation",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use a mouse or touchpad to play this game.",
    "sourceUrl": "https://gamedistribution.com/games/hidden-object-farm-adventure/"
  },
  {
    "id": "34b3dd35505444f282a9e35a7ceb4a93",
    "slug": "k-pop-hunter-fashion",
    "title": "K-Pop Hunter Fashion",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/34b3dd35505444f282a9e35a7ceb4a93-512x384.jpg",
    "description": "Unleash your creativity in K-Pop Hunter Fashion, a unique dress up game where trendy K-Pop meets gothic demon hunter vibes. Style glamorous idols in bold K-Pop looks while blending them with dark, fantasy-inspired outfits. From leather jackets and spiked boots to neon hair, glowing makeup, and mystical accessories—you’ll create fierce, otherworldly fashion statements.",
    "publisher": "Cutedressup",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-07T08:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "Left Mouse Button Click",
    "sourceUrl": "https://gamedistribution.com/games/k-pop-hunter-fashion/"
  },
  {
    "id": "8d9a72373d1140ceb3bda7e421d7dbcd",
    "slug": "bubble-tea",
    "title": "Bubble Tea",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/8d9a72373d1140ceb3bda7e421d7dbcd-512x384.jpeg",
    "description": "Bubble Tea is a super fun simulating tea making game, which has many levels waiting for you to challenge. It allows you to add the specified raw materials in each level according to the requirements, and make a variety of flavors of tea. It's easy to operate, wish you can have a good time in the Bubble Tea!",
    "publisher": "YAD.Com",
    "languages": [],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2020-05-15T14:08:23.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Mouse click or tap the screen to play",
    "sourceUrl": "https://gamedistribution.com/games/bubble-tea/"
  },
  {
    "id": "2dee9d404697435aa76111eb4015e1d5",
    "slug": "merge-fruit",
    "title": "Merge Fruit",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/2dee9d404697435aa76111eb4015e1d5-512x512.jpeg",
    "description": "Tetris + 2048! Very Popular endless game around the world.\\nYou drop some random fruit and two same fruit can merge to high level one. At last, merge your own Big fruit! ",
    "publisher": "LoraStudio",
    "languages": [],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2021-03-15T08:27:13.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "Portrait",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Drag to move, click to drop down, two same fruit can merge to high level one.",
    "sourceUrl": "https://gamedistribution.com/games/merge-fruit/"
  },
  {
    "id": "1f7e42ff6598484fb996a31a9721bd10",
    "slug": "merge-2048-cake",
    "title": "Merge 2048 Cake",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/1f7e42ff6598484fb996a31a9721bd10-512x512.jpg",
    "description": "Merge 2048 Cake is a colorful and relaxing puzzle game where you merge matching tiles to create higher numbers!\\nCombine three or more identical tiles to form a new one with double the value. Plan your moves, trigger satisfying chain reactions, and aim for the ultimate 2048 tile!\\nEnjoy smooth gameplay, vivid visuals, and a cozy, casual vibe that’s easy to play and hard to put down.",
    "publisher": "GameBerry Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-06T10:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Tap or click on groups of three or more matching tiles to merge them into one with a higher number.\\nEarn coins and use boosters — the Rocket, Magnet, and Sorter — to clear the board and keep the game going.\\nThink strategically and see how far you can go before the board fills up!",
    "sourceUrl": "https://gamedistribution.com/games/merge-2048-cake/"
  },
  {
    "id": "a9d35516635d487d9fb95bb5d95c42e5",
    "slug": "monkey-bubble-defense",
    "title": "Monkey Bubble Defense",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/a9d35516635d487d9fb95bb5d95c42e5-512x384.jpg",
    "description": "Survive the bubble invasion in this fast-paced 2D top-down tower defense game. Construct and upgrade various defensive turrets to take down hordes of bubbles.\\n\\nEarn cash by popping bubbles. Use cash to to purchase new towers, upgrade existing ones, or sell for cash and reinvest into a different turret.\\n",
    "publisher": "MarketJS",
    "languages": [
      "English",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-06T08:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Construct turrets to protect your base from rogue bubbles.",
    "sourceUrl": "https://gamedistribution.com/games/monkey-bubble-defense/"
  },
  {
    "id": "ad50ffe7f40340fb955a2d933b0be10c",
    "slug": "thief-stick-puzzle-man-escape",
    "title": "Thief Stick Puzzle Man Escape",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/ad50ffe7f40340fb955a2d933b0be10c-512x512.jpg",
    "description": "Enjoy a hilarious and brain-twisting adventure in Thief Stick Puzzle: Man Escape. It’s a mix of stickman comedy, clever puzzle levels, and funny escape challenges that will keep you hooked for hours! You play as a sneaky thief stickman trying to escape from tricky situations. To survive, you’ll need to solve smart brain teaser puzzles. For example, finding the correct path through a maze to obtain treasure, or bypassing a cutting machine to save a puppy.",
    "publisher": "YAD.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-06T08:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/thief-stick-puzzle-man-escape/"
  },
  {
    "id": "ccdfb2317e054214984d5f64ddda2ab9",
    "slug": "okay",
    "title": "Okay",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/ccdfb2317e054214984d5f64ddda2ab9-512x384.jpg",
    "description": "Okay is a minimalist puzzle game where your goal is to clear every element from the board by drawing a single strategic line. Each line you draw interacts with the objects on screen — if it hits them correctly, they disappear. The challenge lies in predicting the trajectory and eliminating everything with just one attempt.",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-06T08:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Draw a line using your mouse or finger.\\nOnce released, the line will move and bounce according to the game's physics, interacting with objects on the board.\\nYour objective is to make every element disappear in one move — no second attempts within the same turn.",
    "sourceUrl": "https://gamedistribution.com/games/okay/"
  },
  {
    "id": "f267dd323da14be7a0aade7dd70125d5",
    "slug": "gal-sliding-puzzle",
    "title": "Gal Sliding Puzzle",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/f267dd323da14be7a0aade7dd70125d5-512x384.jpg",
    "description": "It's a classic sliding puzzle.\\nYou can challenge yourself by increasing the difficulty level from 3*3, 4*4, 5*5.\\nTrain and activate your brain~\\nComplete it and meet various pretty girls.",
    "publisher": "MOVISOFT.Co.,Ltd",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-06T07:52:09.604Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Select a block around an empty space.\\nMove to the empty space.\\nMove the block to complete the picture.",
    "sourceUrl": "https://gamedistribution.com/games/gal-sliding-puzzle/"
  },
  {
    "id": "83085f4569024404b66e2bbb14507a0c",
    "slug": "snow-rider-3d-nostalgia",
    "title": "Snow Rider 3D nostalgia",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/83085f4569024404b66e2bbb14507a0c-512x384.jpg",
    "description": "Snow Rider 3D: Nostalgia brings back the beloved old version of the iconic sleigh-riding game — the same thrilling ride, relaxing snow tracks, and joyful music that started it all.",
    "publisher": "GameBiz",
    "languages": [
      "English"
    ],
    "mobile": [],
    "firstActiveDate": "2025-11-05T15:10:17.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Up arrow key or W - Jump\\nLeft arrow key or A - Steer Left\\nRight arrow key or D - Steer Right\\n\\n\\n",
    "sourceUrl": "https://gamedistribution.com/games/snow-rider-3d-nostalgia/"
  },
  {
    "id": "11233fb28e134834a682ca49624ec0bd",
    "slug": "hidden-objects-story",
    "title": "Hidden Objects Story",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/11233fb28e134834a682ca49624ec0bd-512x384.jpg",
    "description": "Every scene tells a story, waiting for your discovery. Collect coins, unlock hints and piece together secrets buried beneath the surface. The mystery deepens with every level. Stay focused or the secrets slip away forever.\\n",
    "publisher": "Inlogic Software",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Portuguese",
      "Russian",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-05T10:03:52.366Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Find all objects listed in the scene by tapping them. Use coins to buy power-ups: the compass highlights an object’s area, the magnifying glass reveals it instantly. Avoid wrong taps, as each mistake and the timer reduce your available time.\\n",
    "sourceUrl": "https://gamedistribution.com/games/hidden-objects-story/"
  },
  {
    "id": "5049d27064274196b0120626252b0aa2",
    "slug": "save-the-bees",
    "title": "Save the Bees",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/5049d27064274196b0120626252b0aa2-512x384.jpg",
    "description": "In \\",
    "publisher": "Eyestorm Pte. LTD.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-05T09:52:01.735Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Confront danger, protect the natural environment, and save the bee world!",
    "sourceUrl": "https://gamedistribution.com/games/save-the-bees/"
  },
  {
    "id": "387c69e13ef341268e7b659cc2e2311c",
    "slug": "obby-blox-hook",
    "title": "Obby Blox Hook",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/387c69e13ef341268e7b659cc2e2311c-512x384.jpg",
    "description": "Obby Blox Hook is an addictive physics-based platformer where players control the Roblox players swinging through levels using a grappling hook. With smooth animations, challenging obstacles, and fun physics mechanics, the game tests your timing and precision as you swing from one point to another, avoiding obstacles and making daring jumps to reach the finish line.",
    "publisher": "kiz10.com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-05T08:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Use the mouse or touch to hook",
    "sourceUrl": "https://gamedistribution.com/games/obby-blox-hook/"
  },
  {
    "id": "f4055ea8c0794a50badf82d7ce837eaa",
    "slug": "archers-random",
    "title": "Archers Random",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/f4055ea8c0794a50badf82d7ce837eaa-512x384.jpg",
    "description": "Archers Random is a fast-paced stickman archery game that tests your reflexes and aim.\\n\\nFight endless enemy waves, explore new areas, and earn coins to unlock helmets, armor, and triple arrows. Upgrade speed, damage, health, and arm power, master 12 special arrows like fire, poison, rocket, and electric, face epic bosses, and survive nonstop action.\\n\\nPlay solo or challenge a friend in 2 Player mode on the same device for intense head-to-head battles.",
    "publisher": "Goolandia",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-05T08:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "1 Player Mode\\nUse the left mouse button to control the archer.\\n\\n2 Player Mode\\nPlayer 1: W\\nPlayer 2: UP ARROW\\n\\nTouch for mobile.\\n",
    "sourceUrl": "https://gamedistribution.com/games/archers-random/"
  },
  {
    "id": "7d557c57bcf84ef0a1bd65bd224a2306",
    "slug": "color-yarn-sort",
    "title": "Color Yarn Sort",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/7d557c57bcf84ef0a1bd65bd224a2306-200x120.jpg",
    "description": "Color Yarn Sort is a fun and relaxing puzzle game where you need to sort colorful spools of yarn into their matching buckets. The challenge? You have limited space to place the buckets, and you must think carefully about which bucket to move forward. Each yarn color must be placed in its corresponding bucket, but you can only move the buckets into the available spaces—there’s no room for error!",
    "publisher": "Bravestars Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-05T07:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "How to play: The goal is to match the yarns with their respective colored buckets. You can only move one bucket at a time, and each bucket takes up a space. If you place a bucket incorrectly, you’ll lose a space. Once all the spaces are filled, you’ll lose the game if you haven’t correctly matched all the yarns. With limited space and multiple buckets to choose from, you'll need to plan your moves carefully to avoid getting stuck!",
    "sourceUrl": "https://gamedistribution.com/games/color-yarn-sort/"
  },
  {
    "id": "92e2ea1340a4401bbec402925a611e76",
    "slug": "noob-vs-zombie-apocalypse:-shooting-pro",
    "title": "Noob vs Zombie Apocalypse: shooting pro",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/92e2ea1340a4401bbec402925a611e76-512x384.jpg",
    "description": "Post-apocalypse! Noob finds himself alone against zombies. Passing levels, he accumulates coins and picks up weapons.\\nThere is a grenade launcher, a pistol, an uzi, a shotgun, a machine gun, a laser pistol, a rifle, a laser rifle - and so on!\\n\\nNoob vs Zombie Apocalypse: shooting pro is an epic noob game in the world, similar to minecraft fnaf. Noob shoots at zombies with a variety of weapons like a rambo. Noob miner starts his fighting fnaf survival!\\n\\nThere are 60 levels and 15 bosses in total!\\n",
    "publisher": "Stickman vs Monster School Team",
    "languages": [
      "English",
      "Russian",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-04T10:23:42.947Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Smartphone/Tablet:\\nArrows: move, jump;\\nSword: attack;\\n\\nPC:\\nArrows and WAD: movement\\nSpace / E: Attack\\n\\nCollect coins!\\nUpgrade your character!\\nTo pass to the next level you need to defeat all the enemies!",
    "sourceUrl": "https://gamedistribution.com/games/noob-vs-zombie-apocalypse:-shooting-pro/"
  },
  {
    "id": "aef52b1f2b9542e18556b6bfa58e0220",
    "slug": "pottery-master",
    "title": "Pottery Master",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/aef52b1f2b9542e18556b6bfa58e0220-512x384.jpeg",
    "description": "Pottery Master invites you into a peaceful world of creativity and clay. Shape, sculpt, and refine your pottery using intuitive tools, then add your personal touch with vibrant colors. Each creation is a moment to unwind, express your style, and transform simple clay into a stunning masterpiece in a relaxing, artistic flow",
    "publisher": "Rike Games",
    "languages": [
      "No Text"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-04T08:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Left-click to interact with the game UI.",
    "sourceUrl": "https://gamedistribution.com/games/pottery-master/"
  },
  {
    "id": "62589158906a4ce69d53bfbd3ea2d134",
    "slug": "flower-sort",
    "title": "Flower Sort",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/62589158906a4ce69d53bfbd3ea2d134-512x384.jpg",
    "description": "Sort Flowers is a bright and relaxing puzzle game where you sort flowers by type!\\nCombine three identical flowers in one pot to grow a lush, beautiful bush.\\nPlan your moves, create satisfying merge chains, and enjoy the colorful and cozy atmosphere.\\nEach level brings new combinations, vibrant colors, and delightful visual effects.",
    "publisher": "GameBerry Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-04T08:25:43.530Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Drag flowers into the correct pots to sort them.\\nPay attention — each pot shows how many flower layers it contains.\\nYou can see flower shadows behind the front layer — clear it to reveal what’s hidden!\\nComplete the sorting before time runs out to finish the level and move on to the next one!",
    "sourceUrl": "https://gamedistribution.com/games/flower-sort/"
  },
  {
    "id": "69d27d0c48e74ee097104e4f6f6ddea5",
    "slug": "tiny-baker-ocean-jelly-cake",
    "title": "Tiny Baker Ocean Jelly Cake",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/69d27d0c48e74ee097104e4f6f6ddea5-512x384.jpg",
    "description": "Dive into a world of sweetness with Tiny Baker Ocean Jelly Cake! Create a shimmering ocean-inspired jelly dessert using playful shapes and colors, then decorate it with sea-themed toppings for the perfect underwater delight.",
    "publisher": "iclickgames",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-04T07:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use MOUSE to play the game.",
    "sourceUrl": "https://gamedistribution.com/games/tiny-baker-ocean-jelly-cake/"
  },
  {
    "id": "b9d470763a744f22a3d5c00d58e56b7f",
    "slug": "mojicon-emoji-connect",
    "title": "Mojicon Emoji Connect",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/b9d470763a744f22a3d5c00d58e56b7f-200x120.jpg",
    "description": "A fast, fun twist on classic Onet puzzles!\\nGet ready to match and relax with Mojicon: Emoji Connect – the cheerful tile-linking puzzle bursting with personality!\\nConnect identical emoji tiles, clear the board, and enjoy satisfying spark effects with every perfect match.\\nWith hundreds of cute icons, calming backgrounds, and rewarding combos, Mojicon delivers endless relaxing fun for all ages.\\nPlay anywhere, anytime – no downloads, just pure emoji joy!",
    "publisher": "2Million Games",
    "languages": [
      "Czech",
      "Dutch",
      "English",
      "French",
      "German",
      "Italian",
      "Japanese",
      "Polish",
      "Portuguese",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-04T07:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Both",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Tap or click two matching emoji tiles to connect them with a line and clear them from the board.\\nThe connection path can turn up to two times – plan your matches carefully!\\nClear the board before time runs out to win stars.\\nUse Hints or Shuffle power-ups when you’re stuck, and chase the highest combo streak!",
    "sourceUrl": "https://gamedistribution.com/games/mojicon-emoji-connect/"
  },
  {
    "id": "52c85b3037d84d5f9fbd7108bc832ccc",
    "slug": "brainrot-mega-parkour",
    "title": "Brainrot Mega Parkour",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/52c85b3037d84d5f9fbd7108bc832ccc-512x384.jpg",
    "description": "Step into the wildest parkour adventure yet. Brainrot Mega Parkour brings together four intense modes, forty handcrafted levels, and a cast of hilarious characters in a single high-speed package. Whether you’re climbing an endless tower, racing across a platform full of traps, escaping a rolling lava ball, or surviving a lava flood, every level pushes your reflexes and timing to the limit.",
    "publisher": "gameVgames",
    "languages": [
      "Arabic",
      "English",
      "German",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-03T08:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Player 1: Move W A S D, Sprint Shift, Jump Space, Double Jump Space+Space\\nPlayer 2: Move Arrows, Sprint K, Jump L, Double Jump L+L\\nMobile: On-screen buttons.",
    "sourceUrl": "https://gamedistribution.com/games/brainrot-mega-parkour/"
  },
  {
    "id": "58607e4beb494dc1a06a0b11093ef5fa",
    "slug": "mahjong-cute-tiles",
    "title": "Mahjong Cute Tiles",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/58607e4beb494dc1a06a0b11093ef5fa-512x384.jpg",
    "description": "Enjoy a classic Mahjong game, now in another dimension! Rotate the board, explore fresh tile layouts and challenge your mind. Show off your skills and use powerful boosters like undo moves, tile shuffles, bombs and hints to help you advance faster.\\n",
    "publisher": "Inlogic Software",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Portuguese",
      "Russian",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-03T07:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Your goal is to clear all the tiles from the board by matching identical ones. Rotate the board and tap 3 identical tiles to remove them. You can only match tiles that are free, not blocked by others. Use special boosters and keep matching until the board is clear.\\n",
    "sourceUrl": "https://gamedistribution.com/games/mahjong-cute-tiles/"
  },
  {
    "id": "38bbd63f000a442b8545e3cd55c8b619",
    "slug": "tile-sort-match-3",
    "title": "Tile Sort - Match 3",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/38bbd63f000a442b8545e3cd55c8b619-512x512.jpg",
    "description": "Tile Sort - Match 3 is an addictive match-3 puzzle game where your task is to sort and match identical tiles on the board. The game combines classic match-3 gameplay with elements of sorting, adding an extra layer of strategy and logic. Move tiles, creating combinations of three or more identical tiles to clear the board.",
    "publisher": "GamePush",
    "languages": [
      "No Text"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-02T15:10:00.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Move tiles to create lines of three. Matching tiles disappear, making room for new ones.",
    "sourceUrl": "https://gamedistribution.com/games/tile-sort-match-3/"
  },
  {
    "id": "ed76913882be488e992262a466d3fff2",
    "slug": "last-ufo-defense",
    "title": "Last Ufo Defense",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/ed76913882be488e992262a466d3fff2-512x384.jpg",
    "description": "Last UFO DefenseThe galaxy is no safe place. \\nAs the last UFO of your kind, you stand alone against endless waves of hostile alien forces determined to wipe you out.\\nPilot your hovering warship and unleash its full potential:One UFO, endless enemies. \\nSurvive as long as you can with precise upgrades and tactical choices.\\nFace relentless alien swarms in an endless survival challenge.You are the final line of defense in a hostile galaxy.\\nHow long can the last UFO endure?",
    "publisher": "Orenji Spark",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-02T14:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Defold"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Defold"
    ],
    "instructions": "use mouse or tap to interact with game elements.",
    "sourceUrl": "https://gamedistribution.com/games/last-ufo-defense/"
  },
  {
    "id": "be305649d03f439eb03340d2bdf9543a",
    "slug": "road-digging-puzzle",
    "title": "Road Digging Puzzle",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/be305649d03f439eb03340d2bdf9543a-512x384.jpg",
    "description": "This is a puzzle game. you can make a way to pass a level. Dig your way through unique physics puzzles.\\n\\nIt's new and fun brain teasers each step of the way.",
    "publisher": "Eyestorm Pte. LTD.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-02T13:30:00.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Featuring fluid water, lava, bombs, mines, breakable glass, hive and more. Start digging and relax with your free time NOW!\\n\\nJust dig with your fingers",
    "sourceUrl": "https://gamedistribution.com/games/road-digging-puzzle/"
  },
  {
    "id": "4dda77818bd24826b46f6d8525fa55cd",
    "slug": "cake-link-master",
    "title": "Cake Link Master",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/4dda77818bd24826b46f6d8525fa55cd-512x384.jpg",
    "description": "Cake Link Master is a fun puzzle game where you tap two matching cakes to connect them with a line. The line can turn up to two times but cannot go over other tiles. The game has 120 challenging levels, and the difficulty grows as you play. Clear the cakes, solve the puzzles, and enjoy hours of sweet, relaxing fun!",
    "publisher": "Lof Games",
    "languages": [
      "Arabic",
      "Bulgarian",
      "Chinese (Simplified)",
      "Czech",
      "Danish",
      "Dutch",
      "English",
      "Estonian",
      "Finnish",
      "French",
      "German",
      "Greek",
      "Hebrew",
      "Hindi",
      "Hungarian",
      "Indonesian",
      "Italian",
      "Japanese",
      "Korean",
      "Latvian",
      "Lithuanian",
      "Norwegian (Nynorsk)",
      "Polish",
      "Portuguese",
      "Romanian",
      "Russian",
      "Serbian",
      "Simple English",
      "Slovak",
      "Spanish",
      "Swahili",
      "Swedish",
      "Tagalog",
      "Thai",
      "Turkish",
      "Ukrainian",
      "Vietnamese"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-02T11:00:00.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use a mouse or touchpad to tap two matching cakes and connect them.\\nClear all matching pairs to complete the level!",
    "sourceUrl": "https://gamedistribution.com/games/cake-link-master/"
  },
  {
    "id": "e4f7741da98c4a96b04c20f142761a89",
    "slug": "coe-rabbit",
    "title": "Coe Rabbit",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/e4f7741da98c4a96b04c20f142761a89-512x512.jpg",
    "description": "Coe Rabbit is a puzzle platformer where you control a cute bunny and teleport him between platforms! Progress through each level by teleporting to higher platforms, collecting power-ups to adjust the height of your portal, and find the perfect path to reach your destination!\\n\\nAlso have fun with the floating bunny, where you control a carrot ship and avoid crashing into obstacles. Play with your best friend in the challenging two-player mode. Who will win?",
    "publisher": "Newness Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-02T08:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Desktop\\nA/Left arrow key = Turn Left\\nD/Right arrow key = Turn Right\\nZ = Teleport\\n\\nMobile\\nLeft Button = Turn Left\\nRight Button = Turn Right\\nZ Button = Teleport\\n",
    "sourceUrl": "https://gamedistribution.com/games/coe-rabbit/"
  },
  {
    "id": "ca554ec617fe473aa87b3e24609b2e7f",
    "slug": "ants-party",
    "title": "Ants Party",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/ca554ec617fe473aa87b3e24609b2e7f-512x512.jpg",
    "description": "Welcome to Ants Party — a charming strategy-idle game where your colony's mission is clear: eat it all! On each level, a delicious item appears — from juicy apples to giant cakes — and your ants must devour it completely. Starting from your anthill, they march out, take a bite, and carry the piece back home. The level ends when the entire treat is consumed and hauled away.",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-02T07:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "MelonJS"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "MelonJS"
    ],
    "instructions": "Each level features a single large food item — like an apple, donut, or birthday cake — placed somewhere on the map. Your anthill sits at the center (or edge), sending out worker ants automatically. Ants walk to the food, bite off a small piece, then carry it back to the anthill. The level is complete once the entire item is eaten and transported.",
    "sourceUrl": "https://gamedistribution.com/games/ants-party/"
  },
  {
    "id": "d710f86a708c4c3ea46336dbfe177567",
    "slug": "people-playground!-ragdoll-arena!",
    "title": "People Playground! Ragdoll Arena!",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/d710f86a708c4c3ea46336dbfe177567-512x512.jpg",
    "description": "People Playground! Ragdoll Arena! is a fun physics-based adventure where chaos is the goal. Tap and hold objects to move them, then release to throw them at the doll.\\n\\nYour goal:\\nInflict maximum damage and destroy your doll using everything at your disposal. Drop a car on his head, throw a rock at him, or throw him off a cliff. Every action triggers a reaction, so experiment with different ways to destroy. Sometimes there will be multiple dolls: twice the targets, twice the strategies!",
    "publisher": "GamePush",
    "languages": [
      "English",
      "German",
      "Japanese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-01T15:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "On a mobile phone, simply tap and slide your finger across the screen. On a computer, control by pressing the left mouse button.",
    "sourceUrl": "https://gamedistribution.com/games/people-playground!-ragdoll-arena!/"
  },
  {
    "id": "953cf9c3407f4fda9407724436d00065",
    "slug": "zenith-rush",
    "title": "Zenith Rush",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/953cf9c3407f4fda9407724436d00065-1280x550.jpg",
    "description": "Beat the track time to advance further! \\nSwitch the road and pickup upgrades, buy and upgrade cars to be faster and advance further!\\n",
    "publisher": "Mateq",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-01T13:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Beat the track time to advance further! Collect pickups on your road to upgrade your car as you go, buy and upgrade cars in your garage!\\n\\nSpeed-Increases your car`s max speed\\nAcceleration- improves how fast you car accelerates\\nHandling-increases your car`s speed on turns and reduces handling distance\\n\\nArrows/AD to turn left/right, or button left right to switch road.",
    "sourceUrl": "https://gamedistribution.com/games/zenith-rush/"
  },
  {
    "id": "1c1aa253dc5b41ddacba63887244994d",
    "slug": "flow-block",
    "title": "Flow Block",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/1c1aa253dc5b41ddacba63887244994d-512x384.jpg",
    "description": "Perfectly blends the classic Tetris gameplay with innovative sand flow mechanics. In the game, players not only follow the basic rules of traditional Tetris but also need to guide flowing sand particles to fill target areas.",
    "publisher": "Infinity Loop",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-01T13:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Click on the sand blocks at the bottom to place them into the game. When same-colored sand particles successfully connect the left and right ends, the elimination effect is triggered and points are awarded.",
    "sourceUrl": "https://gamedistribution.com/games/flow-block/"
  },
  {
    "id": "158143c3d8bb49a086f9d098c51a65cf",
    "slug": "hero-transform-run",
    "title": "Hero Transform Run",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/158143c3d8bb49a086f9d098c51a65cf-512x512.jpg",
    "description": "Superheroes accumulate energy by constantly upgrading themselves, and at the end of the level they must quickly defeat different enemies. This is a casual combat parkour game!",
    "publisher": "Raccoon",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-01T13:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Mouse click or tap to play",
    "sourceUrl": "https://gamedistribution.com/games/hero-transform-run/"
  },
  {
    "id": "a1c1c4b21be6456ca467dcb109fbd524",
    "slug": "unicorn-princess-dress-up",
    "title": "Unicorn Princess Dress Up",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/a1c1c4b21be6456ca467dcb109fbd524-512x384.jpg",
    "description": "Welcome to Unicorn Princess Dress Up, a casual girl dress-up game online. Dive into a fashion world where you design fashionable clothing, create trendy hairstyles, and produce perfect eye makeup. Unleash your creativity and talents in fashion design to make your princess doll charming and beautiful!",
    "publisher": "Yiv.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-01T10:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/unicorn-princess-dress-up/"
  },
  {
    "id": "4306ca5c08ae4da78734aed19ed7ed39",
    "slug": "car-vs-zombies",
    "title": "Car vs Zombies",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/4306ca5c08ae4da78734aed19ed7ed39-1280x550.jpeg",
    "description": "Car vs Zombies features:\\n- fun gameplay\\n- good graphics",
    "publisher": "JulGames",
    "languages": [],
    "mobile": [],
    "firstActiveDate": "2019-08-14T06:55:19.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "HTML5",
      "WebGL"
    ],
    "instructions": "AD or left/right arrows to move car",
    "sourceUrl": "https://gamedistribution.com/games/car-vs-zombies/"
  },
  {
    "id": "b6a6a26c7c69491eaac77a4d69f5d973",
    "slug": "through-the-wall-3d",
    "title": "Through the Wall 3D",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/b6a6a26c7c69491eaac77a4d69f5d973-200x120.jpg",
    "description": "Through the Wall 3D takes the mind-bending puzzle gameplay of the original Through the Wall to a whole new level with stunning 3D graphics! Test your reflexes, strategy, and flexibility as you contort your character to match a variety of dynamic shapes in a visually immersive world.",
    "publisher": "Eyestorm Pte. LTD.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-11-01T07:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Test your reflexes, strategy, and flexibility as you contort your character to match a variety of dynamic shapes in a visually immersive world.",
    "sourceUrl": "https://gamedistribution.com/games/through-the-wall-3d/"
  },
  {
    "id": "7fb77a35cb98418c9a8b16278e7b74b0",
    "slug": "obby-modes!-online-mini-games",
    "title": "Obby Modes! Online Mini-Games",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/7fb77a35cb98418c9a8b16278e7b74b0-512x512.jpg",
    "description": "Is a massive online world where three unique modes are waiting for you!\\n\\nTake on the challenge of 100 levels of hard obby, compete in crazy races with 5 players, and test your fate on a glass bridge in the spirit of Squid Game!\\n\\nCreate your unique character by choosing from over 100 cool skins!\\n\\nTeam up with friends using a code in squads of up to 3 people and conquer all modes together!\\n\\nReady to show off your agility and strategy? Set records and become a legend!",
    "publisher": "GamePush",
    "languages": [
      "English",
      "French",
      "German",
      "Indonesian",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-31T16:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Press the \\",
    "sourceUrl": "https://gamedistribution.com/games/obby-modes!-online-mini-games/"
  },
  {
    "id": "fba057ae9bf3478fa188b3d1a9995e90",
    "slug": "ragdoll-jump",
    "title": "Ragdoll Jump",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/fba057ae9bf3478fa188b3d1a9995e90-512x384.jpg",
    "description": "Welcome to Ragdoll Jump! In this exciting jumping game, you will control a lovable stickman character on a thrilling journey out of a building. You will experience the sensation of soaring high as you jump and glide through the air, creating spectacular action sequences. Get ready for hilarious falls, and remember that you won't always land safely.",
    "publisher": "Eyestorm Pte. LTD.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-31T13:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "The gameplay is very simple- just tap and swipe to move your stickman character upward, towards the goal. But be careful of the traps along the way! These traps can cause you to tumble, preventing you from completing your mission. Collect items along the way to boost your power and enhance your flying ability. This jumping game not only tests your agility but also challenges your judgment.",
    "sourceUrl": "https://gamedistribution.com/games/ragdoll-jump/"
  },
  {
    "id": "864cf0717b9249159c67d01ac3c7a02c",
    "slug": "mahjong-connect:-spooky",
    "title": "Mahjong Connect: Spooky",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/864cf0717b9249159c67d01ac3c7a02c-512x384.jpg",
    "description": "Connect two tiles of an identical type. A move can only be made if there are 2 or fewer bends in the line between them. Clear the board to advance to the next level, but be warned, the game is time sensitive.",
    "publisher": "davidgilbert",
    "languages": [
      "English"
    ],
    "mobile": [],
    "firstActiveDate": "2025-10-31T13:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Kids",
      "Teens",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Click on a tile to select it. Click on another identical tile with a valid move to delete both of them.",
    "sourceUrl": "https://gamedistribution.com/games/mahjong-connect:-spooky/"
  },
  {
    "id": "31fa04101e284375b6562bfd0d2efda1",
    "slug": "sweet-haunt-2",
    "title": "Sweet Haunt 2",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/31fa04101e284375b6562bfd0d2efda1-512x512.jpg",
    "description": "Guide the ghost to pick up all of the candy and get it to the exit in this Sokoban-like puzzle game. 50 challenging levels to complete. You'll need to pick up candy carefully as depending on how they are carried, the ghost and the candy might not fit into the pathway to the exit. Use bombs strategically to destroy objects the ghost is carrying to be sure you can make it to the exit and not get stuck.",
    "publisher": "MathNook",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-31T13:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use the arrow keys or the on-screen arrow buttons to move the ghost. Use the Solve Button to watch a short ad and see how to complete the level.",
    "sourceUrl": "https://gamedistribution.com/games/sweet-haunt-2/"
  },
  {
    "id": "98def268a5ba41f7b59dba7a3a776bf9",
    "slug": "toco-teens-halloween-party",
    "title": "Toco Teens Halloween Party",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/98def268a5ba41f7b59dba7a3a776bf9-512x384.jpg",
    "description": "Step into the spooky fun world of Toca Teens Halloween Party, a fashionable Halloween dress-up game made just for style lovers! ?\\nJoin the Toca teens as they get ready for the most glamorous Halloween event of the year. Choose from eerie yet elegant outfits, haunting accessories, and bold makeup looks to create the perfect spooky-chic style.",
    "publisher": "Cutedressup",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-31T08:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "Left Mouse Button Click",
    "sourceUrl": "https://gamedistribution.com/games/toco-teens-halloween-party/"
  },
  {
    "id": "01c1407ac20942e688452cf1ab136b30",
    "slug": "lost-in-the-forest",
    "title": "Lost in the Forest",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/01c1407ac20942e688452cf1ab136b30-512x384.jpg",
    "description": "Lost in the forest is a classic adventure game. The protagonist is an airman who ends up in a storm, loses control of his plane and falls into a mysterious forest.\\nThe next day is stuck under a tree and must find a way to break free and solve various puzzles to make it back home safely.\\n",
    "publisher": "Rabbit Bay Games",
    "languages": [
      "Arabic",
      "Chinese (Simplified)",
      "English",
      "French",
      "German",
      "Russian",
      "Spanish"
    ],
    "mobile": [],
    "firstActiveDate": "2025-10-31T08:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use your mouse to find, use objects and move around",
    "sourceUrl": "https://gamedistribution.com/games/lost-in-the-forest/"
  },
  {
    "id": "e244ec5c2ea2418294d41a2e20e5bf0d",
    "slug": "water-sort",
    "title": "Water Sort",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/e244ec5c2ea2418294d41a2e20e5bf0d-512x384.jpg",
    "description": "Experience the simple yet addictive water sorting puzzle game! It’s the ultimate free game for training your brain, killing time, and relaxing!",
    "publisher": "Albayoo",
    "languages": [
      "English",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-31T07:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": " - Sort the Colors: Your goal is simple - pour colored water into matching bottles.\\n - Pour Smartly: Tap one bottle to pour its contents into another. Remember, you can only pour water of the same color, and each bottle can only hold one color at a time!\\n - Level Up: Solve thousands of brain-teasing levels, earn rewards, and unlock unique bottle designs!",
    "sourceUrl": "https://gamedistribution.com/games/water-sort/"
  },
  {
    "id": "a39c45f985354760bce8990b067858e1",
    "slug": "shanghai-town",
    "title": "Shanghai Town",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/a39c45f985354760bce8990b067858e1-1280x550.jpg",
    "description": "Mahjong matching game!\\nIf you select the same mahjong block, it will be removed.\\nPlease remove the last block!\\nMatch the tiles to create a cool building!\\nCollect the buildings and create a cool city!",
    "publisher": "MOVISOFT.Co.,Ltd",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-30T13:50:00.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "If you select the same mahjong block, it will be removed.\\nPlease remove the last block!",
    "sourceUrl": "https://gamedistribution.com/games/shanghai-town/"
  },
  {
    "id": "38d45e35b9c24bd0b6029c1be21f0d05",
    "slug": "murder-mystery",
    "title": "Murder Mystery",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/38d45e35b9c24bd0b6029c1be21f0d05-512x384.jpg",
    "description": "Murder Mystery – A fast-paced social deduction game. One player is the killer, another the sheriff, the rest are innocents. Use logic, stealth, and quick decisions to survive or expose the murderer. Perfect for high engagement and multiplayer retention.",
    "publisher": "2Play",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-30T13:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "- Each round, players are randomly assigned a role: Murderer, Sheriff, or Innocent.\\n- Murderer must eliminate all others without getting caught.\\n- Sheriff must identify and shoot the murderer.\\n-If the sheriff dies, anyone can pick up the weapon and take their place.",
    "sourceUrl": "https://gamedistribution.com/games/murder-mystery/"
  },
  {
    "id": "1f6151dd14ff43359d8a543f2e741add",
    "slug": "tile-living",
    "title": "Tile Living",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/1f6151dd14ff43359d8a543f2e741add-512x384.jpg",
    "description": "Select matching tiles that can be connected with up to 3 straight lines to clear them! Clear all the tiles to complete the stage! Use the coins you collect from clearing stages to decorate your room!",
    "publisher": "Synk Inc.",
    "languages": [
      "English",
      "Japanese"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-30T12:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Tap a tile to select it.",
    "sourceUrl": "https://gamedistribution.com/games/tile-living/"
  },
  {
    "id": "0c93562b5f614eeaabd1515778affdd1",
    "slug": "hex-sense",
    "title": "Hex Sense",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/0c93562b5f614eeaabd1515778affdd1-512x384.jpg",
    "description": "Guide Mochi across risky hex lands. His hex sense lets him read the numbers that give clues of how many dangers are nearby, and use them to find a safe path. Reveal tiles, flag traps, and guide brave Mochi to the Exit. \\n\\nHex Sense is a minesweeper-style puzzle on a field of hex tiles. Some tiles hide dangerous hazards, but clues around them help you figure out where it's safe to go. Cross several unique chapters filled with new kinds of hazards and clues.",
    "publisher": "Pro Mobile",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-30T11:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Each level has open and closed tiles. Reach the Exit without stepping on hazards. Moving onto a closed tile reveals what’s inside — if it’s a hazard, you lose. You can move through open tiles and only to closed ones next to them. Numbered tiles show how many hazards surround them (one per tile). Use logic to find safe paths.\\nTools:\\nFlag – mark suspected hazards.\\nEye – peek inside a closed tile without stepping on it.",
    "sourceUrl": "https://gamedistribution.com/games/hex-sense/"
  },
  {
    "id": "277a4d07d41345448bf22177767fdd32",
    "slug": "anime-dress-up-doll-dress-up",
    "title": "Anime Dress Up - Doll Dress Up",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/277a4d07d41345448bf22177767fdd32-512x512.jpg",
    "description": "Anime Dress Up - Doll Dress Up is a fashionable and wonderful dress-up game with shocking graphic effects that will provide females with an unforgettable dress-up experience! This game is ideal for everyone who enjoys fashion and adventure, thanks to its amazing graphics and simple UI.",
    "publisher": "Bravestars Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-30T08:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "To play Anime Dress Up - Doll Dress Up, players just choose their favorite clothing items, hairstyles, and accessories from the game's large wardrobe and apply them to their princess figure using the game's touch and drag controls. Once their princess is properly dressed and accessorized, they can save and share their masterpiece on social media with friends and family.",
    "sourceUrl": "https://gamedistribution.com/games/anime-dress-up-doll-dress-up/"
  },
  {
    "id": "353fea6c9bd74e65adc3c63efb52183f",
    "slug": "shoot-2048-hexa",
    "title": "Shoot 2048 Hexa",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/353fea6c9bd74e65adc3c63efb52183f-200x120.jpg",
    "description": "Shoot 2048 Hexa is a fun and colorful puzzle game where you shoot hexagon tiles with numbers to make bigger ones. Aim carefully and match the same numbers to reach new values. The board slowly fills up, so think fast and plan your moves. Try to stay in the game as long as you can and get the highest score!",
    "publisher": "GameBerry Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-30T07:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Tap or click to aim and shoot the tile with a number into the hexagon field. When two tiles with the same number meet, they merge into a larger one. Keep matching numbers to make space and earn points. The game ends when there’s no room left — see how many points you can get!",
    "sourceUrl": "https://gamedistribution.com/games/shoot-2048-hexa/"
  },
  {
    "id": "75a32bc545d947eaadfa11cef57644df",
    "slug": "boo-tiful-princess-match",
    "title": "Boo-tiful Princess Match",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/75a32bc545d947eaadfa11cef57644df-512x384.jpg",
    "description": "Welcome to an exciting puzzle-game, created in a Halloween atmosphere. There are three princesses in the game and each one is ready for her own eerily beautiful transformation. The player will have to look for paired cards to discover new elements of the girls future image. Each successful match brings you closer to creating a unique costume, makeup or hairstyle. Only the most attentive players will be able to make their princesses truly scary-beautiful!",
    "publisher": "DL-studio",
    "languages": [
      "English",
      "Russian",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-29T12:55:03.111Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "A puzzle game for the development of attention and memory, in which players create a collection of Halloween looks for girls, discovering new elements and combining them. The most interesting images can be saved as a screenshot in PNG format. Depending on the gaming device, either a click of a computer mouse or a simple touch on touchscreens is used for control.",
    "sourceUrl": "https://gamedistribution.com/games/boo-tiful-princess-match/"
  },
  {
    "id": "9a522145ab764004a4efeece301179cc",
    "slug": "toilet-time",
    "title": "Toilet Time",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/9a522145ab764004a4efeece301179cc-1280x550.jpg",
    "description": "Toilet Time is more than just a puzzle game—it’s a hilarious journey into the quirkiest parts of everyday life. Challenge yourself with toilet-inspired puzzles that combine creativity, wit, and humor.",
    "publisher": "Eyestorm Pte. LTD.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-29T08:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Toilet Time is more than just a puzzle game—it’s a hilarious journey into the quirkiest parts of everyday life. Challenge yourself with toilet-inspired puzzles that combine creativity, wit, and humor.",
    "sourceUrl": "https://gamedistribution.com/games/toilet-time/"
  },
  {
    "id": "cee36dd2c4f34d5797921a49bb1d4b83",
    "slug": "rooftop-run",
    "title": "Rooftop Run",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/cee36dd2c4f34d5797921a49bb1d4b83-512x384.jpg",
    "description": "Run, jump, and slide over rooftops in this fast-paced parkour game! Dodge obstacles, smash through barriers, and escape from enemies as you race through exciting levels.\\n",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-29T08:33:27.856Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "\\n?️ Desktop Controls:\\n\\n↑ (Up Arrow) – Move up\\n\\n↓ (Down Arrow) – Move down\\n\\n← (Left Arrow) – Move left\\n\\n→ (Right Arrow) – Move right\\n\\nSpacebar – Fire weapon\\n\\nShift – Activate boost\\n\\n? Mobile Controls:\\n\\nOn-Screen Joystick – Drag to move\\n\\nFire Button – Tap to shoot\\n\\nBoost Button – Tap to go faster\\n\\nBe the best parkour runner! Play Rooftop Run now and start your adventure! ",
    "sourceUrl": "https://gamedistribution.com/games/rooftop-run/"
  },
  {
    "id": "4e22050914184629af6a2b27f5de5820",
    "slug": "challenge-your-friends",
    "title": "Challenge Your Friends",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/4e22050914184629af6a2b27f5de5820-512x384.jpg",
    "description": "Challenge yourself! With seven different games, you can experience thrilling moments whether you're playing solo or competing against your friends. Drunken Duel, Tug The Table, Stick Duel, Milk The Cow, and many more games are waiting for you! Plus, to make the competition even more fun, you can choose exciting dares to make the matches unforgettable! For those who prefer solo play, 6 games are ready to keep you entertained! Step into this world of fun and enjoy the thrill of competition!",
    "publisher": "Hihoy",
    "languages": [
      "Arabic",
      "Chinese (Simplified)",
      "English",
      "French",
      "German",
      "Italian",
      "Japanese",
      "Korean",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [],
    "firstActiveDate": "2025-10-29T08:32:07.263Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Right Player: UP ARROW or Touch Controls\\nLeft Player: W or Touch Controls",
    "sourceUrl": "https://gamedistribution.com/games/challenge-your-friends/"
  },
  {
    "id": "fde0930bb7fc49dbaa01ed881e3e40ce",
    "slug": "zooma-dragon",
    "title": "Zooma Dragon",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/fde0930bb7fc49dbaa01ed881e3e40ce-512x512.jpg",
    "description": "Zooma Dragon is a brand new and amazing zoom style game!\\nComplete all 300 levels! Try to get three stars in each level!\\nA bright adventure with colored balls awaits you!\\nInstead of a frog, you will play as a dragon.",
    "publisher": "Starodymov Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-29T08:32:49.543Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "The goal of the game is to destroy all the balls moving along the chain before they reach the hole. If one of the balls manages to reach the hole, the level will be lost.\\nThe game controls are simple: You need to tap on the screen to shoot the ball in the right direction.\\nYou can choose one of the two active balls to shoot. To do this, click on the back of the dragon, where the ball is spinning.\\n",
    "sourceUrl": "https://gamedistribution.com/games/zooma-dragon/"
  },
  {
    "id": "a633d25a54494d3ead790c890eaf229c",
    "slug": "the-sorting-mart",
    "title": "The Sorting Mart",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/a633d25a54494d3ead790c890eaf229c-512x384.jpg",
    "description": "The Sorting Mart is a store sorting puzzle game that lets you experience the fun of shopping in a store. Rearrange items between shelves to match three identical ones on a shelf, clearing it and letting the upper shelves drop down. Clear entire stacks to shift adjacent shelves and keep matching before time runs out. If you get stuck, use the shuffle button to mix up the shelves and find matches more easily. Challenge your sorting skills as levels become more difficult!",
    "publisher": "Lof Games",
    "languages": [
      "Arabic",
      "Bulgarian",
      "Chinese (Simplified)",
      "Czech",
      "Danish",
      "Dutch",
      "English",
      "Estonian",
      "Finnish",
      "French",
      "German",
      "Greek",
      "Hebrew",
      "Hindi",
      "Hungarian",
      "Indonesian",
      "Italian",
      "Japanese",
      "Korean",
      "Latvian",
      "Lithuanian",
      "Norwegian (Nynorsk)",
      "Polish",
      "Portuguese",
      "Romanian",
      "Russian",
      "Serbian",
      "Simple English",
      "Slovak",
      "Spanish",
      "Swahili",
      "Swedish",
      "Tagalog",
      "Thai",
      "Turkish",
      "Ukrainian",
      "Vietnamese"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-28T10:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Drag items between shelves using your mouse or touchpad. Arrange three matching items on a shelf to clear them, causing the shelves above to drop down. Fully clearing a stack shifts the neighboring shelves. Collect all items before time runs out!",
    "sourceUrl": "https://gamedistribution.com/games/the-sorting-mart/"
  },
  {
    "id": "a637f9d7958143408f9beb2b7933b54a",
    "slug": "hidden-horrors",
    "title": "Hidden Horrors",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/a637f9d7958143408f9beb2b7933b54a-512x384.jpg",
    "description": "Ready to explore the haunted Halloween world? Play a hidden object game with 30 Halloween levels. Each level has 6 hidden objects. Find all objects before time runs out. If you need help, use a hint. The game is easy to play. Enjoy colorful Halloween scenes and fun gameplay.",
    "publisher": "Lof Games",
    "languages": [
      "Arabic",
      "Bulgarian",
      "Chinese (Simplified)",
      "Czech",
      "Danish",
      "Dutch",
      "English",
      "Estonian",
      "Finnish",
      "French",
      "German",
      "Greek",
      "Hebrew",
      "Hindi",
      "Hungarian",
      "Indonesian",
      "Italian",
      "Japanese",
      "Korean",
      "Latvian",
      "Lithuanian",
      "Polish",
      "Portuguese",
      "Romanian",
      "Russian",
      "Serbian",
      "Simple English",
      "Slovak",
      "Spanish",
      "Swahili",
      "Swedish",
      "Tagalog",
      "Thai",
      "Turkish",
      "Ukrainian",
      "Vietnamese"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-28T10:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use a mouse or touchpad to play this game.",
    "sourceUrl": "https://gamedistribution.com/games/hidden-horrors/"
  },
  {
    "id": "0fdb95499d85453f9ba09182ab7c5be2",
    "slug": "triple-cups",
    "title": "Triple Cups",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/0fdb95499d85453f9ba09182ab7c5be2-512x384.jpg",
    "description": "Triple Cups is a bright and dynamic puzzle game where your goal is to flip colorful cups and arrange them to create rows of matching colors!\\nEvery move requires focus and strategy: pick up cups from the top and place them on the stand below to form groups of three or more of the same color. When identical cups line up, they disappear, freeing space for new moves.",
    "publisher": "GameBerry Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-28T09:05:21.724Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Check the goal. The top bar shows how many cups of each color you need to collect.\\nFlip and place cups. Take a cup from the top and place it on one of the positions on the stand below.\\nMatch three or more. When three or more cups of the same color line up, they disappear, earning you points and opening up new space for moves.",
    "sourceUrl": "https://gamedistribution.com/games/triple-cups/"
  },
  {
    "id": "fe8f211d3127476fa138e81b96ed4248",
    "slug": "top-hog",
    "title": "TOP HOG",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/fe8f211d3127476fa138e81b96ed4248-512x384.jpg",
    "description": "Welcome to the forest adventure! A drowsy bear just wants to rest, but a playful group of hedgehogs has decided to throw a party close by. Your task? Grab a hockey stick and send those troublemakers soaring through the air! Build your strength, collect bonuses to enhance your skills, and face the exciting challenges in each level. Who will rise as the winter forest champion? Become a true bear hockey expert! Simple to play, fun, and packed with thrilling airborne action! Give it a try now!",
    "publisher": "Playgama",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-28T07:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Press the arrow button to swing and the same button to send the hedgehog flying!",
    "sourceUrl": "https://gamedistribution.com/games/top-hog/"
  },
  {
    "id": "9e22007bdf4940b5a6bf2addd9e2fed6",
    "slug": "flower-shop",
    "title": "Flower Shop",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/9e22007bdf4940b5a6bf2addd9e2fed6-512x384.jpg",
    "description": "Match 6 of the same flowers to ship them! You can place your flowers in any empty spot on the board. Place a flower next to a tray with the same kind to make them merge. When the right conditions are met, customers will come by to visit! Complete their requests to earn rewards. The game ends when there’s no more space left to place flowers.",
    "publisher": "Synk Inc.",
    "languages": [
      "English",
      "Japanese"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-27T12:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Drag to place the flower tray",
    "sourceUrl": "https://gamedistribution.com/games/flower-shop/"
  },
  {
    "id": "bf6439db0088415593e786e19a04e5b3",
    "slug": "swat-cats-shooter",
    "title": "SWAT Cats Shooter",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/bf6439db0088415593e786e19a04e5b3-512x512.jpg",
    "description": "SWAT Cats is an online shooter set in a world where every hero is a battle cat. Ready for purr-fect battle with wild action? Jump in, grab your helmet, and join the fight.",
    "publisher": "LUCKY TRY",
    "languages": [
      "Arabic",
      "Chinese (Simplified)",
      "English",
      "French",
      "German",
      "Italian",
      "Japanese",
      "Korean",
      "Portuguese",
      "Russian",
      "Spanish",
      "Thai"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-27T12:14:25.349Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "TAB – Pause menu\\nWASD – Movement\\nSPACE – Jump\\nC – Crouch\\nM – Toggle map\\n1–5 – Select item\\nM2 – Shoot\\nM1 – Aim\\nR – Reload\\nT – Open chat",
    "sourceUrl": "https://gamedistribution.com/games/swat-cats-shooter/"
  },
  {
    "id": "9d733cf5dd3f449f9cf2345020a63987",
    "slug": "noob:-jailbreak-2",
    "title": "Noob: Jailbreak 2",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/9d733cf5dd3f449f9cf2345020a63987-512x384.jpg",
    "description": "No sooner has Noob escaped from prison than he finds himself behind bars again!\\n\\nEach time the conditions of escape change.\\nThe tasks have become even more difficult, and the tension is even higher.\\nUse your brain to the fullest!\\n\\nOur hero is waiting for you! Help him out!\\n\\nGame Features:\\n- 50 unique levels;\\n- Beautiful graphics;\\n- Nice sounds and music;\\n- Nubik Game;\\n- Puzzle Game;\\n- Continuation of the popular game.",
    "publisher": "Stickman vs Monster School Team",
    "languages": [
      "English",
      "Russian",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-27T08:37:25.618Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Goal: Help Noob escape from prison.\\n\\nMobile Devices: press the arrow keys to move around.\\nComputers: use the keyboard to move around.\\n\\nDo not get caught on obstacles (spikes, saws, lava, etc).\\n\\nIf you can not pass the level you can watch ads and skip the level.",
    "sourceUrl": "https://gamedistribution.com/games/noob:-jailbreak-2/"
  },
  {
    "id": "335518c5b7b145288276a0b003dce76f",
    "slug": "juicy-match-2",
    "title": "Juicy Match 2",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/335518c5b7b145288276a0b003dce76f-512x384.jpg",
    "description": "Juicy Match 2 returns with even more natural, fresh, and juicy fun! Step into the best Juice Bar in town and match delicious fruits to create perfect juice blends. Your cheerful Banana friend will guide you with helpful tips along the way. Match three or more fruits to juice them, trigger chain reactions for big bonuses, and master hundreds of new levels. With Daily Missions, Weekly Challenges, and endless juicy puzzles, the adventure never stops in Juicy Match 2!",
    "publisher": "SOFTGAMES – Mobile Entertainment Services GmbH",
    "languages": [
      "Dutch",
      "English",
      "French",
      "German",
      "Italian",
      "Polish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-27T08:36:28.226Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "Juicy Match is a refreshing Match 3 game. Combine identical fruits and other juicy items into groups of three or more to clear them from the board! Each level has a specific goal you must achieve to advance. Focus on the objective and plan your moves wisely to avoid running out of turns before completing the task. Enjoy the challenge of matching fruits and creating delicious juice blends in this vibrant, fruity adventure!",
    "sourceUrl": "https://gamedistribution.com/games/juicy-match-2/"
  },
  {
    "id": "7bbfd38bad4a4e93bf9e721955db6c80",
    "slug": "relay-race",
    "title": "Relay Race",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/7bbfd38bad4a4e93bf9e721955db6c80-512x384.jpg",
    "description": "Relay race game is an engaging and addictive game that combines puzzle solving elements, casual gameplay and exciting race challenges. This game offers players a unique combination of fun puzzles and trolls for a thrilling and engaging gaming experience.",
    "publisher": "Eyestorm Pte. LTD.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-27T08:30:00.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "The player is responsible for navigating the character to the finish line by overcoming challenges. The puzzles range from simple to complex but are so engaging that you can't stop.",
    "sourceUrl": "https://gamedistribution.com/games/relay-race/"
  },
  {
    "id": "2c78611ed1104149a04c99a4f9f017b6",
    "slug": "hexa-go!",
    "title": "Hexa GO!",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/2c78611ed1104149a04c99a4f9f017b6-512x512.jpg",
    "description": "A puzzle game about dropping hexagons from grid. To do this, use a bomb and explode all the tiles nearby! Click on the rotate-button and swap the tiles! And also use other special tiles!",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-26T14:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "There is an arrow on each hexagon. If you click on a tile, it will roll to where this arrow points. Your task is to drop all the hexagons from the grid.",
    "sourceUrl": "https://gamedistribution.com/games/hexa-go!/"
  },
  {
    "id": "cdcd36514eee4fad99a0fbbf40ddf8ac",
    "slug": "draw-to-fly",
    "title": "Draw To Fly",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/cdcd36514eee4fad99a0fbbf40ddf8ac-512x384.jpg",
    "description": "Ready for a game that’s as creative as it is challenging? Draw Fly brings your imagination to life, turning simple drawings into pathways to solve puzzles and conquer obstacles. Whether you’re flying past traps or dodging tricky obstacles, this puzzle game will keep you entertained for hours.",
    "publisher": "Eyestorm Pte. LTD.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-26T13:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Navigate through a world of fun, quirky challenges by drawing lines to guide your character to the finish line. Every level introduces new puzzles, obstacles, and surprises, pushing your creativity and problem-solving skills to the limit.",
    "sourceUrl": "https://gamedistribution.com/games/draw-to-fly/"
  },
  {
    "id": "1fbcee4e7fa54e13ae9dfdf3552128c5",
    "slug": "halloween-match-trio",
    "title": "Halloween Match Trio",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/1fbcee4e7fa54e13ae9dfdf3552128c5-512x384.jpg",
    "description": "Halloween Match Trio is a classic match-3 puzzle game with fun challenges. Swap items to make a line of three or more matching items, horizontally or vertically. Keep matching to unlock all tiles and reach the final stage. Use power-ups like bombs, arrows, magnets, and more to clear levels faster. Complete all 75 levels to win the game!",
    "publisher": "Lof Games",
    "languages": [
      "Arabic",
      "Bulgarian",
      "Chinese (Simplified)",
      "Czech",
      "Danish",
      "Dutch",
      "English",
      "Estonian",
      "Finnish",
      "French",
      "German",
      "Greek",
      "Hebrew",
      "Hindi",
      "Hungarian",
      "Indonesian",
      "Italian",
      "Japanese",
      "Korean",
      "Latvian",
      "Lithuanian",
      "Norwegian (Nynorsk)",
      "Polish",
      "Portuguese",
      "Romanian",
      "Russian",
      "Serbian",
      "Simple English",
      "Slovak",
      "Spanish",
      "Swahili",
      "Swedish",
      "Tagalog",
      "Thai",
      "Turkish",
      "Ukrainian",
      "Vietnamese"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-26T10:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use a mouse or touchpad to swap items.",
    "sourceUrl": "https://gamedistribution.com/games/halloween-match-trio/"
  },
  {
    "id": "1a32843b3ad74864aff287f1c75cbeda",
    "slug": "color-block-sort",
    "title": "Color Block Sort",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/1a32843b3ad74864aff287f1c75cbeda-512x384.jpg",
    "description": "This is a casual puzzle game about sorting blocks by color!\\n\\nSimply tap your finger to sort various blocks, achieve winning streaks, and win exciting rewards.",
    "publisher": "HeiTie",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-26T09:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Tap to move different blocks to start your sorting game.\\n\\nOnly blocks of the same color can be stacked together.\\n\\nSort all blocks of the same color into the same space.",
    "sourceUrl": "https://gamedistribution.com/games/color-block-sort/"
  },
  {
    "id": "ee8b2be14fa24256b113d31a90835383",
    "slug": "red-stickman-vs-craftmans-2",
    "title": "Red Stickman vs Craftmans 2",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/ee8b2be14fa24256b113d31a90835383-200x120.jpg",
    "description": "Classic platformer with shooting. Stickman got into the world of Minecraft, flooded with zombie people and zombie animals. Help Stickman destroy all the infected, save Eve and get out of this world.",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-26T07:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Run to the right, jump over obstacles, collect coins. Shoot zombie animals and zombie noobs. When you find a jetpack, jump higher by double-tapping the jump button. Find more powerful weapons. Upgrade Stickman on the upgrade screens for faster progress. Save Eva so that she can help you in difficult moments.",
    "sourceUrl": "https://gamedistribution.com/games/red-stickman-vs-craftmans-2/"
  },
  {
    "id": "2767718b88624c8795dfc10cd22d804c",
    "slug": "car-jam:-traffic-puzzle",
    "title": "Car Jam: Traffic Puzzle",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/2767718b88624c8795dfc10cd22d804c-512x384.jpg",
    "description": "Get ready for Car Jam: Traffic Puzzle, the ultimate test of logic and fun! Untangle the traffic, move the cars, and clear the way in this addictive puzzle adventure. With every level, new challenges appear—packed parking lots, tricky buses, and colorful traffic jams waiting for your brainpower. Easy to play, hard to master, and endlessly entertaining.\\n",
    "publisher": "jimo game",
    "languages": [
      "No Text"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-25T13:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Move the Vehicles – Slide cars and buses around to open pathways.\\nMatch the Colors – Guide passengers to their color-matched cars.\\nPlan Smart Moves – Use logic and timing to solve bus jam madness.\\nBeat Levels – Earn up to 3 stars by finishing with the fewest moves.\\nClimb the Leaderboard – Compete with puzzle masters worldwide!",
    "sourceUrl": "https://gamedistribution.com/games/car-jam:-traffic-puzzle/"
  },
  {
    "id": "e72a5554d24c48eda302d76170354071",
    "slug": "cool-cars:-racing-at-altitude",
    "title": "Cool Cars: racing at altitude",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/e72a5554d24c48eda302d76170354071-512x512.jpg",
    "description": "Cool Cars: racing at altitude is an exciting racing game in which you can buy cars, build your own garage and compete with other players.\\n\\nEarn points by collecting bonuses on a straight track, compete with other players to complete special tracks against the clock, equip your auto repair shop and collect cool cars!\\nIn the game you will find a large number of cars, exciting tracks, your own garage with purchased cars, the ability to change the environment to suit you and much more.",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-25T13:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "The game is controlled on the computer using the mouse. To move you need to hold down the left mouse button and move it.\\nControl on mobile devices is carried out by tapping on the screen.\\n\\nIn the main mode, the player needs to gain maximum power from the car in order to receive the largest bonus to flight range at the end of the track. The track bonus consists of accumulated gold and the player's current level.",
    "sourceUrl": "https://gamedistribution.com/games/cool-cars:-racing-at-altitude/"
  },
  {
    "id": "834471cba9de4c80986b63b576e345ae",
    "slug": "jenny's-math-puzzle",
    "title": "Jenny's Math Puzzle",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/834471cba9de4c80986b63b576e345ae-512x384.jpg",
    "description": "Challenge your mind with Jenny’s Math Puzzle, a fun and brain-boosting online game where logic meets creativity. Arrange number tiles to solve equations, unlock new puzzles, and sharpen your math skills along the way. Play on your phone or computer — every move counts, and every solution brings you closer to becoming a true math master.",
    "publisher": "Playgama",
    "languages": [
      "Chinese (Simplified)",
      "English",
      "French",
      "German",
      "Japanese",
      "Portuguese",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-25T08:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Cocos"
    ],
    "instructions": "The main objective is to complete all mathematical equations on the board by dragging number tiles from the pool to the empty slots. Each equation must be valid (e.g., horizontally or vertically correct). To win, fill the entire grid correctly without any mismatches. The primary control is using the mouse (or touch on mobile devices) to drag and drop tiles. If you make a mistake, you can remove tiles by dragging them back to the pool.",
    "sourceUrl": "https://gamedistribution.com/games/jenny's-math-puzzle/"
  },
  {
    "id": "e1f9f921a48e4321a62dbcfbc2e9ed95",
    "slug": "frog-knight",
    "title": "Frog Knight",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/e1f9f921a48e4321a62dbcfbc2e9ed95-512x384.jpg",
    "description": "Frog Bubble your mission is to help a spirited frog pop an array of mischievous bubbles! Using your swift reflexes and strategic skills, you’ll throw your lily pad-shaped projectiles at bubbles to clear each level.",
    "publisher": "CHCStudio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-25T08:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Tap to aim, release to shot the sword destroy all puzzle.",
    "sourceUrl": "https://gamedistribution.com/games/frog-knight/"
  },
  {
    "id": "316107e126fb4b0fbcd404c2308d5a7f",
    "slug": "color-block-jam-2",
    "title": "Color Block Jam 2",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/316107e126fb4b0fbcd404c2308d5a7f-512x384.jpg",
    "description": "Play Color Block Jam 2 — a free online puzzle game you can enjoy instantly in your browser, no download needed. Slide colorful blocks into matching gates through calm, logic-based levels that test your brain and timing. Perfect for quick breaks, Cool Math Game fans, and unblocked school play. Relaxing, casual, and mobile-friendly — play anywhere and solve satisfying color puzzles for free.",
    "publisher": "GMG",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-25T07:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Using Left Mouse",
    "sourceUrl": "https://gamedistribution.com/games/color-block-jam-2/"
  },
  {
    "id": "09c23c4edceb49808d39cffafa60c912",
    "slug": "spider-bubu",
    "title": "Spider Bubu",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/09c23c4edceb49808d39cffafa60c912-512x384.jpg",
    "description": "Spider-Bubu swings from wall to wall across the city. Halloween has arrived, and you need to collect all the Halloween candies along with Spider-Bubu. Don’t forget to grab the giant pumpkin too! You must be very careful in the city — sharp spinning blades and pointed spikes are everywhere. Collect all the pumpkins and safely reach the portal that appears in the city.",
    "publisher": "FBK",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-25T07:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "*To move from wall to wall, tap and release on mobile, or click and release with the mouse on PC.\\n*Collect all three pumpkins and safely reach the visible portal.\\n*Playable on both mobile and PC.",
    "sourceUrl": "https://gamedistribution.com/games/spider-bubu/"
  },
  {
    "id": "02f515cdc8794f6aa7d3dbd6788763b2",
    "slug": "mr-long-legs",
    "title": "Mr Long Legs",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/02f515cdc8794f6aa7d3dbd6788763b2-512x512.jpg",
    "description": "Get ready to wobble, stretch, and stumble with Mr. Long Legs, the funniest physics puzzle game you’ll ever play! Step into the shoes of a long-legged stickman hero and control his stretchy legs to cross impossible terrains.",
    "publisher": "Eyestorm Pte. LTD.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-25T05:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "With every tap, Mr. Long’s legs stretch hilariously as he tries to balance across tricky paths, dodge obstacles, and survive ridiculous traps. Whether it’s trekking mountains, running through cities, or slipping on ice, every step creates laugh-out-loud moments.",
    "sourceUrl": "https://gamedistribution.com/games/mr-long-legs/"
  },
  {
    "id": "d2aea68de5124e86bb0920bbfe7122f3",
    "slug": "block-master-super-puzzle",
    "title": "Block Master - Super Puzzle",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/d2aea68de5124e86bb0920bbfe7122f3-512x512.jpg",
    "description": "Welcome to a unique puzzle game where logic and strategy decide everything! Experience a fresh take on classic block games! The pieces appear at the bottom, and it’s up to you to decide where to place them. Drag the blocks onto the field, fill horizontal and vertical lines, and clear space for new moves. Every action requires careful planning—can you score the highest points? ",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-24T13:28:23.697Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Drag pieces from the bottom of the screen onto the game board, aiming to fill horizontal or vertical lines. When a line is fully filled, it disappears, making space for new moves. If you run out of possible moves, use boosters! They allow you to swap current pieces or clear multiple lines, saving you from losing. Plan your moves, combine strategies, and rack up the highest scores!",
    "sourceUrl": "https://gamedistribution.com/games/block-master-super-puzzle/"
  },
  {
    "id": "fdc27f2a01054e3db5d8ca70057d2cc2",
    "slug": "mr-bounce",
    "title": "Mr Bounce",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/fdc27f2a01054e3db5d8ca70057d2cc2-512x384.jpg",
    "description": "Challenge yourself with Mr Bounce, the brain-boosting puzzle game that will test your thinking skills and reflexes. Each level is a new puzzle demanding strategic planning and precise execution. Mr Bounce is more than just a game; it's a mental workout that improves your cognitive abilities. ",
    "publisher": "Eyestorm Pte. LTD.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-24T12:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Draw calculated paths, anticipate obstacles, and bounce your way to victory.",
    "sourceUrl": "https://gamedistribution.com/games/mr-bounce/"
  },
  {
    "id": "bdeba12650fe4ce0bfeb1cc9ee2e23cb",
    "slug": "iconic-halloween-costumes",
    "title": "Iconic Halloween Costumes",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/bdeba12650fe4ce0bfeb1cc9ee2e23cb-512x384.jpg",
    "description": "Get ready for a spooky and stylish adventure in Iconic Halloween Costumes! Help three BFFs pick out their perfect Halloween looks, from royal Glinda and Bridgerton-inspired outfits to edgy Beetlejuice vibes and cowgirl-chic styles. Customize their costumes with tops, bottoms, accessories, and makeup to create iconic Halloween outfits. Play now and let the fashion fun begin!",
    "publisher": "Gamerina",
    "languages": [
      "English",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-24T11:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use your mouse to play this game on a desktop, tap to play on mobile devices.",
    "sourceUrl": "https://gamedistribution.com/games/iconic-halloween-costumes/"
  },
  {
    "id": "3206ecd57d78461ea89e73a3c77b4368",
    "slug": "merge-heroes-titans",
    "title": "Merge Heroes Titans",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/3206ecd57d78461ea89e73a3c77b4368-512x384.jpg",
    "description": "In this game, you will command squads of melee fighters and ranged archers fighting against waves of enemies. Your agility and strategic thinking will give you an edge to victory.\\n\\nUnlock new powerful fighters and accurate archers by combining those available for purchase. Place them on the map according to abilities and win.\\n\\nYou will have to discover not only new characters, but also beautiful different worlds, enjoy our new game.",
    "publisher": "NovaSky",
    "languages": [
      "Czech",
      "English",
      "French",
      "German",
      "Italian",
      "Russian",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-24T08:10:00.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Merge same characters by dragging one on top of another to get more powerful ones. Unlock new characters and expand your army",
    "sourceUrl": "https://gamedistribution.com/games/merge-heroes-titans/"
  },
  {
    "id": "589aeed18a104d34b7516dae0a3ad9c3",
    "slug": "black-pink-halloween-concert",
    "title": "Black Pink Halloween Concert",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/589aeed18a104d34b7516dae0a3ad9c3-512x384.jpg",
    "description": "Step into the spooky spotlight with Black Pink Halloween Concert, a thrilling dress-up game where you style the K-Pop superstars for their haunted Halloween performance. Choose from a wide variety of creepy-cute costumes, bold hairstyles, and festive accessories to make the members shine on stage.",
    "publisher": "Cutedressup",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-24T07:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "Left Mouse Button Click",
    "sourceUrl": "https://gamedistribution.com/games/black-pink-halloween-concert/"
  },
  {
    "id": "f2bec0af787d426ca63dc7ee3faf877f",
    "slug": "cheerful-plumber",
    "title": "Cheerful Plumber",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/f2bec0af787d426ca63dc7ee3faf877f-512x384.jpg",
    "description": "Greetings, young artist. Do you like video games and creativity? Then this game is for you! Color video game characters: a princess, a cheerful plumber, a dragon and others! Choose different colors on the main and secondary palette. Play and color! Take a screenshot and share the result with your friends!",
    "publisher": "DL-studio",
    "languages": [
      "No Text"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-24T07:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Color the characters of the famous game. Use all the available tools: two color palettes, brushes of different sizes, a pipette to capture colors and an eraser to remove bad moments. The result can be saved as a PNG image. Depending on the gaming device, a computer mouse pointer or touch on touchscreens is used to control it.",
    "sourceUrl": "https://gamedistribution.com/games/cheerful-plumber/"
  },
  {
    "id": "82d7fc893b324317b608042f8b2b96d0",
    "slug": "ancient-wars:-caesar",
    "title": "Ancient Wars: Caesar",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/82d7fc893b324317b608042f8b2b96d0-512x512.jpg",
    "description": "Ancient Wars: Caesar is an exciting strategy game in which you lead an army and fight for supremacy on the battlefield. The game takes you to the world of epic battles where tactics, planning and proper utilization of resources are important. Control various units, including warriors, archers and generals, to destroy enemy troops and destroy their base.\\n",
    "publisher": "Starodymov Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-24T07:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "In Ancient Wars: Caesar you will have to control an army to defeat your enemies and destroy their base. At the beginning of each level, you have gold that you can use to hire soldiers. Choose units such as warriors, archers or generals and send them into battle.\\nEach unit has its own features and cost, so it's important to strategize about who to send first and who to leave in reserve. Earn gold by destroying enemies and use it to hire new fighters or support soldiers with abilities.",
    "sourceUrl": "https://gamedistribution.com/games/ancient-wars:-caesar/"
  },
  {
    "id": "4ecdb7d6dc0c4290ad57122cec4bf3b4",
    "slug": "cake-sort",
    "title": "Cake Sort",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/4ecdb7d6dc0c4290ad57122cec4bf3b4-512x384.jpg",
    "description": "Cake Sort is a colorful and cozy puzzle game where you stack and sort delicious desserts to score as many points as possible! Move cakes around the table and match them by type to build perfect stacks of identical treats.\\nBright graphics, smooth animations, and tasty visuals make the game relaxing, cheerful, and endlessly replayable.\\nYour goal is simple — keep sorting cakes and earn points for every perfect match until the table is full!",
    "publisher": "GameBerry Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-24T06:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "The table is filled with plates, and at the bottom, you’ll find three stacks of cakes on a tray.\\nPlace the stacks on the plates so that identical cakes end up next to each other — they’ll merge into a taller stack and give you points.\\nThink ahead and make smart moves to keep the table from filling up too fast.\\nThe game ends when there’s no more space — how high can you score?",
    "sourceUrl": "https://gamedistribution.com/games/cake-sort/"
  },
  {
    "id": "2162290b330340aa9c07bb499f8d3125",
    "slug": "flower-block",
    "title": "Flower Block",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/2162290b330340aa9c07bb499f8d3125-512x384.jpg",
    "description": "Dive into our unique COMBO gameplay, where you strategically place blocks to clear rows or columns. Watch as clearing multiple lines triggers exciting animations and earns you bonus points. Challenge your mind and plan your moves wisely to ace Flower Block!",
    "publisher": "Albayoo",
    "languages": [
      "English",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-24T06:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "- Don’t wait for perfect blocks; seize opportunities to clear space.\\n- Take your time—there’s no rush.",
    "sourceUrl": "https://gamedistribution.com/games/flower-block/"
  },
  {
    "id": "6bc18ef844ad4cc583cd72ccfdf57fc0",
    "slug": "construction-set-3d-builder",
    "title": "Construction Set - 3D Builder",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/6bc18ef844ad4cc583cd72ccfdf57fc0-512x384.jpg",
    "description": "Dive into the fascinating world of 3D constructors and puzzles, where each block is a new step towards creativity and development.\\nThis game invites players to assemble amazing buildings, monuments and characters using more than 200 different bricks.\\nFrom simple sets to complex models, each level presents a new challenge and develops attention, logic and spatial thinking.",
    "publisher": "Mirra Games",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Russian",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-23T11:08:20.913Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "The goal of the game is to assemble models from the construction set. You need to find each part separately and put it according to the instructions to assemble the model correctly.\\nControls: LMB/Touch",
    "sourceUrl": "https://gamedistribution.com/games/construction-set-3d-builder/"
  },
  {
    "id": "5db477a1d2394f7a8e82512ca57b5959",
    "slug": "number-rush",
    "title": "Number Rush",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/5db477a1d2394f7a8e82512ca57b5959-512x384.jpg",
    "description": "You can absorb smaller or equal numbers while avoiding obstacles.\\nIf you collide with a number bigger than you, it's game over.\\nMake the largest number possible to break through the wall and get the treasure chest~!",
    "publisher": "MOVISOFT.Co.,Ltd",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-23T09:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Absorb numbers lower than mine to create a bigger number!",
    "sourceUrl": "https://gamedistribution.com/games/number-rush/"
  },
  {
    "id": "726d7dbf31be4f8bb97176f20999a68a",
    "slug": "color-dots-challenge",
    "title": "Color Dots Challenge",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/726d7dbf31be4f8bb97176f20999a68a-512x384.jpg",
    "description": "Dive into Color Dots Challenge, a bright and addictive puzzle game that puts your logic and strategy to the test. Connect, match, and move colorful dots to clear the board and score big! Simple to play yet hard to master, this free online game is perfect for quick breaks or long sessions on your phone or computer. Can you outsmart the colors and conquer every level?",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-23T08:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "- Tap on color dot to move right place.\\n-Put the dots in their respective slots.\\n-Avoid Hitting other dots.\\n-Simple and fun puzzle game.\\n- Enjoy an experience that’s both easy to learn and fun to play.\\n- Play with fun.",
    "sourceUrl": "https://gamedistribution.com/games/color-dots-challenge/"
  },
  {
    "id": "c012a6c196af46f8a44cd81ec974fcd7",
    "slug": "stickman-archero-fight:-stick-shadow-fight-war",
    "title": "Stickman Archero Fight: stick shadow fight war",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/c012a6c196af46f8a44cd81ec974fcd7-512x384.jpg",
    "description": "Complete levels, collecting items that you can then put on yourself and improve in your inventory. You can finish off your enemies with colorful fatalities. Try different skill combinations to complete as many levels as possible. \\nGame features:\\n\\n- Fights with stickmen\\n- Skins: warrior, fighter, ninja\\n- Enemies: red stickman, black stickman\\n- Various biomes\\n\\nDid you like the game \\",
    "publisher": "Stickman vs Monster School Team",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-23T07:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Kids",
      "Teens",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Press the W/A/S/D keys to move around. Press \\",
    "sourceUrl": "https://gamedistribution.com/games/stickman-archero-fight:-stick-shadow-fight-war/"
  },
  {
    "id": "1632d62cc49b4a139f41739a19de37f8",
    "slug": "survival-in-area-51",
    "title": "Survival in Area 51",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/1632d62cc49b4a139f41739a19de37f8-512x512.jpg",
    "description": "You will play as the character Stas, who works in Area 51. One day, Stas was given a strange task, to find acid and pour it into an unusual device. Then something terrible happened... In Area 51, an explosion occurred underground, and zombies appeared. They began to attack scientists and guards. Your task is to destroy zombies, mercenaries and find a way out of this terrible underground place. The game offers shooting, simple puzzles, a plot, many locations and a final battle.",
    "publisher": "Starodymov Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-23T06:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Carefully read what the characters tell you. Open all the doors, press all the blue buttons.\\n\\nControls on PC:\\nWASD or arrows - character movement\\nMouse - camera control\\nLeft mouse button - attack\\nRight mouse button - aiming\\nE - interaction with objects and buttons\\nMouse wheel - change weapons\\nNumbers 1,2 - change weapons\\nR - reload weapons\\n\\nControls on a mobile device:\\nTouch buttons and joystick on the screen.",
    "sourceUrl": "https://gamedistribution.com/games/survival-in-area-51/"
  },
  {
    "id": "c1dd869e0c174b699a37f02f02ecc387",
    "slug": "butterfly-triple",
    "title": "Butterfly Triple",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/c1dd869e0c174b699a37f02f02ecc387-512x384.jpg",
    "description": "Butterfly Tripple is a bright and relaxing puzzle game where you merge cute butterflies!\\nPlace the shapes on the board so that three or more butterflies of the same color touch each other. When they connect, they’re released and gracefully fly away. Vivid graphics, smooth animations, and a cozy atmosphere make the game a true pleasure to play.",
    "publisher": "GameBerry Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-23T06:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Choose one of three available shapes and place it on the board.\\nIf three or more butterflies of the same color are next to each other, they merge and disappear, earning you points.\\nPlan your moves carefully — the more consecutive combinations you make, the higher your score will be!",
    "sourceUrl": "https://gamedistribution.com/games/butterfly-triple/"
  },
  {
    "id": "a63252d73aa8430d8fb78a100f203c07",
    "slug": "ultimate-yatzy",
    "title": "Ultimate Yatzy",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/a63252d73aa8430d8fb78a100f203c07-512x384.jpg",
    "description": "Ultimate Yatzy is the classic dice game that delivers endless fun and excitement. Roll five dice to score the best combinations and outsmart your opponents. Whether you're a casual player or a Yatzy pro, this game blends strategy and luck to keep you challenged and entertained. Aim for a Full House, a Straight, or the elusive Yatzy—every roll is a new chance to win.",
    "publisher": "Playgama",
    "languages": [
      "English",
      "French",
      "Italian",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-22T09:38:57.000Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Roll five dice and aim for the best combos over 13 rounds. Score high in each category—highest total wins! Bonus points for top scores and extra Yatzys!",
    "sourceUrl": "https://gamedistribution.com/games/ultimate-yatzy/"
  },
  {
    "id": "204675b2a7324aafa33ad9fd5caf88ab",
    "slug": "koko-loco-block-blast",
    "title": "Koko Loco Block Blast",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/204675b2a7324aafa33ad9fd5caf88ab-512x384.jpg",
    "description": "Think fast, blast smart — can you beat your best score? Blast blocks, fit shapes, and outsmart the grid in this fast-paced puzzle challenge! Every move counts: clear space, chain combos, and keep the board from filling up. With smooth controls, colorful blocks, and quick rounds, it’s perfect for casual fun or deep strategy. Easy to pick up, hard to put down — how high can you climb the high score ladder?",
    "publisher": "Tarmar Dreams",
    "languages": [
      "No Text"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-22T07:54:55.096Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Controls:\\n\\nMouse: Click and drag to place shapes\\n\\nTouch (Mobile): Tap and drag to place shapes\\n",
    "sourceUrl": "https://gamedistribution.com/games/koko-loco-block-blast/"
  },
  {
    "id": "8c1bfbc5d6814c8aa3061061e050b8b4",
    "slug": "vegamix-match-3-village",
    "title": "VegaMix Match-3 Village",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/8c1bfbc5d6814c8aa3061061e050b8b4-512x384.jpg",
    "description": "A cozy match-3 with a heartfelt story! ? Visit grandma in the village — she’s a true star with fun tales from her youth. Play classic match-3 levels, earn stars and complete quests for villagers. Bright puzzles, touching stories, colorful graphics and daily bonuses await you. Perfect for short sessions and relaxing breaks. ? For fans of match-3 with plot, coziness and helping heroes.",
    "publisher": "Broccoli Games",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-22T07:50:36.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "How to play match-3 puzzle:\\n\\n● Match 3 or more pieces in a line to explode them.\\n● Match 4 pieces to create the Rocket. The Rocket blows up the whole line!\\n● Match 4 pieces to form a square to create the Spinner. The Spinner destroys one of the targets!\\n● Make a T-shaped match of 5 pieces to create the Bomb. The Bomb makes a massive explosion on the board!\\n● Match 5 pieces in a line to create the Rainbow Flower. The Rainbow Flower explodes pieces of the same color!",
    "sourceUrl": "https://gamedistribution.com/games/vegamix-match-3-village/"
  },
  {
    "id": "d0c31b0603f24b43b33e4b93d13d64bf",
    "slug": "drunken-fighters",
    "title": "Drunken Fighters",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/d0c31b0603f24b43b33e4b93d13d64bf-512x512.jpg",
    "description": "Are you ready for an adrenaline-filled fighting adventure?\\n\\nStep into the ring in Drunken Fighters’ single-player mode and face opponents that will test your reflexes, or grab a friend and fight in two-player mode on the same device.\\n\\nMaster ragdoll physics and boost the thrill with Funny Mod options: Stretch Kick, Stretch Punch, Big Punch, Super Punch, and Big Head or let Random Mode surprise you with chaos!",
    "publisher": "Goolandia",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-22T07:50:02.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "1 Player Mode\\nFight against strong opponents!\\n\\nDefense: A\\nKick: S\\nPunch: D\\n\\n2 Player Mode\\nChallenge your friend on the same device!\\n\\nPlayer 1:\\nDefense: A\\nKick: S\\nPunch: D\\n\\nPlayer 2:\\nDefense: Right Arrow\\nKick: Down Arrow\\nPunch: Left Arrow\\n\\nOn Mobile Devices:\\nYou can use the on-screen touch buttons for all actions.",
    "sourceUrl": "https://gamedistribution.com/games/drunken-fighters/"
  },
  {
    "id": "06df4062b392479f8a81a4376c5a1c90",
    "slug": "solitaire-story-tripeaks-6",
    "title": "Solitaire Story Tripeaks 6",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/06df4062b392479f8a81a4376c5a1c90-512x384.jpg",
    "description": "The highly anticipated 6th installment of one of the most popular Solitaire Story card games of all time! Your good friend Foxy will take you on a journey to new destinations, visiting countries, landscapes, and landmarks like Japan, Egypt, Brazil, Korea, New Zealand, Madagascar, North Pole, and Fiji. With 6700+ levels, Daily Missions, Weekly Air Balloon and Pet Events, and dozens of new card designs, this is the biggest Solitaire Story game yet!",
    "publisher": "SOFTGAMES – Mobile Entertainment Services GmbH",
    "languages": [
      "Dutch",
      "English",
      "French",
      "German",
      "Italian",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish",
      "Vietnamese"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-22T07:39:37.405Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "You have to draw cards one at a time from your stockpile. Select the cards that are one higher or one lower in value to your drawn card to remove it from the playing field. To complete a level you need to remove all the cards from the playing field without running out of cards from your stockpile. Complete the daily missions and events to unlock new deck designs and prizes that help you solve those tricky levels.",
    "sourceUrl": "https://gamedistribution.com/games/solitaire-story-tripeaks-6/"
  },
  {
    "id": "b96b71b611274b38a1de99b6ac82318c",
    "slug": "asmr-girl:-livestream-mukbang",
    "title": "ASMR Girl: Livestream Mukbang",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/b96b71b611274b38a1de99b6ac82318c-512x512.jpg",
    "description": "Step into the world of ASMR Girl: Livestream Mukbang, where you take on the role of an adorable mukbang streamer! Get ready to indulge in delicious food, satisfy your cravings, and share the experience with your viewers in a cozy, interactive livestream. The more you eat and engage, the more you earn!",
    "publisher": "Bravestars Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-22T07:38:42.446Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "?️ Shop, Cook, and Enjoy Delicious Foods\\nStart by shopping for ingredients, then move on to cooking mouth-watering dishes! From spicy noodles to delicious seafood and even sweet treats, the possibilities are endless. Prepare a meal that will make your audience hungry for more!\\n",
    "sourceUrl": "https://gamedistribution.com/games/asmr-girl:-livestream-mukbang/"
  },
  {
    "id": "ba23931cd64944a6ba5dc162f70c1684",
    "slug": "chicken-banana-quest",
    "title": "Chicken Banana Quest",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/ba23931cd64944a6ba5dc162f70c1684-512x512.jpg",
    "description": "Help the Chicken and Banana to solve all puzzle quest and find the play button. Use your skills to solve the puzzles before the lives run out and complete all levels with the less possible clicks",
    "publisher": "kiz10.com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-22T07:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Use the mouse or touch to play",
    "sourceUrl": "https://gamedistribution.com/games/chicken-banana-quest/"
  },
  {
    "id": "39f3d521b1134600ad5703502ca9d247",
    "slug": "wave-road-3d",
    "title": "Wave Road 3D",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/39f3d521b1134600ad5703502ca9d247-512x384.jpg",
    "description": "Wave Road 3D is a fast-paced reflex game that challenges your focus, timing, and precision. You control a sleek arrow gliding through a floating road filled with gears, traps, and collectible gems. Whether you’re chasing high scores in endless mode, conquering 20 handcrafted levels in classic mode, or racing head-to-head with a friend in 2 player mode, Wave Road 3D offers a refreshing and dynamic experience.",
    "publisher": "gameVgames",
    "languages": [
      "Arabic",
      "English",
      "German",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-22T06:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Player 1: W / Left Mouse Click / Spacebar\\nPlayer 2 (in 2 Player Mode): Up Arrow Key\\nMobile: Tap anywhere on the screen",
    "sourceUrl": "https://gamedistribution.com/games/wave-road-3d/"
  },
  {
    "id": "3592b08b0e944ff1b45c09d8f3b06d64",
    "slug": "pet-merge",
    "title": "Pet Merge",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/3592b08b0e944ff1b45c09d8f3b06d64-512x384.jpg",
    "description": "Merge adorable pets! \\nCombine cute companions to unlock rare and magical species. \\nPass exciting levels in adventure mode or beat your high score in the classic mode.\\nLet's Play! Meow",
    "publisher": "PT Arena Solusi Digital",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-21T09:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Mobile, or Tablet :\\nSlide the tiles left and right with finger then release to drop\\n\\nComputers:\\nSlide the tiles left and right with mouse or arrows then release on mouse or click down arrow to drop\\n(It is also possible to click with mouse or finger directly where we want to drop the tile without having to slide)\\n",
    "sourceUrl": "https://gamedistribution.com/games/pet-merge/"
  },
  {
    "id": "b8419951885944a1933a1ad6ddee7dbc",
    "slug": "mindblow",
    "title": "Mindblow",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/b8419951885944a1933a1ad6ddee7dbc-512x384.jpg",
    "description": "Get ready for a mind-teasing adventure in Mindblow, the ultimate word puzzle game that challenges your vocabulary and logic skills. Explore hundreds of fun and engaging levels — from simple to truly tricky — all designed to keep your brain sharp and entertained. Play for free on desktop or mobile, uncover hidden words from beautiful images, and enjoy new levels added every month. Think you have what it takes to become a true word master?",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-21T08:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "From easy peasy to brain-busters, we’ve got levels for every player. Earn coins for right guesses and use them for hints when stuck.\\nGuess the Word handy on your device. New levels are added to Mindblow every month, so there’s always something fresh to enjoy.\\nGuess the Word, start your journey of amazing pictures and satisfying word discoveries. Are you up for the challenge?",
    "sourceUrl": "https://gamedistribution.com/games/mindblow/"
  },
  {
    "id": "3f1f94669400422db98da97674048194",
    "slug": "royal-crown-blast",
    "title": "Royal Crown Blast",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/3f1f94669400422db98da97674048194-1280x720.jpg",
    "description": "Royal Crown Blast is a colorful and relaxing casual puzzle game where you tap, blast, and clear vibrant blocks to complete each level’s goals.\\nImmerse yourself in a royal atmosphere as you match groups of blocks of the same color and shape, triggering spectacular explosions and powerful boosters.\\nWith many levels, charming visuals, and simple one-tap controls, the game is both relaxing and delightfully addictive.",
    "publisher": "GameBerry Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-21T08:26:22.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Check the level objective — for example, collect a certain number of blocks of a specific color or free the crowns.\\nTap on a group of two or more adjacent blocks of the same color to make them disappear.\\nAs the blocks are cleared, new ones fall from above, forming fresh combinations.\\nCreate larger groups to activate boosters such as rockets, bombs, or rainbow disks — each capable of clearing even more blocks at once.",
    "sourceUrl": "https://gamedistribution.com/games/royal-crown-blast/"
  },
  {
    "id": "01a2209f6b014104951400328089a30d",
    "slug": "space.io",
    "title": "Space.io",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/01a2209f6b014104951400328089a30d-512x512.jpg",
    "description": "Jump into the cockpit of a powerful spaceship and engage in fast-paced 3D space battles! Face off against 9 other enemy ships in an intense dogfight where only the best pilot survives. Shoot down your opponents before they take you out, climb the rankings, and prove you're the ultimate space warrior! Unlock a wide variety of skins to customize your ship and dominate the battlefield in style. Can you claim the top spot?",
    "publisher": "Mao Games",
    "languages": [
      "English",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-21T07:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Both",
      "HTML5",
      "WebGL"
    ],
    "instructions": "PC:\\n- Move: WASD or Mouse\\n- Boost: Shift or Right Click\\n- Shoot: Spacebar or Left Click\\n\\nMobile:\\n- Move: Swerve to advance\\n- Boost: Tap the boost button",
    "sourceUrl": "https://gamedistribution.com/games/space.io/"
  },
  {
    "id": "1a82638838cc4a09a0c16ef6fd21929a",
    "slug": "cool-orange-ball:-bounce-adventure",
    "title": "Cool Orange Ball: Bounce Adventure",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/1a82638838cc4a09a0c16ef6fd21929a-512x384.jpg",
    "description": "Cool orange ball went on an adventure in which evil stones beat him, but the orange ball has 3 hearts. The game is similar to mario and sonic.\\n\\nGame Features:\\n- Lots of exciting levels\\n- Various biomes\\n- Secrets in some levels\\n- Skins of colorful balls\\n\\nDid you like the game Cool Orange Ball: Bounce Adventure? - Then try our other games and write a review on what to improve or what game we should release next!",
    "publisher": "Stickman vs Monster School Team",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-21T06:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "You can move and jump using the arrow keys, the WASD buttons (for PC) or by tapping the virtual buttons on the screen (for smartphones and tablets).\\n\\nTo win and go to the next level - find the key, it will open the door to the finish.",
    "sourceUrl": "https://gamedistribution.com/games/cool-orange-ball:-bounce-adventure/"
  },
  {
    "id": "291e5f0c1e2e4aebb222fd5bd4bbdb49",
    "slug": "brainrot-merge",
    "title": "Brainrot Merge",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/291e5f0c1e2e4aebb222fd5bd4bbdb49-512x384.jpg",
    "description": "Get ready for a weirdly satisfying evolution puzzle!\\nIn Brainrot Merge, drop creatures like Tun-Tun-Tun Sahur, Chimpanzini-Bananini, and Spioniro-Golubiro. Watch them bounce, roll, and merge into even stranger beings!\\nA mix of physics and pure absurdity — perfect for when your brain needs a break.",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-02T12:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "- Drag left or right to choose where to drop the creature.\\n- When identical creatures touch — they merge!\\n- Merged creatures evolve into new forms.\\n- The higher the level, the more points you earn!",
    "sourceUrl": "https://gamedistribution.com/games/brainrot-merge/"
  },
  {
    "id": "e003f23e182a4c2984407681402d4e77",
    "slug": "magic-and-wizards-match",
    "title": "Magic and Wizards Match",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/e003f23e182a4c2984407681402d4e77-200x120.jpg",
    "description": "Magic and Wizards is an enchanting Match 3 game where you and your friend Aurora embark on a mystical journey through a magical realm. With over 4000+ levels, match gems representing magical elements to overcome obstacles, using powerful boosters to progress. Complete Daily Missions, tackle tricky blockers, and uncover hidden treasures. With stunning graphics and immersive gameplay, Magic \\u0026 Wizards delivers a captivating experience filled with mystery. Ready for your magical adventure?",
    "publisher": "SOFTGAMES – Mobile Entertainment Services GmbH",
    "languages": [
      "Dutch",
      "English",
      "French",
      "German",
      "Italian",
      "Japanese",
      "Polish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-20T11:12:58.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "Combine more magical gems of the same kind to unlock powerful spells! Embark on an adventure through a mystical world with 4000+ levels. Join Aurora as you remove obstacles and cast spells to uncover hidden treasures. Watch out for magical creatures trying to hinder your progress! Enjoy daily missions, challenges, and discover enchanted rewards along the way. Experience endless fun and mystery in this captivating Match 3 game, Magic and Wizards!",
    "sourceUrl": "https://gamedistribution.com/games/magic-and-wizards-match/"
  },
  {
    "id": "769f3b2834b94b7ea57a8aa899d93272",
    "slug": "magic-and-wizards-mahjong",
    "title": "Magic and Wizards Mahjong",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/769f3b2834b94b7ea57a8aa899d93272-1280x550.jpg",
    "description": "Enter the enchanting world of Magic \\u0026 Wizards Mahjong! Match mystical tiles adorned with runes, potions, and magical artifacts across beautifully crafted layouts. Enjoy smooth gameplay with boosters like Hint, Shuffle, Undo, Torch, and Freeze. Race against the clock to earn time bonuses, or use extra seconds to finish your quest. With 50 rotating layouts and stunning wizardly visuals, every match feels like a spellbinding adventure for Mahjong lovers and casual players alike.",
    "publisher": "SOFTGAMES – Mobile Entertainment Services GmbH",
    "languages": [
      "Dutch",
      "English",
      "French",
      "German",
      "Italian",
      "Polish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-20T09:01:29.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Find and match identical tiles to clear the board! Only tiles free on at least one side can be selected. Plan your moves carefully to uncover hidden pairs and complete the layout. Use Hint when stuck, Shuffle to mix remaining tiles, Undo to reverse mistakes, and Torch or Freeze for special boosts. Finish before time runs out for bonus points! Enjoy magical visuals, smooth gameplay, and endless fun as you master each level of Magic \\u0026 Wizards Mahjong!",
    "sourceUrl": "https://gamedistribution.com/games/magic-and-wizards-mahjong/"
  },
  {
    "id": "701576d8cb014f90a0612b091a556c64",
    "slug": "cute-kitty-merge",
    "title": "Cute Kitty Merge",
    "category": "Simulation",
    "thumbnail": "https://img.gamedistribution.com/701576d8cb014f90a0612b091a556c64-512x384.jpg",
    "description": "Step into the role of a farmer and grow your own fruits and vegetables. In Solitaire TriPeaks Farming you will spend time in beautiful nature and play fun and constantly changing levels that will never allow for boredom. It is all about having fun.\\n",
    "publisher": "Inlogic Software",
    "languages": [
      "English",
      "French",
      "German",
      "Portuguese",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-20T08:12:54.540Z",
    "lastUpdated": "",
    "genres": [
      "Simulation",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Your objective is to beat the levels containing solitaire tripeaks games with variable difficulty. Each level earns you up to three stars. The more stars you earn, the more you grow your farm.\\n",
    "sourceUrl": "https://gamedistribution.com/games/cute-kitty-merge/"
  },
  {
    "id": "badfffd6951b4bdfa9b5eab7342496ab",
    "slug": "survival-island:-evo",
    "title": "Survival Island: EVO",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/badfffd6951b4bdfa9b5eab7342496ab-512x384.jpg",
    "description": "Play a fun adventure and simulation game in Survival Island: EVO. You are alone on a mysterious island, and the challenge begins: survive, build, and thrive. Gather more resources like food, water, wood, and stone. And craft the tools you need to stay alive. Build your shelter, light a fire, and protect yourself from hunger and wild animals. Explore hidden corners of the island, discover secrets, and unlock new crafting recipes. Become the true survivor.",
    "publisher": "YAD.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-20T08:10:47.074Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/survival-island:-evo/"
  },
  {
    "id": "b450025a35a0458493e9de730a67aff5",
    "slug": "vice-city-driver",
    "title": "Vice City Driver",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/b450025a35a0458493e9de730a67aff5-512x384.jpg",
    "description": "Get ready to skid the wheels of a stunning sports car through an expansive morning city map! Customize and upgrade your sports car with cool upgradables and become the best driver in the city. Take your dog with you in 3 driving challenges and conquer the missions together. Use nitro to beat slow traffic and beat all speed, stunt and drift triggers spread across the map. Are you ready to show your driving skills? Prove yourself!",
    "publisher": "Fuego! Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-20T06:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Car:\\nArrow Keys/W, A, S, D: Drive/Steer/Brake\\nC: Change Camera\\nF: Nitro\\n\\nCharacter:\\nArrow Keys/W,A,S,D: Move\\nMouse Orbit: Look Around",
    "sourceUrl": "https://gamedistribution.com/games/vice-city-driver/"
  },
  {
    "id": "8141e93045c245ce96ac745c5cb442fe",
    "slug": "last-stand-warrior",
    "title": "Last Stand Warrior",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/8141e93045c245ce96ac745c5cb442fe-512x512.jpg",
    "description": "A thrilling third-person shooter where you play as an experienced shooter defending your land from endless hordes of enemies. Control the hero, apply precise punches, use skills and fight with waves of mobs to prevent them from breaking through. Upgrade your weapons and abilities to become a true defense champion!\\n\\nIdeal for fans of dynamic gameplay, arcade battles and survival in the «wave of opponents» mode.",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-19T13:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Control on PC:\\nHold your mouse in the direction you want to move the player\\n\\nControl on mobile devices:\\nHold your finger in the direction you want to move the player.",
    "sourceUrl": "https://gamedistribution.com/games/last-stand-warrior/"
  },
  {
    "id": "a9fdba41525b438baed7ba8b2c842110",
    "slug": "snow-road-puzzle",
    "title": "Snow Road Puzzle",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/a9fdba41525b438baed7ba8b2c842110-512x384.jpg",
    "description": "Play Snow Road Puzzle — a free online puzzle you can play instantly in your browser, no download needed. Slide icy tiles, carve snowy routes, and solve frosty road puzzles across bite-sized logic levels. Perfect for Cool Math Games fans and unblocked fun at school or home. Fast-loading, mobile-friendly, and zero installs — dive into cozy winter puzzling and endless replay on desktop or phone.",
    "publisher": "GMG",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-19T13:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Using Left Mouse",
    "sourceUrl": "https://gamedistribution.com/games/snow-road-puzzle/"
  },
  {
    "id": "49a4a4a0fa2a48e4984f80bce7a32279",
    "slug": "paws-off-my-clues!",
    "title": "Paws Off My Clues!",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/49a4a4a0fa2a48e4984f80bce7a32279-512x384.jpg",
    "description": "Explore unique locations filled with hidden objects and unexpected mysteries. From sunny beaches to the ancient ruins of Persia, every corner of this fluffy world comes to life as you hunt for hidden treasures.\\n\\nWatch as the cats go about their lives, adding charm and humor to the atmosphere, while you search through their delightful mess. Solve puzzles, progress through levels, and become the ultimate hidden object master!",
    "publisher": "H5 Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-19T12:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Choose a level from the vibrant and detailed locations.\\nCarefully scan the screen to spot hidden objects.\\nComplete the level by finding all listed items and move on to the next exciting scene.",
    "sourceUrl": "https://gamedistribution.com/games/paws-off-my-clues!/"
  },
  {
    "id": "0c9e186c2adf4c52961d042085dfaeb1",
    "slug": "powerful-punch",
    "title": "Powerful Punch",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/0c9e186c2adf4c52961d042085dfaeb1-512x384.jpg",
    "description": "Ready to let off some steam? Powerful Punch is the perfect game to brighten your day and release your frustrations. Rescue the weak, take down villains, and unleash your spooky punch, sprunky punch, or even a spranky punch in levels filled with surprises and hilarity",
    "publisher": "Eyestorm Pte. LTD.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-19T12:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Whether you're punching bosses or dealing with bothersome difficulties, the game is a rollercoaster of challenges and laughs.",
    "sourceUrl": "https://gamedistribution.com/games/powerful-punch/"
  },
  {
    "id": "aac48696a9cb4ef7a6b820ba265af557",
    "slug": "smart-dots-reloaded",
    "title": "Smart Dots Reloaded",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/aac48696a9cb4ef7a6b820ba265af557-512x384.jpg",
    "description": "Smart Dots Reloaded is a fresh remake of the classic Dots and Boxes puzzle from Windows 3.1. Players take turns drawing lines between dots. Completing a square earns a point, and the game ends when the board is full. Featuring modern visuals, smooth animations, and both AI and two-player modes, this is a strategy game that’s easy to learn but hard to master.",
    "publisher": "Cassino.dev",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-19T09:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Click in lines and try to make squares to earn points.",
    "sourceUrl": "https://gamedistribution.com/games/smart-dots-reloaded/"
  },
  {
    "id": "68661b4a96164e9aafcba3d856a26065",
    "slug": "head-runner-dash",
    "title": "Head Runner Dash",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/68661b4a96164e9aafcba3d856a26065-512x384.jpg",
    "description": "Head Runner Dash is a 2D platformer game where you need to run, jump, and climb walls to overcome obstacles and traps. Pass the obstacles and raise the flag to complete the level. Difficult levels will make you addicted and feel challenged. ",
    "publisher": "atupdev",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-19T06:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "touch: jump\\nspace: jump",
    "sourceUrl": "https://gamedistribution.com/games/head-runner-dash/"
  },
  {
    "id": "a3e4731d2b7242f3bd293ea0d0b62173",
    "slug": "labuba-halloween-infestation",
    "title": "Labuba Halloween Infestation",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/a3e4731d2b7242f3bd293ea0d0b62173-512x512.jpg",
    "description": "Monsters are invading Halloween! You must destroy them all — the fate of Halloween is in your hands. The game features three different modes, each with tougher and more powerful monsters.",
    "publisher": "FBK",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-19T06:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "*Click the Fire button to shoot, or use your mouse to shoot when playing on PC.\\n*Use the WASD and Arrow keys to move.",
    "sourceUrl": "https://gamedistribution.com/games/labuba-halloween-infestation/"
  },
  {
    "id": "931169e8860040f5b169335e479cffc5",
    "slug": "capybara-skewer-match",
    "title": "Capybara Skewer Match",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/931169e8860040f5b169335e479cffc5-512x384.jpg",
    "description": "Capybara Skewer Match\\nStep into the cozy world of Capybara, your friendly skewer merchant! Help Capybara clear out the skewers by grilling and matching them before time runs out.\\n\\nCapybara needs your help to keep the BBQ stand running. Can you master the grill, match all the skewers, unlock tasty collectibles, and make Capybara proud?",
    "publisher": "Orenji Spark",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-18T12:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Cocos"
    ],
    "instructions": "How to Play:\\n\\nDrag skewers onto the grill.\\nMatch 3 of the same kind to cook them perfectly.\\nKeep grilling until all skewers are cleared!\\nFinish before the timer runs out to win.",
    "sourceUrl": "https://gamedistribution.com/games/capybara-skewer-match/"
  },
  {
    "id": "a3b56e35133044ea971b8db76481d06d",
    "slug": "park-master:-multi-level-challenge",
    "title": "Park Master: Multi-Level Challenge",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/a3b56e35133044ea971b8db76481d06d-512x384.jpg",
    "description": "Think you're a parking pro? Put your skills to the ultimate test in Park Master: Multi-Level Challenge! Navigate complex parking lots and master mind-bending levels with a mix of classic and sleek sports cars. Can you conquer every challenge?",
    "publisher": "Zoomie Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-18T09:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "?Keyboard: Use the arrow keys or WASD to drive and steer your car.\\n\\n?Mobile/Touch: Tap the on-screen buttons (gas, brake, and steering arrows) to control your car.\\n\\n?The goal of each level is to drive and park your car in the designated parking spot without hitting any obstacles. The fewer crashes you have, the higher your score!",
    "sourceUrl": "https://gamedistribution.com/games/park-master:-multi-level-challenge/"
  },
  {
    "id": "806ccd2db43a4bf7a9ebaf31723e2bca",
    "slug": "family-squid-challenge",
    "title": "Family Squid Challenge",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/806ccd2db43a4bf7a9ebaf31723e2bca-512x384.jpg",
    "description": "Hey Player, bring your friend along and team up in this Squid adventure! There are black and red masked men everywhere, so you must be very careful. Run from them and collect the keys to complete the level. Be cautious — both of you need to survive!",
    "publisher": "FBK",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-18T06:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "*Use the WASD and Arrow keys to move. \\n*Jump on enemies to defeat them. \\n*Collect the blue and red keys!",
    "sourceUrl": "https://gamedistribution.com/games/family-squid-challenge/"
  },
  {
    "id": "f40840102a1c4ac3b00c10c5d18673bb",
    "slug": "bubble-trouble",
    "title": "Bubble Trouble",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/f40840102a1c4ac3b00c10c5d18673bb-512x384.jpg",
    "description": "Avoid and pop the bubbles! Shoot the bubbles with your harpoon and split them in smaller bubbles, until eventually they disappear.\\nThe classic arcade game from 2002, remastered.\\nBubble Trouble (later Bubble Struggle) has been played hundreds of millions of times, labeled 'one of the top 10 online games'.\\n\\n22 unique levels, for 1 or 2 players (on the same keyboard).\\nFinal boss level.\\nChallenge other player's scores.",
    "publisher": "Aditon Inc",
    "languages": [
      "English",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-18T06:50:05.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Avoid and pop the bubbles.\\nSPACE to shoot, ARROW KEYS to move.",
    "sourceUrl": "https://gamedistribution.com/games/bubble-trouble/"
  },
  {
    "id": "369c9754eaf94e9f9969b86e03e491db",
    "slug": "fashion-heroes-academy",
    "title": "Fashion Heroes Academy",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/369c9754eaf94e9f9969b86e03e491db-512x384.jpg",
    "description": "Welcome to the Academy of Fashion Heroines, a place where style and superpowers go hand in hand! Three brave girls entered the academy in order not only to reveal their abilities, but also to create their own unique image. And you will help them in this. Choose outfits for studying, training and super battles. Experiment with makeup and accessories. Let each schoolgirl become a superhero and a style icon at the same time!",
    "publisher": "DL-studio",
    "languages": [
      "No Text"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-18T06:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Help the students of an unusual school choose clothes and accessories to create a stylish look: from school uniforms to heroic costumes. Don't forget about makeup and hairstyles. The most interesting options can be saved as a screenshot in PNG format. Depending on the gaming device, either a click of a computer mouse or a simple touch on touchscreens is used to control it.",
    "sourceUrl": "https://gamedistribution.com/games/fashion-heroes-academy/"
  },
  {
    "id": "7b34855c2eb74532925de32ab10a97d5",
    "slug": "k-pop-hunter-halloween-fashion",
    "title": "K-Pop Hunter Halloween Fashion",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/7b34855c2eb74532925de32ab10a97d5-512x384.jpg",
    "description": "Step into the glamorous world of K-Pop Hunter Halloween Fashion! In this fun dress-up game, you become the ultimate stylist, creating spooky yet stylish looks for popular K-Pop stars. Mix and match Halloween costumes, trendy hairstyles, and cool accessories to design jaw-dropping outfits for the season’s most exciting event.",
    "publisher": "Cutedressup",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-17T12:34:17.899Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "Left Mouse Button Click or Tap to play",
    "sourceUrl": "https://gamedistribution.com/games/k-pop-hunter-halloween-fashion/"
  },
  {
    "id": "332805b21f3c4890bb4258477857b0bb",
    "slug": "run-now",
    "title": "Run Now",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/332805b21f3c4890bb4258477857b0bb-512x512.jpg",
    "description": "Dive into Run Now, where each step is a puzzle waiting to be solved! This game offers a unique blend of creative challenges, quirky humor, and addictive gameplay. Perfect for puzzle enthusiasts and casual gamers alike, Run Now invites you to test your skills in a world filled with unexpected obstacles and entertaining surprises.",
    "publisher": "Eyestorm Pte. LTD.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-17T12:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Guide your character through a maze of obstacles, using quick reflexes and clever tactics to overcome each challenge. Discover hidden paths, collect rewards, and unravel the mysteries of each level in this captivating adventure.",
    "sourceUrl": "https://gamedistribution.com/games/run-now/"
  },
  {
    "id": "c34c0b22a8bd46b494b470ebb47ebb3f",
    "slug": "color-3d-bump-it-up",
    "title": "Color 3D - Bump It Up",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/c34c0b22a8bd46b494b470ebb47ebb3f-512x384.jpg",
    "description": "The main principle is pretty simple – you are controlling a small ball that is always moving forward.\\n\\nOn your way, there are a few obstacles that you need to get through. There’s a small problem however, because you can only touch obstacles that are the same color as your ball. If you touch an obstacle with a different color, the game ends and you need to start from the beginning.",
    "publisher": "Tiny Castle Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-17T11:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Using the left mouse to swipe ",
    "sourceUrl": "https://gamedistribution.com/games/color-3d-bump-it-up/"
  },
  {
    "id": "d8d3f8a172ed4ef8aca904005e9d14a8",
    "slug": "labubu-pop",
    "title": "Labubu Pop",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/d8d3f8a172ed4ef8aca904005e9d14a8-512x384.jpg",
    "description": "Labubu Pop is a bright and cheerful puzzle game where the playful Labubus have completely taken over the box! Connect matching characters into chains, clear the board, and earn points to level up. Each stage brings fun surprises, and even more exciting combos!\\n\\nWith its colorful visuals, smooth animations, and simple yet addictive gameplay, Labubu Pop is perfect for relaxing and having fun anytime. The longer your chain — the higher your score and the flashier the effects!",
    "publisher": "GameBerry Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-17T08:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "The box is filled with Labubus of different colors. Connect three or more identical Labubus in a single line to make them pop and earn points.\\nChains can go horizontally, vertically, or diagonally, and new Labubus appear after every move to keep the action going.\\n\\nReach the target score to advance to the next level. As you progress, new characters, colors, and effects appear — making every round feel fresh, fun, and full of life!",
    "sourceUrl": "https://gamedistribution.com/games/labubu-pop/"
  },
  {
    "id": "c373cffa43d94eb4bef26b941fc46073",
    "slug": "student-and-teacher",
    "title": "Student and Teacher",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/c373cffa43d94eb4bef26b941fc46073-1280x720.jpg",
    "description": "The school is not ready for you!\\nBroken laptops, chairs in splinters, the dining room is looted!\\nRevenge is a dish served in the form of chaos!\\nForget about the silent protest – only crushing anarchy!\\nMake your classmates regret it!\\nThe teacher is in a panic!\\nThe head teacher is furious!\\nThe main thing is not to get caught and avenge the setup!",
    "publisher": "Starodymov Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-17T08:34:08.294Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Desktop controls:\\nWASD - movement\\nspace - jump\\nE - Pick up the item\\nF - Hit\\nQ - Hide\\n\\nMobile control:\\njoystick on the left — movement\\nbutton with a jump icon — jumping\\non the buttons interacts with the game",
    "sourceUrl": "https://gamedistribution.com/games/student-and-teacher/"
  },
  {
    "id": "00702c3b78ba42c5870b70f5f25cd985",
    "slug": "zip-zap",
    "title": "Zip Zap",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/00702c3b78ba42c5870b70f5f25cd985-512x384.jpg",
    "description": "Step into the fascinating world of Zip Zap, a unique online physics puzzle game that blends mechanics, movement, and precision. Tap, twist, and control your way through clever levels filled with moving parts and intricate structures. Every stage tests your timing and creativity — can you reach every target? Play for free on desktop or mobile and enjoy a perfectly balanced mix of challenge and relaxation.",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-17T08:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Tap to contract hinges in your mechanical structure.\\nRelease to activate movement build momentum, tip parts, and react to gravity.\\nAim to touch all white circles or reach targeted zones to complete the level and progress.",
    "sourceUrl": "https://gamedistribution.com/games/zip-zap/"
  },
  {
    "id": "b16de7275fcf41dd93211f127e28273d",
    "slug": "mall-anomaly",
    "title": "Mall Anomaly",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/b16de7275fcf41dd93211f127e28273d-512x384.jpg",
    "description": "Mall Anomaly is not your usual mall trip. Instead of shopping, you’re stuck in endless hallways where mannequins stare, furniture floats, and unusual kitties vanish into thin air. Spot these bizarre anomalies before the place completely glitches out—it’s like spot the difference, but in a cursed shopping center.",
    "publisher": "iclickgames",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-17T06:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use MOUSE / AD / LEFT RIGHT ARROW / SPACE to play the game.",
    "sourceUrl": "https://gamedistribution.com/games/mall-anomaly/"
  },
  {
    "id": "f97244f04ed44f83bdae1f71c02361cb",
    "slug": "noob:-parkour-tricks",
    "title": "Noob: parkour tricks",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/f97244f04ed44f83bdae1f71c02361cb-512x384.jpg",
    "description": "Welcome to Noob: Parkour tricks!\\n\\nThis is a runner and timekiller in the minecraft universe about the adventures of Noob. Do parkour tricks and complete challenges.\\n\\nMonster School kicked out Noob, and Herobrine turned him into a Gigachad!\\n\\nGame Features:\\n- Run through the village with trials.\\n- Do parkour tricks.\\n- Complete challenges and avoid traps.\\n- Collect diamonds.\\n- Unlock new skins.",
    "publisher": "Stickman vs Monster School Team",
    "languages": [
      "English",
      "Russian",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-16T06:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Control:\\n\\nA\\\\D or Arrows - run left and right\\nW or Up Arrow - jump\\n\\nPurpose of the game: Get to the portal without falling into the holes and collecting diamonds along the way!",
    "sourceUrl": "https://gamedistribution.com/games/noob:-parkour-tricks/"
  },
  {
    "id": "76f026c1a1054c38b62a350e7bed02bc",
    "slug": "rock-crawling",
    "title": "Rock Crawling",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/76f026c1a1054c38b62a350e7bed02bc-512x384.jpg",
    "description": "Welcome to the thrilling world of 3D Rock Crawling Racing, where speed meets strategy and off-road dominance is your only goal. In this high-adrenaline off-road simulator, players take the wheel of powerful 4x4 rock crawlers and navigate some of the most extreme and rugged terrains ever designed in a browser game. From sharp mountain ridges to slippery mud tracks, this is not your average racing game—it’s a true test of control, timing, and grit.",
    "publisher": "StoreRider",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-16T06:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Mouse to navigate menu. Hold mouse click or space key to drive.",
    "sourceUrl": "https://gamedistribution.com/games/rock-crawling/"
  },
  {
    "id": "cf9a49ccdc2647cc9db47605ce183190",
    "slug": "dinosaur-shifting-run",
    "title": "Dinosaur Shifting Run",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/cf9a49ccdc2647cc9db47605ce183190-1280x720.jpg",
    "description": "Get ready for a prehistoric race unlike any other! Dinosaur Shifting Run throws you into a thrilling adventure where you transform into mighty dinosaurs to overcome obstacles and outrun rivals.",
    "publisher": "Bravestars Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-16T05:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "- Transform the character to suit the environment.\\n- Make sure you choose the right one to become the winner.\\n- The higher level it is, the more difficult game-play it is.",
    "sourceUrl": "https://gamedistribution.com/games/dinosaur-shifting-run/"
  },
  {
    "id": "90dab544fe47444eacfdfb97b704d5c1",
    "slug": "lost-adventure",
    "title": "Lost Adventure",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/90dab544fe47444eacfdfb97b704d5c1-512x384.jpg",
    "description": "Lost Adventure is a survival puzzle game where you guide a determined pilot through a strange, untamed land after a mid-air crash. Craft tools, mine resources, and solve clever challenges as you race to rescue scattered passengers. Your choices shape their fate—will you lead them to safety before the wilderness claims them for good?",
    "publisher": "Ultra Games Entertainment Private limited",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-16T06:00:08.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "ControlsUse WASD / arrow keys / mouse to move.",
    "sourceUrl": "https://gamedistribution.com/games/lost-adventure/"
  },
  {
    "id": "05a3746787c943669531c4241f7df085",
    "slug": "math-wall-simulator",
    "title": "Math Wall Simulator",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/05a3746787c943669531c4241f7df085-512x384.jpg",
    "description": "Combine brainpower and action in this math-based Roblox adventure! Solve equations to break through walls, collect coins, and unlock new challenges. Progress through 20 classes of increasing difficulty, from basic arithmetic to extreme math puzzles",
    "publisher": "2Play",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-15T07:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Approach the Wall: Face a wall presenting a math question.\\nSolve the Equation: Quickly compute the correct answer.",
    "sourceUrl": "https://gamedistribution.com/games/math-wall-simulator/"
  },
  {
    "id": "58deefb8f63943dcbc5093070b9b5777",
    "slug": "magic-tiles-3",
    "title": "Magic Tiles 3",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/58deefb8f63943dcbc5093070b9b5777-512x384.jpg",
    "description": "Love music games? Play your favorite songs on Piano Magic Piles 3!\\nMagic Tiles 3 is an engaging music game that combines magic piano, rhythm, and games for a fun and immersive experience. Tap the tiles to the beat, challenge your reflexes, and enjoy a massive library of 45,000+ songs across various genres, pop, EDM, hip-hop, and more! Tap the black tiles to the rhythm while avoiding the white ones.\\nSupport email: magictiles3.support@amanotes.com",
    "publisher": "Amanotes",
    "languages": [
      "Arabic",
      "English",
      "French",
      "German",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-15T07:37:53.978Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Magic Tiles 3 is a music rhythm game where players tap on tiles across 4 lanes as they move down the screen in sync with the music. The game's objective is to keep tapping tiles accurately and without missing any, to achieve high scores. Many different tile types require players to perform actions accordingly: holding long tiles, tapping with both fingers for double tiles, etc.",
    "sourceUrl": "https://gamedistribution.com/games/magic-tiles-3/"
  },
  {
    "id": "f63a94df89ae487aba3ff3bacba2d093",
    "slug": "cyber-arrow",
    "title": "Cyber Arrow",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/f63a94df89ae487aba3ff3bacba2d093-512x384.jpg",
    "description": "Play Cyber Arrow – a fast, fun online game where you become a Techno Archer! Fly a remote-controlled arrow, solve puzzles, defeat enemies, and rescue hostages across 3 exciting game modes in a stunning sci-fi world.",
    "publisher": "Playgama",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-15T07:35:46.018Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Control your arrow via virtual joystick.\\nIn some levels you should draw a path for the arrow.\\nThere also puzzle levels where you should choose enemies as a waypoints for the arrow,",
    "sourceUrl": "https://gamedistribution.com/games/cyber-arrow/"
  },
  {
    "id": "5958bd1704494e81a2eb89adcdf9c26f",
    "slug": "emoji-drop-themes",
    "title": "Emoji Drop Themes",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/5958bd1704494e81a2eb89adcdf9c26f-1280x550.jpg",
    "description": "Dive into the addictive fun of Emoji Drop, a delightful physics puzzle game where strategy meets chain reactions! Drop a variety of charming items, from classic emojis and juicy fruits to wild animals into the container. The magic happens when two matching items touch, merging into something new and bigger. With a challenging Adventure Mode and a relaxing Classic Mode, can you master the merge and discover the final, ultimate item?",
    "publisher": "Bofer Media (Twim Studio)",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-15T06:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Move your mouse (on a computer) or swipe your finger (on mobile) left and right across the top of the screen to position your drop. Click your mouse or lift your finger to release the item into the container.",
    "sourceUrl": "https://gamedistribution.com/games/emoji-drop-themes/"
  },
  {
    "id": "4a042de4eb3d448cb1a31d6cc7382b02",
    "slug": "coffee-match-rush:-sort-puzzle",
    "title": "Coffee Match Rush: Sort Puzzle",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/4a042de4eb3d448cb1a31d6cc7382b02-1280x720.jpg",
    "description": "Get ready for a deliciously challenging in block puzzle game - Coffee Match: Block Puzzle. In this game, you’ll be tasked with block jam 3d puzzle - sorting coffee cups into the right trays. Each level presents a new set of challenges where you’ll need to move the coffee trays around and strategically place the cups before the timer runs out.",
    "publisher": "Bravestars Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-14T08:43:09.717Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "⏳ Race Against Time!\\nThe goal is simple—move the trays to match the right coffee cups to the correct tray, but things get more complicated as you progress. With each level, you’ll need to think faster and act strategically to make sure all the cups are placed in the correct spot before time runs out!",
    "sourceUrl": "https://gamedistribution.com/games/coffee-match-rush:-sort-puzzle/"
  },
  {
    "id": "76cb341b58a3465a9f81ab38033e8665",
    "slug": "farm-defense",
    "title": "Farm Defense",
    "category": "Simulation",
    "thumbnail": "https://img.gamedistribution.com/76cb341b58a3465a9f81ab38033e8665-512x384.jpg",
    "description": "Farm Defense is a fast, arcade-style shooter where you guard your ranch from waves of quirky mutants. Move between lanes, aim, and blast anything that crawls out of the burrows before it reaches your crops. Earn coins, unlock new weapons and gadgets, and power up your electric fence. Bright visuals, snappy controls, and escalating waves make every run tense and satisfying.",
    "publisher": "GameBerry Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-14T08:17:15.030Z",
    "lastUpdated": "",
    "genres": [
      "Simulation",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Swipe or use the arrow keys to switch lanes. Pick up coins and boosters, then invest them between waves to upgrade damage, fire rate, ammo, or special skills. Keep enemies from crossing the defense line—survive the wave to advance. Tougher creatures and mini-bosses appear later, so manage your upgrades wisely and protect the farm!",
    "sourceUrl": "https://gamedistribution.com/games/farm-defense/"
  },
  {
    "id": "db45f820b0c24a0eb1710432fe18b63f",
    "slug": "home-match:-tile-master",
    "title": "Home Match: Tile Master",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/db45f820b0c24a0eb1710432fe18b63f-512x512.jpg",
    "description": "Tile Master - Classic Triple Match \\u0026 Puzzle Game is a challenging matching game.? In the game, you need to blow your mind and match 3 numbers of blocks. When all tiles are matched, you can pass the current level!? Our puzzle game includes large numbers of levels. Some levels might be hard. Challenge your mind and solve the puzzles, and then you will find them easy and exciting!",
    "publisher": "Gamee JSC",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-14T07:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "YoungAdults",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Tile Master - Classic Triple Match \\u0026 Puzzle Game is a challenging matching game.? In the game, you need to blow your mind and match 3 numbers of blocks. When all tiles are matched, you can pass the current level!? Our puzzle game includes large numbers of levels. Some levels might be hard. Challenge your mind and solve the puzzles, and then you will find them easy and exciting! ",
    "sourceUrl": "https://gamedistribution.com/games/home-match:-tile-master/"
  },
  {
    "id": "01b4c5438e0c4f17b046a0d1ca94fdae",
    "slug": "farm:-merge-harvest",
    "title": "Farm: Merge Harvest",
    "category": "Simulation",
    "thumbnail": "https://img.gamedistribution.com/01b4c5438e0c4f17b046a0d1ca94fdae-512x384.jpg",
    "description": "Transform your land into a beautiful farming haven. Start with a small plot and grow it by merging crops, designing structures and unlocking new areas. The more you build, the more surprises await, bringing new rewards and adventures at every stage!\\n",
    "publisher": "Inlogic Software",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Portuguese",
      "Russian",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-14T07:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Simulation",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Combine three or more identical objects to form new and upgraded versions. Deposit your final fusion to collect valuable rewards. Collect coins, tools and experience points to unlock new areas. Keep progressing as you build and expand your farm with new resources!\\n",
    "sourceUrl": "https://gamedistribution.com/games/farm:-merge-harvest/"
  },
  {
    "id": "c20e9806a15f475eb3c37e2d944da6a7",
    "slug": "monster-school-3",
    "title": "Monster School 3",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/c20e9806a15f475eb3c37e2d944da6a7-512x384.jpg",
    "description": "Continuation of the Monster School series from the creators of Noob vs Pro games. Teacher gave the school students a new challenge, this time the monsters will have to draw to survive!",
    "publisher": "Stickman vs Monster School Team",
    "languages": [
      "English",
      "Russian",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-14T06:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Click left mouse button to start. Draw the floor and ceiling to avoid traps and pave the way to the finish line.",
    "sourceUrl": "https://gamedistribution.com/games/monster-school-3/"
  },
  {
    "id": "82f6fa2fa66c47b3a0f2b0543cbdfc43",
    "slug": "elytra-flight",
    "title": "Elytra Flight",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/82f6fa2fa66c47b3a0f2b0543cbdfc43-512x512.jpg",
    "description": " Elytra Flight is an endless flying adventure inspired by the legendary Elytra wings. Players take to the skies in a fast-paced challenge where reflexes and strategy decide how long they can survive. Whether solo or in 2 player mode, the game blends arcade action with survival mechanics, offering a fresh and rewarding experience every flight. ",
    "publisher": "CursoraLabs",
    "languages": [
      "Arabic",
      "English",
      "German",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-14T06:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Player 1: W,A,S,D or ARROW KEYS(1P Mode Only)\\nPlayer 2: ARROW KEYS",
    "sourceUrl": "https://gamedistribution.com/games/elytra-flight/"
  },
  {
    "id": "755f3912501d454fb781db0a4c0c5764",
    "slug": "cooking-restaurant-kitchen",
    "title": "Cooking Restaurant Kitchen",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/755f3912501d454fb781db0a4c0c5764-512x384.jpeg",
    "description": "Prepare and cook delicious food from all over the world in Cooking Restaurant Kitchen. Build the cafe of your dreams while serving hot and awesome meals to hungry customers at a fast pace! Don't let the time run out, practice your time management skills, and get ready to experience the craze of real cooking!\\n",
    "publisher": "Rendered Ideas",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-13T14:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Manage your cafe by welcoming the customers and quickly taking their orders, win their hearts by simply tapping and serving them delicious meals right away!",
    "sourceUrl": "https://gamedistribution.com/games/cooking-restaurant-kitchen/"
  },
  {
    "id": "c11581c478694906b1246632b264dff1",
    "slug": "bubble-shooter-witch-tower-2",
    "title": "Bubble Shooter Witch Tower 2",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/c11581c478694906b1246632b264dff1-512x384.jpg",
    "description": " Bubble Shooter: Witch Tower 2 brings back the magic in a fun, family-friendly way! Pop colorful bubbles, unlock cozy enchanted rooms, and help the Witch Tower shine again. Meet adorable familiars, enjoy charming details, and celebrate the magic of every season — even a touch of Halloween spookiness! Easy to play for all ages, with plenty of bubble-shooting fun to enjoy anytime.",
    "publisher": "Azerion Casual Games",
    "languages": [
      "Czech",
      "Dutch",
      "English",
      "French",
      "German",
      "Italian",
      "Japanese",
      "Polish",
      "Portuguese",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-13T08:49:28.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "YoungAdults",
      "Adults",
      "Both",
      "HTML5",
      "Javascript"
    ],
    "instructions": " Drag to aim and shoot bubbles. Match 3 or more of the same color to pop them. Clear levels to restore new rooms in the Witch Tower. Use boosters to help on tricky stages and try to earn 3 stars on every level!",
    "sourceUrl": "https://gamedistribution.com/games/bubble-shooter-witch-tower-2/"
  },
  {
    "id": "bb4d392023214827884f92b2a0d68c27",
    "slug": "cookie-land",
    "title": "Cookie Land",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/bb4d392023214827884f92b2a0d68c27-512x384.jpg",
    "description": "Step into Cookie Land, the ultimate sweet Match 3 adventure! Match cookies, candies, pies, donuts, cupcakes, and cotton candies to clear the board and trigger scrumptious chain reactions. Explore a fairytale-like saga map filled with colorful sweets, charming graphics, and a catchy soundtrack. With new treats raining down and endless levels of fun, Cookie Land is the most addictive, mouth-watering Match 3 game for all sweet lovers!",
    "publisher": "SOFTGAMES – Mobile Entertainment Services GmbH",
    "languages": [
      "Dutch",
      "English",
      "French",
      "German",
      "Italian",
      "Polish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-13T08:47:05.753Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "Match three or more identical sweets to clear them from the board and reach your level goals. Swap adjacent pieces to create matches and earn points. Each level has unique objectives to complete within limited moves. Use powerful boosters to tackle obstacles, unlock quests, complete daily missions, and plan your moves wisely to conquer every challenge in this sweet and addictive Match 3 adventure!",
    "sourceUrl": "https://gamedistribution.com/games/cookie-land/"
  },
  {
    "id": "8d034584a63642dcb89fa3d24ed6e1b1",
    "slug": "vex-9",
    "title": "Vex 9",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/8d034584a63642dcb89fa3d24ed6e1b1-512x384.jpg",
    "description": "Vex 9 is here- the next evolution in the legendary stickman platformer series! Take your parkour skills to the limit as you run, jump, and slide your way through a brand-new set of Acts filled with dangerous traps, bombs, and other deadly surprises. \\n\\nFor the first time ever, take to the skies with the powerful new Jetpack! Put your reflexes to the ultimate test in the all-new Challenge Mode! Can you conquer every challenge and become the ultimate Vex champion?\\n",
    "publisher": "Azerion Casual Games",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Japanese",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-13T08:44:18.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Male",
      "Teens",
      "YoungAdults",
      "Both",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "On keyboard, use the Arrow keys or WASD to move, jump, and crouch your stickman. On mobile, tap the on-screen buttons to run, jump, slide, and now fly with the Jetpack!",
    "sourceUrl": "https://gamedistribution.com/games/vex-9/"
  },
  {
    "id": "62e8b351034b46129fedb50065e06680",
    "slug": "obby-tower",
    "title": "Obby Tower",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/62e8b351034b46129fedb50065e06680-512x384.jpg",
    "description": "Climb. Think. Survive.\\n\\nAscend a towering obstacle course filled with tricky jumps, moving platforms — and surprise math challenges! Combine your parkour skills with quick thinking to make it to the top.\\n\\nPerfect for players who love obbies and want to test both reflexes and brainpower.",
    "publisher": "2Play",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-13T08:30:00.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "1. Start at the base of the tower.\\n2. Jump, dodge, and parkour through a series of obstacles.\\n3.Reach math checkpoints where you must solve problems to proceed.\\n5. One wrong move and it’s back to the bottom!\\n6. Climb as high as you can to earn rewards and bragging rights.",
    "sourceUrl": "https://gamedistribution.com/games/obby-tower/"
  },
  {
    "id": "70f45225c4364584abc12fd8f7504c78",
    "slug": "jumper",
    "title": "JUMPER",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/70f45225c4364584abc12fd8f7504c78-512x384.jpg",
    "description": "Bounce your way to record-breaking heights in JUMPER! Dodge epic traps, collect unique power-ups, and enjoy upgraded visuals as you climb higher and higher.\\n\\nUnlock adorable skins and earn achievements as you master your jumps. Whether you're aiming for the top or just chilling, JUMPER offers a relaxing platform-hopping experience packed with charm.",
    "publisher": "Playgama",
    "languages": [
      "English",
      "Russian",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-13T07:54:17.427Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "On Desktop:\\nA / Left Arrow / Click left side – Move left\\nD / Right Arrow / Click right side – Move right\\n\\nOn Mobile:\\nTap left side of the screen – Move left\\nTap right side of the screen – Move right",
    "sourceUrl": "https://gamedistribution.com/games/jumper/"
  },
  {
    "id": "19d86bb378c4493397397fe3b8f2f0af",
    "slug": "path-ice",
    "title": "Path ice",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/19d86bb378c4493397397fe3b8f2f0af-512x384.jpg",
    "description": "Chill the soda, add some ice, but here's the problem, it's not so easy to get into the glass, you need to draw a path for the ice.\\n\\nDraw the path as you like.\\nGo through many levels\\nDiscover all kinds of ice and glasses",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-12T14:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "The game consists of several stages, to lead the way from box 1 to box 2 picking up as much ice, then from box 2 hold ice in a glass of soda, thereby cooling it.\\nThe main task is to score as much or more ice.\\nTo draw a path, just swipe your finger or mouse. If you drew the wrong path, choose an eraser and erase it.\\n\\n\\n",
    "sourceUrl": "https://gamedistribution.com/games/path-ice/"
  },
  {
    "id": "db69d7374a614188848b8834284d993f",
    "slug": "shotting-balls",
    "title": "Shotting Balls",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/db69d7374a614188848b8834284d993f-512x512.jpg",
    "description": "In this fun game, you'll have to use your skills to destroy all the black blocks you find in each level in order to advance to the next one. But that's not all: you'll also have to avoid losing the ball, because if it leaves the screen, you'll lose a life and, ultimately, the game. On the other hand, you can also collect gems, which will allow you to obtain new skins to give your ball a new look.",
    "publisher": "DarknesGamesStudio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-12T13:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Kids",
      "Teens",
      "Portrait",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "-Tap the screen and slide your finger to change the direction of the ball\\n-Release to make the ball move",
    "sourceUrl": "https://gamedistribution.com/games/shotting-balls/"
  },
  {
    "id": "520d3a78eecd42b99e0fd689a02d3cfe",
    "slug": "red-hide-ball",
    "title": "Red Hide Ball",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/520d3a78eecd42b99e0fd689a02d3cfe-512x384.jpg",
    "description": "In Red Hide Ball you protect designated balls from roaming monsters by manipulating the level layout and placing shields or obstacles. Each stage presents a fixed arrangement of elements and predictable monster movements, turning each solution into a small tactical exercise. Success depends on reading patterns, timing actions and using limited moves to create safe zones. The game balances accessible mechanics with steadily increasing difficulty to engage players who enjoy pure logic challenges.",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-12T12:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Study the board and predict monster movement. Tap or drag to place objects, block paths, and hide the good balls. ",
    "sourceUrl": "https://gamedistribution.com/games/red-hide-ball/"
  },
  {
    "id": "9d73154af21641cd9616d94bcd284a33",
    "slug": "mr-long-hand",
    "title": "Mr Long Hand",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/9d73154af21641cd9616d94bcd284a33-512x384.jpg",
    "description": "Immerse yourself in the quirky and delightful world of Mr Long Hand, where you take on the role of a stickman with incredibly long arms. Your mission is simple yet endlessly entertaining: use your elongated limbs to swing through obstacles, solve puzzles, and embark on thrilling rescues. Mr Long Hand offers a unique blend of creativity, challenge, and humor that is sure to captivate players of all ages.",
    "publisher": "Eyestorm Pte. LTD.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-12T12:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Playing Mr Long Hand is intuitive and fun. Simply pull your stickman’s long arms to attach to various points, helping you navigate through tricky obstacles and reach your goal. Use your smarts to solve puzzles in the most creative ways, rescue characters in distress, and play pranks on unsuspecting foes.",
    "sourceUrl": "https://gamedistribution.com/games/mr-long-hand/"
  },
  {
    "id": "3eccd25a86d245d28ae593793fe81e2b",
    "slug": "sort-master",
    "title": "Sort Master",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/3eccd25a86d245d28ae593793fe81e2b-512x384.jpg",
    "description": "Get ready to bring order to the chaos in Sort Master, a relaxing yet addictive online puzzle game. Test your logic and observation skills as you sort, match, and organize a variety of fun challenges — from colors to everyday objects. Whether you’re playing on your phone or computer, enjoy the satisfying feeling of tidying up and completing each level with perfection. Play for free and become the ultimate Sort Master!",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-12T11:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Each level is a unique mini-game that will not give you boredom. \\nYou'll have to find patterns and logical connections to pass on. \\nA lot of different activities to enjoy: unpacking, fill the fridge, goods matching, color matching, sorting, and organizing all the things in their places and puzzles.",
    "sourceUrl": "https://gamedistribution.com/games/sort-master/"
  },
  {
    "id": "c6e9fe916ff54b1c8a5e17a68d1479e5",
    "slug": "jetstream-escape",
    "title": "Jetstream Escape",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/c6e9fe916ff54b1c8a5e17a68d1479e5-512x384.jpg",
    "description": "Jetstream Escape — a fast-paced speedboat arcade built for quick-browser thrills. Pilot cutting-edge speedboats through tight channels, dodge coast guards, outrun storms and shave seconds off laps in this free, no-download boat racing game. Play online on desktop or mobile — an unblocked, cool-math-style speed boat game and boat games online free favorite. Unlock skins, climb leaderboards, casual-friendly, ad-moderated. Boost, drift, and escape!!",
    "publisher": "GMG",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-12T09:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Using AWDS, Arrow on PC, Mouse On Mobile",
    "sourceUrl": "https://gamedistribution.com/games/jetstream-escape/"
  },
  {
    "id": "1ac2392ea7bd4a1ca9f9b1e229287825",
    "slug": "dino-slide",
    "title": "Dino Slide",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/1ac2392ea7bd4a1ca9f9b1e229287825-512x512.jpg",
    "description": "A puzle slide game wher you have to feed Dino. Move Dino with the keyboard arrow or swipe. Each level you have to complete the goal that consist in eating fruits and vegetables.",
    "publisher": "Wolele",
    "languages": [
      "No Text"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-12T09:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use keyboard arrow to move or swipe left righ up and down",
    "sourceUrl": "https://gamedistribution.com/games/dino-slide/"
  },
  {
    "id": "b3d496aa204043c7bb39a355d8c97235",
    "slug": "car-mechanic-simulator-2025",
    "title": "Car Mechanic Simulator 2025",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/b3d496aa204043c7bb39a355d8c97235-512x512.jpg",
    "description": "In \\",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-12T05:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Desktop controls:\\nWASD - movement\\nSpace - jump\\nE - Use\\nF - Open\\nLMB - paint\\n\\nMobile controls:\\nleft joystick - movement\\nbutton with jump icon - jump\\nall controls are performed on buttons",
    "sourceUrl": "https://gamedistribution.com/games/car-mechanic-simulator-2025/"
  },
  {
    "id": "6d07333e823c477db438cee11c426b22",
    "slug": "witch-craft-potion-sort",
    "title": "Witch Craft Potion Sort",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/6d07333e823c477db438cee11c426b22-512x384.jpg",
    "description": "Step into the witch’s lair this Halloween night and test your skills in a spooky potion puzzle! Sort the eerie liquids, mix glowing brews, and fill each cauldron with the right color to complete your craft.",
    "publisher": "Orenji Spark",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-11T13:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Click a bottle to pour its eerie potion. Fill each bottle with a single color to break the curse.",
    "sourceUrl": "https://gamedistribution.com/games/witch-craft-potion-sort/"
  },
  {
    "id": "084149320d0e44fc9eaa25ebeb8133af",
    "slug": "tappy-bird-avoid-the-spikes",
    "title": "Tappy Bird - Avoid the Spikes",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/084149320d0e44fc9eaa25ebeb8133af-512x512.jpg",
    "description": "Tap on the screen to move bird up, avoiding the spikes as the level progresses more spikes appear and the possibility to collect coins increases.",
    "publisher": "PHATCAT Games Ltd",
    "languages": [
      "Arabic",
      "Chinese (Simplified)",
      "Danish",
      "English",
      "French",
      "German",
      "Greek",
      "Hindi",
      "Italian",
      "Persian",
      "Polish",
      "Portuguese",
      "Romanian",
      "Russian",
      "Simple English",
      "Spanish",
      "Swedish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-11T13:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Tap on the screen to move bird up, avoiding the spikes as the level progresses more spikes appear and the possibility to collect coins increases.",
    "sourceUrl": "https://gamedistribution.com/games/tappy-bird-avoid-the-spikes/"
  },
  {
    "id": "7e943bed895146b0a6939bb7c92a8e7c",
    "slug": "bricks-balls-breaker",
    "title": "Bricks Balls Breaker",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/7e943bed895146b0a6939bb7c92a8e7c-512x384.jpg",
    "description": "Dive into Bricks Balls Breaker, an addictive online arcade game where precision and timing are everything. Launch the ball, shatter the bricks, and plan your every move to keep the field clear. Easy to play yet challenging to master, this free game offers hours of fun on both mobile and desktop. Can you clear every level before the bricks reach the bottom?",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-11T11:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "- Hold the screen with your finger and move to aim.\\n- Find best positions and angles to hit all bricks.\\n- When the durability of brick reaches 0, destroyed.\\n- Never let bricks reach the bottom or game is over.",
    "sourceUrl": "https://gamedistribution.com/games/bricks-balls-breaker/"
  },
  {
    "id": "877356dc859c48f3b7e1922a48110439",
    "slug": "chicken-math",
    "title": "Chicken Math",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/877356dc859c48f3b7e1922a48110439-512x512.jpg",
    "description": "I am Archimedes. I've been trying to solve this difficult problem for a week, and those chickens have stolen my numbers again. Grab the rifle and head to the backyard. Find and retrieve my numbers. Just be careful — I need the correct numbers!",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-11T09:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Get the problem. Think through the solution. Wait for the chicken with your answer to come out of the coop. Then it’s easy — after all, you’ve got a rifle in your hands! But be careful: those chickens are always trying to fool you!\\n\\nTAB – pause menu\\nLeft mouse button – shoot\\nRight mouse button – aim",
    "sourceUrl": "https://gamedistribution.com/games/chicken-math/"
  },
  {
    "id": "ab2ee8bbe1e540c9ae06719d2c4170d6",
    "slug": "destruction-simulator",
    "title": "Destruction Simulator",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/ab2ee8bbe1e540c9ae06719d2c4170d6-512x384.jpg",
    "description": "Experience the ultimate destruction sandbox! Bend time, shift gravity, and unleash realistic debris effects. Choose from 13+ explosives, quakes, and tornadoes, or craft custom weapons. Wreck 30+ maps or design your own with the advanced map editor!",
    "publisher": "Playgama",
    "languages": [
      "English",
      "French",
      "German",
      "Portuguese",
      "Russian",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-11T09:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "From a computer, press LMB (Left Mouse Button) and swipe across the screen to rotate the camera. Movement on WASD (and QE to raise the camera shutter). The rest is through the game interface.\\nFor mobile use fingers and in-game UI.",
    "sourceUrl": "https://gamedistribution.com/games/destruction-simulator/"
  },
  {
    "id": "a2329d5becb7463e89808bd94cd0910d",
    "slug": "sand-block-blast",
    "title": "Sand Block Blast",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/a2329d5becb7463e89808bd94cd0910d-512x384.jpg",
    "description": "Play Sand Block Blast — a free browser block-puzzle playable online with no download. Drop sand-shaped blocks, watch them turn to grains, and clear lines in a relaxing but strategic web game. Perfect for quick breaks, classrooms, and unblocked game lists. No install or registration; mobile-ready, ad-moderated, and cool-math-friendly. Play online free now.",
    "publisher": "GMG",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-11T07:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Using Mouse to Drag",
    "sourceUrl": "https://gamedistribution.com/games/sand-block-blast/"
  },
  {
    "id": "e90dc6d410f24698b6da64cadbfdc300",
    "slug": "circuit-master",
    "title": "Circuit Master",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/e90dc6d410f24698b6da64cadbfdc300-512x512.jpg",
    "description": "Circuit Master is a puzzle game where you aim to get a green light by connecting the circuit correctly! Arrange the wires, fans, and machines in the right places, then turn on the button to see the electricity flow. Only the correctly connected circuit will make the green light shine. Use hints if you need help.",
    "publisher": "BeedoGames",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-11T06:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Use touch and drag to place components on the circuit board, once all placed, tap on red power button to power it up.",
    "sourceUrl": "https://gamedistribution.com/games/circuit-master/"
  },
  {
    "id": "25ed0a49c8414d8fbd16cbee344b8e5d",
    "slug": "what's-in-my-bag",
    "title": "What's In My Bag?",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/25ed0a49c8414d8fbd16cbee344b8e5d-512x384.jpg",
    "description": "Unpack style and surprises in What’s In My Bag? – the ultimate dress-up and makeup game for fashion lovers! Choose cute outfits, glam makeup, and trendy bags, then reveal what’s inside each one. From influencer props to girly goodies, every bag tells a story. Get creative, show off your style, and join the viral “what’s in my bag” trend now! Perfect for fans of dress-up games, makeup fun, and aesthetic vibes.",
    "publisher": "Gamerina",
    "languages": [
      "English",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-10T12:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use your mouse to play this game on a desktop, tap to play on mobile devices. ",
    "sourceUrl": "https://gamedistribution.com/games/what's-in-my-bag?/"
  },
  {
    "id": "6b0e26c64fc141a8a64e64e306d22893",
    "slug": "beat-music-battle",
    "title": "Beat Music Battle",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/6b0e26c64fc141a8a64e64e306d22893-512x384.jpg",
    "description": "Step into the world of Beat Music Battle: 456 Survival, where rhythm meets creativity and fun! This casual music game is perfect for puzzle enthusiasts and party lovers alike.",
    "publisher": "Eyestorm Pte. LTD.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-10T12:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "- Select beats and create your mix.\\n- Craft custom dance moves and match the rhythm.\\n- Solve puzzles to progress through exciting music battles.",
    "sourceUrl": "https://gamedistribution.com/games/beat-music-battle/"
  },
  {
    "id": "6a81e8ec192d4a48950e683e903d749c",
    "slug": "capybara-coin-master",
    "title": "Capybara Coin Master",
    "category": "Simulation",
    "thumbnail": "https://img.gamedistribution.com/6a81e8ec192d4a48950e683e903d749c-512x384.jpg",
    "description": "Capybara Coin Master is a cozy yet addictive incremental tycoon clicker game where every flip counts!\\n\\nStart small by buying your first coin and flipping it for income—heads mean profit! As your fortune grows, hire adorable Capybara Coin Masters to flip coins for you, even while you relax. \\nUpgrade your coins to higher quality for bigger rewards, and unlock powerful Coin Mastery to boost your team’s flipping skills.\\n\\nFlip. Upgrade. Profit. Rule the coin empire with your capybara crew! ",
    "publisher": "Orenji Spark",
    "languages": [
      "English",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-10T09:55:42.335Z",
    "lastUpdated": "",
    "genres": [
      "Simulation",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Upgrade your coins to higher quality for bigger rewards, and unlock powerful Coin Mastery to boost your team’s flipping skills.",
    "sourceUrl": "https://gamedistribution.com/games/capybara-coin-master/"
  },
  {
    "id": "54c0012499194a2a8417409422158d0a",
    "slug": "marble-bubble-legend",
    "title": "Marble Bubble Legend",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/54c0012499194a2a8417409422158d0a-200x120.jpg",
    "description": "Marble Puzzle Quest is a fun and addictive casual puzzle game where your task is to sort colorful marbles into the correct slots. With each new level, the challenge grows — chains become longer and more colorful, while the space for moves gets tighter. Use logic, plan ahead, and clear the board! Watch out: the marbles fill four slots at the top, and only three of the same color will disappear. Place them incorrectly, and you lose the round.",
    "publisher": "GameBerry Studio",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-10T09:11:04.988Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Each chain of marbles starts and ends with a special ball marked with arrows showing its direction. Drag this ball into the slot of the same color to guide the whole chain. If the chain contains multiple colors, sort the marbles one by one, making sure each finds its matching slot.",
    "sourceUrl": "https://gamedistribution.com/games/marble-bubble-legend/"
  },
  {
    "id": "4d4a37a2047f42feb66e746959be9177",
    "slug": "ammo-rush-master",
    "title": "Ammo Rush Master",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/4d4a37a2047f42feb66e746959be9177-512x384.jpg",
    "description": "Get ready to run, multiply, and blast your way to victory in Ammo Rush Master!\\nDodge obstacles, choose the right gates, and build the biggest Ammo army of bullets. Then, grab your blaster and unleash a storm of foam darts to smash through targets, enemies, and bosses!",
    "publisher": "Ultra Games Entertainment Private limited",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-10T08:46:06.382Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "? How to Play\\n\\nRun through the track and pass through gates (+, -, ×, ÷) to increase your firepower.\\n\\nCollect stickman allies and multiply your shooting strength.\\n\\nAvoid traps and tricky gates that can reduce your numbers.\\n\\nAt the end, aim your Ammo blaster and fire away to break through walls and bosses!",
    "sourceUrl": "https://gamedistribution.com/games/ammo-rush-master/"
  },
  {
    "id": "5daeb7a5fdb7489ab0e1bf821e5e6db3",
    "slug": "snakes",
    "title": "SNAKES",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/5daeb7a5fdb7489ab0e1bf821e5e6db3-512x384.jpg",
    "description": "SNAKES is a modern puzzle game that combines strategy and spatial reasoning. Players guide multiple snakes across a grid, filling every empty tile to complete each level. With clear visuals and intuitive mechanics, the game offers a relaxing yet challenging experience that sharpens logical thinking. Each level introduces unique layouts and obstacles, ensuring variety and depth as players advance.",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-10T08:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Select a level to begin.\\nUse your mouse (drag and release) or finger (swipe) to move the snakes.\\nGuide them across the grid until all empty tiles are covered.\\nAvoid blocking yourself—plan moves ahead and use longer paths first.",
    "sourceUrl": "https://gamedistribution.com/games/snakes/"
  },
  {
    "id": "61444bd7cc1d42dc9e50d8ea31235f1e",
    "slug": "cat-life-simulator:-devil-cat",
    "title": "Cat Life Simulator: Devil Cat",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/61444bd7cc1d42dc9e50d8ea31235f1e-1280x720.jpg",
    "description": "Ever wanted to experience life as a mischievous cat? In Cat Life Simulator: Devil Cat, you take on the role of a playful yet naughty kitty, causing absolute mayhem inside Grandma’s house—all from a first-person perspective! This exciting 3D simulation game lets you see through the eyes of a troublemaking feline as you knock over furniture, scratch walls, and do everything in your power to drive Grandma crazy! Are you ready to embrace the chaos? ",
    "publisher": "Bravestars Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-10T08:05:43.339Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "?Explore the House – Wander freely and discover all the objects you can mess with. Every room is a playground for destruction!\\n? Create Chaos – Scratch walls, break items, and knock things over to rack up points. The bigger the mess, the higher your score!\\n?‍♂️ Avoid Granny – Stay on the move and dodge Granny’s attempts to stop you while you continue your pranks!\\n? Unleash Your Inner Devil Cat – Jump onto tables, push objects off shelves, and leave a trail of destruction behind you!",
    "sourceUrl": "https://gamedistribution.com/games/cat-life-simulator:-devil-cat/"
  },
  {
    "id": "e0c6fbe378ad4ed5a1325176324a79dd",
    "slug": "foxy-eco-sort",
    "title": "Foxy Eco Sort",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/e0c6fbe378ad4ed5a1325176324a79dd-512x384.jpg",
    "description": "Join Foxy and Raccoon on their eco-mission! Sort waste, play match-3 and matching pairs to clean polluted locations. \\n\\nBut it's not just cleaning! Uncover the conspiracy of cunning Ratty who wants to destroy the forest. Complete story chapters: track garbage trucks, expose arsonists and save your home!",
    "publisher": "DRA",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-09T09:35:13.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "1. Sort Waste Correctly\\nDrag items to their matching categories: cardboard to cardboard, plastic to plastic, glass to glass, organic to organic.\\n\\n2. Play \\",
    "sourceUrl": "https://gamedistribution.com/games/foxy-eco-sort/"
  },
  {
    "id": "50581d05ea344baea7d8f62991d18e4c",
    "slug": "block-puzzle-3d",
    "title": "Block Puzzle 3D",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/50581d05ea344baea7d8f62991d18e4c-512x384.jpg",
    "description": "Block 3D Puzzle is a colorful logic game where you need to place 3D blocks on the board in the right order. Every move turns into a bright visual effect — when you place a figure and complete a line, the entire line lights up with that block’s color!\\nPlan your moves carefully, fill the lines, and clear space for new blocks. The game combines relaxing gameplay, smooth animations, and stylish 3D graphics, making every puzzle a true visual delight.",
    "publisher": "GameBerry Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-09T09:32:17.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Drag and drop the blocks onto the board to fill horizontal or vertical lines.\\nWhen a line is completely filled, it changes to the color of the placed block and disappears, freeing up space for the next moves.\\nThe game ends when there’s no room left for new blocks.\\nThink ahead, combine smartly, and get the highest score possible!",
    "sourceUrl": "https://gamedistribution.com/games/block-puzzle-3d/"
  },
  {
    "id": "6f86278e329d4246a3ee3c56706116a1",
    "slug": "chicken-banana-run",
    "title": "Chicken Banana Run",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/6f86278e329d4246a3ee3c56706116a1-512x512.jpg",
    "description": "Explore the World and Space with the famous Chicken Banana! Run and keep running to collect gold, diamonds and special items and finish with the longest distance to get a high score! Play now the new free runner game for everyone.\\n\\n\\n",
    "publisher": "kiz10.com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-09T07:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Use the mouse or touch to jump or double jump ",
    "sourceUrl": "https://gamedistribution.com/games/chicken-banana-run/"
  },
  {
    "id": "f13a0ab3316c4be8b273610a5f2c872c",
    "slug": "mini-golf-battle",
    "title": "Mini Golf Battle",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/f13a0ab3316c4be8b273610a5f2c872c-512x384.jpg",
    "description": "Mini Golf Battle is a casual sports puzzle where precision and timing decide the outcome. Your task is to sink the ball into the hole with the fewest strokes possible while navigating ramps, walls, and tricky obstacles. Special power-ups like Fire, Wing, and Spring shots add variety, letting you approach each course with unique strategies. Whether for short play sessions or longer runs, Mini Golf Battle delivers an engaging mix of relaxation and skillful play.",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-09T07:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Drag or swipe to aim, then pull back to set shot strength and release to hit the ball. Plan your angles to bounce off walls and avoid obstacles. Use power-ups wisely: Fire for fast long shots, Wing for extended glides, and Spring for bounces or jumps. The goal is to reach the hole in as few moves as possible.",
    "sourceUrl": "https://gamedistribution.com/games/mini-golf-battle/"
  },
  {
    "id": "78eb21dc67c744fe8ae7fcf97a69d868",
    "slug": "grunge-chic-alt-fashion",
    "title": "Grunge Chic Alt Fashion",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/78eb21dc67c744fe8ae7fcf97a69d868-512x384.jpg",
    "description": "Step into the edgy world of Grunge Chic Alt Fashion, where style meets attitude. This dress-up game lets you explore the perfect mix of grunge edge and chic sophistication.\\n\\nFrom plaid skirts and ripped jeans to oversized jackets, fishnets, and combat boots—you’ll have endless options to design your alternative fashion star. Top it off with smoky makeup, bold lipstick, and layered accessories to complete the vibe.",
    "publisher": "Cutedressup",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-09T06:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "Left Mouse Button Click",
    "sourceUrl": "https://gamedistribution.com/games/grunge-chic-alt-fashion/"
  },
  {
    "id": "940c7c7f620b46f0ba61998e9a98b8fb",
    "slug": "formula-traffic-racer",
    "title": "Formula Traffic Racer",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/940c7c7f620b46f0ba61998e9a98b8fb-1280x720.jpg",
    "description": "Skid the wheels of 6 stunning F1 cars with modified body kits and drive them through 3 landscape highways without crashing. Show how well you can steer the wheels of these amazing cars with roaring engines and conquer 3 awesome game modes. Use replenishing nitro to overtake slow cars and drive in speed at all times. Customize and upgrade your cars with the best upgrades and get the most out of all the cars. Are you ready to show your driving skills? Prove yourself in F1 Traffic Racer",
    "publisher": "Fuego! Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-09T06:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "W, A, S, D/ Arrow Keys: Drive/Steer/Brake , F: Nitro , C: Change Camera",
    "sourceUrl": "https://gamedistribution.com/games/formula-traffic-racer/"
  },
  {
    "id": "15622637a8f1434fb43b1273cd1e163a",
    "slug": "dog-escape",
    "title": "Dog Escape",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/15622637a8f1434fb43b1273cd1e163a-200x120.jpg",
    "description": "Dog Escape is the best dog simulation game with twists and turns that will keep you busy for hours. Whether you're a dog or cat lover, this game is perfect for everyone. Each level is a maze of challenging obstacles, security guards and rooms full of traps. The game becomes more challenging as you progress to higher levels.",
    "publisher": "NovaSky",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForAndroid"
    ],
    "firstActiveDate": "2024-08-30T10:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Swipe mouse \\u0026 finger. Unlike other dog games, there are no cats around to bother you, but you will find many power-ups and hiding spots, such as:\\n\\n-Hiding Spots: Take a break from the guards and hide in a closet, the perfect place to avoid detection until you're ready to continue your adventure.\\n\\n-Dog Treats: If you come across a cookie, eat it. They are delicious.\\n\\n-Buttons: Press buttons to eliminate electric traps or remove obstacles that prevent your dog from escaping.",
    "sourceUrl": "https://gamedistribution.com/games/dog-escape/"
  },
  {
    "id": "61217cb6c59e49a29ad154c64ea209de",
    "slug": "minecraft-battle-party",
    "title": "Minecraft Battle Party",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/61217cb6c59e49a29ad154c64ea209de-512x384.jpg",
    "description": "Ready for a hot feast of square battles? In Minecraft Battle Party, you'll enter a pixel-styled battle arena where nervous fighting meets iconic Minecraft-style visuals. In this world, every game is a duel to the death. You will play different roles and use different weapons. For example, as a gunner, constantly move your character so that enemies are shot within your scanning range. Watch out for other people's attacks.",
    "publisher": "YAD.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-08T06:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/minecraft-battle-party/"
  },
  {
    "id": "5d6e368f1b55466aa897cb7f0c67419c",
    "slug": "sort-tiles",
    "title": "Sort Tiles",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/5d6e368f1b55466aa897cb7f0c67419c-512x384.jpg",
    "description": "Sort Tiles: Tap Away is a fun and addictive puzzle game where you move tiles, clear the board, and reveal hidden pictures. It’s simple to learn but offers endless logic challenges that keep your brain active. Perfect for fans of tile puzzles, logic games, and relaxing brain teasers.\\n\\nKey Features:\\nUnique puzzle mechanics — move tiles in the arrow’s direction and solve logic puzzles step by step.\\nHidden images — every cleared puzzle board reveals a new picture.",
    "publisher": "Clever Apps Pte. Ltd.",
    "languages": [
      "Arabic",
      "Chinese (Simplified)",
      "Dutch",
      "English",
      "French",
      "German",
      "Italian",
      "Japanese",
      "Korean",
      "Latvian",
      "Polish",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-08T06:45:05.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Tap a bolt to pick the top nut.\\nTap another bolt to drop it onto a matching color or into an empty bolt.\\nSort all nuts by color to complete the level.\\n\\nIf you enjoy puzzle games, brain training, and logic challenges, Sort Tiles: Tap Away is the perfect game for you.",
    "sourceUrl": "https://gamedistribution.com/games/sort-tiles/"
  },
  {
    "id": "28f14620b6b4490b8ca14b5ebc684175",
    "slug": "merge-beasts",
    "title": "Merge Beasts",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/28f14620b6b4490b8ca14b5ebc684175-512x512.jpg",
    "description": "A fun and addictive merge game where you combine cute and quirky beasts to create stronger and rarer creatures. Each merge brings you closer to discovering powerful evolutions and unlocking new surprises. Collect coins, upgrade your beasts, and watch your monster city grow!",
    "publisher": "bestphysics",
    "languages": [
      "No Text"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-08T06:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Just drag and drop matching beasts to merge them into a stronger one.",
    "sourceUrl": "https://gamedistribution.com/games/merge-beasts/"
  },
  {
    "id": "cadf585751cf43dfbc12aa1092186855",
    "slug": "legend-of-fireball",
    "title": "Legend of Fireball",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/cadf585751cf43dfbc12aa1092186855-512x384.jpg",
    "description": "Fireballs are your weapon of choice as you tap on objects to obliterate them and earn rewards. Every tap brings you closer to becoming the ultimate Fireball King! Collect various fireballs, costumes, and upgrades, enhancing your powers with every victory. Master cool fireball skills to crush objects even faster and more efficiently.\\nRace against time to demolish all targets in thrilling challenges, proving you're the strongest fireball wielder in the universe!",
    "publisher": "TapNation",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-07T09:19:18.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Click on the screen to shoot a fireball. Navigate the menus to spend currency and update your character as you progress into the game.",
    "sourceUrl": "https://gamedistribution.com/games/legend-of-fireball/"
  },
  {
    "id": "b8075d28037148ec9764c96e3be18bfc",
    "slug": "asmr-pet-treatment",
    "title": "ASMR Pet Treatment",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/b8075d28037148ec9764c96e3be18bfc-512x384.jpg",
    "description": "Take care of your adorable puppy and kitty in this relaxing ASMR game! Wash, heal, and pamper your pets with gentle treatments. After they feel happy and healthy, have fun dressing them up in cute outfits. Relaxing sounds and sweet pets make every moment enjoyable!",
    "publisher": "iclickgames",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-07T09:11:25.222Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use MOUSE to play the game.",
    "sourceUrl": "https://gamedistribution.com/games/asmr-pet-treatment/"
  },
  {
    "id": "3e6a6aeec5b04d4aa60754e9b9d31bd1",
    "slug": "slice-it-up",
    "title": "Slice it Up",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/3e6a6aeec5b04d4aa60754e9b9d31bd1-200x120.jpg",
    "description": "Slice It Up is a colorful arcade puzzle where precision is key! Cut fruits, toys, and other shapes exactly in half to earn stars. The closer your slice is to the center, the better your score. Simple controls, smooth animation, and bright graphics make every level fun and challenging. Test your reflexes, aim for three stars, and unlock new levels in this exciting game for all ages!",
    "publisher": "GameBerry Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-07T09:07:47.195Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Swipe your finger or move the mouse across the screen to make a cut. The closer the line is to the perfect center of the object, the higher your score. Try to be as accurate as possible to earn three stars and unlock new levels!",
    "sourceUrl": "https://gamedistribution.com/games/slice-it-up/"
  },
  {
    "id": "6259b8781bfe4a1dbcd274ca61837902",
    "slug": "aliens-hunter",
    "title": "Aliens Hunter",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/6259b8781bfe4a1dbcd274ca61837902-512x512.jpg",
    "description": "You are an alien hunter and your mission is to use your abilities to find the aliens hidden in the city and use your gun to accurately shoot the aliens to get rewards. Each round has different aliens hiding in different locations. You have to accurately choose, aim and shoot to complete the level mission.\\n\\n",
    "publisher": "Yizhiyuan Network Technology Co., Ltd.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-07T07:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Find the aliens hidden in the city and use your gun to accurately shoot the aliens to get rewards",
    "sourceUrl": "https://gamedistribution.com/games/aliens-hunter/"
  },
  {
    "id": "8b43e10dbeb84f7c90e848fb8109d489",
    "slug": "bubble-shooter-temple-jewels",
    "title": "Bubble Shooter Temple Jewels",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/8b43e10dbeb84f7c90e848fb8109d489-512x512.jpg",
    "description": "Embark on a temple adventure in Bubble Shooter Temple Jewels! Pop colorful bubbles as you progress through ancient ruins inspired by Central American temples. Keep track of your journey with the Stats screen, showing your best, current, and previous scores across Novice, Expert, and Master modes. With vibrant visuals, exciting challenges, and detailed progress tracking, this bubble shooter keeps you motivated to aim higher and improve every round!",
    "publisher": "SOFTGAMES – Mobile Entertainment Services GmbH",
    "languages": [
      "Dutch",
      "English",
      "French",
      "German",
      "Italian",
      "Polish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-06T12:56:19.943Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "Aim the cannon with the arrow and shoot bubbles to match 3 or more of the same color. The middle bubble shows your current shot, and the one at the bottom left shows the next. Clear bubbles to prevent the stack from reaching the bottom. Missed shots add fouls, and new rows appear when grey bubbles run out. Plan your shots, match strategically, and keep popping to survive!",
    "sourceUrl": "https://gamedistribution.com/games/bubble-shooter-temple-jewels/"
  },
  {
    "id": "e399b210de7d4db9a5ab7334c5fa0c1b",
    "slug": "linklink",
    "title": "LinkLink",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/e399b210de7d4db9a5ab7334c5fa0c1b-512x384.jpg",
    "description": "Round and cute animal blocks are piled up.\\nIf you connect the same types together, you can get points by disappearing!\\nLet's compete to see who gets the highest score in a minute",
    "publisher": "MOVISOFT.Co.,Ltd",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-06T08:18:08.079Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "LinkLink is a puzzle game where you select and connect three or more blocks of the same picture. Click or touch the mouse and slide to connect three blocks of the same picture to remove them.",
    "sourceUrl": "https://gamedistribution.com/games/linklink/"
  },
  {
    "id": "a8b96cd1ff1e4ce7ad23864aaf27f219",
    "slug": "word-seasons",
    "title": "Word Seasons",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/a8b96cd1ff1e4ce7ad23864aaf27f219-512x384.jpg",
    "description": "Puzzle lovers, it’s time to get solving! Discover hidden words on a word-filled journey through the seasons. Don’t let tough spots stop you – hints are always there to guide you. Keep moving forward, solving one puzzle after another.\\n",
    "publisher": "Inlogic Software",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Portuguese",
      "Russian",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-06T08:16:09.454Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Letters are scattered across the board. Form words to match the number of empty spaces above. Use hints when needed to help with tricky spots. Enjoy relaxing backgrounds that change as you advance through the levels.\\n",
    "sourceUrl": "https://gamedistribution.com/games/word-seasons/"
  },
  {
    "id": "91eb12a4669543ea825a9e2469143b93",
    "slug": "twilight-solitaire-tripeaks",
    "title": "Twilight Solitaire TriPeaks",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/91eb12a4669543ea825a9e2469143b93-512x384.jpg",
    "description": "Step into the shadows with Twilight Solitaire TriPeaks! Explore abandoned castles, fend off lurking vampires, and rebuild forgotten halls. Play 200+ haunting Solitaire levels plus 50 chilling Mahjong boards. Face spooky twists like frozen and locked cards, tricky obstacles, and powerful boosts. Search the dark, cobwebby corners of every last level for gems and coins to purchase new castle upgrades and power-ups. Are you ready for a Solitaire adventure that sends shivers down your spine?",
    "publisher": "Mad Data",
    "languages": [
      "English",
      "French",
      "German",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-06T08:10:12.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Remove all cards from the tableau by playing any face-up card that is one higher or lower than the stock card. When stuck, flip the next stock card. The game ends when the tableau is cleared or no moves remain.",
    "sourceUrl": "https://gamedistribution.com/games/twilight-solitaire-tripeaks/"
  },
  {
    "id": "b12634b876af4c14b88ce37a9319c642",
    "slug": "onet-monster-book",
    "title": "Onet Monster Book",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/b12634b876af4c14b88ce37a9319c642-512x512.jpg",
    "description": "A \\",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-05T15:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Game rules are very simple: find matching pictures, tap one and then tap its pair. If there are no other pictures blocking the path between them, they will connect and disappear, clearing the way for new matches. Make sure to finish before time runs out, or you'll have to start over.\\n\\nIf you're stuck, you can use hints:\\n- Reveal a matching pair\\n- Shuffle all pictures\\n- Add more time",
    "sourceUrl": "https://gamedistribution.com/games/onet-monster-book/"
  },
  {
    "id": "58cd87d5fac94261800865d2c46e70ac",
    "slug": "unstack-tower",
    "title": "Unstack Tower",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/58cd87d5fac94261800865d2c46e70ac-512x384.jpg",
    "description": "Unstack Tower is a puzzle game that challenges players to dismantle a tower of colorful cubes in the correct order. Every move matters—remove or drop blocks carefully to keep the structure stable while freeing space for the next step. Different block materials such as glass or wood add variety and difficulty, making each level unique. With its blend of strategy and reflex-based gameplay, Unstack Tower offers a mix of tension and fun that keeps players engaged.",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-05T12:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Click or tap to remove or drop cubes from the tower.\\nRotate or reposition pieces when possible for better placement.\\nMatch three or more blocks of the same color to clear them and score points.\\nAvoid unbalanced moves that could cause the tower to collapse.",
    "sourceUrl": "https://gamedistribution.com/games/unstack-tower/"
  },
  {
    "id": "3a935e65bc2844558b7051d63246a51d",
    "slug": "fishing-the-russian-way",
    "title": "Fishing the Russian Way",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/3a935e65bc2844558b7051d63246a51d-512x512.jpg",
    "description": "Embark on a journey through Central Russia: picturesque rivers and lakes, different types of fish, and the exciting process of fishing. Improve your tackle, control your rod, decide the fate of your catch, and add to your collection of rare finds.\\n\\nUse your car to discover new locations, complete tasks, participate in tournaments, and receive daily rewards. Freedom of choice and the path to becoming a true fishing master await you!",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-05T12:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Casting the rod\\nTap the water to set the rod. The further you cast, the faster you will get a bite.\\n\\nBite and reeling in\\nWhen you hear the bell, tap the button and reel in your catch. Take into account the resistance of the fish so as not to damage the rod.\\n\\nCatch results\\nYou can sell the fish you catch for money and experience, or release it back into the sea and gain more experience.\\n\\nEquipment\\nKeep an eye on the condition of your equipment. If something breaks, buy new parts at the base.",
    "sourceUrl": "https://gamedistribution.com/games/fishing-the-russian-way/"
  },
  {
    "id": "3187b1da3c484ca5947c15826b377644",
    "slug": "paris-kiss",
    "title": "Paris Kiss",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/3187b1da3c484ca5947c15826b377644-512x384.jpg",
    "description": "Welcome to Paris Kiss, a fun and quirky puzzle game where your goal is simple — bring the characters together for a kiss",
    "publisher": "Eyestorm Pte. LTD.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-05T11:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Tap, stretch, and solve clever puzzles by bending and pulling their elastic limbs. Use your creativity to connect hearts in all kinds of funny, sweet, and unexpected ways. From shy first kisses to bold kiss in public moments, every level offers a charming surprise!",
    "sourceUrl": "https://gamedistribution.com/games/paris-kiss/"
  },
  {
    "id": "4c4f11af25194527be18ac273ceb08c2",
    "slug": "panda-mahjong-classic",
    "title": "Panda Mahjong Classic",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/4c4f11af25194527be18ac273ceb08c2-512x384.jpg",
    "description": "The panda has a challenge for you. You will face five tests on your way to the top. Attempt to finish all stages and earn the honor of being a Mahjong master.",
    "publisher": "Sanoma",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-05T09:00:00.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Your task is to clear the game board by matching pairs of identical tiles that have no tiles on top of them and at least one long side free. For season and flower pairs, the symbols do not need to be identical. You will earn extra time and bonus points if you find pairs quickly enough! In a tight spot, you can reveal a pair using the hint button in the bottom right corner.",
    "sourceUrl": "https://gamedistribution.com/games/panda-mahjong-classic/"
  },
  {
    "id": "bb4f4af57f614d68bcf68dbe8a9ceaa3",
    "slug": "mysterious-familiars-enchanted-bestiary",
    "title": "Mysterious Familiars Enchanted Bestiary",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/bb4f4af57f614d68bcf68dbe8a9ceaa3-512x384.jpg",
    "description": "Welcome to the magical world of Mysterious Familiars! Your task is to fill the magic vessel by simply tapping on the screen. Each click fills the potion bowl. As soon as the vessel is filled, a new image of one of the familiars or its next stage of maturation will open. Explore magical locations, from the Moonlight Glade to the Slug Trail, and watch incredible creatures appear from small drops of magic potion. Start the adventure right now - the familiars are waiting for you!",
    "publisher": "DL-studio",
    "languages": [
      "English",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-05T07:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Explore the world of magical familiars. There are many magical familiars in the game, presented in different stages of development; bonuses that speed up the game; the opportunity to take a screenshot with your favorite familiar; the atmosphere of fairy tales, magic and comfort. And, most importantly, simple and relaxing game mechanics - click and the magic will come to life.",
    "sourceUrl": "https://gamedistribution.com/games/mysterious-familiars-enchanted-bestiary/"
  },
  {
    "id": "689a12e3cfb24c3ea00b1b0ac122ac54",
    "slug": "treasure-seeker",
    "title": "Treasure Seeker",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/689a12e3cfb24c3ea00b1b0ac122ac54-512x384.jpeg",
    "description": "This is fun game to play.\\nYou have 5 languages to choose.\\nThere are levels to complete in this game by matching the 3 items and collect the correct items on the list to complete the levels.\\nEnjoy this game!",
    "publisher": "Pro_Gaming",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-05T07:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 2"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 2"
    ],
    "instructions": "Click and drag the item to match.",
    "sourceUrl": "https://gamedistribution.com/games/treasure-seeker/"
  },
  {
    "id": "0e8ab73503cb457a8ae6936f464f4344",
    "slug": "on-fire-basketball-shots",
    "title": "On Fire Basketball Shots",
    "category": "Sports",
    "thumbnail": "https://img.gamedistribution.com/0e8ab73503cb457a8ae6936f464f4344-512x384.jpg",
    "description": "The gym is packed, and the crowd is roaring! The scoreboard's ticking down, and your team is trailing. The only way to win is to sink blazing basketball shots from the court. You're the star player, but the pressure's on—every shot counts, and the hoop's rim is red-hot, making each attempt trickier!",
    "publisher": "SecGame",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-05T07:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Sports",
      "HTML5",
      "Construct 2"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 2"
    ],
    "instructions": "- Click to shoot the basketball toward the hoop.\\n- Drag and drop to aim your shot through moving obstacles.\\n- Double-click to power up for a flaming long-range shot.\\n- Right-click to steal the ball from opponents for a bonus shot.",
    "sourceUrl": "https://gamedistribution.com/games/on-fire-basketball-shots/"
  },
  {
    "id": "c857585a877f4f32bb2b9e2c2849b189",
    "slug": "car-destruction-king",
    "title": "Car Destruction King",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/c857585a877f4f32bb2b9e2c2849b189-512x384.jpg",
    "description": "Get behind the wheel and push your limits in this dynamic driving simulator! Choose from different cars, race across diverse maps, and challenge yourself against rotating hammers, giant presses, catapults, and other wild obstacles. With multiple game modes, realistic crash physics, and even the ability to slow down time, every drive is an unpredictable adventure. Set new records, experiment with stunts, and see how far your skills can take you!",
    "publisher": "Playgama",
    "languages": [
      "English",
      "French",
      "German",
      "Russian",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-04T13:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Drive your car using the on-screen controls (mobile) or keyboard (PC). Navigate through obstacle-filled tracks, race to achieve record times, and test your vehicle against extreme crash challenges. Use nitro for bursts of speed, handbrake for sharp turns, and slow motion for precise control during crashes. Try different cars and maps to experience all the game modes.",
    "sourceUrl": "https://gamedistribution.com/games/car-destruction-king/"
  },
  {
    "id": "e66029eabf6e447f928009efa6b527d4",
    "slug": "sort-water-now",
    "title": "Sort Water Now",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/e66029eabf6e447f928009efa6b527d4-512x384.jpg",
    "description": "A fascinating puzzle journey, a mysterious water sorting adventure, waiting for your experience!Rich and fascinating levels and a variety of props combination, let the classic puzzle game take on a new look!",
    "publisher": "HeiTie",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-04T12:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Click on a bottle to pick it up, click on another bottle to pour water, and make sure that there is only one color of water in the final bottle.",
    "sourceUrl": "https://gamedistribution.com/games/sort-water-now/"
  },
  {
    "id": "099ab589874f4c50a5d69a37d51bb126",
    "slug": "brainrot-click-to-hatch",
    "title": "Brainrot Click to Hatch",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/099ab589874f4c50a5d69a37d51bb126-512x512.jpg",
    "description": "Enter Brainrot Click to Hatch, the most absurd and epic clicker at the same time. With every tap you release BRAINROTS, each one stranger and more chaotic than the last. Accumulate energy, unlock upgrades, and watch how the BRAINROTS evolve into impossible forms. From viral classics to MAX POWER versions, the challenge is clear: collect them all before losing your mind. Do you think you can dominate the Brainrot universe with just a click?",
    "publisher": "Xpresate Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-04T12:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Use the left mouse button to play and interact with the in-game UI.",
    "sourceUrl": "https://gamedistribution.com/games/brainrot-click-to-hatch/"
  },
  {
    "id": "b0cf3c351a0346f786c8ea15c911b885",
    "slug": "bubble-piggies",
    "title": "Bubble Piggies",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/b0cf3c351a0346f786c8ea15c911b885-512x384.jpg",
    "description": "Bubbles Piggies is an engaging bubble shooter game with 50 levels. Free all piggies to complete the levels. When there are no piggies left in the tube the level will drop down 1 floor. Each level will face challenging features like the sleeping piggy, the hidden piggy, the powerup bubble, the moving bubble and more. ",
    "publisher": "Bubble Shooter",
    "languages": [
      "Dutch",
      "English",
      "French",
      "German",
      "Italian",
      "Polish",
      "Portuguese",
      "Spanish",
      "Swedish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-04T12:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Shoot the bubbles and make combinations of 3 or more. Complete each level by popping all bubbles.",
    "sourceUrl": "https://gamedistribution.com/games/bubble-piggies/"
  },
  {
    "id": "ef711682d87f412fa9d21670c90c34c1",
    "slug": "just-mahjong",
    "title": "Just Mahjong",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/ef711682d87f412fa9d21670c90c34c1-512x512.jpg",
    "description": "Immerse yourself in an atmosphere of tranquility with \\",
    "publisher": "GamePush",
    "languages": [
      "Chinese (Simplified)",
      "English",
      "French",
      "German",
      "Japanese",
      "Russian",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-04T11:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Your goal is to clear the playing field by finding and removing pairs of identical free tiles. A tile is considered free if it is not covered from above by other tiles and has at least one side (left or right) open.",
    "sourceUrl": "https://gamedistribution.com/games/just-mahjong/"
  },
  {
    "id": "058083edfeb4411fa82a440a16ae0247",
    "slug": "k-pop-puzzle-hunters",
    "title": "K-Pop Puzzle Hunters",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/058083edfeb4411fa82a440a16ae0247-512x384.jpg",
    "description": "K-Pop Puzzle Hunters is a fun and creative puzzle game inspired by the K-Pop Demon Hunters universe where you get to piece together 12 stunning images featuring Huntrix, Saja Boys, and Derpy Tiger. Choose your challenge with 16, 36, 64, or 100 puzzle pieces and use hints when needed. Perfect for K-Pop fans, anime lovers, and puzzle enthusiasts, this free game mixes strategy, logic, and fandom fun. Start solving today and become the ultimate Puzzle Hunter!",
    "publisher": "Gamerina",
    "languages": [
      "English",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-04T08:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use your mouse to play this game on a desktop, tap to play on mobile devices. ",
    "sourceUrl": "https://gamedistribution.com/games/k-pop-puzzle-hunters/"
  },
  {
    "id": "6c87066d2e774bafbafbe7d00652712a",
    "slug": "shark-chomp-chase",
    "title": "Shark Chomp Chase",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/6c87066d2e774bafbafbe7d00652712a-512x384.jpg",
    "description": "Shark Chomp Chase — play this free browser shark game online with no download required. Hunt, grow, and survive in fast-paced arcade action; easy to pick up, hard to master. Perfect casual web game for kids and adults, unblocked and mobile-ready. HTML5 WebGL graphics, ad-moderated and teacher-friendly — great for classroom breaks and cool math-style play. Play now for free — no install: play shark game online, free shark game online, browser shark game, play shark game no download.",
    "publisher": "GMG",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-04T07:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Using Arrow or Mouse",
    "sourceUrl": "https://gamedistribution.com/games/shark-chomp-chase/"
  },
  {
    "id": "d8dea5d83d1c4132a119fabedbc60bd6",
    "slug": "3d-chess-master",
    "title": "3D Chess Master",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/d8dea5d83d1c4132a119fabedbc60bd6-512x512.jpg",
    "description": "3D Chess Master – The ultimate 3D chess experience! Enjoy stunning three-dimensional graphics while testing your strategy skills. Challenge your friends in head-to-head matches or take on powerful AI opponents in the most immersive chess game yet.",
    "publisher": "8Games.Net",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-03T13:15:58.345Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Use mouse to play.",
    "sourceUrl": "https://gamedistribution.com/games/3d-chess-master/"
  },
  {
    "id": "631a7f3f3b8946d1a77d1e2efcced2b4",
    "slug": "bubble-sorting-infinite-remastered",
    "title": "Bubble Sorting Infinite Remastered",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/631a7f3f3b8946d1a77d1e2efcced2b4-512x384.jpg",
    "description": "Bubble Sorting Infinite Remastered is a fun and calming puzzle game where you sort colorful bubbles into matching tubes. Just move the bubbles around, stack 3 to 10 of the same color together, and watch them pop away! With endless levels and relaxing gameplay, it’s the perfect brain teaser to unwind anytime, anywhere.",
    "publisher": "Lof Games",
    "languages": [
      "Arabic",
      "Bulgarian",
      "Chinese (Simplified)",
      "Czech",
      "Danish",
      "Dutch",
      "English",
      "Estonian",
      "Finnish",
      "French",
      "German",
      "Greek",
      "Hebrew",
      "Hindi",
      "Hungarian",
      "Indonesian",
      "Italian",
      "Japanese",
      "Korean",
      "Latvian",
      "Lithuanian",
      "Norwegian (Nynorsk)",
      "Polish",
      "Portuguese",
      "Romanian",
      "Russian",
      "Serbian",
      "Simple English",
      "Slovak",
      "Spanish",
      "Swahili",
      "Swedish",
      "Tagalog",
      "Thai",
      "Turkish",
      "Ukrainian",
      "Vietnamese"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-03T12:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Play using a mouse or touchpad –Tap a tube to pop the top bubble, then tap the target tube to move it there.",
    "sourceUrl": "https://gamedistribution.com/games/bubble-sorting-infinite-remastered/"
  },
  {
    "id": "2e9bc55864514d32b224992842cf8bc9",
    "slug": "tied-up",
    "title": "Tied Up",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/2e9bc55864514d32b224992842cf8bc9-512x512.jpg",
    "description": "Tied Up is a physics-based arcade survival game where you control a small ball tethered to a larger one by a spring. Use momentum and precise mouse movements to swing, evade, and counter waves of enemies. With only three lives per round, survival demands quick reflexes and smart play. Rack up high scores and push for a new personal best!",
    "publisher": "Dissorto",
    "languages": [
      "English"
    ],
    "mobile": [],
    "firstActiveDate": "2025-10-03T12:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "HTML5",
      "WebGL"
    ],
    "instructions": "PC (Mouse) : Move the mouse to control the small ball's movement.\\n-The big ball will swing and rotate, connected by the spring.\\n\\nGoal : Survive wave after wave of enemies.\\n-Avoid collisions and score as high as you can before losing all 3 lives!",
    "sourceUrl": "https://gamedistribution.com/games/tied-up/"
  },
  {
    "id": "a3b05c8c36084707be9c6f58c6723c9a",
    "slug": "zero-to-millionaire!",
    "title": "Zero to Millionaire!",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/a3b05c8c36084707be9c6f58c6723c9a-512x384.jpg",
    "description": "\\",
    "publisher": "GamePush",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Russian",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-03T12:02:01.935Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Start the game with limited funds. Get a job, earn money, and spend wisely. Gradually invest in businesses, upgrade your home, buy vehicles, and develop your character.\\n\\nTips:\\n• Work regularly for stable income.\\n• Balance work, rest, and relationships.\\n• Invest in profitable businesses and upgrade often.\\n• Build relationships, improve charisma and intelligence.\\n• Aim for a better lifestyle and ultimate success.\\n\\nYou control your destiny. Build your own path to wealth!",
    "sourceUrl": "https://gamedistribution.com/games/zero-to-millionaire!/"
  },
  {
    "id": "8ef64da20e3d486684971c1274d13a3b",
    "slug": "ball-bunker:-sneaky-stacks",
    "title": "Ball Bunker: Sneaky Stacks",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/8ef64da20e3d486684971c1274d13a3b-512x384.jpg",
    "description": "Ball Bunker: Sneaky Stacks is a fun physics puzzle where your goal is to keep the ball safe! Tap to drop shapes and stack them into a bunker. Rotate pieces to fill gaps, then release the enemy balls. If your bunker holds, you win — if the ball gets hit, you fail. Simple, clever, and addictive!",
    "publisher": "Carrot Quest",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-03T11:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Tap a shape — it will fall straight down from where it sits.\\nWhen all props are dropped the enemy balls fall. If your ball stays hidden, you win. If an enemy hits the ball, tap Retry or watch an ad to retry instantly",
    "sourceUrl": "https://gamedistribution.com/games/ball-bunker:-sneaky-stacks/"
  },
  {
    "id": "01e876961e1f433c880c9fadf6399882",
    "slug": "super-swing",
    "title": "Super Swing",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/01e876961e1f433c880c9fadf6399882-512x384.jpg",
    "description": "Dive into the thrilling world of Super Swing, where you’ll swing, fly, and solve hilarious puzzles in this hyper-casual adventure! Play as a daring stickman hero, swinging through colorful and lively scenes filled with quirky challenges and creative problem-solving opportunities.",
    "publisher": "Eyestorm Pte. LTD.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-03T11:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Super Swing is perfect for puzzle enthusiasts and casual gamers alike. The simple controls make it easy to learn, while the progressively challenging levels keep you coming back for more. Enjoy playing online or offline, with beautiful graphics and relaxing music enhancing your gaming experience.",
    "sourceUrl": "https://gamedistribution.com/games/super-swing/"
  },
  {
    "id": "8411f0d3331f4c339f68eb330673408e",
    "slug": "block-builder-jam",
    "title": "Block Builder Jam",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/8411f0d3331f4c339f68eb330673408e-512x384.jpg",
    "description": "Block Builder Jam is a physics-based puzzle game that blends logic with creativity. Your goal is to drop blocks and fit them into the outlined shape on the screen. Each block falls according to real physics, so precision and timing matter. As levels progress, shapes become more complex and demand sharper planning. With its simple mechanics and engaging challenges, Block Builder Jam offers a satisfying mix of strategy and experimentation.",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-03T09:04:43.663Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Tap a floating block to drop it. Position and stack blocks carefully to complete the required shape. Physics will affect how the pieces land, so time your drops precisely. Clear each stage by filling the shape fully, then move on to the next challenge.",
    "sourceUrl": "https://gamedistribution.com/games/block-builder-jam/"
  },
  {
    "id": "c1a565ff55b24f8dba2e591c07e6e991",
    "slug": "miracle-mahjong",
    "title": "Miracle Mahjong",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/c1a565ff55b24f8dba2e591c07e6e991-512x384.jpg",
    "description": "The panda has a challenge for you. You will face five tests on your way to the top. Attempt to finish all stages and earn the honor of being a Mahjong master.",
    "publisher": "Sanoma",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-03T08:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Match pairs of identical tiles with a line that has at most two 90-degree angles. At least one side of both tiles must be free. The chain bonus activates when you find pairs quickly enough. In a tight spot, you can reveal a pair using the hint button in the bottom right corner.",
    "sourceUrl": "https://gamedistribution.com/games/miracle-mahjong/"
  },
  {
    "id": "262f87d0232f43bbb3659c1cb39f2bb7",
    "slug": "gloomy-princess-favorite-toy",
    "title": "Gloomy Princess Favorite Toy",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/262f87d0232f43bbb3659c1cb39f2bb7-512x384.jpg",
    "description": "Immerse yourself in the mysterious world of the Gloomy Princess and her strange but touching teddy friend. Create unique images for the heroine of the game: choose makeup, outfits and accessories - from witch hats to lace corsets in the Gothic spirit. Add personality to her favorite toy. Assemble the perfect duo - a princess hiding her feelings behind a flawless image, and her beloved companion reflecting the inner world of the hostess!",
    "publisher": "DL-studio",
    "languages": [
      "English",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-03T07:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Become a fashion stylist for the Gloomy Princess and her plush pet. Create unique fashionable images for the heroes of the game, and save the most interesting options as PNG images for your friends. Depending on the gaming device, either a click of a computer mouse or a simple touch on touchscreens is used to control it.",
    "sourceUrl": "https://gamedistribution.com/games/gloomy-princess-favorite-toy/"
  },
  {
    "id": "bf89159a695c4b1da8fdb1115336ea39",
    "slug": "knife.io",
    "title": "Knife.io",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/bf89159a695c4b1da8fdb1115336ea39-512x512.jpg",
    "description": "Knife.io is a fast-paced 2D battle game where you throw knives at your enemies to eliminate them! Dodge incoming attacks, aim precisely, and take down as many opponents as possible without getting hit. With vibrant worlds to explore and tons of unique characters to unlock, every match is a colorful and action-packed challenge. Play solo or team up with a friend in local multiplayer, only the sharpest player will survive!",
    "publisher": "Mao Games",
    "languages": [
      "English",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-02T13:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Single Player:\\n- PC: Move with the mouse or WASD, attack with Spacebar or Left Click\\n- Mobile: First finger to move, second finger to attack\\n\\nTwo Players (Local Multiplayer):\\n- PC:\\nPlayer 1: Move with WASD, attack with Spacebar\\nPlayer 2: Move with Arrow Keys, attack with L\\n- Mobile: First finger to move, second finger to attack (same as single player)",
    "sourceUrl": "https://gamedistribution.com/games/knife.io/"
  },
  {
    "id": "4a0b780699b44c9cac8dfbda58a0dd04",
    "slug": "my-tiny-market",
    "title": "My Tiny Market",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/4a0b780699b44c9cac8dfbda58a0dd04-512x384.jpg",
    "description": "In My Tiny Market, you're the boss of your very own supermarket. Manage your time and resources well to find the perfect balance between all your tasks: restock shelves, serve customers and keep everything running at full speed!\\n",
    "publisher": "Inlogic Software",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Portuguese",
      "Russian",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-02T11:42:24.182Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Start with a small supermarket and grow it step by step! Take care of everything: from simple tasks like picking tomatoes or feeding chickens to restocking shelves and serving customers at the checkout. Hire employees to speed things up and expand your store to become the ultimate market manager!\\n",
    "sourceUrl": "https://gamedistribution.com/games/my-tiny-market/"
  },
  {
    "id": "aac365d8418b460f80a27e6b1c0e05fa",
    "slug": "neighborhood-defense",
    "title": "Neighborhood Defense",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/aac365d8418b460f80a27e6b1c0e05fa-512x384.jpg",
    "description": "Neighborhood Defense is a dynamic tower defense strategy game where your mission is to protect your neighborhood from waves of zombies. Diverse maps with multiple exits, different types of enemies, and limited tower spots make each match unique. Upgrade your towers, combine their abilities, and plan your tactics carefully to stop the horde and prevent them from breaking through.",
    "publisher": "GameBerry Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-02T08:47:37.217Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "At the start of each level, choose free spots to place towers: archers, bombers, snipers, or electric turrets. Each tower has three upgrade levels that increase damage and attack range. Watch out for zombie waves — warnings will show where they appear. Focus on blocking key paths and managing your resources wisely to hold back stronger enemies. If too many zombies break through the exit, the game is over.",
    "sourceUrl": "https://gamedistribution.com/games/neighborhood-defense/"
  },
  {
    "id": "9dd243c7b2a243e4b9a7f92a23120c45",
    "slug": "brawl-stars-brave-adventure",
    "title": "Brawl Stars Brave Adventure",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/9dd243c7b2a243e4b9a7f92a23120c45-512x384.jpg",
    "description": "Brawl Stars Brave Adventure is a casual battle game designed for brave boys who love fast-paced action and nonstop adventure. Control fearless heroes as you battle enemies, avoid traps, and blast your way through nervous levels. Defeat monsters to constantly upgrade. Choose your skills to ensure your survival or increase your damage! Keep moving to avoid enemy attacks! Complete all levels to win. Get coins to unlock a variety of awesome weapons. Like darts, axes, etc.",
    "publisher": "YAD.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-02T06:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/brawl-stars-brave-adventure/"
  },
  {
    "id": "0efaa39c52bf4579bb21af3ff7bc0ab3",
    "slug": "durak",
    "title": "Durak",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/0efaa39c52bf4579bb21af3ff7bc0ab3-512x384.jpg",
    "description": "Play the classic card game Durak online — a fun mix of strategy and luck that you can enjoy for free on your phone or computer. It’s a well-known Russian card game that challenges you to think fast and play smart. The goal? Don’t be the last one left with cards. With just 36 cards in the deck, every match brings a fresh, dynamic experience.",
    "publisher": "Playgama",
    "languages": [
      "English",
      "French",
      "Italian",
      "Portuguese",
      "Russian",
      "Spanish"
    ],
    "mobile": [],
    "firstActiveDate": "2025-10-02T06:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Durak is played by 2 to 4 players. Total cards used are 36 cards - Only 6 7 8 9 10 J Q K A of all suits are used.",
    "sourceUrl": "https://gamedistribution.com/games/durak/"
  },
  {
    "id": "98c818ecf7ff428f85285d7684c5de93",
    "slug": "cube-to-hole-puzzle",
    "title": "Cube to Hole Puzzle",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/98c818ecf7ff428f85285d7684c5de93-512x512.jpg",
    "description": "Welcome to Cube to Hole Puzzle!\\nGet ready for an exciting and brain-teasing experience! In Cube to Hole Puzzle, your objective is simple: fill the colored cubes into their matching colored holes. But there’s a catch—limited space on the board and only a few slots to move the cubes forward. You’ll need to plan ahead and choose the right cube to move first. Strategize carefully to avoid blocking yourself and clear the board to progress through each level!",
    "publisher": "Bravestars Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-02T06:05:06.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Do you have the skills to solve every puzzle? With increasing difficulty and new challenges at every level, Cube to Hole Puzzle will keep you entertained for hours. ",
    "sourceUrl": "https://gamedistribution.com/games/cube-to-hole-puzzle/"
  },
  {
    "id": "87bdc78edaac4365aa21f3acdfe7791d",
    "slug": "hidden-objects",
    "title": "Hidden Objects",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/87bdc78edaac4365aa21f3acdfe7791d-512x384.jpg",
    "description": "Hidden Objects is a visually stunning puzzle game that challenges your observation skills. Explore beautifully detailed scenes filled with cleverly hidden items. Use hints if needed, but the real reward lies in uncovering every object on your own. Dive into a world of mystery and sharpen your perception.",
    "publisher": "TapNation",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Simple English",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-02T06:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Click on hidden objects and complete the collection",
    "sourceUrl": "https://gamedistribution.com/games/hidden-objects/"
  },
  {
    "id": "716f4ed14dfb4a5fabdebd48ca04d0c3",
    "slug": "ugc-math-race",
    "title": "UGC Math Race",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/716f4ed14dfb4a5fabdebd48ca04d0c3-512x384.jpg",
    "description": "Run fast. Think faster!\\n\\nSolve math problems on the go in this competitive racing game! Choose the correct answer to stay on track, one mistake and you fall. \\n\\nPerfect for players who love speed, smarts, and math.",
    "publisher": "2Play",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-01T12:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "1. Start running on the track.\\n\\n2. A math question appears pick the correct answer by stepping on the right tile.\\n\\n3. Step on the wrong tile and you fall!\\n\\n4. Finish the race to climb Leaderboard\\n",
    "sourceUrl": "https://gamedistribution.com/games/ugc-math-race/"
  },
  {
    "id": "fe3c5c9d90f24f10a9e01cca22f5243f",
    "slug": "italian-brainrot-baby-clicker",
    "title": "Italian Brainrot Baby Clicker",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/fe3c5c9d90f24f10a9e01cca22f5243f-512x384.jpg",
    "description": "Get ready for the cutest twist on the viral Brainrot universe! Italian Brainrot Baby Clicker is the baby-themed sequel to the hit Brainrot Clicker! Tap your way through the baby versions of your favorite characters, collect upgrades, and enjoy a whole new atmosphere with colorful visuals, cheerful music, and fresh sound effects designed to fit the playful baby theme!\\n\\n",
    "publisher": "gameVgames",
    "languages": [
      "Arabic",
      "English",
      "German",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-01T07:59:48.641Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Click or TAP to earn Brainrot Points and use them for upgrades!\\nActivate 2x mode for extra power. \\nIn 2 Player mode, Player 1 taps with \\",
    "sourceUrl": "https://gamedistribution.com/games/italian-brainrot-baby-clicker/"
  },
  {
    "id": "bb65344d29f74da1bd1f41500d8b1dc2",
    "slug": "two-stunt-racers",
    "title": "Two Stunt Racers",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/bb65344d29f74da1bd1f41500d8b1dc2-512x384.jpg",
    "description": "Skid the wheel of a stunning sports car through 3 awesome game modes and showcase your driving skills. Customize your car according to your taste and drive in style with the roaring engines. Feel the heat in 2 player mode where you go head to head with your friend in 2 amazing game modes! Are you ready to conquer the stunt city? Prove yourself with Two Stunt Racers!",
    "publisher": "Fuego! Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-01T07:58:53.975Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Player 1:\\nW,A,S,D: Drive/Steer/Brake\\n\\nPlayer 2:\\nArrow Keys: Drive/Steer/Brake",
    "sourceUrl": "https://gamedistribution.com/games/two-stunt-racers/"
  },
  {
    "id": "93630196f06f465995df303524c3e706",
    "slug": "tales-of-lagoona",
    "title": "Tales of Lagoona",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/93630196f06f465995df303524c3e706-512x384.jpg",
    "description": "Embark on a magical Hidden Object adventure beneath the waves! In Coral Bay, the New Anemone Orphanage is in danger of closing – only you can save it. Search beautiful underwater scenes for hidden treasures, sell your finds at the market, upgrade the orphanage, play 160 mini-games, and take on quests from the townsfolk. Join Islabelle the Mermaid in a heartwarming quest to rescue the orphans!",
    "publisher": "Mad Data",
    "languages": [
      "Dutch",
      "English",
      "French",
      "German",
      "Italian",
      "Portuguese",
      "Spanish",
      "Swedish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-01T07:58:01.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "In each level of this Hidden Object game, search the New Anemone Orphanage for all items on your panel. Explore the sleeping quarters with shell-lined bunks, a coral-trimmed dining room, a bubble-filled kitchen, a pearl-dusted attic, and a porch overlooking shimmering reefs. Cozy yet cluttered with toys, laundry, and sea treasures, each room hides your targets. Use a hint if one stays hidden.",
    "sourceUrl": "https://gamedistribution.com/games/tales-of-lagoona/"
  },
  {
    "id": "4a671eb17a2a44e19b18143242c155fc",
    "slug": "merge-haven",
    "title": "Merge Haven",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/4a671eb17a2a44e19b18143242c155fc-512x384.jpg",
    "description": "Merge items to restore the café to its former glory, uncover hidden secrets, and discover its mysterious past. Start merging today to reveal the café's enchanting story!",
    "publisher": "Clever Apps Pte. Ltd.",
    "languages": [
      "Arabic",
      "Chinese (Simplified)",
      "Dutch",
      "French",
      "German",
      "Italian",
      "Japanese",
      "Korean",
      "Latvian",
      "Polish",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-01T07:48:37.425Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Join Liza in Merge Haven — a cozy merge-2 puzzle adventure! Complete board orders, unlock renovation stages, and uncover family secrets through relaxing, rewarding gameplay.",
    "sourceUrl": "https://gamedistribution.com/games/merge-haven/"
  },
  {
    "id": "f9b693fb35b641d1a39e1141feec3aac",
    "slug": "princess-rescue:-save-girl",
    "title": "Princess Rescue: Save Girl",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/f9b693fb35b641d1a39e1141feec3aac-512x512.jpg",
    "description": "Dive into a heart-pounding quest in Princess Rescue: Save Girl, a thrilling puzzle adventure full of danger, strategy, and fast-paced action! If you're into dragon-themed puzzles that test your reflexes and thinking skills, this is your next favorite game.",
    "publisher": "Bravestars Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-10-01T06:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "In Princess Rescue: Save Girl, your goal is to save the princess from fearsome dragons, cunning traps, and brain-bending puzzles. Whether you're a puzzle lover or a casual gamer, this game delivers high-stakes fun with every level. Do you have what it takes to become the hero and save the day?",
    "sourceUrl": "https://gamedistribution.com/games/princess-rescue:-save-girl/"
  },
  {
    "id": "b8487b142c0d47c68de4e6ced1ab2801",
    "slug": "marble-puzzle-quest",
    "title": "Marble Puzzle Quest",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/b8487b142c0d47c68de4e6ced1ab2801-512x384.jpg",
    "description": "Marble Puzzle Quest is a fun and addictive casual puzzle game where your task is to sort colorful marbles into the correct slots. With each new level, the challenge grows — chains become longer and more colorful, while the space for moves gets tighter. Use logic, plan ahead, and clear the board! Watch out: the marbles fill four slots at the top, and only three of the same color will disappear. Place them incorrectly, and you lose the round.",
    "publisher": "GameBerry Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-30T08:34:19.824Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Each chain of marbles starts and ends with a special ball marked with arrows showing its direction. Drag this ball into the slot of the same color to guide the whole chain. If the chain contains multiple colors, sort the marbles one by one, making sure each finds its matching slot.",
    "sourceUrl": "https://gamedistribution.com/games/marble-puzzle-quest/"
  },
  {
    "id": "75a29a8124a64ef8a407c2d368479fa0",
    "slug": "tung-sahur-bots-chase-room",
    "title": "Tung Sahur Bots Chase Room",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/75a29a8124a64ef8a407c2d368479fa0-512x384.jpg",
    "description": "Horror brainrot bots are on the hunt! Watch out, stay alive!\\n\\nWelcome to Tung Sahur Bots Chase Room – the ultimate brainrot meme horror escape game!\\n\\nGet ready for heart-pounding chases as you find yourself trapped in backroom full of unpredictable Tung Tung Tung Tung Sahur, Tralalero Tralala Bots and other viral meme creatures. Can you keep up with the chaos, dodge the brainrot traps, and make it out alive? Only the fastest runners will escape this nightmare.",
    "publisher": "Bravestars Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-30T08:28:51.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "With Tung Tung Tung Tung Sahur, Bombardiro Crocodilo, and a whole bunch of internet’s wildest memes on your tail, survival is the only goal. Can you outsmart them and escape the maze?",
    "sourceUrl": "https://gamedistribution.com/games/tung-sahur-bots-chase-room/"
  },
  {
    "id": "233db5ed35e349469befd32b73b157a9",
    "slug": "ship-out",
    "title": "Ship Out",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/233db5ed35e349469befd32b73b157a9-512x384.jpg",
    "description": "The harbor’s a mess! Ships of all sizes and colors are stuck in a massive jam. Pay attention to their direction, plan your moves, and clear the chaos! Need help? Use special power-ups to sail through tougher levels.\\n",
    "publisher": "Inlogic Software",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Portuguese",
      "Russian",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-30T07:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Slide the ships to clear the path, but remember: each ship has its own movement rules! As you advance, new ships and challenges appear. Use strategy and clever moves to solve the chaos and progress through the levels.\\n",
    "sourceUrl": "https://gamedistribution.com/games/ship-out/"
  },
  {
    "id": "66888fb5eec54304bc3a5215ccc589ac",
    "slug": "maze-craze",
    "title": "Maze Craze",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/66888fb5eec54304bc3a5215ccc589ac-512x384.jpg",
    "description": "Step into the captivating world of Maze Craze, a puzzle game that combines creativity, humor, and strategic problem-solving. Perfect for puzzle enthusiasts and casual gamers, Maze Craze offers an endless journey through a variety of mazes, each with its own unique set of challenges and surprises.",
    "publisher": "Eyestorm Pte. LTD.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-29T11:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Step into the captivating world of Maze Craze, a puzzle game that combines creativity, humor, and strategic problem-solving. Perfect for puzzle enthusiasts and casual gamers, Maze Craze offers an endless journey through a variety of mazes, each with its own unique set of challenges and surprises. Easy to Control: Simple and intuitive controls ensure that players of all ages can jump right into the action.",
    "sourceUrl": "https://gamedistribution.com/games/maze-craze/"
  },
  {
    "id": "59719ccbc7764864bae2c4c7aea820b6",
    "slug": "tropical-match-2",
    "title": "Tropical Match 2",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/59719ccbc7764864bae2c4c7aea820b6-512x384.jpg",
    "description": "Tropical Match is back with its highly anticipated second sequel! Join your island friend Coco for a colorful Match 3 adventure in a lush tropical paradise. Match juicy fruits, vibrant flowers, and clear away algae and clouds across 1,250+ exciting levels. Complete Daily Missions and discover tropical treasures along the way! With relaxing island tunes and gorgeous scenery, this is the perfect summer escape. Dive in and start your tropical adventure today!",
    "publisher": "SOFTGAMES – Mobile Entertainment Services GmbH",
    "languages": [
      "Dutch",
      "English",
      "French",
      "German",
      "Italian",
      "Polish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-29T08:47:20.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "Swap tropical fruits and flowers to line up three or more of the same kind. Clear them from the board and complete the level’s goal within a limited number of moves. Match four or more for powerful combos and big bonuses! Use boosters to clear tough obstacles. Complete Daily Missions, unlock special quests, and watch your island paradise grow even more beautiful as you progress through over 1,250 sunny, fun-filled levels!",
    "sourceUrl": "https://gamedistribution.com/games/tropical-match-2/"
  },
  {
    "id": "cce096455e0142e6af582c76cb176de4",
    "slug": "tag-run",
    "title": "Tag Run",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/cce096455e0142e6af582c76cb176de4-512x384.jpg",
    "description": "Tag Run is an adrenaline-fueled multiplayer action parkour game where 1–4 local players race to ditch the bomb and be the last standing! Tag opponents, use teleport pads and jump springs, and survive thrilling matches with 6 players. Explore six dynamic maps: Pixel, Winter, Lava, Jungle, Candy, and Night, and packed with creative power-ups. Test your reflexes, strategy, and parkour skills in this fast-paced, chaotic playground challenge.",
    "publisher": "CursoraLabs",
    "languages": [
      "Arabic",
      "English",
      "German",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-29T07:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Player 1: W,A,S,D or ARROW KEYS\\nPlayer 2: ARROW KEYS\\nPlayer 3: T,F,H\\nPlayer 4: I,J,L",
    "sourceUrl": "https://gamedistribution.com/games/tag-run/"
  },
  {
    "id": "9e073556f53549909374d94d231f828e",
    "slug": "dreamy-home",
    "title": "Dreamy Home",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/9e073556f53549909374d94d231f828e-1280x550.jpg",
    "description": "It's not just a game, but a warm and peaceful adventure that helps you feel the magic of ordinary moments.\\nOpening box after box, you will find personal items and lovingly find the perfect place for them. Room by room, step by step, you will assemble mosaics of memories and emotional stories hidden in simple objects.",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-28T15:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "If you are playing on a computer:\\n- Click on an item with the mouse;\\n- Hold down the mouse key and drag the item to the desired location.\\nIf you are playing on a smartphone:\\n- Tap the item with your finger;\\n- Hold your finger on the touchscreen and drag the item to the desired location.\\nThere are also 3 boosters available to you:\\n- Hint (light bulb icon). Sets the item to its correct location;\\n- Freeze. Freezes the timer for 60 seconds;\\n- Compass. Will show the location of any 4 items.",
    "sourceUrl": "https://gamedistribution.com/games/dreamy-home/"
  },
  {
    "id": "da74ea2637b049369d1998357e960f7f",
    "slug": "smashdoll",
    "title": "Smashdoll",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/da74ea2637b049369d1998357e960f7f-512x512.jpg",
    "description": "Smashdoll – Ragdoll Smash Game is a fast and chaotic physics game where you smash through floors, obstacles, and enemies to reach the bottom! Collect coins, dodge bullets, and upgrade your smash power, jump force, and trails.\\n\\nBreak enough floors to charge your smash meter and transform into an unstoppable bullet of destruction. How far can you smash?",
    "publisher": "Qam Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-28T13:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Click, hold, and move the left mouse button to control your character.\\n\\nLet go of your click to do a SMASH!",
    "sourceUrl": "https://gamedistribution.com/games/smashdoll/"
  },
  {
    "id": "89d386a1a15b47a0bb265c404f1aa6de",
    "slug": "fun-mini-games-for-princess",
    "title": "Fun Mini Games For Princess",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/89d386a1a15b47a0bb265c404f1aa6de-512x384.jpg",
    "description": "Welcome to Fun Mini Games For Princess, a collection of mini casual games for kids. Dive into the gaming world and enjoy the fun of playing at your fingertips! Whether you are a casual gamer who looks for relaxation or a skillful player with a purpose, you will find your favorite game and enjoy endless fun in our mini games. Our mini games cover a large range of categories.",
    "publisher": "Yiv.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-28T13:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/fun-mini-games-for-princess/"
  },
  {
    "id": "d071c2d00d4144de82c7f77e034b0778",
    "slug": "autumn-glam-gala",
    "title": "Autumn Glam Gala",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/d071c2d00d4144de82c7f77e034b0778-512x384.jpg",
    "description": "Get ready for the ultimate fall beauty adventure at the Autumn Glam Gala! Help three BFFs create stunning makeup looks for the most anticipated gala of the season. From soft, natural tones to bold, sparkling colors, you’ll have endless fun choosing makeup, hairstyles, and glamorous outfits. Experiment with fall-inspired looks and fashion trends to ensure each girl shines at the gala. Are you ready to showcase your makeup artist skills? Play Autumn Glam Gala now and let the glam begin!",
    "publisher": "Gamerina",
    "languages": [
      "English",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-28T12:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use your mouse to play this game on a desktop, tap to play on mobile devices.",
    "sourceUrl": "https://gamedistribution.com/games/autumn-glam-gala/"
  },
  {
    "id": "f618546bbe6a42b4850156aebb8c202e",
    "slug": "strange-packages",
    "title": "Strange packages",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/f618546bbe6a42b4850156aebb8c202e-512x512.jpg",
    "description": "You wake up alone in an empty apartment where everything seems calm… until the first knock at the door. Nameless parcels, mysterious objects, eerie creatures, and meaningless incantations turn your cozy home into a nightmarish trap.\\n\\nWho is sending you these items — an enemy or a savior?\\nWhy do toys come to life, eyes grow on the walls, and a ceiling-high worm bursts from the bathtub?",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-28T05:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Use your mouse to interact with the world around you.\\n\\nClick on objects, collect clues, use items from your inventory on the scene, and explore the apartment.\\n\\nRead notes, open boxes, play music, and pay attention to hints — every detail could be the key to survival.\\n\\nWarning: many items are unusual and require courage to use. The game features full Russian voice acting to enhance the eerie, mystical atmosphere.",
    "sourceUrl": "https://gamedistribution.com/games/strange-packages/"
  },
  {
    "id": "69953734f7b945618a0479a3db329c8e",
    "slug": "color-hoop-sort",
    "title": "Color Hoop Sort",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/69953734f7b945618a0479a3db329c8e-200x120.jpg",
    "description": "Color Hoop Sort Puzzle Game is a fun and relaxing online puzzle where you sort colorful hoops onto rods. Test your logic and focus as levels get harder! Perfect for all ages, this brain-teasing game will keep you entertained for hours. Play now and see how far you can go!",
    "publisher": "s1interactivestudio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-27T14:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "How to Play:\\nTap a hoop, then tap another pillar to move it.\\nYou can only stack hoops of the same color and if there's space.\\nEach pillar has limited capacity.\\nNo timer, no penalties — relax and enjoy!\\nStuck? Restart anytime!",
    "sourceUrl": "https://gamedistribution.com/games/color-hoop-sort/"
  },
  {
    "id": "2aa46992a4c24c0daf581f7689cddecb",
    "slug": "metaxis",
    "title": "Metaxis",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/2aa46992a4c24c0daf581f7689cddecb-200x120.jpg",
    "description": "In Metaxis, a minimalist puzzle-platformer, if you stop moving, you die. Descend into a black-and-white underworld to save a lost soul, facing Death’s cruel challenge: succeed or stay trapped forever. Cross dangerous, changing isometric levels with quick reflexes and sharp thinking. Every step is a fight between life and death. Your only chance is to keep moving.",
    "publisher": "The Weekend Gamedev",
    "languages": [
      "English"
    ],
    "mobile": [],
    "firstActiveDate": "2025-09-27T12:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "HTML5",
      "Javascript"
    ],
    "instructions": "How to play:\\n\\nReach the end of each level by avoiding deadly traps and solving puzzles. Your helping ability is a short-range teleport, which allows you to cross gaps, dodge enemies, and reposition in the blink of an eye. Learn to master this skill to escape impossible situations. But remember: if you stop moving, Death will take you.\\n\\nControls\\n\\nW, A, S, D: Move\\n\\nSpace: Jump\\n\\nE: Teleport\\n\\nF: Interact\\n\\nM: Level Menu\\n\\nP: Toggle Sound",
    "sourceUrl": "https://gamedistribution.com/games/metaxis/"
  },
  {
    "id": "9a38876695d94bc4afaca71ce3757761",
    "slug": "draw-bridge-puzzle",
    "title": "Draw Bridge Puzzle",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/9a38876695d94bc4afaca71ce3757761-512x512.jpg",
    "description": "Drag to create a path and guide the bike to the goal.\\nTo draw the bridge, you need to line over the open areas and your vehicle will go over them. there will be multiple vehicles in the same level make sure you don't make them collide each other.\\nYou can only draw the line once\\nYou can only draw it once, make sure the bike bridge you create is strong enough. Safety comes first, make sure your bike gets to the finish line safely.",
    "publisher": "Eyestorm Pte. LTD.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-27T12:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Drag to create a path and guide the bike to the goal.\\nTo draw the bridge, you need to line over the open areas and your vehicle will go over them. there will be multiple vehicles in the same level make sure you don't make them collide each other.",
    "sourceUrl": "https://gamedistribution.com/games/draw-bridge-puzzle/"
  },
  {
    "id": "1b57d99609cc4775a30d56c036b8796d",
    "slug": "tap-tap-builder",
    "title": "Tap Tap Builder",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/1b57d99609cc4775a30d56c036b8796d-512x512.jpg",
    "description": "\\",
    "publisher": "GamePush",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Russian",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-27T09:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Want to build a skyscraper? Tap-tap and you're done! Not enough money? Tap-tap and earn some! A fire broke out? Tap-tap and save your people!",
    "sourceUrl": "https://gamedistribution.com/games/tap-tap-builder/"
  },
  {
    "id": "510f69e44889402d821cb969c9f32656",
    "slug": "chinese-food-chef-dudu",
    "title": "Chinese Food Chef DuDu",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/510f69e44889402d821cb969c9f32656-512x384.jpg",
    "description": "Are you a fan of Chinese food? Do you want to discover the mystery of delicious Chinese cuisine? You do not want to miss this cooking game - Chinese Food Chef DuDu. Here, you have the chance to learn different recipes of traditional Chinese food, such as dumplings, rice dumplings, and zongzi. Win the heart of the little monkey with your delicious Chinese food!",
    "publisher": "bestgames.com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-27T08:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/chinese-food-chef-dudu/"
  },
  {
    "id": "2e504b71c34e4288ae38d7f5e6d32f0a",
    "slug": "arrow-survival:-15-seconds",
    "title": "Arrow Survival: 15 Seconds",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/2e504b71c34e4288ae38d7f5e6d32f0a-512x512.jpg",
    "description": "Dodge and shoot to survive 15 seconds! Master 40 levels of arrow chaos in this fast-paced pixel art platformer! \\n\\nDive into Arrow Survival: 15 Seconds, a thrilling 2D pixel art platformer where every second counts! As a skilled archer, your mission is to survive 15 seconds per level by dodging deadly hazards and strategically firing arrows.\\n\\n",
    "publisher": "Low Pixel Byte",
    "languages": [
      "English"
    ],
    "mobile": [],
    "firstActiveDate": "2025-09-27T06:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "GDevelop"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "HTML5",
      "GDevelop"
    ],
    "instructions": "Move: A / D or ← / → \\nJump: W, ↑, or Spacebar \\nShoot Arrows: J or X \\nRestart Level: R \\nPause Game: P",
    "sourceUrl": "https://gamedistribution.com/games/arrow-survival:-15-seconds/"
  },
  {
    "id": "2249f0e134d4428a80eb217ef57cf4e6",
    "slug": "zomblox",
    "title": "Zomblox",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/2249f0e134d4428a80eb217ef57cf4e6-1280x720.jpg",
    "description": "Zomblox is a free FPS shooter in the spirit of CS, Minecraft, and Roblox.\\n\\nSurvive in a school overrun by zombies, catch memes, rescue your friends, and blast the undead in pixelated chaos.\\nWatch out: the teacher has turned into Zombalina Teachrina and is turning everyone into zombies!",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-26T13:23:06.328Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "On PC:\\nWASD — move\\nMouse — look around and shoot\\n1 / 2 / 3 — switch weapons\\n4 — throw a grenade\\n5 — throw a cat\\nE —pick up items\\nR— reload\\nSpace — jump\\nOn mobile:\\nUse the left joystick to move\\nSwipe the right side of the screen to look around\\nTap on-screen buttons to jump, pick up items, and perform other actions",
    "sourceUrl": "https://gamedistribution.com/games/zomblox/"
  },
  {
    "id": "46613925f08d4efeb8cf5501194e29a7",
    "slug": "brainrot-hole",
    "title": "Brainrot Hole",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/46613925f08d4efeb8cf5501194e29a7-512x512.jpg",
    "description": "Brainrot Hole is a fun casual game where you control a hole that sucks in objects. Your task is to guide the hole to eat all the objects and defeat all the Brainrot Enemies . As you progress through the levels, the game gets more challenging with more complex obstacles to avoid. Use your strategy and quick reflexes to become the ultimate Brainrot Hole master!",
    "publisher": "kiz10.com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-26T12:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Use the mouse or touch to guide the hole",
    "sourceUrl": "https://gamedistribution.com/games/brainrot-hole/"
  },
  {
    "id": "69c74bfda0034c2bb724484d5a5876bd",
    "slug": "back-to-school:-uniforms-edition",
    "title": "Back To School: Uniforms Edition",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/69c74bfda0034c2bb724484d5a5876bd-512x384.jpg",
    "description": "Explore global fashion in Back to School: Uniforms Edition! This fun dress-up game lets you spin the wheel to unlock school uniforms from countries like Japan, the U.S., the U.K., India, France, and South Korea. Customize your character with stylish outfits, accessories, and hairstyles inspired by each culture. Dive into the diversity of school uniforms and become a fashion expert while having fun!",
    "publisher": "Gamerina",
    "languages": [
      "English",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-26T12:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Female",
      "Teens",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use your mouse to play the game on a desktop, tap to play on mobile devices.",
    "sourceUrl": "https://gamedistribution.com/games/back-to-school:-uniforms-edition/"
  },
  {
    "id": "e0b9814572714668906ad81a84796350",
    "slug": "big-head",
    "title": "Big Head",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/e0b9814572714668906ad81a84796350-512x384.jpg",
    "description": "Looking for a logic puzzle that’s both smart and funny? Big Head is a mobile maze game that flips classic mazes upside down with creative challenges and comedy. Each tricky puzzle is a brain challenge that makes you think outside the box while enjoying hilarious animations.",
    "publisher": "Eyestorm Pte. LTD.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-26T11:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Every level introduces something fresh secret paths, goofy maze escapes, or silly twists. It’s not just about solving a maze it’s about enjoying a hilarious game full of surprises.",
    "sourceUrl": "https://gamedistribution.com/games/big-head/"
  },
  {
    "id": "b3bbf5afebc24bcd8f1d9e0faacab71b",
    "slug": "sausage-flip-free",
    "title": "Sausage Flip Free",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/b3bbf5afebc24bcd8f1d9e0faacab71b-1280x550.jpg",
    "description": "In Sausage Flip Free, you're not just any sausage. You’re a daring, bouncy hero on a mission to overcome wild levels full of danger, timing, and precision! This action, casual game blends goofy fun with real skill challenges! Tap to launch your sausage with a perfect flip! Launch the sausage on the vine and keep moving to the next pot or shelf, etc. Use your perfect skills to master each tricky obstacle. Cross the finish line to win.",
    "publisher": "YAD.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-26T09:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/sausage-flip-free/"
  },
  {
    "id": "f2d91c8a392342a397abc1942912c67c",
    "slug": "snake-out",
    "title": "Snake Out",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/f2d91c8a392342a397abc1942912c67c-512x384.jpg",
    "description": "Dive into Snake Out – a vibrant puzzle adventure packed with fun and challenges! ?✨ Sharpen your skills, conquer tricky stages, and enjoy endlessly rewarding gameplay. Ideal for casual gamers and puzzle lovers alike! ?",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-25T12:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Control Snakes of different colors and lengths, and guide them to their holes before time runs out.\\nWith intuitive drag and move mechanic, each level offers a unique challenge to test your strategic thinking.",
    "sourceUrl": "https://gamedistribution.com/games/snake-out/"
  },
  {
    "id": "b495c95f02914d67b7e9f46878f6f26c",
    "slug": "monster-arena",
    "title": "Monster Arena",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/b495c95f02914d67b7e9f46878f6f26c-512x384.jpg",
    "description": "Be the longest monster ever! Beat out your rival monsters by eating fruits and grows. This snake io game let you roam free, grow large, and finish your enemies by making them crash into you. Be the king of the island!",
    "publisher": "Bravestars Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-25T11:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "- Select the island.\\n- Drag to move your monster.\\n- Eat fruits to grow larger.\\n- Dodge incoming rival monsters.\\n- Be the first monster to reach 100%.",
    "sourceUrl": "https://gamedistribution.com/games/monster-arena/"
  },
  {
    "id": "754a3153c5964afe918325052fa17419",
    "slug": "halloween-fruit-slice",
    "title": "Halloween Fruit Slice",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/754a3153c5964afe918325052fa17419-512x384.jpg",
    "description": "Halloween Fruit Slice is a high-energy arcade action game set in a spooky Halloween world. Vivid fruits and devious traps streak across the screen in an instant. Your task is to slice as many fruits as possible with lightning speed, chaining spectacular combos and racking up points while dodging explosive bombs. Rich visuals, splashy juice effects, and eerie backdrops create a thrilling, immersive atmosphere. The tempo keeps rising, so every moment tests your reflexes and precision.",
    "publisher": "GameBerry Studio",
    "languages": [
      "English",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-25T09:46:49.131Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Swipe across the screen or move your mouse to slash with your blade. Each clean cut adds points, and rapid successive strikes build powerful combos to boost your score. Miss a fruit or hit a bomb and your streak breaks, so stay sharp and refine your strategy. Maintain your rhythm and speed to push your final score ever higher.",
    "sourceUrl": "https://gamedistribution.com/games/halloween-fruit-slice/"
  },
  {
    "id": "ae42ea5c4e0b4ff4b9eddf47fbd2cc5e",
    "slug": "marble-run-ultimate-race!",
    "title": "Marble Run - Ultimate Race!",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/ae42ea5c4e0b4ff4b9eddf47fbd2cc5e-512x384.jpg",
    "description": "Race, roll, and clash in Marble Run, the ultimate marble racing game! Guide your marble through physics-based tracks, dodge obstacles, knock rivals off the edge, and aim for the finish line. \\n\\nWith fast-paced races, competitive knockout rounds, and fun marble skins, it’s the most addictive 3D marble runner you’ll play!",
    "publisher": "Sunday GmbH",
    "languages": [
      "Chinese (Simplified)",
      "English",
      "French",
      "German",
      "Hindi",
      "Indonesian",
      "Japanese",
      "Korean",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish",
      "Vietnamese"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-25T06:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Swipe or tilt to control your marble, avoid traps, push opponents off, and race to the finish without falling!",
    "sourceUrl": "https://gamedistribution.com/games/marble-run-ultimate-race!/"
  },
  {
    "id": "3e88933d9b3d4e0b95b2356d978c32e1",
    "slug": "stickman-rocket",
    "title": "Stickman Rocket",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/3e88933d9b3d4e0b95b2356d978c32e1-512x512.jpg",
    "description": "You have a powerful cannon loaded with Stickman Ragdols which you must shoot far to reach your target! Solve all kinds of challenges as you collect gems, avoid obstacles and control your throws to reach the targets in each level. Try not to bump into obstacles along the way and use all the raggedy characters you need to have fun with these amazing challenges - good luck! ",
    "publisher": "kiz10.com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-24T10:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Use the mouse or touch to aim and shoot",
    "sourceUrl": "https://gamedistribution.com/games/stickman-rocket/"
  },
  {
    "id": "ae61bf1a3a834b238384329766580768",
    "slug": "murderers-vs-sheriffs-duels",
    "title": "Murderers VS Sheriffs Duels",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/ae61bf1a3a834b238384329766580768-512x512.jpg",
    "description": "Love Roblox-style action games? Get ready for the ultimate showdown!\\n\\nJump into fast-paced 1v1, 2v2, 3v3, and 4v4 duels where every second counts. Play as a Murderer or a Sheriff, master unique abilities, and outplay your enemies in style.\\n\\nIf you enjoy games like Murder Mystery or Arsenal in Roblox, this is made for you!",
    "publisher": "2Play",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-24T09:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "1. Choose a mode – Solo (1v1) or Team Duels (2v2, 3v3, 4v4).\\n2. You're randomly assigned as a Murderer or Sheriff.\\n3. Use your abilities wisely – each role has unique powers.\\n4. Eliminate the enemy team before they take you out.\\n5. Win matches to earn rewards, unlock skins, and level up!",
    "sourceUrl": "https://gamedistribution.com/games/murderers-vs-sheriffs-duels/"
  },
  {
    "id": "60f0c13b4bbc412eb0c3bb9479f10fc4",
    "slug": "queens-royal:-sudoku-puzzle",
    "title": "Queens Royal: Sudoku Puzzle",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/60f0c13b4bbc412eb0c3bb9479f10fc4-512x384.jpg",
    "description": "Queens Royal: Sudoku Puzzle reimagines the classic eight queens challenge into a sleek logic game with over 5,000 levels. Place queens strategically so none share a row, column, or color zone while avoiding attacks in all directions. With elegant visuals, daily challenges, endless mode, and smart hints, every puzzle offers a unique test of reasoning and precision for players who enjoy refined brain-teasers.",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-24T07:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Your goal is to position one queen in each row, column, and color zone on the grid without letting any two queens attack one another—even diagonally. Each puzzle has exactly one solution, so every move requires careful reasoning rather than guesswork. Start by analyzing available safe spots, then place queens strategically to avoid conflicts. If you get stuck, use hints for subtle guidance without revealing the full solution.",
    "sourceUrl": "https://gamedistribution.com/games/queens-royal:-sudoku-puzzle/"
  },
  {
    "id": "3a0e41cb80d041e5bd058bc1bc7bb273",
    "slug": "sea-lords",
    "title": "Sea Lords",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/3a0e41cb80d041e5bd058bc1bc7bb273-512x384.jpg",
    "description": "Set sail for success in Sea Lords - the fun idle tycoon simulation game where you're the master of the seas. Start with a small fishing port and gradually build your global shipping empire! Manage ships, upgrade docks, hire captains, and automate your logistics as you conquer new routes and earn riches - even while you're offline! It's time to prove your skills as the next sea lord! Buy and upgrade ships to boost your delivery speed and cargo capacity.",
    "publisher": "YAD.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-24T06:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/sea-lords/"
  },
  {
    "id": "724fead0a2f8417986c03173ea1ef35e",
    "slug": "dynamons-7",
    "title": "Dynamons 7",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/724fead0a2f8417986c03173ea1ef35e-512x384.jpg",
    "description": "Embark on a brand new Dynamons adventure in Dynamons 7! This online monster collecting game includes two fresh areas to explore; Tall Pines world and the bonus cave.\\n\\nSeasoned Dynamons connoisseur Jovani will tell you everything you need to know to become a true Dynamon Captain. Encounter Crocynos, Huango, Cybeenyx, Aragonyx and many more special Dynamons. Recruit them for your team and beat others in thrilling 1v1 battles with special attacks and power-ups.",
    "publisher": "Azerion Casual Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-23T12:50:08.624Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Play the game using touchscreen controls or your mouse.\\n\\nThe game consists of spellbinding turn-based battles. You can use the action cards to attack, and catch the opposing creature when it’s weakened. The backpack is filled with items you can collect and use during your journeys. By selecting it during battle, you can access these special items. Use shards to level up your Dynamons, and to gain new action cards. Challenge other trainers and become the strongest Dynamon Captain!",
    "sourceUrl": "https://gamedistribution.com/games/dynamons-7/"
  },
  {
    "id": "ba08d794f5c84775b848781e70497849",
    "slug": "3dash",
    "title": "3Dash",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/ba08d794f5c84775b848781e70497849-512x512.jpg",
    "description": "3Dash is a fast-paced 3D rhythm platformer inspired by Geometry Dash—dash, jump, and flip through dizzying, rotating tracks while keeping perfect time. Tackle six hand-crafted levels, then build your own with the level editor for endless replay",
    "publisher": "Royale Gamers",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-23T11:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Space/RMB/Mouse-Click to jump",
    "sourceUrl": "https://gamedistribution.com/games/3dash/"
  },
  {
    "id": "40e3d57bd45f47e493f9324a537ba71c",
    "slug": "3d-acrylic-nail:-nail-art-game",
    "title": "3D Acrylic Nail: Nail Art Game",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/40e3d57bd45f47e493f9324a537ba71c-512x512.jpg",
    "description": "3D Acrylic Nail: Nail Art Game lets you become the ultimate nail artist! Step into your very own nail salon where creativity has no limits. Design stunning acrylic nails with trendy styles, vibrant colors, and charming accessories. Satisfy your customers' unique requests, earn money, and upgrade your salon to become the best nail stylist in town!",
    "publisher": "Bravestars Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-23T10:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Run your own nail salon and serve customers with unique design requests.\\nUse stylish nail polishes, cute charms, and sleek acrylic nail designs to impress.\\nEarn money from happy customers and upgrade your salon with new tools and decor!",
    "sourceUrl": "https://gamedistribution.com/games/3d-acrylic-nail:-nail-art-game/"
  },
  {
    "id": "1f9b60ba0bc64da2b082fcc8aa4b5100",
    "slug": "galaxy-clicker",
    "title": "Galaxy Clicker",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/1f9b60ba0bc64da2b082fcc8aa4b5100-512x384.jpg",
    "description": "Explore space in Galaxy Clicker, a free online game where you travel through galaxies with just a click. Play on your phone or computer and enjoy a relaxing space adventure that tests your strategy while keeping you entertained.",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-23T09:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Hold the left mouse button or tap to make the planets revolve faster.",
    "sourceUrl": "https://gamedistribution.com/games/galaxy-clicker/"
  },
  {
    "id": "828f432b9cdd4b55a2bed671d5cea9e4",
    "slug": "3d-block-gladiator:-sword-draw",
    "title": "3D Block Gladiator: Sword Draw",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/828f432b9cdd4b55a2bed671d5cea9e4-512x512.jpg",
    "description": "Sketch Your Path to Fight and Become the Ultimate Champion!\\n\\nStep into the gladiator arena where only the strongest and smartest warriors survive! In 3D Block Gladiator: Sword Draw, you don’t just fight—you draw your attacks and dodges, controlling your gladiator’s every move with precision. Swipe, slash, and outmaneuver your enemies to claim victory!",
    "publisher": "Bravestars Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-23T09:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Your sword skills are in your hands—literally! Draw lines on the screen to determine your gladiator’s movement, dodge incoming strikes, and land the perfect attack. Timing and strategy are key—one wrong move and you're down!",
    "sourceUrl": "https://gamedistribution.com/games/3d-block-gladiator:-sword-draw/"
  },
  {
    "id": "8882384211dd4d2ca5d76131554a6812",
    "slug": "halloween-merge-mania",
    "title": "Halloween Merge Mania",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/8882384211dd4d2ca5d76131554a6812-512x384.jpg",
    "description": "Halloween Merge Mania is a fast-paced casual game with a fun Halloween vibe. Cute monster balls—pumpkins, black cats, mummies, vampires, and other iconic characters—appear on the screen. Your task is to merge identical creatures to create new, rarer, and more valuable ones. Each successful merge unlocks the next level of spooky yet adorable monsters, while the dark background and vivid graphics immerse you in the festive autumn atmosphere. ",
    "publisher": "GameBerry Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-23T09:09:50.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Drag or drop the falling monster heads onto the board, aiming to place identical ones next to each other. When two matching figures touch, they combine into a new, stronger character. Watch the “next monster” indicator to plan your moves and free up space strategically. Use your mouse or tap the screen—controls are simple and intuitive.\\nThe goal is to last as long as possible, cleverly merging characters and unlocking increasingly rare monsters to achieve the highest score.",
    "sourceUrl": "https://gamedistribution.com/games/halloween-merge-mania/"
  },
  {
    "id": "c18628dc38904a5c8da49c7ba330d93b",
    "slug": "driverz-ed",
    "title": "Driverz Ed",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/c18628dc38904a5c8da49c7ba330d93b-512x384.jpg",
    "description": "Driverz Ed invites you into an open-world driving adventure where exploration meets discovery. Collect hidden puzzle pieces scattered across diverse locations, unlock a wide selection of cars, and complete missions that blend racing with strategy. With free exploration, fast travel, and mission tracking, the game delivers a fresh take on the driving genre while keeping every ride exciting and unpredictable.",
    "publisher": "Playgama",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-23T08:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Control your car with WASD or Arrow keys and adjust the view with the mouse. Explore the world to uncover puzzle pieces and unlock new cars. Press “G” for fast travel to the race start, “M” to check missions, and “P” to pause or adjust settings. The goal is to discover, race, and collect while mastering both speed and strategy across different challenges.",
    "sourceUrl": "https://gamedistribution.com/games/driverz-ed/"
  },
  {
    "id": "543726ab6de449acad2444f1ae66b492",
    "slug": "knife-madness",
    "title": "Knife Madness",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/543726ab6de449acad2444f1ae66b492-512x384.jpg",
    "description": "Aim, throw and survive! Watch out — avoid hitting other blades. The spinning wheel gets faster, the stakes get higher and only your quick reflexes will keep you in the game. Can you defeat the boss levels and unlock epic knife skins? The challenge is on!\\n",
    "publisher": "Inlogic Software",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Portuguese",
      "Russian",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-23T07:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "The goal of the game is to throw knives onto a spinning wheel, avoiding those already placed. Aim carefully and use your precision to hit empty spots. Each level brings more knives, faster speeds and increased difficulty.\\n",
    "sourceUrl": "https://gamedistribution.com/games/knife-madness/"
  },
  {
    "id": "6de7fe918ed24506a45f8047a16bff72",
    "slug": "bubble-shooter-neon",
    "title": "Bubble Shooter Neon",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/6de7fe918ed24506a45f8047a16bff72-512x384.jpg",
    "description": "Bubble Shooter Neon brings vibrant neon colors and exciting bubble-popping action! Match and pop glowing bubbles before they reach the bottom—new rows appear every 15 seconds, so stay focused! With sleek, modern visuals and fast-paced gameplay, it’s perfect for bubble shooter fans and casual players alike. Sharpen your aim, beat the clock, and enjoy the glowing thrill of Bubble Shooter Neon!",
    "publisher": "SOFTGAMES – Mobile Entertainment Services GmbH",
    "languages": [
      "Dutch",
      "English",
      "German",
      "Italian",
      "Polish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-22T09:09:07.384Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "Aim and shoot bubbles to match 3 or more of the same color and clear them from the board. Use the arrow to line up your shot. You’ll see your current bubble and the next one in the lower left—use this to plan strategic swaps. Hitting matches clears bubbles, but missed shots add new rows every 15 seconds, pushing the stack down. Keep the board clear and don’t let the bubbles reach the bottom, or the game will end!",
    "sourceUrl": "https://gamedistribution.com/games/bubble-shooter-neon/"
  },
  {
    "id": "01b599eae87a466d994fe9ba12cca55f",
    "slug": "home-run-boy",
    "title": "Home Run Boy",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/01b599eae87a466d994fe9ba12cca55f-512x384.jpg",
    "description": "There is a boy who wants to become a home run king.\\nHe's been practicing his batting and his dream is to hit the ball to the end of the world.\\nHit the ball, build up your strength, and hit it farther and farther!",
    "publisher": "MOVISOFT.Co.,Ltd",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-22T08:04:45.919Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Stop the arrow at the center of the at-bat gauge.\\nFor mobile, you can stop the arrow by touching the screen,\\nand for PC, click the left mouse button.",
    "sourceUrl": "https://gamedistribution.com/games/home-run-boy/"
  },
  {
    "id": "1669d535753248c39bee2cbf6746f2e5",
    "slug": "zombie-road:-shooter-with-destruction",
    "title": "Zombie Road: Shooter with Destruction",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/1669d535753248c39bee2cbf6746f2e5-512x512.jpg",
    "description": "Grandpa is eager for adventure again! Survive in a harsh zombie world. This time, Grandpa has to save the world from evil zombies. Zombies can drive and shoot! And Grandpa can destroy evil spirits! Fight the most dangerous mutants. Buy cool guns, find unique attachments, assemble your own unique gun and go into battle! Many locations, go through the whole world, from hot deserts to sea battles!",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-21T14:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "To win, you need to destroy your pursuers.\\nControls Mobile:\\nTouch the screen and move it to aim, shooting will start automatically. \\nPC:\\nShooting: left mouse button Sight: right mouse button Sight control: by moving the mouse Weapon switching: 1, 2, 3, 4 Reload - R",
    "sourceUrl": "https://gamedistribution.com/games/zombie-road:-shooter-with-destruction/"
  },
  {
    "id": "bfaef70799794d38b92ebb9ca7dce162",
    "slug": "pixel-blast",
    "title": "Pixel Blast",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/bfaef70799794d38b92ebb9ca7dce162-512x384.jpg",
    "description": "Pixel Blast is a colorful online arcade game that mixes classic gameplay with modern design. Play for free on your phone or computer and enjoy smooth controls and vibrant pixel art. It’s easy to pick up and fun for players of all ages.",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-21T13:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Getting started with Pixel Blast is simple. Begin by launching the game on your preferred device. Use your mouse or tap and slide on your touchscreen to control your character. Your objective is to maneuver through various levels while avoiding obstacles and collecting bonuses.",
    "sourceUrl": "https://gamedistribution.com/games/pixel-blast/"
  },
  {
    "id": "4b89e6d06e474c0eb5d933a30972b36e",
    "slug": "ball-jump-switch-the-colors",
    "title": "Ball Jump Switch The Colors",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/4b89e6d06e474c0eb5d933a30972b36e-512x384.jpg",
    "description": "Tap on the screen, that will make the ball bounce higher and higher. The ball has one color, and can pass through obstacle with the same color, or sneak in between obstacles with different colors.\\n\\nEasy-to-play and addictive !",
    "publisher": "SecGame",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-21T13:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 2"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Construct 2"
    ],
    "instructions": "- Tap to make the ball bounce higher and higher \\n- Pass through obstacles matching the ball's color \\n- Sneak between obstacles with different colors \\n- Avoid mismatched obstacles to keep bouncing ",
    "sourceUrl": "https://gamedistribution.com/games/ball-jump-switch-the-colors/"
  },
  {
    "id": "4cc02f6491cf40fb85abc4f3c160f203",
    "slug": "phantom-thief-cat-running",
    "title": "Phantom thief Cat Running",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/4cc02f6491cf40fb85abc4f3c160f203-512x384.jpg",
    "description": "Avoid obstacles and reach the goal! Tap to change direction, and the game ends when your stamina reaches zero. Pick up items to increase your score or restore stamina. Collect three stars to enter Invincible Mode. Fish bones reduce stamina, but collecting ten turns coins into high-scoring diamonds for a short time!",
    "publisher": "Synk Inc.",
    "languages": [
      "English",
      "Japanese"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-21T12:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Tap to change direction.",
    "sourceUrl": "https://gamedistribution.com/games/phantom-thief-cat-running/"
  },
  {
    "id": "6e6a0711d38e45759a7410a16f60bde8",
    "slug": "bubble-shooter-hawaii",
    "title": "Bubble Shooter Hawaii",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/6e6a0711d38e45759a7410a16f60bde8-512x512.jpg",
    "description": "Bubble Shooter Hawaii is a bubble shooter game with a hawaii theme and classic gameplay combined with special bubble mechanics. It's unique level map will guide you to the challenging levels with unique bubbles like the horizontal row destroyer, the rocks or the hidden bubbles.",
    "publisher": "Bubble Shooter",
    "languages": [
      "Dutch",
      "English",
      "French",
      "German",
      "Italian",
      "Polish",
      "Portuguese",
      "Spanish",
      "Swedish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-21T12:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Mouse: Click to shoot the bubble.\\nMobile: Touch and release to shoot the bubble.",
    "sourceUrl": "https://gamedistribution.com/games/bubble-shooter-hawaii/"
  },
  {
    "id": "c9b68fc0a50d4085ba406292b1a06470",
    "slug": "alien-wreckage-1",
    "title": "Alien Wreckage 1",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/c9b68fc0a50d4085ba406292b1a06470-512x512.jpg",
    "description": "In \\",
    "publisher": "Catom Games",
    "languages": [
      "English"
    ],
    "mobile": [],
    "firstActiveDate": "2025-09-21T12:45:06.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Teens",
      "YoungAdults",
      "Adults",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Controls:\\nWASD : Move\\nX or C : Shoot\\nM : Open map\\nT: Show Stats\\nP / ESC : Pause / Unpause game\\n",
    "sourceUrl": "https://gamedistribution.com/games/alien-wreckage-1/"
  },
  {
    "id": "0a2c06c9f7df4a2f9035b221674cf5fb",
    "slug": "forest-glade-mysteries",
    "title": "Forest Glade Mysteries",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/0a2c06c9f7df4a2f9035b221674cf5fb-512x384.jpg",
    "description": "Immerse yourself in the world of Forest Glade Mysteries — a magical forest where the cutest animals live! Each level introduces you to new fluffy friends and exciting challenges. This forest is full of mysteries, and every step brings you closer to uncovering ancient secrets!",
    "publisher": "H5 Games",
    "languages": [
      "Arabic",
      "English",
      "German",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-21T12:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Match animals",
    "sourceUrl": "https://gamedistribution.com/games/forest-glade-mysteries/"
  },
  {
    "id": "54ae0c6997124ee1b169b42405ffcba8",
    "slug": "traitor-beaver!",
    "title": "Traitor Beaver!",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/54ae0c6997124ee1b169b42405ffcba8-512x512.jpg",
    "description": "Beaver Traitor! An exciting game where one player takes on the role of the traitor, while the other players act as regular participants. Your goal as the traitor is to secretly kill all the other players, sabotaging their tasks at the nuclear power plant. You'll need to be cunning, careful, and think strategically to avoid detection and achieve victory. Use various tactics and deception to reach your goals.",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-21T10:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Control on PC:\\nMovement: Keyboard arrows or keys:\\nW (up), A (left), S (down), D (right).\\nAttack: Spacebar or on-screen button.\\nJump into hatch: F key or on-screen button.\\n\\nOn mobile devices:\\nControl using a virtual joystick and on-screen buttons.",
    "sourceUrl": "https://gamedistribution.com/games/traitor-beaver!/"
  },
  {
    "id": "b06e1ebff45240f6b5bd3084f38e89ad",
    "slug": "blankets",
    "title": "Blankets",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/b06e1ebff45240f6b5bd3084f38e89ad-512x384.jpg",
    "description": "Put together cozy blanket pieces with the same colors and patterns to make them disappear and keep your board nice and neat!\\nWith soft colors and a calm, happy feel, Blankets is great for kids who like fun puzzles without too much stress.\\n\\nCan you build the coziest blanket and get the best score in Blankets?",
    "publisher": "BlackMoon Design",
    "languages": [
      "No Text"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-21T09:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Use A and D keys to move left and right. Use S key to drop the tile. \\nOn mobile you can swipe left/right/down. ",
    "sourceUrl": "https://gamedistribution.com/games/blankets/"
  },
  {
    "id": "e70be762f60c4643b46978198a3108e1",
    "slug": "through-the-wall",
    "title": "Through The Wall",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/e70be762f60c4643b46978198a3108e1-512x512.jpeg",
    "description": "Move THROUGH THE WALL! Collect the diamonds to unlock new skins for your blocks. Make no mistakes and try to fit in the hole.",
    "publisher": "Azerion Casual Games",
    "languages": [],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2019-04-25T08:48:51.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "PixiJS"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "PixiJS"
    ],
    "instructions": "Move left or right by touching, clicking or using the left or right arrow keys on your keyboard.",
    "sourceUrl": "https://gamedistribution.com/games/through-the-wall/"
  },
  {
    "id": "4767c882290e4962ba89d4dee7460d65",
    "slug": "swim-good",
    "title": "Swim Good",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/4767c882290e4962ba89d4dee7460d65-512x384.jpg",
    "description": "Chomp your way through a swirling feast of worms while dodging deadly spiky firing urchins! Stay alive, keep circling, and see how long you can last.",
    "publisher": "LetiArts",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-21T06:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Left-click/Tap on the on-screen button.",
    "sourceUrl": "https://gamedistribution.com/games/swim-good/"
  },
  {
    "id": "1cfafb9f22ee44399c4efa93f97ff9d5",
    "slug": "draw-a-path-to-the-finish-line!",
    "title": "Draw a path to the finish line!",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/1cfafb9f22ee44399c4efa93f97ff9d5-512x384.jpg",
    "description": "Draw a path and lead your character to the finish line! Use your creativity and planning to avoid obstacles and reach your goal. Whether you're playing on a computer or phone, this fun puzzle game is all about finding smart and artistic ways to win. Great for all ages!",
    "publisher": "Playgama",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-20T14:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Getting started with Draw a Path to the Finish Line is simple. On a computer, use your mouse to draw a line from the starting point to the finish line. On a mobile device, use your finger to achieve the same effect. Be mindful of obstacles such as mines, which can restart the level if encountered. The goal is to create a seamless path that safely guides your character to the end.",
    "sourceUrl": "https://gamedistribution.com/games/draw-a-path-to-the-finish-line!/"
  },
  {
    "id": "60161dd3c2dc4fda92d23365cf9d0cff",
    "slug": "tile-match-cafe",
    "title": "Tile Match Cafe",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/60161dd3c2dc4fda92d23365cf9d0cff-200x120.jpg",
    "description": "Discover the engaging tile-matching puzzle game that plunges you into a world of triple-tile tapping challenges and stimulating fun.\\n\\nPrepare yourself for an exciting adventure filled with complex puzzles as you match tiles, clear the boards, and strive to become the top tile master.\\n\\nWith its intuitive mechanics and addictive gameplay, Tile Match Cafe is an ideal pick for fans of tile-matching games seeking a charming and rewarding puzzle experience.",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-20T14:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Match 3 identical tiles to destroy them!\\nCompete with other players and get rewards!",
    "sourceUrl": "https://gamedistribution.com/games/tile-match-cafe/"
  },
  {
    "id": "760aa10dee0d47d085b0d8c80d185548",
    "slug": "tricky-challenges:-mini-games",
    "title": "Tricky Challenges: Mini Games",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/760aa10dee0d47d085b0d8c80d185548-512x384.jpg",
    "description": "Only 5% will pass all the Challenges! Ready to test your reactions and wit? Take the challenge and prove that you are better than thousands of bloggers!\\n\\n✨ \\",
    "publisher": "Welwise Studio",
    "languages": [
      "English",
      "German",
      "Japanese",
      "Russian",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-20T09:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "✨ Just tap, tap, tap to overcome each challenge! All the mechanics are intuitive, and each level contains management tips.\\n\\n❤️Test your reflexes, creativity and accuracy in many viral challenges!",
    "sourceUrl": "https://gamedistribution.com/games/tricky-challenges:-mini-games/"
  },
  {
    "id": "f5757999ce0a439fb8970f282a56c5cc",
    "slug": "goon-ball",
    "title": "Goon Ball",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/f5757999ce0a439fb8970f282a56c5cc-512x384.jpg",
    "description": "Fast-paced, two-player game where players try to control a \\",
    "publisher": "CK's Games",
    "languages": [
      "English"
    ],
    "mobile": [],
    "firstActiveDate": "2025-09-20T07:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Teens",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Hit the Goon Ball to paint the floor your color! Bump the other player to stun them. Cover the most ground in 90 seconds to win!",
    "sourceUrl": "https://gamedistribution.com/games/goon-ball/"
  },
  {
    "id": "9cdad5a9a02b4a6daec83566092951ff",
    "slug": "square-punki-long-hand",
    "title": "Square Punki Long Hand",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/9cdad5a9a02b4a6daec83566092951ff-512x384.jpg",
    "description": "Ever wondered what life would be like with super long arms? In Square Punki Long Hand, you get to experience just that! This unique puzzle game challenges you to stretch, grab, prank, and solve hilarious puzzles using your extra-long limbs. Whether you're rescuing trapped characters, reaching impossible places, or pulling off mischievous tricks, every level is filled with surprises and laughter!",
    "publisher": "Eyestorm Pte. LTD.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-20T07:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "- Stretch your arms to interact with objects and characters.\\n- Solve puzzles creatively—no single solution exists!\\n- Navigate tricky obstacles and use logic to outsmart challenges.\\n- Watch funny animations unfold as you complete each level!",
    "sourceUrl": "https://gamedistribution.com/games/square-punki-long-hand/"
  },
  {
    "id": "6f38d609768747a692974c6ef97b2514",
    "slug": "block-parkour-trials",
    "title": "Block Parkour Trials",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/6f38d609768747a692974c6ef97b2514-512x384.jpg",
    "description": "Block Parkour Trials is a super fun and free-to-play parkour game. Your goal is to reach the portal at the finish line by skillfully jumping over obstacles. Have fun and enjoy the challenge!",
    "publisher": "Vi Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-20T06:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "WASD or Arrow keys to walk and right mouse click or SPACE to jump.",
    "sourceUrl": "https://gamedistribution.com/games/block-parkour-trials/"
  },
  {
    "id": "a9f59998c10542ee9ab5d6311a7b4aec",
    "slug": "jigsaw-fantasy",
    "title": "Jigsaw Fantasy",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/a9f59998c10542ee9ab5d6311a7b4aec-512x384.jpg",
    "description": "Jigsaw Fantasy is the perfect game for puzzle lovers! Choose from a wide collection of puzzles, each offering a relaxing and fun experience. Want a personal touch? Upload your family photos and turn them into custom puzzles. Simply drag and drop the scattered pieces into place to complete the image. With intuitive controls and a clean interface, Jigsaw Fantasy is great for kids and adults alike. ",
    "publisher": "GamePush",
    "languages": [
      "Arabic",
      "Chinese (Simplified)",
      "English",
      "French",
      "German",
      "Hindi",
      "Indonesian",
      "Italian",
      "Japanese",
      "Korean",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-19T13:58:49.975Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Choose a Puzzle\\nBrowse the puzzle gallery and select one to begin. You can also upload a photo to create your own custom puzzle.\\n\\nStart Assembling\\nThe puzzle pieces will appear scattered. Your goal is to place each piece in the correct position to complete the image.\\n\\nDrag and Drop\\nClick or tap a piece, drag it to where it fits, and release to place it. Keep going until the full picture is complete!\\n\\nEnjoy and Replay\\nOnce completed, try another puzzle or create a new one for endless fun!",
    "sourceUrl": "https://gamedistribution.com/games/jigsaw-fantasy/"
  },
  {
    "id": "13704aa4f1d84d7e8834db56c23ddeae",
    "slug": "fluffy-mania",
    "title": "Fluffy Mania",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/13704aa4f1d84d7e8834db56c23ddeae-512x384.jpg",
    "description": "Step into the charming world of Fluffy Mania, where bright, fluffy creatures are ready to test your puzzle-solving skills. This online game combines adorable visuals with clever gameplay, creating a fun and relaxing challenge. Play on desktop or mobile and dive into colorful levels full of lovable characters. Connect matching creatures, score points, and climb through progressively tricky stages.",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-19T13:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Get started by clicking on any fluffy animal and dragging your cursor to connect it with others of the same color. Release to form a chain. The longer the chain, the more points you earn. Complete the objectives for each level to progress further. Use your mouse on a computer or swipe on your phone to make connections.",
    "sourceUrl": "https://gamedistribution.com/games/fluffy-mania/"
  },
  {
    "id": "4bc3f6649cb7482392611ad1c4167c32",
    "slug": "spooky-chains",
    "title": "Spooky Chains",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/4bc3f6649cb7482392611ad1c4167c32-512x384.jpg",
    "description": "Spooky Chains is a fun Halloween puzzle game. Tap a tile and drag through matching nearby items to make a chain of 3 or more. The items vanish, and the tiles turn golden. Your goal is to turn all tiles golden. Sometimes a Flying Witch glides across the board. Tap her while she flies to watch a reward ad. After the ad, she blasts some tiles into golden. You can also watch a reward ad to remove the timer and play without time pressure.",
    "publisher": "Lof Games",
    "languages": [
      "Arabic",
      "Bulgarian",
      "Chinese (Simplified)",
      "Czech",
      "Danish",
      "Dutch",
      "English",
      "Estonian",
      "Finnish",
      "French",
      "German",
      "Greek",
      "Hebrew",
      "Hindi",
      "Hungarian",
      "Indonesian",
      "Italian",
      "Japanese",
      "Korean",
      "Latvian",
      "Lithuanian",
      "Norwegian (Nynorsk)",
      "Polish",
      "Portuguese",
      "Romanian",
      "Russian",
      "Serbian",
      "Simple English",
      "Slovak",
      "Spanish",
      "Swahili",
      "Swedish",
      "Tagalog",
      "Thai",
      "Turkish",
      "Ukrainian",
      "Vietnamese"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-19T13:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use a mouse or touchpad to play this game.",
    "sourceUrl": "https://gamedistribution.com/games/spooky-chains/"
  },
  {
    "id": "aada1dda0c9f404187438b121d48b644",
    "slug": "isometric-escape-2",
    "title": "Isometric Escape 2",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/aada1dda0c9f404187438b121d48b644-512x512.jpg",
    "description": "Isometric Escape 2 challenges you to solve a variety of puzzles in uniquely designed isometric rooms. Search for hidden objects and use your logic and memory to unravel the riddles and escape.",
    "publisher": "isotronic",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-19T10:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use the left mouse button to interact with the objects.",
    "sourceUrl": "https://gamedistribution.com/games/isometric-escape-2/"
  },
  {
    "id": "62e4e7134be5426e9daf69ed7d037040",
    "slug": "fortune's-deck-solitaire",
    "title": "Fortune's Deck Solitaire",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/62e4e7134be5426e9daf69ed7d037040-512x384.jpg",
    "description": "Welcome to Fortune's Deck Solitaire, where ancient Tarot magic meets the timeless thrill of Tripeaks!\\n\\nThree enchanted towers of fate await your touch - draw from the mystical deck and begin your journey through the arcana.\\n\\nInspired by the classic Tripeaks Solitaire, this magical twist invites you to clear the cards, trust your intuition, and let the deck reveal your fortune.\\n\\nWill you find insight, mystery… or unexpected luck?",
    "publisher": "Monstera Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-19T09:55:04.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Clear cards from the three pyramid stacks by playing one rank higher or lower than the card on the waste pile - suits don’t matter!\\nStuck? Draw a new card from the deck to keep your streak alive and your fortune unfolding.",
    "sourceUrl": "https://gamedistribution.com/games/fortune's-deck-solitaire/"
  },
  {
    "id": "9c97a939fdd4400788f2732ba35e7698",
    "slug": "journey-of-escape",
    "title": "Journey Of Escape",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/9c97a939fdd4400788f2732ba35e7698-512x512.jpg",
    "description": "Escape games have always been a popular genre among puzzle enthusiasts and adventure seekers. They challenge players to think critically, solve intricate puzzles, and uncover hidden secrets while racing against time. \\",
    "publisher": "GAMES4KING",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-19T09:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Use mouse click and play",
    "sourceUrl": "https://gamedistribution.com/games/journey-of-escape/"
  },
  {
    "id": "66fddb2022464fce86e045f78db3f46d",
    "slug": "hexa-sort-trick-or-treat",
    "title": "Hexa Sort Trick or Treat",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/66fddb2022464fce86e045f78db3f46d-512x384.jpg",
    "description": "Step into a haunted puzzle realm where glowing hexagonal blocks hide within a web of spooky challenges. Your task: sort eerie, color-coded pieces into their rightful places before the shadows close in. With every drag and drop, you’ll sharpen your wits and unravel chillingly clever layouts that grow trickier as you progress. Easy to pick up yet devilishly addictive, this Halloween brain-teaser will keep players of all ages spellbound through hundreds of spooky levels.",
    "publisher": "GameBerry Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-19T09:06:03.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Drag and drop the hexagonal blocks onto the board. Match the ghostly colors by fitting each piece into its rightful place. Plan ahead to avoid overlaps and fill the board completely. Conquer the puzzle to escape the level - before the darkness closes in.",
    "sourceUrl": "https://gamedistribution.com/games/hexa-sort-trick-or-treat/"
  },
  {
    "id": "f6272f861afc4fd4809f90583e4e4720",
    "slug": "bid-wars-1:-auction-simulator",
    "title": "Bid Wars 1: Auction Simulator",
    "category": "Simulation",
    "thumbnail": "https://img.gamedistribution.com/f6272f861afc4fd4809f90583e4e4720-512x384.jpg",
    "description": "Ever dreamed of becoming a smart and fearless auction tycoon? Bid Wars 1: Auction Simulator is an addictive auction and simulation game that puts you in exciting bidding wars to uncover hidden treasures! In this game, you join intense auctions for storage units, antiques, and mysterious items. Spot valuable gems, bid wisely, and sell them for huge profits! From small street auctions to luxury halls, build your empire step by step!",
    "publisher": "YAD.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-19T05:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Simulation",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/bid-wars-1:-auction-simulator/"
  },
  {
    "id": "5f0179bde2b543d5900d20792978a3a5",
    "slug": "outside",
    "title": "OUTSIDE",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/5f0179bde2b543d5900d20792978a3a5-512x384.jpg",
    "description": "OUTSIDE is a sleek and minimal puzzle game where every move matters. Guide a one-eyed character through a grid to collect the key and reach the exit — but there’s a twist: once you start moving, you won’t stop until you hit a wall.\\n\\nPlan your route carefully, avoid dead ends, and use the environment to your advantage. With simple mechanics and clean visuals, OUTSIDE is easy to pick up but tough to master — a perfect test of logic and spatial thinking.",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-19T04:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Desktop Controls:\\nArrow Keys / WASD – Move\\nR – Restart level\\nQ – Back to menu\\nM – Mute\\n\\nMobile Controls:\\nSwipe – Move\\nOn-screen buttons – Restart / Menu / Mute",
    "sourceUrl": "https://gamedistribution.com/games/outside/"
  },
  {
    "id": "39d142afe1104238a13023b8295a0559",
    "slug": "number-tubes",
    "title": "Number Tubes",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/39d142afe1104238a13023b8295a0559-512x512.jpg",
    "description": "Relax and train your brain with Number Tubes — the addictive number sorting and merging game! Tap to move balls, merge the same numbers into bigger ones, and keep going to beat your best score. No time limits, no pressure — just pure fun. Perfect for fans of merge games, number games, and classic sort puzzles.",
    "publisher": "GameBerry Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-18T12:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "- Tap a ball to move it into another tube, or move a whole matching chain together.\\n\\n- Merge balls with the same number to create a higher number.\\n\\n- Keep merging to reach the biggest numbers and set new records!\\n",
    "sourceUrl": "https://gamedistribution.com/games/number-tubes/"
  },
  {
    "id": "04639779c15c490c9d65d1a8f0a97d71",
    "slug": "chroma-trek",
    "title": "Chroma Trek",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/04639779c15c490c9d65d1a8f0a97d71-512x384.jpg",
    "description": "Dive into the glowing world of Chroma Trek, a vibrant neon platformer where every step is a test of skill and perception. With dazzling visuals and a unique color-switching mechanic, each level feels like a handcrafted puzzle filled with dynamic challenges.\\n\\nShift colors to phase through obstacles, stay sharp to dodge traps, and be inspired by motivational messages that guide you along the way. Your goal? Reach the shimmering Finish Crystal and conquer every stage with style.",
    "publisher": "Playgama",
    "languages": [
      "English",
      "French",
      "German",
      "Russian",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-18T12:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Objective:\\nNavigate tricky levels filled with traps and challenges to reach the Finish Crystal and complete each stage.\\n\\nControls (Desktop):\\nA or ← – Move Left\\nD or → – Move Right\\nW or Spacebar – Jump\\n\\nGameplay Tips:\\nDodge Hazards – Avoid spikes, pits, and other dangers.\\nSwitch Colors – Use your color-shifting ability to pass through matching barriers.\\nStay Focused – Every level introduces something new—keep adapting!",
    "sourceUrl": "https://gamedistribution.com/games/chroma-trek/"
  },
  {
    "id": "3d11dfed72a04e00ae9a43ab3fd49bd6",
    "slug": "dan-the-man",
    "title": "Dan the Man",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/3d11dfed72a04e00ae9a43ab3fd49bd6-512x512.jpg",
    "description": "With a cracking funny story, action, an awesome upgradeable fighting skills and an epic arsenal of weapons that will make even the most heroic of heroes envious, Dan The Man's arcade fight fest has enough enemies and boss fights to satisfy every hardcore Action Platformer enthusiast and every indie game lover.",
    "publisher": "Yes2Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-18T10:03:32.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Follow the adventure of Dan in a new stage to this epic series. Get ready to kick foes in one of the most epic retro platformer games to date!",
    "sourceUrl": "https://gamedistribution.com/games/dan-the-man/"
  },
  {
    "id": "26b8b04411e84591b2afc276ce177c37",
    "slug": "hidden-object:-my-hotel",
    "title": "Hidden Object: My Hotel",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/26b8b04411e84591b2afc276ce177c37-512x384.jpg",
    "description": "Hidden Objects: My Hotel – A fun hidden-object game where you help a young woman restore her dream hotel! After buying the old building, she needs your help to clean up cluttered rooms, find hidden items, and bring back its lost charm.",
    "publisher": "DRA",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-18T09:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Female",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Object Hunt – Find cleverly hidden items in messy rooms to tidy up.\\nSmart Hints – Stuck? Use hints to spot tricky objects!",
    "sourceUrl": "https://gamedistribution.com/games/hidden-object:-my-hotel/"
  },
  {
    "id": "6952bddd01eb47c6b11446844b483c32",
    "slug": "magical-diary:-paper-dress-up",
    "title": "Magical Diary: Paper Dress Up",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/6952bddd01eb47c6b11446844b483c32-1280x720.jpg",
    "description": "Dress up your paper doll with mystical styles in Magical Diary: Paper Dress Up! ?✨ Get ready to enter a dreamy world where fantasy meets fashion. This isn’t just a dress-up game—it’s your magical escape, where every outfit tells a story and every style reveals a spellbound secret. Whether you're a fashion dreamer, a lover of magic, or a diary keeper at heart, this enchanted adventure is made just for you.\\n",
    "publisher": "Bravestars Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-18T09:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "In Magical Diary: Paper Dress Up, you’ll become the personal stylist to your own charming paper doll. Choose from a wide variety of outfits inspired by gothic glam, dark academia, celestial queens, fairy witches, and more. Mix and match accessories like crystal tiaras, moonlit cloaks, glowing wings, and enchanted shoes to craft a look that’s totally you. Each outfit becomes a page in your mystical diary—a visual story of who your doll is and who she might become.",
    "sourceUrl": "https://gamedistribution.com/games/magical-diary:-paper-dress-up/"
  },
  {
    "id": "17665c710d0245b88f71998ffa3cdfac",
    "slug": "grill-party",
    "title": "Grill Party",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/17665c710d0245b88f71998ffa3cdfac-1280x720.jpg",
    "description": "Welcome to Grill Party! Step into the exciting world of grilling and become a master at crafting tasty skewers! In Grill Party!, you’ll experience a thrilling match-3 puzzle game where you’ll arrange meats, seafood, and veggies to create perfect combos. Serve up mouthwatering treats and show off your grilling skills!",
    "publisher": "Bravestars Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-18T08:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Sort \\u0026 Match – Swap and align 3 identical BBQ skewers on the grill to complete orders and clear the space for your next move!\\nPlan Your Moves – Each level presents unique challenges with limited time and space. Think ahead and place your pieces strategically!\\nBoost the Heat – If you’re stuck, use powerful boosters to clear obstacles and speed up the cooking process!",
    "sourceUrl": "https://gamedistribution.com/games/grill-party/"
  },
  {
    "id": "b42420ae0c3640cf9a113e40e9e4390a",
    "slug": "cryptogram",
    "title": "Cryptogram",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/b42420ae0c3640cf9a113e40e9e4390a-512x384.jpg",
    "description": "This game is for people who do not just look at letters but see the meaning behind them.\\nEach phrase hides a thought that can be revealed if you use logic, intuition and persistence.",
    "publisher": "Wit Games",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Russian",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-18T08:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "In front of you is an encrypted phrase.\\nAll letters have been replaced with numbers. The same number always represents the same letter.\\n\\nYour goal is to fully decode the phrase.\\nIt could be a quote, a proverb, a line from a song, or an interesting fact.\\n\\nClick on the letters on the keyboard to insert a letter into the highlighted cell.\\n\\nLetters whose numbers you have already discovered are highlighted in green on the keyboard.\\n\\nIf you get stuck, use a hint.\\n\\nGood luck and have fun!",
    "sourceUrl": "https://gamedistribution.com/games/cryptogram/"
  },
  {
    "id": "75a3a423df984e27a3fbf1deb13b8e5c",
    "slug": "schoolboy-runaway:-room-escape",
    "title": "Schoolboy Runaway: room escape",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/75a3a423df984e27a3fbf1deb13b8e5c-512x384.jpg",
    "description": "Step into the gripping adventure of Schoolboy Runaway: Room Escape, where strategy and mystery go hand in hand. A young schoolboy finds himself locked in a strange room, full of tricky puzzles and hidden clues. Help him think fast, solve each challenge, and escape before it’s too late. Play for free on both mobile and desktop and see if you can unravel the secrets of every room.",
    "publisher": "Playgama",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-17T14:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Begin your escape journey by exploring your surroundings. Interact with objects and search for clues that will aid your escape. Use your wit to solve puzzles and unlock doors. The game is designed to challenge your problem-solving skills, so think creatively and stay alert.",
    "sourceUrl": "https://gamedistribution.com/games/schoolboy-runaway:-room-escape/"
  },
  {
    "id": "200443b8a09a402ea935508e948f04fb",
    "slug": "dynamons-9",
    "title": "Dynamons 9",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/200443b8a09a402ea935508e948f04fb-512x384.jpg",
    "description": "Embark on a brand new Dynamons adventure in Dynamons 9! This online monster collecting game includes two fresh areas to explore; Halloween world and the bonus cave.\\n\\nEncounter Tholanyx, Scarykin, Anubolt, Sauryx in frankenstein skin, Zonysus in Dracula skin and many more special Dynamons. Recruit them for your team and beat others in thrilling 1v1 battles with special attacks and power-ups.\\n",
    "publisher": "Azerion Casual Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-17T14:03:39.882Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Play the game using touchscreen controls or your mouse.\\n\\nThe game consists of spellbinding turn-based battles. You can use the action cards to attack, and catch the opposing creature when it’s weakened. The backpack is filled with items you can collect and use during your journeys. By selecting it during battle, you can access these special items. Use shards to level up your Dynamons, and to gain new action cards. Challenge other trainers and become the strongest Dynamon Captain!",
    "sourceUrl": "https://gamedistribution.com/games/dynamons-9/"
  },
  {
    "id": "13b79da649a6446bbbb25c483925ffe7",
    "slug": "fruit-jam-merge-puzzle-game",
    "title": "Fruit Jam - Merge Puzzle Game",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/13b79da649a6446bbbb25c483925ffe7-512x512.jpg",
    "description": "Fruit Jam - Merge Puzzle Game\\nSwipe fruits, blast combos \\u0026 solve hundreds of juicy match-3 puzzles! Fun for all ages with vibrant graphics, daily rewards, offline play \\u0026 no time limits. ?? Perfect for quick play or long sessions. Match, crush \\u0026 enjoy!\\n\\nPlay now and test your brain!",
    "publisher": "Minor Bugs",
    "languages": [
      "No Text"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-17T13:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Touch the fruit to sort them",
    "sourceUrl": "https://gamedistribution.com/games/fruit-jam-merge-puzzle-game/"
  },
  {
    "id": "7003f00653b24b0686c8d448eca7083b",
    "slug": "crazy-stunts-3d",
    "title": "Crazy Stunts 3D",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/7003f00653b24b0686c8d448eca7083b-512x384.jpg",
    "description": "Get behind the wheel and conquer extreme tracks! Jump from ramps, compete with players, complete modes and unlock new cars!",
    "publisher": "Mirra Games",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-17T10:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "The goal of the game is to complete levels, overcoming difficult tracks with ramps and obstacles, earn in-game currency and unlock new cars. Different modes may have their own tasks: drive carefully to the finish line, perform tricks or ride freely in the sandbox.\\n\\nMobile controls: touch / swipe.\\nDesktop controls: WASD/Arrows for movement, Space for handbrake.",
    "sourceUrl": "https://gamedistribution.com/games/crazy-stunts-3d/"
  },
  {
    "id": "9c760581e6bf486f8a43e1813614f6bd",
    "slug": "math-lava:-tower-race",
    "title": "Math Lava: Tower Race",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/9c760581e6bf486f8a43e1813614f6bd-512x512.jpg",
    "description": "Test your math skills under pressure in Math Lava: Tower Race, a fast-paced Roblox style web game where quick thinking and accurate answers are your keys to survival. Answer math questions correctly to build blocks beneath you, racing against opponents and rising lava. The faster and more accurate you are, the higher you climb!",
    "publisher": "2Play",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-17T08:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Start the Race: Join a game and prepare to solve math problems.\\nAnswer Questions: Quickly solve presented math questions; each correct answer adds a block beneath you. Avoid the Lava: Incorrect answers or slow responses can cause you to fall into the rising lava.",
    "sourceUrl": "https://gamedistribution.com/games/math-lava:-tower-race/"
  },
  {
    "id": "4563680ee85c4a4c8d89744bbb6cff27",
    "slug": "hide-ball",
    "title": "Hide Ball",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/4563680ee85c4a4c8d89744bbb6cff27-512x384.jpg",
    "description": "Hide Ball is an addictive puzzle game where your mission is to protect the red ball from dangerous spiky enemies. Use the given blocks to build a safe shelter and hide the ball. Each level brings a new challenge — the constructions become trickier, and the enemies more relentless. Plan your moves, create a solid defense, and save your little hero!",
    "publisher": "GameBerry Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-17T07:37:02.558Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "On the screen, you’ll see a red ball that needs protection. Spiky enemies appear from above and try to reach it.\\nYou have green blocks of various shapes — tap to drop them and position them so they cover the ball.\\nOnce the enemies start falling, your construction must hold strong.\\nBut be careful: the number of blocks is limited, and levels get harder step by step. Use logic, creativity, and clever strategies to build the most reliable shelters.",
    "sourceUrl": "https://gamedistribution.com/games/hide-ball/"
  },
  {
    "id": "7366d797ba8649cd8381f587ddcb29de",
    "slug": "ninja-obby-parkour",
    "title": "Ninja Obby Parkour",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/7366d797ba8649cd8381f587ddcb29de-512x384.jpg",
    "description": "Step into the thrilling world of Ninja Obby Parkour, where every level is a test of speed, agility, and strategy. Packed with hundreds of unique obstacle courses, this game combines competitive racing with ninja-style combat and dazzling customization options.\\n\\nFrom smashing glass doors at checkpoints with your ninja power to unlocking powerful bonuses like speed boost, giant mode, and flight, every run feels fresh. ",
    "publisher": "gameVgames",
    "languages": [
      "Arabic",
      "English",
      "German",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-16T11:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Player 1: WASD to move, SPACE to jump.\\nPlayer 2: Arrow Keys to move, L to jump.\\nDouble-tap jump button for Double Jump.\\nHold forward key for Sprint.\\nOn Mobile: Joystick + Jump button.",
    "sourceUrl": "https://gamedistribution.com/games/ninja-obby-parkour/"
  },
  {
    "id": "de39260e780f439daa9d9573a4723519",
    "slug": "emergency-jam",
    "title": "Emergency Jam",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/de39260e780f439daa9d9573a4723519-512x512.jpg",
    "description": "As you progress, encounter cars in 8 different colors, adding complexity to your strategy. Use powerful boosters to line up characters by color or shuffle vehicles, clearing the way more efficiently. Test your logic, think fast, and rescue passengers.\\n",
    "publisher": "Inlogic Software",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Portuguese",
      "Russian",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-16T09:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Move emergency cars of different sizes around the parking lot. Each one moves in a specific direction. Rescue passengers of matching colors as the selected car exits. The goal is to clear the way and get the selected car out of the parking lot in the most efficient way.\\n",
    "sourceUrl": "https://gamedistribution.com/games/emergency-jam/"
  },
  {
    "id": "6196c00bcfbc49c5a240f10e009badda",
    "slug": "asmr-tattoo-treatment",
    "title": "ASMR Tattoo Treatment",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/6196c00bcfbc49c5a240f10e009badda-512x384.jpg",
    "description": "Treat a cool rocker in your ASMR clinic! Heal their sore piercing with gentle tools, retouch their fading star tattoo, and enjoy relaxing sounds with every step. Make them smile with your careful care and earn rewards for a perfect treatment!",
    "publisher": "iclickgames",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-16T07:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use MOUSE to play the game.",
    "sourceUrl": "https://gamedistribution.com/games/asmr-tattoo-treatment/"
  },
  {
    "id": "4f76d0c61d4f4aa79c64dcd1065e5d59",
    "slug": "words-or-die",
    "title": "Words or Die",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/4f76d0c61d4f4aa79c64dcd1065e5d59-512x384.jpg",
    "description": "Build words to survive — think fast or get crushed!\\n\\nIn this fast-paced word survival game, players race to create words from random letters. Each correct word builds a tower under your feet. Fail to spell on time? Lava rises, and you're out!\\n\\n - Stay above the lava\\n - Show off your vocabulary skills\\n - Compete against others in real-time\\n - Choose your character and style\\n - Only the smartest will survive!",
    "publisher": "2Play",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-15T13:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "1. Type real words using the random letters you’re given.\\n2. Each correct word builds a block under you climb higher!\\n3. The lava is rising! If you don’t build fast enough, you're eliminated.\\n4. Longer and harder words give you more blocks.\\n5. Last player standing wins the round!",
    "sourceUrl": "https://gamedistribution.com/games/words-or-die/"
  },
  {
    "id": "a29d8240d69c4b39b954c698f83bc3f7",
    "slug": "sort-and-style:-back-to-school",
    "title": "Sort And Style: Back To School",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/a29d8240d69c4b39b954c698f83bc3f7-512x384.jpg",
    "description": "Step into the world of Sort And Style: Back To School, a fun mix of sorting and dress-up games for girls! Organize messy desks, lockers, wardrobes, and even bento boxes across 9 exciting levels. Then, challenge your creativity in the final dress-up unit where you style your school look with trendy uniforms, shoes, hairstyles, and accessories. Perfect for fans of organizing games, makeover fun, and school fashion challenges!",
    "publisher": "Gamerina",
    "languages": [
      "English",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-15T13:00:47.519Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use your mouse to play this game on a desktop, tap to play on mobile devices.",
    "sourceUrl": "https://gamedistribution.com/games/sort-and-style:-back-to-school/"
  },
  {
    "id": "5e09090e42fc4ce598650af75ea5739e",
    "slug": "dream-pet-hotel",
    "title": "Dream Pet Hotel",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/5e09090e42fc4ce598650af75ea5739e-512x384.jpg",
    "description": "Dream Pet Hotel is a charming connect puzzle game with an engaging hotel meta. Match tiles to clear levels, earn rewards, and unlock cozy rooms. Decorate and furnish spaces to create a unique style, then welcome adorable pets to stay in your hotel. Watch your collection grow as you design the perfect home for cats, dogs, pandas, and more. Relaxing, addictive, and fun to play online — build your dream pet hotel today!",
    "publisher": "Azerion Casual Games",
    "languages": [
      "Czech",
      "Dutch",
      "English",
      "French",
      "German",
      "Italian",
      "Japanese",
      "Polish",
      "Portuguese",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-15T12:21:44.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Both",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "Connect matching tiles to clear the board! Tap two identical tiles that can be linked with a line of up to three turns. Clear all pairs before the timer runs out to pass the level. Use boosters like Shuffle, Hint, or Freeze Time to help when you’re stuck. Complete puzzles, earn rewards, and progress through hundreds of exciting levels!",
    "sourceUrl": "https://gamedistribution.com/games/dream-pet-hotel/"
  },
  {
    "id": "169c01c96fb5407680dfea26391d01d2",
    "slug": "vex-hyper-dash",
    "title": "Vex Hyper Dash",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/169c01c96fb5407680dfea26391d01d2-512x384.jpg",
    "description": " Get ready for a fast-paced challenge in this brand-new Vex spin-off: Vex Hyper Dash! Inspired by the legendary Geometry Dash. Your goal is simple: survive as long as possible. Jump from platform to platform, time your moves perfectly, and avoid the countless dangers that stand in your way. One wrong move, one mistimed jump, and it’s game over. \\n\\nVex Hyper Dash puts your reflexes and precision to the ultimate test. Can you master the flow and set a new high score?\\n",
    "publisher": "Azerion Casual Games",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Japanese",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-15T09:45:52.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Jump: Arrow keys, Spacebar, or Mouse click\\nDash: K or Shift (customizable in settings)\\nIn the settings, you can move the dash button to the left or right side of the screen, making it comfortable for both left- and right-handed players.",
    "sourceUrl": "https://gamedistribution.com/games/vex-hyper-dash/"
  },
  {
    "id": "fab4ba7adaf04d8a92905989e85b55c7",
    "slug": "idol-livestream:-doll-dress-up",
    "title": "Idol Livestream: Doll Dress Up",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/fab4ba7adaf04d8a92905989e85b55c7-1280x720.jpg",
    "description": "In Idol Livestream: Doll Dress Up, you’re dressing up your doll and getting her ready to go live. Pick from different styles—she can look like a fairy, wear chill street clothes, or go for a beach outfit. When you’re done, she jumps on the stream and starts showing off her look.\\n\\nYou can mess with her hair, add makeup, and try out accessories. There’s also a battle mode where you go up against other players to see who styled it best.",
    "publisher": "Bravestars Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-15T09:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Dress Up: Tap or click to pick outfits and mix styles\\nGo Live: Send your doll on stage and watch her perform\\nBattle: Enter fashion contests and vote on looks\\nNo rush, no limits—just show off your creativity and style sense",
    "sourceUrl": "https://gamedistribution.com/games/idol-livestream:-doll-dress-up/"
  },
  {
    "id": "df8a3f16d8f546b8b607dfa38d856478",
    "slug": "vikings:-an-archer's-journey",
    "title": "Vikings: An Archer's Journey",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/df8a3f16d8f546b8b607dfa38d856478-512x384.jpg",
    "description": "Vikings: An Archer’s Journey blends the fast-paced action of a shoot ’em up with the adrenaline rush of an infinite runner, all presented in a striking minimalist art style. Play as Nott, a fearless Valkyrie archer, on a quest to save her wolf, Oder, from the Underworld. Use intuitive controls, collect powerful upgrades, and team up with Viking heroes to face off against mythical Nordic creatures in this thrilling adventure.",
    "publisher": "Playgama",
    "languages": [
      "Afrikaans",
      "Arabic",
      "Chinese (Simplified)",
      "English",
      "French",
      "German",
      "Indonesian",
      "Italian",
      "Japanese",
      "Korean",
      "Malay",
      "Portuguese",
      "Russian",
      "Spanish",
      "Thai",
      "Turkish",
      "Vietnamese"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-15T09:05:37.115Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "On desktop:\\nSpace bar = jump.\\nLeft click \\u0026 pull = aim.\\nLeft click release = shot.\\n\\nOn mobile:\\nUse your tap and on-screen controllers.",
    "sourceUrl": "https://gamedistribution.com/games/vikings:-an-archer's-journey/"
  },
  {
    "id": "a455fc9c9c324c33a288ead33ad21661",
    "slug": "witchy-and-the-puzzle-adventures",
    "title": "Witchy and the Puzzle Adventures",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/a455fc9c9c324c33a288ead33ad21661-512x512.jpg",
    "description": "Help the brave Witch to pass all the puzzling tests and find all the seals to shelter them in her cozy forest house. Kittens are lost in the forest, which is full of various traps and dangers, you need to help the Witch to pass all the tests and find all the seals. ",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-14T15:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "The task of each level is to guide the witch to the cat. To do this, you need to use cards and objects on the level. Interaction takes place with the help of special cards that can be obtained at the level or found, to pick up a card you need to touch it with a witch. At some levels, the paths may be blocked, but everything can be fixed, the laser cannon can be turned and the laser will be directed in the other direction, or simply blow up both the piece and the wall.",
    "sourceUrl": "https://gamedistribution.com/games/witchy-and-the-puzzle-adventures/"
  },
  {
    "id": "eb171eea0aaf438596bfd0245f1ce97c",
    "slug": "fun-sorting-through-the-shelves",
    "title": "Fun Sorting Through The Shelves",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/eb171eea0aaf438596bfd0245f1ce97c-512x384.jpg",
    "description": "Unwind with this charming match-3 puzzle game! Spot matching items, place them neatly on shelves, and merge triplets to free up space. Collect treasures, decorate, and design your own cozy virtual nook in a relaxing experience for all ages.",
    "publisher": "Playgama",
    "languages": [
      "English",
      "German",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-14T13:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Just drag and drop the items and place them neatly on the shelves. Collect three identical objects on the same shelf to create a triplet and make room for new items.\\nComplete the levels, clearing all the shelves and revealing your strategic wit. With each new stage, the difficulty increases, and with it the pleasure of solving problems!",
    "sourceUrl": "https://gamedistribution.com/games/fun-sorting-through-the-shelves/"
  },
  {
    "id": "78028efd6f3f42568f88cb90ab29c4a5",
    "slug": "fruitsland:-escape-from-the-amusement-park",
    "title": "Fruitsland: Escape from the Amusement Park",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/78028efd6f3f42568f88cb90ab29c4a5-512x384.jpg",
    "description": "Fruitsland: Escape from the Amusement Park is a horror escape adventure where bright amusement park rides hide lurking dangers. Players must solve puzzles, collect items, and uncover clues while evading hostile enemies. Stealth and timing are crucial—explore cautiously, hide when needed, and outsmart the threats to survive and escape. The mix of colorful setting and eerie tension creates a unique, suspenseful experience.",
    "publisher": "Playgama",
    "languages": [
      "English",
      "German",
      "Italian",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-14T08:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Move with WASD or Arrow keys, crouch with C, and jump with Space. Explore the park to gather clues and items, solve puzzles, and unlock new paths. Beware of roaming enemies—hide or stay out of sight to avoid being caught. Use collected objects wisely to progress toward the exit and survive the escape.",
    "sourceUrl": "https://gamedistribution.com/games/fruitsland:-escape-from-the-amusement-park/"
  },
  {
    "id": "6d3928f393774157a7aed692f08ee011",
    "slug": "stickman-kombat-2d",
    "title": "Stickman Kombat 2D",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/6d3928f393774157a7aed692f08ee011-512x512.jpg",
    "description": "Adrenaline unleashed! Rage, speed, and chaos collide in explosive 2D battles. Feel every hit — and dive into the madness. Are you ready?",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-14T08:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "CONTROLS FOR 1 PLAYER:\\n\\nWASD — move\\nJ — attack\\nK — special move\\nBACK + K — second special move\\nS + J — uppercut\\nHOLD S — block\\n\\nCONTROLS FOR 2 PLAYERS ON ONE PC:\\n\\nPlayer 1: WASD + F (attack), G (special moves)\\nPlayer 2: IJKL + : (colon) (attack), \\",
    "sourceUrl": "https://gamedistribution.com/games/stickman-kombat-2d/"
  },
  {
    "id": "bbea46dc5a4a428cb59caa71010f59a0",
    "slug": "hexamatch",
    "title": "Hexamatch",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/bbea46dc5a4a428cb59caa71010f59a0-512x384.jpeg",
    "description": "Click on a hexagon to move it in the direction that it is pointing Each hexagon will push any hexagons in front of it Stack all hexagons of the same color",
    "publisher": "Roman Parada",
    "languages": [],
    "mobile": [],
    "firstActiveDate": "2018-12-28T08:07:49.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "HTML5",
      "Javascript"
    ],
    "instructions": "",
    "sourceUrl": "https://gamedistribution.com/games/hexamatch/"
  },
  {
    "id": "a44a7eaafa0d4cfc90e75064c370b335",
    "slug": "pull-the-pin:-fish-rescue!",
    "title": "Pull the Pin: Fish Rescue!",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/a44a7eaafa0d4cfc90e75064c370b335-512x384.jpg",
    "description": "Pull the Pin: Fish Rescue! is a relaxing and addictive puzzle game with lots of interesting puzzles. You will see several niches in it. They will be separated by partitions. In one niche you will see a fish, and in another water. You will need to carefully study everything and pull the pin. Thus, you will open it and water will get to the fish.",
    "publisher": "Simplegame",
    "languages": [
      "No Text"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-14T07:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Your mission is simple: pull the pin and water will get to the fish.",
    "sourceUrl": "https://gamedistribution.com/games/pull-the-pin:-fish-rescue!/"
  },
  {
    "id": "593ad8af2f19463b89ed1ecb011e9d38",
    "slug": "meme-wars",
    "title": "Meme Wars",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/593ad8af2f19463b89ed1ecb011e9d38-512x384.jpg",
    "description": "MeMe Wars is a strategy battler with US-style Shanhaijing flair. Build a quirky hero lineup with unique roles and stats. Place them on the board for max power, adapt to new foes each stage, and win.",
    "publisher": "Guangzhou Yomitoo Network Technology Co., Ltd.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-14T07:40:04.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Cocos"
    ],
    "instructions": "1.Tap Start to battle right away—easy to pick up, no extra steps.\\n2.Drag identical units together to merge into a new one.\\n3.Melee or ranged—place them wisely.\\n4.Spend coins to summon more and build your lineup.",
    "sourceUrl": "https://gamedistribution.com/games/meme-wars/"
  },
  {
    "id": "2c2c1d3ce1e944d7940cdff636f19c1c",
    "slug": "italian-brainrot-find-the-stars",
    "title": "Italian Brainrot Find the Stars",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/2c2c1d3ce1e944d7940cdff636f19c1c-512x384.jpg",
    "description": "Play Italian Brainrot Find the Stars game online and for free. Find out the hidden stars in the specified images. Each level has 12 hidden stars. There are 12 levels in total. The time is limited so be fast and find all hidden objects before time runs out. Clicking in the wrong place several times reduces the time by an additional 5 seconds. So, if you are ready, start the game and have fun!",
    "publisher": "New Kids Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-14T06:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Use your mouse or tap the screen to find the stars.",
    "sourceUrl": "https://gamedistribution.com/games/italian-brainrot-find-the-stars/"
  },
  {
    "id": "81bd3a3dac2a4fce968ee2d8dc648bbe",
    "slug": "minicraft-chef-cake-wars",
    "title": "Minicraft Chef Cake Wars",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/81bd3a3dac2a4fce968ee2d8dc648bbe-512x384.jpg",
    "description": "Hey player, would you like to have a cooking competition with your friend? In this cooking contest, you must beat your friend. Collect all the cooking materials as quickly as possible. We need to gather the cake ingredients floating in balloons in the air. The player who collects the most ingredients the fastest wins the game. To bake the cake, collect everything: salt, flour, and milk. Gather all the ingredients and win the game!",
    "publisher": "FBK",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-14T06:50:05.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "*The first player to collect 10 cake ingredients wins the game.\\n*Use the WASD and Arrow keys to move.\\n*Double Jump available.\\n*Playable on both mobile and PC.\\n*Use S and Down Arrow keys to push",
    "sourceUrl": "https://gamedistribution.com/games/minicraft-chef-cake-wars/"
  },
  {
    "id": "68b9d83103d2484583d69df6c5f985e3",
    "slug": "stellar-guardian",
    "title": "STELLAR GUARDIAN",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/68b9d83103d2484583d69df6c5f985e3-512x384.jpg",
    "description": "Stellar Guardian – Cosmic Defense Force is a fast-paced space shooter where you command powerful ships, unlock upgrades, and defend the galaxy across challenging missions and game modes. to fix the lag you need to keep the PC on a full screen, while on other devices it runs smoothly",
    "publisher": "ukaa",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-14T06:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Controls Desktop: ← / → or A / D – Move left and right Spacebar or Click – Shoot E – Activate shield F – Slow motion C –",
    "sourceUrl": "https://gamedistribution.com/games/stellar-guardian/"
  },
  {
    "id": "abdcf6513abb494ebea7cb79e846fa11",
    "slug": "sudoku-vault",
    "title": "Sudoku Vault",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/abdcf6513abb494ebea7cb79e846fa11-512x384.jpg",
    "description": "Sudoku Vault is a logic-based puzzle game featuring 4x4, 6x6, and 9x9 boards — each with four difficulty levels: Basic, Normal, Hard, and Expert. Whether you're a beginner or an expert, every grid offers a fresh challenge for your mind. Use smart NOTES to keep track of possibilities, and when you want to check your progress, tap the CHECK button — it will remove incorrect inputs and lock the correct ones, helping you stay focused on the solution. \\n",
    "publisher": "Lof Games",
    "languages": [
      "English",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-13T14:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use a mouse or touchpad to select a cell, then choose a number from the on-screen number pad to fill it in. Use the Note button to toggle pencil marks, and tap Check to validate your entries — incorrect numbers are removed, and correct ones are locked.",
    "sourceUrl": "https://gamedistribution.com/games/sudoku-vault/"
  },
  {
    "id": "14663fc250304592a452dbf37e71b5fd",
    "slug": "fish-rain-2",
    "title": "Fish rain 2",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/14663fc250304592a452dbf37e71b5fd-512x512.jpg",
    "description": "\\",
    "publisher": "GamePush",
    "languages": [
      "Arabic",
      "Chinese (Simplified)",
      "English",
      "French",
      "German",
      "Hindi",
      "Indonesian",
      "Italian",
      "Japanese",
      "Korean",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-13T14:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "The game is controlled using the mouse.\\n\\n1. To cast the line, click on the hook button.\\n2. For a hook set, wait for the float to go under water and press the hook button.\\n3. To pull in the fish, click anywhere on the screen. It's important to keep an eye on the fishing-out gauge: it should neither be too low nor exceed the limits. Keep it at an average level.\\n4. You will learn the rest of the details as you play.",
    "sourceUrl": "https://gamedistribution.com/games/fish-rain-2/"
  },
  {
    "id": "600ac5e4d65147f9a1db843e3bd7add3",
    "slug": "travel-with-me:-asmr-edition",
    "title": "Travel With Me: ASMR Edition",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/600ac5e4d65147f9a1db843e3bd7add3-512x384.jpg",
    "description": "Prepare to jet-set across the world with Travel With Me: ASMR Edition! Join Lisa, the stylish vlogger, as she explores stunning destinations, allowing you to dress her up in fabulous outfits that match each location perfectly. From the serene temples of Thailand to the desert adventures in Dubai, and the tropical paradise of Maldives, challenge your fashion skills and create unforgettable looks for every occasion. ",
    "publisher": "Gamerina",
    "languages": [
      "English",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-13T13:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use your mouse to play this game on a desktop, tap to play on mobile devices. ",
    "sourceUrl": "https://gamedistribution.com/games/travel-with-me:-asmr-edition/"
  },
  {
    "id": "1726345e0eb4405a8bc8f20d14f33993",
    "slug": "dragon-egg",
    "title": "Dragon Egg",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/1726345e0eb4405a8bc8f20d14f33993-512x384.jpg",
    "description": "Players can unlock higher-level Divine Dragon eggs by moving three or more of them. Supports multi-level recursive synthesis of 5-color dragon eggs. Eventually, unlocking high-level dragon eggs can unlock the birth of new dragons, accompanied by splendid animations, filling the sense of achievement to the fullest.",
    "publisher": "ovokit",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-13T13:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use the mouse or finger to click on the Dragon eggs on the game map and move them to the appropriate position. If three or more of them meet the synthesis rules, high-level Dragon eggs will be unlocked.",
    "sourceUrl": "https://gamedistribution.com/games/dragon-egg/"
  },
  {
    "id": "3793271659c74331a7c65a1a66718603",
    "slug": "carvivor-ops",
    "title": "Carvivor Ops",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/3793271659c74331a7c65a1a66718603-512x384.jpg",
    "description": "Carvivor Ops puts you behind the wheel of a weaponized supercar in a nonstop chase for survival. Dodge relentless police, unleash rockets, and upgrade your gear as you fight through chaotic urban streets. Every second counts as you outmaneuver enemies, collect power-ups, and push your skills to the limit in this high-octane mix of driving and combat.",
    "publisher": "Playgama",
    "languages": [
      "English",
      "French",
      "German",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-13T12:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Control your car with WASD or Arrow keys on desktop, or touch buttons on mobile. Dodge incoming police cars, collect upgrades, and fire rockets at enemies when you have a clear shot. Survive as long as possible to earn rewards and unlock new upgrades.",
    "sourceUrl": "https://gamedistribution.com/games/carvivor-ops/"
  },
  {
    "id": "e06bbab372b741228acea8c3c08aa001",
    "slug": "skate-hooligans",
    "title": "Skate Hooligans",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/e06bbab372b741228acea8c3c08aa001-1280x550.jpg",
    "description": "Help the little hooligans escape from the policeman who is constantly trying to catch them. Try to collect as many bonuses and coins as possible on the road, for which you can buy new coolest skateboards and amazing characters. And do not forget to complete funny tasks, because the number of points you receive depends on this!",
    "publisher": "GamePush",
    "languages": [
      "Arabic",
      "Chinese (Simplified)",
      "English",
      "French",
      "German",
      "Hindi",
      "Indonesian",
      "Italian",
      "Japanese",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-13T08:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "If you play the keyboard, then use its left and right arrows to move between tracks, up arrow to jump and down arrow to slide. And if on the screen of your favorite phone-tablet, then just swipe left or right to move between the tracks, swipe up for a jump and swipe down for a slide. Ready? Well then let's hooligan! =)",
    "sourceUrl": "https://gamedistribution.com/games/skate-hooligans/"
  },
  {
    "id": "d6c65947f9264445a7843dac3f0021f1",
    "slug": "froggy-hop",
    "title": "Froggy Hop",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/d6c65947f9264445a7843dac3f0021f1-1280x720.jpg",
    "description": "Froggy Hop is a fun, physics-based game where you launch a bouncy frog and help it travel across lily pads, turtles, and spring pads while dodging obstacles. Upgrade jump power, height, and bounce to go farther. Unlock cool skins with upgrades, complete daily missions, and aim for the best distance!",
    "publisher": "Dissorto",
    "languages": [
      "English",
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-13T07:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Tap or click to launch the frog at the perfect moment by watching the jump meter. While in the air, time your dives to land precisely on lilypads, turtles, or spring pads to keep bouncing and travel farther. Avoid obstacles like rocks and trees, collect coins, and aim for the longest distance possible!",
    "sourceUrl": "https://gamedistribution.com/games/froggy-hop/"
  },
  {
    "id": "5073a2f310b54790bd9621b66d2a9a5c",
    "slug": "italian-brainrot-survival-arena",
    "title": "Italian Brainrot Survival Arena",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/5073a2f310b54790bd9621b66d2a9a5c-512x384.jpg",
    "description": "Are you ready for the ultimate showdown between Trallero and Tung Tung Sahur? Yes, in a lava-filled cave — let’s see who will win! The player who falls into the lava the most loses the game. You can push your friend. Push your friend and make them fall into the lava. Be very careful! Avoid falling into the lava at all costs. Remember, it’s not just the danger of falling down — you also have to watch out for rocket missiles falling from the cave ceiling. ",
    "publisher": "FBK",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-13T07:35:05.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "*Use the WASD or Arrow keys to move.\\n*Press S or the Down arrow key to push each other.\\n*The player who falls into the lava the most or gets hit by a rocket loses the game.\\n*Playable on both mobile and PC.",
    "sourceUrl": "https://gamedistribution.com/games/italian-brainrot-survival-arena/"
  },
  {
    "id": "d915f03f46804091933c3be8d17273be",
    "slug": "billiard-diamond-challenge",
    "title": "Billiard Diamond Challenge",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/d915f03f46804091933c3be8d17273be-512x384.jpg",
    "description": "Billiard Diamond Challenge is a fun and free online billiard game for both kids and adults. Your goal is to sink all the balls into the pockets except for the white ball. While playing, you can collect blue diamonds that allow you to unlock a brand new cue. The game offers both level mode and time mode, so you can choose the challenge that suits you best. Get ready to test your skills and have fun at the billiard table!",
    "publisher": "Vi Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-13T06:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Use mouse to play.",
    "sourceUrl": "https://gamedistribution.com/games/billiard-diamond-challenge/"
  },
  {
    "id": "9547692496ca45bb8e01e655e9121bdd",
    "slug": "farm-business-saga",
    "title": "Farm Business Saga",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/9547692496ca45bb8e01e655e9121bdd-512x384.jpg",
    "description": "Create the farm you’ve always wanted in Farm Business Saga! ? Plant crops, care for animals, trade products, and grow your farming empire. With beautiful visuals, endless ways to customize, and engaging simulation gameplay, it’s fun for all ages!",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-12T13:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Objective: Build a thriving farm business by growing crops, raising animals, producing goods, and selling them for profit. Expand your farm, unlock new opportunities, and become a farming mogul!\\nControls:\\n?️ Tap \\u0026 Drag – Interact with crops, animals, and buildings.\\n? Menu Navigation – Use on-screen buttons to manage inventory, sales, and upgrades.\\n⚙️ Strategy Planning – Balance resources to maximize profits and efficiency.",
    "sourceUrl": "https://gamedistribution.com/games/farm-business-saga/"
  },
  {
    "id": "dac9b9cfefef453ea3d993000589cb61",
    "slug": "code-runner:-binary-confusion",
    "title": "Code Runner: Binary Confusion",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/dac9b9cfefef453ea3d993000589cb61-512x384.jpg",
    "description": "A fast-paced binary runner where logic and reflexes collide. Match the rule, dodge the wrong digit — survive the code! .A psychological runner puzzle where every second counts and one rule could change everything.",
    "publisher": "rose91petals",
    "languages": [
      "English"
    ],
    "mobile": [],
    "firstActiveDate": "2025-09-12T13:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "HTML5",
      "WebGL"
    ],
    "instructions": "1. Swipe left/right (or use arrow keys) to switch lanes\\n2. Watch the active rule (top of screen)\\n3.Follow the rule carefully — each mistake costs a life!\\n",
    "sourceUrl": "https://gamedistribution.com/games/code-runner:-binary-confusion/"
  },
  {
    "id": "b0b55fe04fd0469e9f54685f51d4fe35",
    "slug": "brainrot-evolution",
    "title": "Brainrot Evolution",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/b0b55fe04fd0469e9f54685f51d4fe35-512x512.jpg",
    "description": "Welcome to the world of meme Italian animals - a dynamic arcade game where you control unique creatures, destroy the environment, gather resources, and unlock new animals. Your goal is to evolve and progress further, unlocking more and more unusual meme beasts. Help yourself with pets: each one provides advantages and strengthens your character. Explore levels, destroy objects, collect useful resources, and unlock the next stage of evolution.",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-12T13:03:14.376Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "You’ll be controlling a Brainrot — smashing objects to gain experience and evolve.\\nControls:\\n- WASD - Move\\n- Space - Jump\\n- LMB - Hit objects\\n- E – Interact with interactive elements",
    "sourceUrl": "https://gamedistribution.com/games/brainrot-evolution/"
  },
  {
    "id": "47e30ffac22a4599b2c7529d923a94a0",
    "slug": "paint-master",
    "title": "Paint Master",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/47e30ffac22a4599b2c7529d923a94a0-512x384.jpg",
    "description": "Paint Master is a fun casual puzzle game. The homeowner has arranged a strict painting plan for you, you need to arrange the painters to paint in a certain order. Match your paint color with the owner's arrangement and you will be the winner. If there is a difference, the owner will return you to work.",
    "publisher": "Depfov",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2024-09-28T13:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Portrait",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "How to play:\\n1. Observe the schematic diagram given at the top;\\n2. Determine the order of painting based on the available patterns;\\n3. Click on the painter to work;",
    "sourceUrl": "https://gamedistribution.com/games/paint-master/"
  },
  {
    "id": "1ca550a66423424c98c39fcc8cd57ff0",
    "slug": "the-road-home:-granny-escape",
    "title": "The Road Home: Granny Escape",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/1ca550a66423424c98c39fcc8cd57ff0-512x384.jpg",
    "description": "Step into the chilling world of The Road Home: Granny Escape, a horror escape room experience where every shadow hides danger. Solve puzzles, collect items, and find a way out while being relentlessly hunted by Granny and Grandpa. Use stealth, strategy, and courage to survive this terrifying challenge and make your way to freedom.",
    "publisher": "Playgama",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-12T08:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Move with WASD, crouch with C, and jump with Space to navigate the eerie halls. Search for hidden objects and clues to solve puzzles that unlock new areas. Stay quiet and hide when Granny or Grandpa are nearby, as they will chase you if spotted. Combine stealth and logic to find your way out before they catch you.",
    "sourceUrl": "https://gamedistribution.com/games/the-road-home:-granny-escape/"
  },
  {
    "id": "01b3aa0941514408804ca0d2e2fc5fd0",
    "slug": "pop-puzzle",
    "title": "Pop Puzzle",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/01b3aa0941514408804ca0d2e2fc5fd0-512x384.jpg",
    "description": "Dive into the vibrant world of Pop Puzzle, a colorful block-busting challenge that tests your strategy and quick thinking. Tap on groups of matching blocks to clear the screen and progress through levels filled with satisfying chain reactions. Simple, addictive, and fun for players of all ages.",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-11T10:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Click or tap on groups of two or more blocks of the same color to make them disappear. Plan ahead to avoid leaving single blocks behind, as they cannot be cleared alone. Create bigger groups for higher scores and aim for chain reactions to maximize efficiency and conquer each level.",
    "sourceUrl": "https://gamedistribution.com/games/pop-puzzle/"
  },
  {
    "id": "c2c324fd1e324830b3e2e3464cbad8a7",
    "slug": "enchanted-mahjong-saga",
    "title": "Enchanted Mahjong Saga",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/c2c324fd1e324830b3e2e3464cbad8a7-512x384.jpg",
    "description": "Enchanted Mahjong Saga is a fast-paced twist on the classic tile-matching game, with unlimited levels to challenge your mind. Match tiles, beat the clock, and keep your streak alive as each level gets tougher and more exciting. Feeling stuck? Use helpful hints to get back on track and stay in the game.Whether youre playing for a quick break or settling in for a longer session, theres always a new puzzle waiting.\\n",
    "publisher": "Lof Games",
    "languages": [
      "Arabic",
      "Bulgarian",
      "Chinese (Simplified)",
      "Danish",
      "Dutch",
      "English",
      "Estonian",
      "Finnish",
      "French",
      "German",
      "Greek",
      "Hebrew",
      "Hindi",
      "Hungarian",
      "Indonesian",
      "Italian",
      "Japanese",
      "Korean",
      "Latvian",
      "Lithuanian",
      "Norwegian (Nynorsk)",
      "Polish",
      "Portuguese",
      "Romanian",
      "Russian",
      "Serbian",
      "Simple English",
      "Slovak",
      "Spanish",
      "Swahili",
      "Swedish",
      "Tagalog",
      "Thai",
      "Turkish",
      "Ukrainian",
      "Vietnamese"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-11T09:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use your mouse or touchpad to select and match tiles.",
    "sourceUrl": "https://gamedistribution.com/games/enchanted-mahjong-saga/"
  },
  {
    "id": "63fcb74425b24ea1937867a2a0663f75",
    "slug": "thread-match",
    "title": "Thread Match",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/63fcb74425b24ea1937867a2a0663f75-512x384.jpg",
    "description": "Immerse yourself in the world of Thread Match — a unique and exciting puzzle where you sort colorful threads to complete embroidery patterns. Unravel layers of palettes, carefully working your way down to reveal hidden threads. Use logic and strategy to avoid running out of moves. But be careful — the color palette can be tricky, and every choice matters!",
    "publisher": "GameBerry Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-11T09:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "In front of you are layered palettes filled with threads. Pick the colors that match the spools shown at the top of the playing field. Remember: lower palettes won’t open until you’ve cleared the ones above! If there’s no matching spool available, you can place threads onto the special white spool. Once the needed color appears, all stored threads on the white spool will be automatically transferred to the correct one. Plan your moves wisely to progress and complete the embroidery!",
    "sourceUrl": "https://gamedistribution.com/games/thread-match/"
  },
  {
    "id": "fe6a3730ae9d47babee7a2a5b26562c8",
    "slug": "math-obby",
    "title": "Math Obby",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/fe6a3730ae9d47babee7a2a5b26562c8-512x384.jpg",
    "description": "Combine your math skills with parkour prowess in Math Obby, an engaging Roblox experience that challenges players with arithmetic problems amidst obstacle courses. Navigate through stages that test both your agility and your knowledge of addition, subtraction, multiplication, and division. Earn badges as you progress and showcase your mastery in this educational adventure.",
    "publisher": "2Play",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-11T08:24:23.241Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "1. Start the Obby: Enter the game and begin your journey through various math-themed obstacle courses.\\n2. Solve Math Problems: At each stage, encounter arithmetic questions that you must answer correctly to proceed.\\n3. Navigate Obstacles: Use your parkour skills to jump, climb, and maneuver through challenging terrains.",
    "sourceUrl": "https://gamedistribution.com/games/math-obby/"
  },
  {
    "id": "4942941a222e4a6bac994c80a856fcb9",
    "slug": "from-nerd-to-popular-ballerina-cappuccina",
    "title": "From Nerd to Popular Ballerina Cappuccina",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/4942941a222e4a6bac994c80a856fcb9-512x384.jpg",
    "description": "From Nerd to Popular: Ballerina Cappuccina is a makeover and dress-up game that follows a sweet transformation story. Ballerina Cappuccina starts as a shy, awkward girl with big dreams—and it’s your job to help her glow up and become the confident ballerina she’s meant to be.\\n\\nStyle her through each stage with fabulous outfits, stylish hairstyles, and elegant accessories. As you dress her up, she slowly sheds her insecurities and gains the charm and confidence needed to shine on stage.",
    "publisher": "Cutedressup",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-11T07:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "Left Mouse Button Click",
    "sourceUrl": "https://gamedistribution.com/games/from-nerd-to-popular-ballerina-cappuccina/"
  },
  {
    "id": "68c91de8354345d38c54aa8f81e13393",
    "slug": "speed-run-3d",
    "title": "Speed Run 3d",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/68c91de8354345d38c54aa8f81e13393-512x384.jpg",
    "description": "Race through glowing 3D tunnels in a fast, reflex-based runner. Read the patterns, react in a split second, and thread the gaps as speed ramps up. Simple one-touch controls keep the focus on pure flow while crisp neon visuals make every run feel clean and satisfying.",
    "publisher": "GameProgramming",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-11T07:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Arrow controls or Mouse drag",
    "sourceUrl": "https://gamedistribution.com/games/speed-run-3d/"
  },
  {
    "id": "9b80233142ea4265a2002596b3866f18",
    "slug": "cat-escape",
    "title": "Cat Escape",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/9b80233142ea4265a2002596b3866f18-512x384.jpeg",
    "description": "The cat accidentally runs into a bad person's home. If it wants to escape, it will face many difficulties. The decoration of the room is not a big problem, the most difficult problem is how to avoid the security guards searching. Don't let them see!",
    "publisher": "bestgames.com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2021-10-28T07:57:06.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Drag to play.",
    "sourceUrl": "https://gamedistribution.com/games/cat-escape/"
  },
  {
    "id": "3fa4363aedb34131a46ce4aa0f36eab2",
    "slug": "water-junk-warriors",
    "title": "Water Junk Warriors",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/3fa4363aedb34131a46ce4aa0f36eab2-512x384.jpg",
    "description": "Water Junk Warriors is a vibrant eco-adventure game where players dive into polluted waterways to clean up human-made junk and restore the natural balance of riverbanks, beaches, and urban canals. Armed with clever tools and a passion for nature, players collect floating trash, unlock animated milestones, and witness the environment come back to life, one subgoal at a time. ",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-10T13:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Use your pointer to drag junk items floating or lying around the main area of the scene. Drop them onto the collector platform at the bottom center.\\nThe collector works in pairs. Match two of the same item to score points.\\nThe more points you earn, the more you progress through the level goals and sub-goals. Keep going until the entire scene is clean!",
    "sourceUrl": "https://gamedistribution.com/games/water-junk-warriors/"
  },
  {
    "id": "6408783a54014b7688d5476f695fed8a",
    "slug": "labubu-jetpack-rush",
    "title": "Labubu Jetpack Rush",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/6408783a54014b7688d5476f695fed8a-512x512.jpg",
    "description": "Fly high in Jetpack Jump with Labubu to survive the escape from the lab! Tap to use the jetpack and release to run . Upgrade your jetpack, your running speed and other upgrades to be able to travel further than before and beat your high score. The further you travel the more money you get!",
    "publisher": "kiz10.com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-10T13:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Use the mouse or touch to play",
    "sourceUrl": "https://gamedistribution.com/games/labubu-jetpack-rush/"
  },
  {
    "id": "4c3c4c89a1cc479c9c3221b0d4e957d4",
    "slug": "guinea-piggy-matching",
    "title": "Guinea Piggy Matching",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/4c3c4c89a1cc479c9c3221b0d4e957d4-512x384.jpg",
    "description": "Guinea Piggy Match uses well known and easy to learn game mechanics. Your target is to take apart a pattern made of tiles. \\nFor each completed level, you are given a golden puzzle piece. For these, you can uncover images of cute guinea piggies.",
    "publisher": "SBC Games",
    "languages": [
      "Czech",
      "English",
      "French",
      "German",
      "Italian",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-10T11:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "Tap a tile in the pattern to move it to the pick area. Complete threes to let them disappear and make free space for next tiles.\\n\\nComplete levels and collect golden puzzle pieces to unlock images of cute guinea piggies. Browse through unlocked images in the gallery.",
    "sourceUrl": "https://gamedistribution.com/games/guinea-piggy-matching/"
  },
  {
    "id": "636ee0fa322a41cba8a1ad1fb23e379f",
    "slug": "stickman-doors-and-island",
    "title": "Stickman Doors and Island",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/636ee0fa322a41cba8a1ad1fb23e379f-512x384.jpg",
    "description": "Open all the criminal's doors and escape from the desert island!\\nYou will have to go through two interesting escape stories.\\nThe first story is about how the criminal kidnapped the character Stick and locked him in the rooms.\\nThe second story is about how the character Stick ended up on an island in the ocean.\\nGo through all the stories, fight for your life! Break open doors, use various objects. Guess all the puzzles and versions of fate.\\n",
    "publisher": "Starodymov Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-10T07:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Find all the successful ways to escape from the rooms and the island.\\nUse your computer mouse to control the game.\\nIf you have a mobile device, use a stylus or your finger.",
    "sourceUrl": "https://gamedistribution.com/games/stickman-doors-and-island/"
  },
  {
    "id": "81129d4c62274aa6b5e1a0e86bd538c4",
    "slug": "wood-color-block",
    "title": "Wood Color Block",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/81129d4c62274aa6b5e1a0e86bd538c4-512x384.jpg",
    "description": "Step into the colorful puzzle world of Wood Color Block, where strategy and quick thinking collide. Slide vibrant blocks into place, match them with their crushers, and clear the board before time runs out. With each level, the puzzles grow more challenging, pushing your skills to the limit.",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-10T05:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Swipe or drag blocks to align them with matching crushers. Once matched, the blocks break, clearing the path forward. Use boosters wisely to overcome tricky situations and manage the ticking clock. Plan your moves carefully—every second and every placement counts!",
    "sourceUrl": "https://gamedistribution.com/games/wood-color-block/"
  },
  {
    "id": "6b0c62c42b0a4648ba7d447c2f2d607a",
    "slug": "math-duck",
    "title": "Math Duck",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/6b0c62c42b0a4648ba7d447c2f2d607a-512x384.jpeg",
    "description": "Math Duck is a math-puzzle platformer game. Help the little duck solve all equations from each level and reach the exit door before time runs out. Good luck!",
    "publisher": "Misc.261 Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2022-09-09T06:10:32.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Move: A, D / Arrows\\nJump: W / Up key\\nRestart: R",
    "sourceUrl": "https://gamedistribution.com/games/math-duck/"
  },
  {
    "id": "ce1c19c59fae4ecb89c3849f10571760",
    "slug": "katana",
    "title": "Katana",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/ce1c19c59fae4ecb89c3849f10571760-512x384.jpg",
    "description": "It's a first-person Katana game!\\nSlice all the enemy ninjas into small pieces and save the hostages. Use multiple katana swords and shurikens. Fight epic bosses and complete the levels.",
    "publisher": "2Play",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-09T09:00:19.659Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Swipe to slice the enemies. Tap to throw shurikens. ",
    "sourceUrl": "https://gamedistribution.com/games/katana/"
  },
  {
    "id": "ef2d9850b5cd4d71a1a2425f3693c543",
    "slug": "egg-adventure:-mirror-world",
    "title": "Egg Adventure: Mirror World",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/ef2d9850b5cd4d71a1a2425f3693c543-512x512.jpg",
    "description": "Mr. Egg accidentally entered the Mirror World. In this world, all the challenges in each level look the same with Egg Adventure 2, but the ways to pass them are different. Use your wisdom to help Mr. Egg bravely pass every level!",
    "publisher": "Yizhiyuan Network Technology Co., Ltd.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-09T07:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": " manipulate eggs to solve all kinds of puzzles and get out of the door",
    "sourceUrl": "https://gamedistribution.com/games/egg-adventure:-mirror-world/"
  },
  {
    "id": "cff20e69cbee4d17a79c29b2f1ce4c6f",
    "slug": "21-cards",
    "title": "21 Cards",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/cff20e69cbee4d17a79c29b2f1ce4c6f-512x384.jpg",
    "description": "21 Cards is a fun and addictive blackjack-style puzzle game where your goal is to reach exactly 21 points in each column. The game combines the thrill of classic card play with a cozy, home-style atmosphere. Place cards wisely, complete columns, and aim for the perfect 21!\\n",
    "publisher": "GameBerry Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-09T07:29:42.876Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Draw a card from the deck and place it into any column you choose. Keep an eye on the score above each column — once you hit 21, the column is cleared and you earn points. But be careful: if the total goes over 21, you lose! Plan your moves, challenge your friends, and see who can score the highest!\\n",
    "sourceUrl": "https://gamedistribution.com/games/21-cards/"
  },
  {
    "id": "c9c7eaeae8484aeda3b27e5543313292",
    "slug": "basketball-rush",
    "title": "Basketball Rush",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/c9c7eaeae8484aeda3b27e5543313292-1280x550.jpg",
    "description": "This isn’t just about shooting — it's about precision, patience and strategy. As you score, the game intensifies, but with helpful power-ups at your disposal, you’ll be ready for anything. Unlock a variety of unique ball skins to customize your game and add even more excitement.",
    "publisher": "Inlogic Software",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Portuguese",
      "Russian",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-09T06:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Drag and release the ball to aim and shoot it into the basket. The more baskets you score, the more difficult the game becomes! Use power-ups to help you in challenging moments. Earn coins with every successful shot to unlock new ball skins. Keep playing to beat your high score and master the game!",
    "sourceUrl": "https://gamedistribution.com/games/basketball-rush/"
  },
  {
    "id": "9ebebcbe06ab48ec812215c3306a766a",
    "slug": "shanghai-chef",
    "title": "Shanghai Chef",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/9ebebcbe06ab48ec812215c3306a766a-512x384.jpg",
    "description": "A fun and fast-paced matching game where you need to find and connect the same blocks! \\nTest your reflexes and observation skills as you quickly spot matching pairs. \\nCan your hands move faster than your eyes can track? \\nPay close attention to which blocks can be linked together and clear the board as fast as possible!",
    "publisher": "MOVISOFT.Co.,Ltd",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-08T13:28:19.359Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "It is a mahjong puzzle game where you select two tiles of the same picture and match them.\\nYou can remove the same tiles by clicking or touching the mouse.\\nI will explain the conditions for removing tiles.\\nWhen connecting two tiles with a line,\\nThe line must bend less than 3 times.\\nThe level is clear when all tiles are removed.",
    "sourceUrl": "https://gamedistribution.com/games/shanghai-chef/"
  },
  {
    "id": "df40c7d69ae547a28fbdac7886f8bacf",
    "slug": "wordling:-daily-word-challenge",
    "title": "Wordling: Daily Word Challenge",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/df40c7d69ae547a28fbdac7886f8bacf-512x384.jpg",
    "description": "Wordling is a fun, free daily word puzzle game where you guess the hidden word in 6 tries using color-coded clues. Perfect for adults and seniors who love brain games, spelling challenges, and relaxing, ad-free gameplay. Explore all game modes!",
    "publisher": "TapNation",
    "languages": [
      "Arabic",
      "English",
      "French",
      "German",
      "Italian",
      "Japanese",
      "Korean",
      "Portuguese",
      "Russian",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-08T13:29:02.737Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Click on the letters and check which letters match!",
    "sourceUrl": "https://gamedistribution.com/games/wordling:-daily-word-challenge/"
  },
  {
    "id": "15048dd9551c4585b05615ec8668332a",
    "slug": "shape-transforming:-shifting-run",
    "title": "Shape Transforming: Shifting Run",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/15048dd9551c4585b05615ec8668332a-512x512.jpg",
    "description": "Get ready to dive into the exhilarating world of Shape Transforming: Shifting Run, where the power of transformation is in your hands! This game is a thrilling journey across diverse terrains, challenging players to adapt, transform, and conquer. If you have a knack for quick thinking and love dynamic gameplay, this is the perfect game for you! ??",
    "publisher": "Bravestars Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-08T08:01:05.718Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "- Transform the character to suit the environment.\\n- Make sure you choose the right one to become the winner.\\n- The higher level it is, the more difficult game-play it is.",
    "sourceUrl": "https://gamedistribution.com/games/shape-transforming:-shifting-run/"
  },
  {
    "id": "36b51a1ce2bc489092af4b0f5a02a850",
    "slug": "giant-crowd-io-house-capture",
    "title": "Giant Crowd io House Capture",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/36b51a1ce2bc489092af4b0f5a02a850-512x384.jpg",
    "description": "Come to lead your squad in Giant Crowd io House Capture, a fun .io strategy adventure game. You will expand your power in the city, occupy more houses and become the winner of the city. Grow your crowd by collecting more followers as you explore the city.",
    "publisher": "bestgames.com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-07T13:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/giant-crowd-io-house-capture/"
  },
  {
    "id": "eabe56a091214e9baae5c7545739b53e",
    "slug": "idle-pop-merge",
    "title": "Idle Pop Merge",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/eabe56a091214e9baae5c7545739b53e-512x384.jpg",
    "description": "Get ready for endless fun in Idle Pop Merge! Drag and drop characters into the slots to merge them into stronger versions. The more you merge, the more powerful your team becomes. It's a simple, addictive game that anyone can enjoy—whether you’re on desktop or mobile. Perfect for players who love puzzle challenges with a strategic twist!",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [],
    "firstActiveDate": "2025-09-07T13:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Getting started with Idle Pop Merge is easy. Begin by selecting characters and dragging them into the available slots on the game board. When two characters of the same type are adjacent, they merge into a stronger character. Continue merging characters to progress through levels and unlock new challenges. The game's intuitive interface ensures that players of all ages can enjoy the merging madness.",
    "sourceUrl": "https://gamedistribution.com/games/idle-pop-merge/"
  },
  {
    "id": "f03fb0a7474749b9bcb2c5c804eb5a4e",
    "slug": "skip-love",
    "title": "Skip Love",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/f03fb0a7474749b9bcb2c5c804eb5a4e-512x384.jpg",
    "description": "Ready for a funny, brain-teasing love adventure? Play an addictive brain teaser puzzle game in Skip Love. A funny little stickman hero trying to win the heart of his beloved while dodging all sorts of dangers! Each level has unique puzzles that make you think and laugh! Think and use your brain to overcome each challenge, helping the man overcome his sexy wife and lover. For example, help him disguise himself as a clown, disrupt, create chaos, etc.",
    "publisher": "PuzzleGame.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-07T13:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/skip-love/"
  },
  {
    "id": "1f2031ffee5746f990f1dbad0c9d8b61",
    "slug": "connect-em-all",
    "title": "Connect Em All",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/1f2031ffee5746f990f1dbad0c9d8b61-512x384.jpg",
    "description": "Play Connect Em All Online and Solve Colorful Dot Puzzles. Connect Em All is an exciting and addictive puzzle game that you can enjoy for free right in your browser. The goal is simple yet surprisingly challenging: connect all the dots of the same color to complete each level. It sounds easy at first, but as the puzzles grow in size and complexity, you will need clever thinking and careful planning to succeed.\\n",
    "publisher": "Vi Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-07T12:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Portrait",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "To start, simply click or tap on a dot and drag a line to another dot of the same color. Once connected, the line will stay in place unless you choose to remove it. If you make a mistake or want to try a different path, click on the line to erase it and start again. The challenge comes from making sure all lines fit together without overlapping and that every dot is connected before the puzzle is complete.\\n",
    "sourceUrl": "https://gamedistribution.com/games/connect-em-all/"
  },
  {
    "id": "4346016018aa4beca3dcc8a11393b08c",
    "slug": "math-box-balance",
    "title": "Math Box Balance",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/4346016018aa4beca3dcc8a11393b08c-512x384.jpg",
    "description": "Math Box Balance is a puzzle game with numbers. Early levels have 2 boxes, and as you progress you can reach up to 8 boxes. Each box contains 4 number blocks, and the sum of these numbers is shown inside the box. Your goal is to make the sum of all boxes equal. You can swap number blocks between boxes to achieve the equal sum. It is an endless game where the difficulty increases over time, your score goes up, and the fun grows with it.",
    "publisher": "Lof Games",
    "languages": [
      "Arabic",
      "Bulgarian",
      "Chinese (Simplified)",
      "Czech",
      "Danish",
      "Dutch",
      "English",
      "Estonian",
      "Finnish",
      "French",
      "German",
      "Greek",
      "Hebrew",
      "Hindi",
      "Hungarian",
      "Indonesian",
      "Italian",
      "Japanese",
      "Korean",
      "Latvian",
      "Lithuanian",
      "Norwegian (Nynorsk)",
      "Polish",
      "Portuguese",
      "Romanian",
      "Russian",
      "Serbian",
      "Simple English",
      "Slovak",
      "Spanish",
      "Swahili",
      "Swedish",
      "Tagalog",
      "Thai",
      "Turkish",
      "Ukrainian",
      "Vietnamese"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-07T09:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use a mouse or touch pad to play this game.",
    "sourceUrl": "https://gamedistribution.com/games/math-box-balance/"
  },
  {
    "id": "7918aa0f4f7646eda1bc7d8a7c43263c",
    "slug": "block-breaker",
    "title": "Block Breaker",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/7918aa0f4f7646eda1bc7d8a7c43263c-512x384.jpeg",
    "description": "Block Breaker is a casual and very fun game. Break all the blocks in each level to collect points and advance levels. Collect powerups to break many blocks and to increase your body. Good luck and have fun!",
    "publisher": "Fun Best Games",
    "languages": [],
    "mobile": [
      "ForAndroid"
    ],
    "firstActiveDate": "2020-09-07T14:50:32.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Use mouse, arrow keys to move or touch the screen!",
    "sourceUrl": "https://gamedistribution.com/games/block-breaker/"
  },
  {
    "id": "29632c22779b4fa88731722d502b72a3",
    "slug": "my-horse-is-amazing",
    "title": "My horse is amazing",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/29632c22779b4fa88731722d502b72a3-512x512.jpg",
    "description": "Ride a horse and overcome obstacles: fences, pits and water obstacles. Control the jumps — tap and release to jump accurately.\\n\\nCollect powerups with powerups — increase attack and health. The further you run, the stronger your horse becomes!\\n\\nYour steed is growing: it's getting faster and more powerful. Upgrade it and keep running. At the end of each level is a boss battle! Show what you are capable of!\\n",
    "publisher": "GamePush",
    "languages": [
      "English",
      "German",
      "Italian",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-07T04:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Turn:\\n\\nHold down the left mouse button and move it to control the horse left or right. If you're playing on a smartphone, just swipe your finger across the screen.\\n\\nJump:\\n\\nA double mouse click or double tap on the screen will allow your horse to make an impressive jump.",
    "sourceUrl": "https://gamedistribution.com/games/my-horse-is-amazing/"
  },
  {
    "id": "81d1ba7a25164cbfbb1c5add4b98e59e",
    "slug": "meatrider",
    "title": "MeatRider",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/81d1ba7a25164cbfbb1c5add4b98e59e-512x512.jpg",
    "description": "Welcome to \\",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [],
    "firstActiveDate": "2025-09-06T17:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "YoungAdults",
      "Adults",
      "Seniors",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Choose a car, press the \\",
    "sourceUrl": "https://gamedistribution.com/games/meatrider/"
  },
  {
    "id": "925c6df6384146109bc36e0819ea3e02",
    "slug": "perfect-job-run",
    "title": "Perfect Job Run",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/925c6df6384146109bc36e0819ea3e02-512x384.jpg",
    "description": "Run your way to the perfect job. In the Perfect Job Run, you'll run the platform of the workplace. Facing various challenges, selecting the right career path and becoming a winner in the workplace. There will be different career tests along the way. Quickly select tools to accomplish tasks.",
    "publisher": "bestgames.com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-06T13:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/perfect-job-run/"
  },
  {
    "id": "2bd0cefbfab24af8addbc8ddadcd93ce",
    "slug": "sneaker-factory!",
    "title": "Sneaker Factory!",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/2bd0cefbfab24af8addbc8ddadcd93ce-512x384.jpg",
    "description": "Manage your own sneaker factory in this fast-paced online game! Complete orders, organize sneakers, deliver shipments, and rise through the ranks. Put your speed, strategy, and management skills to the test to become the city’s leading factory!",
    "publisher": "Playgama",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-06T13:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "PC Management:\\nBy clicking on the buttons\\nDuring cargo delivery:\\nLeft Arrow - Brake/Reverse gear\\nRight Arrow - Gas\\nSpace Bar - Jump\\n\\nManagement for Mobile devices:\\nBy clicking on the buttons\\nDuring cargo delivery:\\nLeft arrow button - Brake/Reverse\\nRight arrow button - Gas\\nUp arrow button - Jump\\n\\nThe level depends on the amount of reputation. Reputation can be earned by building improvements, sorting, order fulfillment, and shipping.",
    "sourceUrl": "https://gamedistribution.com/games/sneaker-factory!/"
  },
  {
    "id": "50ab04a8916d4c30877160985ac5f762",
    "slug": "horror-school-detective-story",
    "title": "Horror School Detective Story",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/50ab04a8916d4c30877160985ac5f762-512x384.jpg",
    "description": "Ready to enter a horror school full of scares and mysteries? In Horror School: Detective Story, you’ll play the role of a brave detective. Solve the mysteries layered on top of each other at the school. Each scene is tense and exciting, full of suspense and the unknown! Choose the complexity of the scenario to start your challenge.",
    "publisher": "PuzzleGame.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-06T13:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/horror-school-detective-story/"
  },
  {
    "id": "8cd322364cd04efd836221431312f0ca",
    "slug": "tarcat",
    "title": "Tarcat",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/8cd322364cd04efd836221431312f0ca-512x384.jpg",
    "description": "Enter the world of feline destruction with Tarcat, a hilarious casual game where you control a cats paw! Your goal? Smash all targets with quick reflexes and pinpoint accuracy!\\n\\nWith just one tap, hit targets, avoid traps, and dominate each level with the style of a true feline destroyer.",
    "publisher": "Newness Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-06T09:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "USE THE MOUSE CLICK\\nTOUCH THE SCREEN",
    "sourceUrl": "https://gamedistribution.com/games/tarcat/"
  },
  {
    "id": "616d699a34ae4e9188d3b73503fee7b8",
    "slug": "komaru-cat",
    "title": "Komaru cat",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/616d699a34ae4e9188d3b73503fee7b8-512x384.jpg",
    "description": "Take care of Komaru the cat! Pet her, feed her, bathe her, and tuck her in for sleep!\\nDress her up in stylish looks! Hats, glasses, collars, new fur colors, and more! Experiment and create your own unique cat!\\nPlay the merge mini-game, compete on the leaderboard, and earn coins!\\nWatch the best video memes with funny moments from her life!\\nComplete the daily challenges and come back tomorrow, Komaru will miss you!\\nTry to unlock all achievements! Come and have fun!",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-06T07:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Complete daily tasks, earn coins, and don't forget to collect your daily reward!\\nEvery interaction with Komaru until the progress bar is full rewards you with experience and coins.\\n\\nAccept the call (by pressing the green button)\\nDecline the call (by pressing the red button)\\nTo see all the memes, scroll down the screen:\\nOn a computer, use your cursor (drag down);\\nOn a phone, use your finger.",
    "sourceUrl": "https://gamedistribution.com/games/komaru-cat/"
  },
  {
    "id": "1341eb00a1c04730b19524dcdcf23017",
    "slug": "draw-to-crush-:-monster-game",
    "title": "Draw To Crush : Monster Game",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/1341eb00a1c04730b19524dcdcf23017-512x512.jpg",
    "description": "Play the thrilling \\",
    "publisher": "Games Fort Studios",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-06T07:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Strategically sketch and destroy the evil monsters in this monster game, unveiling mysteries through intricate puzzles. Each drawn shape influences the outcome uniquely, demanding strategic thinking. Your tactical approach to solving puzzles and battling monster in this draw lines satisfying games is key to victory.",
    "sourceUrl": "https://gamedistribution.com/games/draw-to-crush-:-monster-game/"
  },
  {
    "id": "484487c7d43b415c85db89d8e007c684",
    "slug": "ultra-realistic-blockcraft",
    "title": "Ultra Realistic BlockCraft",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/484487c7d43b415c85db89d8e007c684-512x384.jpg",
    "description": "Help Steve in the ultra-realistic block world and make sure he reaches the portal. Remember, this realistic world is extremely challenging and monsters are roaming everywhere. You must collect all the diamonds. While collecting diamonds, don’t forget to open the chests you find along the way. Open the chests and crush all the monsters. Reach the portal at the end of the level safely to complete the stage. Remember, you only have one life and if it runs out you will lose everything you’ve earned.",
    "publisher": "FBK",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-06T06:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "*If your life runs out, your progress in the game will be erased, so you must play very carefully.\\n*Use the “WASD” keys to play.\\n*Jump on top of the monsters to crush them.\\n*Find all the diamonds and chests and reach the end of the level.",
    "sourceUrl": "https://gamedistribution.com/games/ultra-realistic-blockcraft/"
  },
  {
    "id": "5e41c93bc2284e158cc5faa719aba03b",
    "slug": "max-crusher:-crazy-destruction-and-car-crashes",
    "title": "Max Crusher: Crazy Destruction and Car Crashes",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/5e41c93bc2284e158cc5faa719aba03b-1280x550.jpg",
    "description": "Max Crusher: Crazy Destruction and Car Crashes is an exciting game in which the player has to become a real wrecking racer.\\n\\nThere are many unique cars available in the game, each of which has its own characteristics and capabilities. From classic sports cars to massive monster trucks, you will have complete freedom to choose the vehicle for your crazy adventures.",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-05T17:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Control:\\nWASD - Driving.\\nShift - nitro.\\nR - turn the car over.\\nC - camera change.\\nEsc - call MENU.\\nT - Time dilation.\\nSpace - handbrake.\\n\\nControls for mobile devices:\\nUse the game interface on the screen.",
    "sourceUrl": "https://gamedistribution.com/games/max-crusher:-crazy-destruction-and-car-crashes/"
  },
  {
    "id": "6209ad03dc334326a2e134ae912bc2b9",
    "slug": "magic-princess-dress-up-doll",
    "title": "Magic Princess Dress Up Doll",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/6209ad03dc334326a2e134ae912bc2b9-512x384.jpg",
    "description": "Welcome to Magic Princess Dress Up Doll, a casual dress-up game for girl gamers. Have you ever dreamed of becoming a beautiful princess one day? Are you an enthusiast of dressing up fashion dolls? Come join us and realize all your imaginations about fashion design! This is a fashion design game where you can make up your own doll from scratch.",
    "publisher": "Yiv.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-05T15:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/magic-princess-dress-up-doll/"
  },
  {
    "id": "e8efd6c9408a48e782472e2c962986b5",
    "slug": "labubu-and-me",
    "title": "Labubu And Me",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/e8efd6c9408a48e782472e2c962986b5-512x384.jpg",
    "description": "Play this fun game for girls where you style your own Labubu monster and yourself! Customize Labubu with fur colors, eyes, tops, stickers, and accessories. Then, match your makeup and outfits to create the ultimate twin look. From trendy dresses and cute bags to stylish hairstyles, show off your fashion skills and creativity. Perfect for fans of Labubu games and makeover fun!",
    "publisher": "Gamerina",
    "languages": [
      "English",
      "Portuguese",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-05T13:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use your mouse to play this game on a desktop, tap to play on mobile devices. ",
    "sourceUrl": "https://gamedistribution.com/games/labubu-and-me/"
  },
  {
    "id": "4ddc9e3502334cfca08e06db4032f8ae",
    "slug": "cosmic-dash",
    "title": "Cosmic Dash",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/4ddc9e3502334cfca08e06db4032f8ae-512x384.jpg",
    "description": "Jump into Cosmic Dash – an endless space runner full of speed and challenges! Dodge debris, break through asteroids, and gather tokens as you race across the solar system. Use boosts, shrinks, and jumps to chase high scores and experience thrilling interplanetary action!",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-05T13:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Your mission is to dash through space, travel as far as possible, and collect tokens while avoiding or destroying obstacles.\\n\\nControls (Keyboard):\\nJump – Press UP arrow\\nShrink – Press DOWN arrow to squeeze through tight gaps and space junk\\nMove – Use LEFT / RIGHT arrows to change position\\nBoost – Press SPACE to speed up and smash through asteroids\\nControls (Touch / Mobile):\\nJump – Swipe UP\\nShrink – Swipe DOWN\\nMove – Swipe LEFT / RIGHT\\nBoost – Tap the screen",
    "sourceUrl": "https://gamedistribution.com/games/cosmic-dash/"
  },
  {
    "id": "2d76470c627847b8b0a5171766d2db61",
    "slug": "fire-snake",
    "title": "Fire snake",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/2d76470c627847b8b0a5171766d2db61-1280x720.jpg",
    "description": "Help the fire snake slither safely home! Dodge dangerous obstacles, collect shiny coins, and master tricky levels. Can you guide the snake through every challenge? Play now and test your skills!",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-05T08:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Guide the fiery snake home! Dodge obstacles, grab bonuses, and slither through challenging levels. How far can you go?",
    "sourceUrl": "https://gamedistribution.com/games/fire-snake/"
  },
  {
    "id": "084076b9e54b4eafa751f6f1398cc88e",
    "slug": "satisdom",
    "title": "Satisdom",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/084076b9e54b4eafa751f6f1398cc88e-512x384.jpg",
    "description": "Step into the calm and quirky world of Satisdom — a game where every little task feels oddly satisfying. Whether you're dragging, tapping, sorting or matching, each level is a chance to relax and have fun. Designed to run smoothly on both phones and computers, Satisdom is the perfect escape for anyone who loves simple pleasures and playful puzzles. Slow down, enjoy the details, and let yourself get lost in the fun.",
    "publisher": "Playgama",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-04T13:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Getting started with Satisdom is a breeze. Begin by selecting the task you want to tackle. Use your mouse or touch screen to drag and tap objects, sort items into categories, match pairs, or assemble pieces. The intuitive controls ensure you can navigate through tasks effortlessly, whether you're playing on a computer or a mobile device.",
    "sourceUrl": "https://gamedistribution.com/games/satisdom/"
  },
  {
    "id": "24ecc6238cea434b8730609226d5f0c2",
    "slug": "bubble-around",
    "title": "Bubble Around",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/24ecc6238cea434b8730609226d5f0c2-512x512.jpg",
    "description": "Bubble Around is bubble shooter with a twist. You shoot the bubbles from the inside to the playing field around you. Match 3 or more bubbles to make them pop. Clear all bubbles to complete the level. Each level will be slightly more challenging. Stuck in a level? Use the bomb, rocket or multi color power up. Find out all level shapes!",
    "publisher": "Bubble Shooter",
    "languages": [
      "Dutch",
      "English",
      "French",
      "German",
      "Italian",
      "Polish",
      "Portuguese",
      "Spanish",
      "Swedish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-04T11:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "The goal is to match 3 ore more bubbles to burst and remove them.",
    "sourceUrl": "https://gamedistribution.com/games/bubble-around/"
  },
  {
    "id": "80df807ffe8a4f41b30c2e647d3567e2",
    "slug": "squid-game-hunter",
    "title": "Squid Game Hunter",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/80df807ffe8a4f41b30c2e647d3567e2-512x384.jpg",
    "description": "Step into the thrilling world of Squid Game – a fast-paced game for stealthy and strategic players that takes you on a wild adventure as a hunter with a deadly knife. With multiple Squid games enemies to kill, challenging missions to complete, and rewards to collect, this game will test your skills and keep you on the edge of your seat.\\n",
    "publisher": "kiz10.com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-04T07:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Teens",
      "Portrait",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Use the mouse or touch to play",
    "sourceUrl": "https://gamedistribution.com/games/squid-game-hunter/"
  },
  {
    "id": "f48d9f456df34590b55abac6a8c2ff87",
    "slug": "dolphin-couple-underwater-dress-up",
    "title": "Dolphin Couple Underwater Dress Up",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/f48d9f456df34590b55abac6a8c2ff87-512x384.jpg",
    "description": "In Dolphin Couple Underwater Dress Up, you get to explore a vibrant underwater world where two playful dolphins are ready to get glammed up! This charming dress-up game lets you choose outfits, accessories, and fun props to create a stylish underwater look for both dolphins.",
    "publisher": "Cutedressup",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-04T07:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Left Mouse Button Click",
    "sourceUrl": "https://gamedistribution.com/games/dolphin-couple-underwater-dress-up/"
  },
  {
    "id": "919644af743a4a7a971738bbf2377e83",
    "slug": "catch-thief",
    "title": "Catch Thief",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/919644af743a4a7a971738bbf2377e83-512x384.jpg",
    "description": "Catch Thief is an addictive puzzle game where you must outsmart a clever thief and stop his escape. Take control of the police, block every possible path and drive the criminal into a dead end. With each new level the challenge grows, requiring you to plan ahead, think strategically and act quickly. Bright cartoon graphics, fun scenarios and increasing difficulty make Catch Thief a perfect choice for fans of logic games who enjoy testing their skills, attention and reaction speed.\\n",
    "publisher": "GameBerry Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-04T07:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Tap or click on a police officer and then on the dot where you want him to move. Place your heroes wisely to block the thief’s escape routes. Simple controls, colorful visuals and dynamic gameplay make Catch Thief easy and fascinating",
    "sourceUrl": "https://gamedistribution.com/games/catch-thief/"
  },
  {
    "id": "2dd5cc92409f4593a7e10034e9202257",
    "slug": "dop:-draw-one-part",
    "title": "DOP: Draw One Part",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/2dd5cc92409f4593a7e10034e9202257-512x384.jpg",
    "description": "► Can you see what’s missing? \\n\\nWhat a pretty picture, but don’t you get the nagging feeling that something’s not quite right? What’s the final touch that will make the image complete? \\n\\nEngage your brain, your imagination and your artistic talents to identify the missing element and add it to the drawing in this delightful puzzle game that will get you thinking and make you smile time and time again.",
    "publisher": "SayGames Ltd",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-04T05:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Female",
      "YoungAdults",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Test your brain! Just draw the missing part to solve this awesome puzzle!\\n\\n► Play Draw One Part now and get both sides of your brain working in perfect harmony to solve endless beautiful, satisfying puzzles with real creative flair.",
    "sourceUrl": "https://gamedistribution.com/games/dop:-draw-one-part/"
  },
  {
    "id": "3ff5df9f5d0248fd9dcd70e2cc253de5",
    "slug": "summer-rider-3d",
    "title": "Summer Rider 3D",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/3ff5df9f5d0248fd9dcd70e2cc253de5-512x384.jpg",
    "description": "Hit the waves in Summer Rider 3D, a sun-soaked surf adventure inspired by high-speed endless runners. Glide over water on a surfboard or jet-ski, collect shimmering starfish, and push your reflexes to the limit as the speed cranks up. With a colorful summer theme and upbeat tropical soundtracks, the game offers endless fun for both solo and 2 player mode!",
    "publisher": "gameVgames",
    "languages": [
      "Arabic",
      "English",
      "German",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-03T12:46:53.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "ARROW KEYS or WASD: Move left, right, or jump to navigate waves and obstacles.\\nOn MOBILE, tap left/right to steer, both sides to jump!",
    "sourceUrl": "https://gamedistribution.com/games/summer-rider-3d/"
  },
  {
    "id": "f58b7225d9014346b2a59f08c60700c7",
    "slug": "manyunya-saving-the-princess",
    "title": "Manyunya Saving the Princess",
    "category": "Simulation",
    "thumbnail": "https://img.gamedistribution.com/f58b7225d9014346b2a59f08c60700c7-1280x720.jpg",
    "description": "Welcome to the time when there were knights, magic, farmers, princesses, and generals. Manyunya sets off at the request of the Supreme Lord to save his princess. On the way you will find a whole dangerous adventure, you will come across colorful views, and characters with whom you can communicate and interact, as well as enemies that you will need to defeat at any cost, and save the princess, and complete the task. Interesting voice acting and story will immerse you in this world with your head!",
    "publisher": "Starodymov Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-03T07:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Simulation",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "To control the game, use your computer mouse. If you have a mobile device, use screen tapping. To complete the game, you need to press different buttons indicated on the screen in the game. To defeat the enemy, you need to quickly press the sight.",
    "sourceUrl": "https://gamedistribution.com/games/manyunya-saving-the-princess/"
  },
  {
    "id": "6529282c80f84c4c905380a86d778ee8",
    "slug": "animal-royal",
    "title": "Animal Royal",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/6529282c80f84c4c905380a86d778ee8-1280x720.jpg",
    "description": "\\",
    "publisher": "Ultra Games Entertainment Private limited",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-03T07:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Click, Drag \\u0026 Drop",
    "sourceUrl": "https://gamedistribution.com/games/animal-royal/"
  },
  {
    "id": "02b2b8f66515455099143d7bec3b2346",
    "slug": "eastern-star-vs-city-style-icon",
    "title": "Eastern Star vs City Style Icon",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/02b2b8f66515455099143d7bec3b2346-512x384.jpg",
    "description": "Welcome to the world of style, where the ancient palaces of the East meet the splendor of a modern metropolis! Two beautiful heroines are waiting for you in the game: an oriental beauty with exquisite outfits in the style of an Ottoman fairy tale and a stylish urban fashionista conquering the catwalks of the metropolis. During the game, you will become a fashion stylist and create unique looks for each of the girls. Choose your side in the cultural dispute and make this choice a reality!",
    "publisher": "DL-studio",
    "languages": [
      "No Text"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-03T07:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Get to know the fashionable life of the medieval and modern East. Feel free to mix elements of an oriental fairy tale and modern glamour; choose the appropriate makeup and hairstyles; add bright accessories to the image. You can save the most interesting images at the end of the game as PNG images. Depending on the gaming device, either a click of a computer mouse or a simple touch on touchscreens is used to control it.",
    "sourceUrl": "https://gamedistribution.com/games/eastern-star-vs-city-style-icon/"
  },
  {
    "id": "b00ba96e1d1c4a739454fd9c1e8f7393",
    "slug": "draw-climber",
    "title": "Draw Leg",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/b00ba96e1d1c4a739454fd9c1e8f7393-512x384.jpeg",
    "description": "Draw and then – climb and run! you must draw legs first.Make sure to draw a new pair every time the character faces new obstacles – different challenges need diverse shapes of the legs.Run fast and get through all the levels successfully!",
    "publisher": "BPTop",
    "languages": [],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2020-04-09T14:37:34.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Female",
      "Kids",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Draw your legs to win the race!",
    "sourceUrl": "https://gamedistribution.com/games/draw-climber/"
  },
  {
    "id": "3f0aec385266424bb0529dfcecfe30b4",
    "slug": "charger-city-driver",
    "title": "Charger City Driver",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/3f0aec385266424bb0529dfcecfe30b4-1280x720.jpg",
    "description": "Get ready to skid the wheels of a stunning muscle car through an expansive night city map! Customize and upgrade your muscle car with cool upgradables and become the best driver in the city. Take your dog with you in 4 driving challenges and conquer the missions together. Use nitro to beat slow traffic and beat all speed, stunt and drift triggers spread across the map. Are you ready to show your driving skills? Prove yourself!",
    "publisher": "Fuego! Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-02T06:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Car:\\nArrow Keys/W, A, S, D: Drive/Steer/Brake\\nC: Change Camera\\nF: Nitro\\n\\nCharacter:\\nArrow Keys/W,A,S,D: Move\\nMouse Orbit: Look Around",
    "sourceUrl": "https://gamedistribution.com/games/charger-city-driver/"
  },
  {
    "id": "3880781bb67a4c0abcdc3b35e40fd8c5",
    "slug": "tiles-of-the-unexpected-2",
    "title": "Tiles of the Unexpected 2",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/3880781bb67a4c0abcdc3b35e40fd8c5-512x384.jpg",
    "description": "Tiles of the Unexpected 2 is a puzzle game with a dark military theme and refined gameplay. Clear groups of tiles, set off chain reactions, and plan each move carefully as the board shifts and collapses. The classic mechanics from Tiles of the Unexpected return with smoother controls and a sharper, more intense style.\\n\\nThe game introduces a new Time Attack mode, where speed and strategy are key. Clear tiles quickly to push back enemy forces and survive as long as possible.\\n",
    "publisher": "Azerion Casual Games",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Japanese",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-01T11:46:19.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use your mouse to click on groups of matching tiles to clear them. Plan your moves to create chain reactions and earn higher scores. In Time Attack mode, clear tiles as fast as possible to defend your base.",
    "sourceUrl": "https://gamedistribution.com/games/tiles-of-the-unexpected-2/"
  },
  {
    "id": "737ae324560947089860f0145c0346e3",
    "slug": "toy-match-3",
    "title": "Toy Match 3",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/737ae324560947089860f0145c0346e3-512x384.jpg",
    "description": "Toy Match 3 is the third sequel to one of our cutest Match 3 puzzle games! Get ready for colorful graphics, fun animations, and a catchy soundtrack. Match adorable toys in over 4,100+ exciting levels and take on Daily Missions and Weekly Challenges! Embark on thrilling quests like the Treasure Hunt for amazing rewards. With tons of extras and surprises, Toy Match 3 is pure puzzle fun. Start playing now for free!",
    "publisher": "SOFTGAMES – Mobile Entertainment Services GmbH",
    "languages": [
      "Dutch",
      "English",
      "French",
      "German",
      "Italian",
      "Polish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-01T11:45:15.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "Match three or more identical items to clear them from the board and reach the level goal. Swap adjacent pieces to create matches and earn points. Each level has specific objectives—complete them within a limited number of moves! Use special boosters to clear obstacles and tough spots. Watch out for unique challenges as you progress. Complete Daily Missions, unlock quests, and plan your moves wisely to master every level in this exciting Match 3 adventure!",
    "sourceUrl": "https://gamedistribution.com/games/toy-match-3/"
  },
  {
    "id": "fed5711667c840b3a394043324bf0def",
    "slug": "traffic-cop-3d",
    "title": "Traffic Cop 3D",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/fed5711667c840b3a394043324bf0def-1280x720.jpg",
    "description": "Traffic Cop 3D is a casual game where you play as a police officer enforcing the law of the road. Scan nearby drivers and use intel from the police database to decide whether you should pull them over, or let them go, all while progressing through the story and increasing your duties as a cop.",
    "publisher": "Kwalee",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-01T10:45:49.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Use the left mouse button on desktop or touch on mobile to play the game.",
    "sourceUrl": "https://gamedistribution.com/games/traffic-cop-3d/"
  },
  {
    "id": "0470cd6225c54abb9cd854dd6c71cbe9",
    "slug": "princess-run-3d",
    "title": "Princess Run 3D",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/0470cd6225c54abb9cd854dd6c71cbe9-512x384.jpg",
    "description": "Want a magical and exciting running adventure? Step into Princess Run 3D, a fun 3D platform arcade game full of exciting challenges. Play as a fearless princess racing through colorful 3D worlds. Collect beautiful clothes, shoes, hair, etc. Increase your charisma to get a maid of honor. They're going to help you fend off enemies in front of you or dirty mud, rain, etc. Be careful to avoid ugly clothes, costumes, bad weather, etc.",
    "publisher": "bestgames.com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-01T07:25:33.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/princess-run-3d/"
  },
  {
    "id": "8c388ef95e04425fb807e5cf7829d08f",
    "slug": "mahjong-3d-match",
    "title": "Mahjong 3D Match",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/8c388ef95e04425fb807e5cf7829d08f-512x384.jpg",
    "description": "Welcome to the 3D Mahjong adventure! Challenge your mind with speed and precision. Plan your moves, view the board from all angles and remove pieces intelligently. Beat increasingly difficult levels, play offline and relax with immersive music.\\n",
    "publisher": "Inlogic Software",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Portuguese",
      "Russian",
      "Spanish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-01T07:09:14.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Tap 3 identical pieces to collect them before time runs out. Clear the board quickly to earn more stars and coins. Visit the shop to unlock 4 unique skills, complete daily events and use helpful aids like shuffling pieces and extra time to keep advancing.\\n",
    "sourceUrl": "https://gamedistribution.com/games/mahjong-3d-match/"
  },
  {
    "id": "e3c98c62b82749a7b0b5d5de77a9ef8e",
    "slug": "uncle-hit:-punch-the-dummy",
    "title": "Uncle Hit: Punch the Dummy",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/e3c98c62b82749a7b0b5d5de77a9ef8e-512x512.jpg",
    "description": "Uncle Hit: Punch the Dummy is a fast-paced action game where you take out your frustration on a relentless, annoying dummy. With quick reflexes and nonstop punches, you’ll unleash a flurry of blows in simple, satisfying bursts. Stay sharp, keep hitting, and enjoy every moment of chaotic stress relief wrapped in hilarious impact.",
    "publisher": "Bravestars Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-09-01T07:09:37.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Tap the screen to punch the annoying dummies.",
    "sourceUrl": "https://gamedistribution.com/games/uncle-hit:-punch-the-dummy/"
  },
  {
    "id": "298e1a444b394ec7b6a3b2ad097a0dd3",
    "slug": "wood-blocks-jam",
    "title": "Wood Blocks Jam",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/298e1a444b394ec7b6a3b2ad097a0dd3-512x512.jpg",
    "description": "Wood Blocks Jam is a relaxing logic puzzle game with colorful wooden blocks. Your goal is to drag each block into a gate of the same color. No time limits — just calm, thoughtful gameplay.\\n\\nEnjoy thousands of handcrafted levels with increasing difficulty and new mechanics to discover.",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-31T16:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Wood Blocks Jam is easy to learn and fun to master:\\n\\nOn mobile: Drag blocks with your finger and drop them into the matching color gates.\\n\\nOn desktop: Click and hold the left mouse button to grab a block, then drag it to the correct gate.\\n\\nYour goal is to clear the board by matching each colored block with its corresponding gate. As you progress, the puzzles get trickier — introducing new mechanics, obstacles, and challenges. Think ahead, plan your moves carefully, and don’t forget to use",
    "sourceUrl": "https://gamedistribution.com/games/wood-blocks-jam/"
  },
  {
    "id": "76133065a48d4dcc9be76ef2ca336713",
    "slug": "dudu-engineering-truck",
    "title": "Dudu Engineering Truck",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/76133065a48d4dcc9be76ef2ca336713-512x384.jpg",
    "description": "DuDu Engineering Truck is a casual and puzzle game where you drive engineering trucks to finish tasks on the worksite. Use your sensitivity to shapes to construct a truck and conquer all challenges ahead. If you love car designing and car games, never miss DuDu Engineering Truck! You will enjoy an adventurous journey of being an engineer.",
    "publisher": "Yiv.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-31T14:20:04.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/dudu-engineering-truck/"
  },
  {
    "id": "98dd55c5894841ad9dec81bb366d0e83",
    "slug": "word-of-fortune",
    "title": "Word of Fortune",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/98dd55c5894841ad9dec81bb366d0e83-512x384.jpg",
    "description": "Guess the hidden 5-letter word, solving the clue and using spins of the letter wheel to get hints! You get 3 spins to reveal letters and 2 guesses to solve it. Win and earn your title, or miss, and you’re out! Each day brings a new puzzle, plus extra themed levels to explore.\\nThis game is great for players of all ages, and it's a fun way to spend time and test vocabulary and mental abilities!",
    "publisher": "Lady Puzzle Pro",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-31T13:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Guess the word solving the clue. Each puzzle begins with a short hint to guide your thinking.\\nNeed more hints?\\n1. Spin the Wheel (Up to 3 times)\\n2. Make Your Guesses (Up to 2 tries)\\n3. Win or Lose\\n4. Explore Themed Levels – Want more? Try special puzzles based on fun themes anytime.",
    "sourceUrl": "https://gamedistribution.com/games/word-of-fortune/"
  },
  {
    "id": "dd9f6afeaa094c3bb262e23f04a7119d",
    "slug": "stick-rope-hero",
    "title": "Stick Rope Hero",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/dd9f6afeaa094c3bb262e23f04a7119d-512x384.jpg",
    "description": "Are you ready to become a super stickman hero? In Stick Rope Hero, you enter an exciting sandbox world filled with adventures and challenges. Swing around the open city with your powerful rope skills and completing many action tasks.",
    "publisher": "bestgames.com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-31T12:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/stick-rope-hero/"
  },
  {
    "id": "26c509ee4eb54c049c7e04c6bf123ecc",
    "slug": "screw-sort-3d:-screw-puzzle",
    "title": "Screw Sort 3D: Screw Puzzle",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/26c509ee4eb54c049c7e04c6bf123ecc-512x384.jpg",
    "description": "Ready to challenge your mind and intelligence in the Screw Sort 3D: Screw Puzzle. This casual 3D Screw Puzzle game will take you into a world of creativity and puzzle solving fun. Here you need to match the screws of the same color and move them to the correct box. You sort screws by their colors. Keep moving the model to find the corresponding color.",
    "publisher": "PuzzleGame.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-31T12:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/screw-sort-3d:-screw-puzzle/"
  },
  {
    "id": "154a56fa76ec432eaebcdc1f3a1ce8ba",
    "slug": "tung-tung-sahur-in-geometry-dash",
    "title": "Tung Tung Sahur in Geometry Dash",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/154a56fa76ec432eaebcdc1f3a1ce8ba-512x384.jpg",
    "description": "Join Tung Tung Sahur, the wooden drum-carrying dawn caller, as he bounces and flips through a neon cityscape just before sunrise! Dodge spikes, leap over traps, and time your jumps to the beat of his signature “tung-tung!” calls. In this Geometry Dash–inspired challenge, the streets are alive with glowing gates, speed pads, and tricky gravity flips. Can you drum your way to the end without missing a beat?",
    "publisher": "Breymantech",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-31T10:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "mouse only",
    "sourceUrl": "https://gamedistribution.com/games/tung-tung-sahur-in-geometry-dash/"
  },
  {
    "id": "0e5b95715bb34907ae915ad4e985cd50",
    "slug": "fusion-2048",
    "title": "Fusion 2048",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/0e5b95715bb34907ae915ad4e985cd50-512x512.jpg",
    "description": "Fusion 2048 is an addictive puzzle game where you combine matching numbered blocks to reach higher values and aim for the elusive 2048 block. Play in Classic or Shape Mode, plan your moves to avoid filling the container, and use TNT blocks to clear space. With clean visuals, smooth controls, and score tracking, it’s perfect for quick sessions or long strategic runs—easy to pick up, hard to master.",
    "publisher": "Tejas Shrimali ",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-31T08:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Desktop :\\nDrag by clicking the left mouse button , and leave the button to drop the block.\\n\\nMobile :\\nDrag with touch screen and block is dropped when the drag ends.",
    "sourceUrl": "https://gamedistribution.com/games/fusion-2048/"
  },
  {
    "id": "227430bc342d490eb159dfc7c70b5ec2",
    "slug": "balloon-pop-frenzy",
    "title": "Balloon Pop Frenzy",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/227430bc342d490eb159dfc7c70b5ec2-512x384.jpg",
    "description": "Balloon Pop Frenzy is a fun and fast-paced tap game where you pop balloons for points!\\nTap normal and gold balloons to score, but avoid the tricky skull balloons!\\nWith vibrant visuals, increasing difficulty, and simple controls, it's perfect for quick, casual play on any device.",
    "publisher": "Zoomie Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-31T07:25:14.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Click/Tap the balloons to pop them",
    "sourceUrl": "https://gamedistribution.com/games/balloon-pop-frenzy/"
  },
  {
    "id": "ff5ec26bffe14cbeacc598412cf4689c",
    "slug": "wire-connect",
    "title": "Wire Connect",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/ff5ec26bffe14cbeacc598412cf4689c-512x512.jpg",
    "description": "Captivating puzzle game where your task is to connect electrical devices to power outlets by drawing conductive paths. But be careful — electricity will flow along your lines, and if it touches water or bystanders, it will cause a short circuit!\\n\\nYour goal is to find a safe route, avoid all hazards, and complete the level successfully.\\nEach new puzzle demands focus, logic, and precision. As you progress, the challenges become more complex, with more obstacles, devices, and tricky scenarios.",
    "publisher": "GamePush",
    "languages": [
      "English",
      "French",
      "German",
      "Japanese",
      "Russian",
      "Turkish"
    ],
    "mobile": [],
    "firstActiveDate": "2025-08-31T05:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Goal: Connect all electrical devices to sockets without causing a short circuit.\\nControls: Draw lines from devices to outlets using your mouse or finger.\\nAvoid dangers: Don’t draw lines through water, people, or other hazards.\\nCheck connections: When everything is connected, activate the current — if it’s safe, you win!\\nMade a mistake? Redraw the wire and try again.",
    "sourceUrl": "https://gamedistribution.com/games/wire-connect/"
  },
  {
    "id": "92024a65afee401793188351ae69f54f",
    "slug": "moscow-metro-driver-3d",
    "title": "Moscow Metro Driver 3D",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/92024a65afee401793188351ae69f54f-1280x550.jpg",
    "description": "Drive a Moscow metro train, transport passengers, explore stations!\\nMetro lines:\\n- Kalininskaya (8) (Tretyakovskaya, Marksistskaya, Ploshchad Ilyicha, Aviamotornaya, Shosse Entuziastov, Perovo, Novogireyevo, Novokosino)\\n\\nTrains:\\n- \\",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-30T16:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Train control:\\n- Speed dial: move the controller on the left to the position \\",
    "sourceUrl": "https://gamedistribution.com/games/moscow-metro-driver-3d/"
  },
  {
    "id": "1fa401cfa7d54cd38c0727d7164730f7",
    "slug": "gun-match-screw",
    "title": "Gun Match Screw",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/1fa401cfa7d54cd38c0727d7164730f7-512x384.jpg",
    "description": "a unique level-based puzzle game that combines screw puzzles with exciting gun-themed mechanics. In this game, each level presents you with a board shaped like different guns or gun parts, and your goal is to unlock all the boards by matching colored screws, which are represented as bullets.",
    "publisher": "QiGame",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-30T13:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Use left mouse button to play the game.",
    "sourceUrl": "https://gamedistribution.com/games/gun-match-screw/"
  },
  {
    "id": "422657dda2114e0396930f72755b6092",
    "slug": "dr.-parking",
    "title": "Dr. Parking",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/422657dda2114e0396930f72755b6092-512x384.jpg",
    "description": "Ready to test your parking skills? Welcome to Dr. Parking - the super addictive car simulation game designed for all the boys who love a true driving challenge. In the game, you will drive various types of vehicles. Traverse the obstacle-laden parking lot and change corners and park your car precisely in the designated spot. And keep an eye out for keys. Each level is a test of your precision, patience, and driving instinct.",
    "publisher": "CarGames.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-30T12:50:06.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/dr.-parking/"
  },
  {
    "id": "cd175ea55efa4e83b6fd63bdbb7881a2",
    "slug": "princess-dress-up-run",
    "title": "Princess Dress Up Run",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/cd175ea55efa4e83b6fd63bdbb7881a2-512x384.jpg",
    "description": "Run, collect, and dress up like a true princess. Race around the fantasy track. Collect all kinds of gorgeous princess dresses, shoes and accessories along the way according to the goal. Create the perfect princess look. And watch out for obstacles and traps, such as suddenly broken platforms, flames, etc.",
    "publisher": "bestgames.com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-30T12:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/princess-dress-up-run/"
  },
  {
    "id": "f3bdc4a7675f4dfda0bd1474f7853dab",
    "slug": "apple-worm",
    "title": "Apple Worm",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/f3bdc4a7675f4dfda0bd1474f7853dab-512x384.jpeg",
    "description": "Apple Worm is an addictive logical puzzle game based on the Snake-like game mechanic (not the traditional snake).\\nBend your worm into impossible positions to get to the apple!",
    "publisher": "Gibton",
    "languages": [],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2022-01-21T08:07:35.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Get the apple and then escape though the black hole. Use the WASD or Arrow Keys to move. “R” to restart a level.\\n\\nAlso playable on mobile with built-in joystick.",
    "sourceUrl": "https://gamedistribution.com/games/apple-worm/"
  },
  {
    "id": "660bc84144404f83bd7155228d1dc391",
    "slug": "that's-my-seat-logic-puzzle",
    "title": "That's My Seat Logic Puzzle",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/660bc84144404f83bd7155228d1dc391-512x384.jpg",
    "description": "Who took my seat? Welcome to the brain-teasing logic puzzle game - That’s My Seat - Logic Puzzle. In this fun and casual game, your mission is to help each quirky character find their perfect seat. Some want to sit by the window, others hate noise, and some need distance from others. Your job is to match everyone’s preferences and place them just right! Each level is a unique puzzle that requires smart seating arrangements.",
    "publisher": "PuzzleGame.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-30T12:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/that's-my-seat-logic-puzzle/"
  },
  {
    "id": "57f28b0116e4414e906c17b2559774d0",
    "slug": "kick-loser",
    "title": "Kick Loser",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/57f28b0116e4414e906c17b2559774d0-512x512.jpg",
    "description": "Dive into the world of Kick Loser, a puzzle game that challenges your creativity and problem-solving skills. The objective is simple—inflict maximum damage on the stickman hero using a variety of objects. Each object has unique properties, adding a strategic element to your gameplay.\\nTake aim and deliver powerful drags to send the stickman crashing into objects. Experiment with different angles and forces to achieve the most satisfying results. ",
    "publisher": "Eyestorm Pte. LTD.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-30T06:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "- Select Objects: Choose from a variety of objects to break, bash, and drag the stickman. Each object has unique properties for maximum impact.\\n- Drag and Break: Drag the stickman into the selected objects and watch the chaos unfold. Experiment with different objects and angles to maximize the damage.",
    "sourceUrl": "https://gamedistribution.com/games/kick-loser/"
  },
  {
    "id": "80cb7c2268534913afe0cb0d703b21ef",
    "slug": "medieval-escape",
    "title": "Medieval Escape",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/80cb7c2268534913afe0cb0d703b21ef-1280x720.jpg",
    "description": "Medieval escape is a adventure escape game where you must search for useful items in the rooms to help you escape. Look carefully around the rooms, and use your logic to solve the riddles. Find your way to escape!",
    "publisher": "isotronic",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-30T06:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use the left mouse button to interact with the objects.",
    "sourceUrl": "https://gamedistribution.com/games/medieval-escape/"
  },
  {
    "id": "e4f91cbf673c4392ac833f4ce2a14c9b",
    "slug": "stickman-mega-boss:-battles!",
    "title": "Stickman Mega Boss: Battles!",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/e4f91cbf673c4392ac833f4ce2a14c9b-1280x550.jpg",
    "description": "Battle hordes of Minecraft mobs! Buy awesome swords and helmets, or unbox them from cases. Take on mega-bosses, unlock different modes, and earn leaderboard points to become the best in this game!",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-29T16:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "PC Controls:\\n[A, W, D] or [Arrow keys] — Move Stick\\n[Space] — Attack (rapid presses for combos)\\n\\nMobile Controls:\\nLeft screen half — Virtual joystick for movement\\nRight screen half — Jump/Attack buttons (tap fast for combos)",
    "sourceUrl": "https://gamedistribution.com/games/stickman-mega-boss:-battles!/"
  },
  {
    "id": "7dfb4b59d3a34dfca8fed13c6eb0f174",
    "slug": "brainrot-a-difference-challenge",
    "title": "Brainrot-A Difference Challenge",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/7dfb4b59d3a34dfca8fed13c6eb0f174-512x384.jpg",
    "description": "Put your observation skills to the test in Brainrot – A Difference Challenge, the ultimate photo puzzle game! Spot subtle differences between two eerily similar Italian \\",
    "publisher": "Lof Games",
    "languages": [
      "Arabic",
      "Bulgarian",
      "Chinese (Simplified)",
      "Czech",
      "Danish",
      "Dutch",
      "English",
      "Estonian",
      "Finnish",
      "French",
      "German",
      "Greek",
      "Hebrew",
      "Hindi",
      "Hungarian",
      "Indonesian",
      "Italian",
      "Japanese",
      "Korean",
      "Latvian",
      "Lithuanian",
      "Norwegian (Nynorsk)",
      "Polish",
      "Portuguese",
      "Romanian",
      "Russian",
      "Serbian",
      "Simple English",
      "Slovak",
      "Spanish",
      "Swahili",
      "Swedish",
      "Tagalog",
      "Thai",
      "Turkish",
      "Ukrainian",
      "Vietnamese"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-29T13:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use a mouse or touchpad to play this game.",
    "sourceUrl": "https://gamedistribution.com/games/brainrot-a-difference-challenge/"
  },
  {
    "id": "d0e9a0e909c14db78153188dc91ef365",
    "slug": "sudoku-relax",
    "title": "Sudoku Relax",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/d0e9a0e909c14db78153188dc91ef365-512x384.jpg",
    "description": "Sudoku Relax is a fresh take on the world-famous sudoku puzzle that you can enjoy anytime and anywhere. This free sudoku game keeps the classic rules but adds a clean, colorful design and smooth controls, making it ideal for both beginners and seasoned puzzle lovers. Simply fill the grid with numbers from 1 to 9 without repeating them in any row, column, or 3×3 square. Train your brain, challenge yourself, and enjoy one of the most beloved logic games in the world with Sudoku Relax!",
    "publisher": "GameBerry Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-29T11:07:09.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Tap or click on any empty cell and choose a number from 1 to 9. Your goal is to ensure that each row, column, and 3×3 block contains all digits without repetition. If you’re unsure, use notes to mark possible numbers and refine them as you go. You can easily erase mistakes and keep solving at your own pace.",
    "sourceUrl": "https://gamedistribution.com/games/sudoku-relax/"
  },
  {
    "id": "e228033eda68498693ce92c906339187",
    "slug": "kids-supermarket",
    "title": "Kids Supermarket",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/e228033eda68498693ce92c906339187-512x384.jpg",
    "description": "Welcome to Kids Supermarket, a casual supermarket simulation game for kids. Have you ever gone shopping alone? Feel confused about finding goods among a large number of products? Join Kids Supermarket to elevate your observation and categorization skills. Our diverse and clearly aligned products will make you feel like shopping in a real-life supermarket. Pick up your shopping basket and start your journey in the supermarket.",
    "publisher": "Yiv.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-29T09:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/kids-supermarket/"
  },
  {
    "id": "23e77c2dea214c0e8e6d60d59b3ddb40",
    "slug": "farm-match-seasons-2",
    "title": "Farm Match Seasons 2",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/23e77c2dea214c0e8e6d60d59b3ddb40-512x384.jpg",
    "description": "Farm Match Seasons 2 is one of the new Match 3 games from the creators of the legendary Garden Tales, Forest Match and Solitaire Farm Seasons. Your friend Poppy needs your help to look after the most beautiful farm in the village. Together you will harvest strawberries, collect flowers and protect butterflies on their farm fields. What is important that you keep the farm free from weeds! The second sequel features a BIG content update with new levels and a relaxing soundtrack to enjoy!",
    "publisher": "SOFTGAMES – Mobile Entertainment Services GmbH",
    "languages": [
      "English",
      "French",
      "German",
      "Italian",
      "Japanese",
      "Polish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-29T07:04:53.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Male",
      "Female",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "Use touch controls or the mouse to swap and match crops, fruits and flowers. Combine at least 3 items of the same kind to make them disappear. The more items of the same kind you combine, the more gifts, boosters and extras you receive! Climb your way up the farm to increasingly more challenging levels until you complete the entire game! So what are you waiting for? Play and enjoy the 2nd sequel of the most beautiful Farm Match 3 game now!",
    "sourceUrl": "https://gamedistribution.com/games/farm-match-seasons-2/"
  },
  {
    "id": "266e4f5a831543b2b630e4cc63789083",
    "slug": "digital-aqua",
    "title": "Digital Aqua",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/266e4f5a831543b2b630e4cc63789083-512x384.jpg",
    "description": "Digital Aqua is a digital aquarium designed for PC Browser.\\nExplore the vibrant world of aquariums, where colorful tropical fish and stunning underwater landscapes come to life.\\nTransform your Monitor into a serene and enchanting aquarium that fills your living room with comfort and wonder.",
    "publisher": "BUSIDOL",
    "languages": [
      "English",
      "French",
      "Korean",
      "Portuguese",
      "Spanish",
      "Vietnamese"
    ],
    "mobile": [],
    "firstActiveDate": "2025-08-28T08:54:34.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Adults",
      "Seniors",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Operable with four-directional keys and the Enter key or a mouse.",
    "sourceUrl": "https://gamedistribution.com/games/digital-aqua/"
  },
  {
    "id": "0477016c022d4f4aa5e1f3e8c94fba7b",
    "slug": "wednesday-addams-beauty-salon",
    "title": "Wednesday Addams Beauty Salon",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/0477016c022d4f4aa5e1f3e8c94fba7b-512x384.jpg",
    "description": "Get spooky and stylish in Wednesday Addams Beauty Salon, where gothic meets glam in a 3-level makeover game. Treat Wednesday to a facial, apply stunning dark-themed makeup, and finish off with iconic dress-up fashion in her unique style. From skincare to eyeliner, you control every detail of her transformation. Whether you’re a fan of the Addams aesthetic or just love alternative beauty, this salon experience offers a complete glow-up from head to toe.",
    "publisher": "Cutedressup",
    "languages": [
      "Simple English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-28T06:30:09.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "Phaser2"
    ],
    "tags": [
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Phaser2"
    ],
    "instructions": "Left Mouse Button Click",
    "sourceUrl": "https://gamedistribution.com/games/wednesday-addams-beauty-salon/"
  },
  {
    "id": "ce51ec5132e640b0bae06b129d14bef8",
    "slug": "pinball-basketball",
    "title": "Pinball Basketball",
    "category": "Sports",
    "thumbnail": "https://img.gamedistribution.com/ce51ec5132e640b0bae06b129d14bef8-200x120.jpg",
    "description": "A captivating fusion of classic arcade pinball excitement and thrilling sports gameplay. Flip your paddle skillfully to keep the ball in play, aiming for the basketball hoop while enjoying the stunning minimalist art and responsive design that make every moment electrifying and addictive.",
    "publisher": "MarketJS",
    "languages": [
      "English",
      "Simple English"
    ],
    "mobile": [
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-28T06:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Sports",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Flip your paddle to score points while avoiding losing the ball!",
    "sourceUrl": "https://gamedistribution.com/games/pinball-basketball/"
  },
  {
    "id": "985cd03bcb5d4734960863839fddbf65",
    "slug": "diy-phone-case-shop",
    "title": "DIY Phone Case Shop",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/985cd03bcb5d4734960863839fddbf65-512x384.jpg",
    "description": "Welcome to Case Craft, a fun and creative game where you'll design and decorate phone cases to impress clients! Run your own phone case shop, attract customers, and fulfill their unique requests. Customize phone cases with various designs, patterns, and themes, and decorate your shop with attractive items to draw in customers. As you meet client demands, earn rewards and upgrade your shop to become the top phone case designer!",
    "publisher": "iclickgames",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-27T06:39:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Use MOUSE to play the game.",
    "sourceUrl": "https://gamedistribution.com/games/diy-phone-case-shop/"
  },
  {
    "id": "d6ad6282493243f1a3f45df40d3fb938",
    "slug": "space-survival-rainbow-friends-monster",
    "title": "Space Survival Rainbow Friends Monster",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/d6ad6282493243f1a3f45df40d3fb938-512x384.jpg",
    "description": "Begin a fun battle like never before in Space Survival - Rainbow Friends Monster! You’re in a mysterious space station overrun by terrifying rainbow monsters. Your task is to escape and rescue your friends. Use your gun to begin the battle. Avoid enemy attacks and unleash shooting combos against waves of enemies.",
    "publisher": "YAD.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-27T06:35:05.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/space-survival-rainbow-friends-monster/"
  },
  {
    "id": "c23f50871019481f99d1ce3d56571dfd",
    "slug": "italian-brainrot-bike-rush",
    "title": "Italian Brainrot Bike Rush",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/c23f50871019481f99d1ce3d56571dfd-512x384.jpg",
    "description": "Hop on for chaotic fun in Italian Brainrot Bike Rush, a meme-filled obby bike platformer. Pick from 5 absurd meme legends and ride through floating platforms, deadly traps, and wild jumps. Play 5 levels across 3 modes—Normal, Challenge, and One Life. Collect coins, unlock checkpoints, and conquer brainrot chaos. Perfect for fans of meme-based bike racing and Italian brainrot platformers!",
    "publisher": "CursoraLabs",
    "languages": [
      "Arabic",
      "English",
      "German",
      "Russian",
      "Spanish",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-27T05:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Player 1:\\nMove: W,A,S,D or (ARROW KEYS - in 1 Player game mode)\\nRun: L-SHIFT\\nJump: SPACE\\nCamera control: MOUSE and RIGHT-CLICK\\nZoom In/Out: MOUSE SCROLL\\n\\nPlayer 2:\\nMove: ARROW KEYS\\nRun: K\\nJump: L",
    "sourceUrl": "https://gamedistribution.com/games/italian-brainrot-bike-rush/"
  },
  {
    "id": "9ab793f828274581b717f1471dbc513c",
    "slug": "soccer-arena-x",
    "title": "Soccer Arena X",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/9ab793f828274581b717f1471dbc513c-512x384.jpg",
    "description": "Soccer Arena X is an exciting football game that delivers dynamic matches, simple controls, and colorful arcade gameplay. Every match is fast, fun, and full of energy, giving you the ultimate multiplayer football experience. As you progress, you’ll collect coins and gems to unlock powerful abilities like freeze, lightning, super kick, or a giant head, adding a bright and entertaining arcade style to the gameplay. Step onto the pitch, score goals, and become a football star!\\n\\n",
    "publisher": "GameBerry Studio",
    "languages": [
      "English",
      "French",
      "German",
      "Russian",
      "Turkish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-26T14:21:25.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "In single-player mode, control your player with W, A, D or the arrow keys, and press Space to kick the ball. In 2 player mode, the left player uses W/A/S/D with F to kick, while the right player uses the arrow keys with K. On mobile, touch buttons appear on screen, making this online football game easy and fun to play anywhere.\\n\\n\\n",
    "sourceUrl": "https://gamedistribution.com/games/soccer-arena-x/"
  },
  {
    "id": "aae36cf8b16e4de79bb4958778ac2462",
    "slug": "brainrot-boing-boing-merge",
    "title": "Brainrot Boing Boing Merge",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/aae36cf8b16e4de79bb4958778ac2462-512x512.jpg",
    "description": "Welcome to Brainrot Boing Boing Merge – a charming merge puzzle game where adorable creatures meet polished gameplay and juicy physics!\\n\\nMerge. Match. Maximize\\nSatisfying Effects \\u0026 Lively Details\\nUnlockable Skins System\\nRelaxing Yet Strategic\\n\\nIf you love satisfying merges, juicy feedback, and charming characters, this game is for you. Play now and see what creature you’ll create next!",
    "publisher": "Iamgronig",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-26T05:54:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "YoungAdults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Click or Tap to merge!",
    "sourceUrl": "https://gamedistribution.com/games/brainrot-boing-boing-merge/"
  },
  {
    "id": "a5fbcbbb494644da9a43f56b4384b2f0",
    "slug": "neon-blast",
    "title": "Neon Blast",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/a5fbcbbb494644da9a43f56b4384b2f0-512x384.jpg",
    "description": "Upgrade your defense cannons by merging them!Watch as your cannons level up and become powerful defenders, and get exciting new powers to crush bosses and attackers!\\n",
    "publisher": "Yizhiyuan Network Technology Co., Ltd.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-26T05:24:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Space shooter with finger drag. Merging and Tower Defense",
    "sourceUrl": "https://gamedistribution.com/games/neon-blast/"
  },
  {
    "id": "c75029d181cb49eaa606d0d72d5fc4a5",
    "slug": "scary-teacher-3d-returns",
    "title": "Scary Teacher 3D Returns",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/c75029d181cb49eaa606d0d72d5fc4a5-512x512.jpg",
    "description": "Start with the size of a board. A faint sound echoes through the hallway. You freeze, the heart is beating, and the house seems to breathe with you. You are inside the mansion of the old teacher once again.\\n\\nIn the 3D fear teacher, every shadow, every echo matters. Your goal is not to escape; it is mischief. But make an error, and you will become its next goal.",
    "publisher": "kiz10.com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-25T12:15:50.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Scary Teacher 3D Returns brings suspense, mischief, and careful strategy together in one immersive package. You’re not just playing—you’re performing. Every element, including timing, tension, and creativity, matters. Set your trap, hold your breath, wait for the scream… and then disappear into the darkness.\\n\\nPC CONTROLS\\nWASD – Move\\nMouse—Look/Interact\\nE – Use gadget or trap\\nShift—Sneak quietly\\n\\nMOBILE CONTROLS\\nVirtual joystick—move\\nTap \\u0026 drag—look/pick up items\\nTap—place or use gadget",
    "sourceUrl": "https://gamedistribution.com/games/scary-teacher-3d-returns/"
  },
  {
    "id": "c88e601ee6fa41d6945331cbd397b047",
    "slug": "diamond-solitaire-mahjong",
    "title": "Diamond Solitaire Mahjong",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/c88e601ee6fa41d6945331cbd397b047-512x384.jpg",
    "description": "Step into the radiant world of Diamond Solitaire Mahjong! Enjoy a beautifully crafted single puzzle with shimmering tiles adorned with diamonds, gems, and sparkling jewels. Zoom in and out for the perfect view as you match tiles in a relaxing setting. Earn points for quick matches and climb the leaderboard. Perfect for casual players and Mahjong fans seeking a peaceful yet rewarding experience.",
    "publisher": "SOFTGAMES – Mobile Entertainment Services GmbH",
    "languages": [
      "Dutch",
      "English",
      "French",
      "German",
      "Italian",
      "Polish"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-25T08:58:19.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Find and match identical tiles to remove them from the board. Ensure tiles are free on at least one side before matching. Clear all tiles to complete the layout and test your skills! Use the Hint feature to guide you through tricky situations. Enjoy a relaxing Mahjong experience with timeless gameplay, beautiful tile designs, and a competitive leaderboard!",
    "sourceUrl": "https://gamedistribution.com/games/diamond-solitaire-mahjong/"
  },
  {
    "id": "8057433344b241b2b5084c8d38cec547",
    "slug": "draw-bridge:-brain-game",
    "title": "Draw Bridge: Brain Game",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/8057433344b241b2b5084c8d38cec547-512x512.jpg",
    "description": "Draw Bridge Puzzle - Draw Game is an exciting and challenging brain game that will put your problem-solving skills to the test. In this bridge-building adventure, your task is to draw paths for the car to safely navigate through obstacles and reach its destination. Get ready to embark on a thrilling journey of bridge construction and puzzle-solving as you draw roads to rescue the stranded car!",
    "publisher": "Bravestars Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-25T07:21:19.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "- Touch the screen to start drawing.\\n- Hold and drag across to make the shapes you want.\\n- Once you finish, release your finger and the car will run.",
    "sourceUrl": "https://gamedistribution.com/games/draw-bridge:-brain-game/"
  },
  {
    "id": "0c621dfab60143809e321fa448476f04",
    "slug": "obby-escape:-prison-rat-dance",
    "title": "Obby Escape: Prison Rat Dance",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/0c621dfab60143809e321fa448476f04-512x512.jpg",
    "description": "Obby Escape: Prison Rat Dance is an exhilarating adventure game that merges the thrill of intricate prison escape challenges with the dynamic agility required in parkour. Assume the role of a resourceful rat striving to escape the strict surveillance of a heavily fortified prison. Find your way through elaborate mazes and overcome diverse, challenging obstacles as you plot your daring prison escape.",
    "publisher": "Bravestars Games",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-25T06:53:44.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Can you navigate the complex pathways, evade the guards, and secure your freedom? Join the action in Obby Escape: Prison Rat Dance and master the art of the prison break!",
    "sourceUrl": "https://gamedistribution.com/games/obby-escape:-prison-rat-dance/"
  },
  {
    "id": "6fcaa70b796547a698ddd10808527345",
    "slug": "paper-doll-diary:-dress-up-diy",
    "title": "Paper Doll Diary: Dress Up DIY",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/6fcaa70b796547a698ddd10808527345-512x512.jpg",
    "description": "? Welcome to Paper Doll Diary: Doll DressUp, where the timeless charm of DIY paper dolls meets the exhilarating world of fashion dress up! Step into a realm of creativity and style where you become the master stylist of your enchanting paper doll dress up. With an expansive wardrobe featuring over 1000 fashion items, including the latest in trendy attire, distinctive accessories, diverse hairstyles, and soothing ASMR makeup touches, your creative potential is limitless.",
    "publisher": "Bravestars Games",
    "languages": [
      "English",
      "Russian",
      "Spanish",
      "Vietnamese"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-25T06:44:46.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "? Unleash your inner fashionista and transform your paper doll into a beacon of style. Whether you're assembling chic outfits or selecting the perfect accessories, each decision propels your paper doll into the spotlight, making her a true fashion icon. Your styling choices not only reflect your unique taste but also guide your doll's journey through thrilling adventures and challenges.",
    "sourceUrl": "https://gamedistribution.com/games/paper-doll-diary:-dress-up-diy/"
  },
  {
    "id": "93b87a4392224301be1d6c7876d8e361",
    "slug": "food-sort-3d",
    "title": "Food Sort 3D",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/93b87a4392224301be1d6c7876d8e361-512x384.jpg",
    "description": "In this game, you manage your own food court, sorting various food items into their respective categories. You'll encounter different eateries, from fast-food joints to upscale restaurants, each requiring you to sort items like burgers,\\nsushi, hotdog, fries, pizza and desserts. The game features colorful graphics and quick, satisfying levels that keep you engaged as you expand your food",
    "publisher": "Ultra Games Entertainment Private limited",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-25T05:29:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Mouse Click",
    "sourceUrl": "https://gamedistribution.com/games/food-sort-3d/"
  },
  {
    "id": "ed5ed952531b4e2a9191f8720f22c22e",
    "slug": "logic-slide",
    "title": "LOGic Slide",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/ed5ed952531b4e2a9191f8720f22c22e-512x384.jpg",
    "description": "Get ready for some beaver fun in LOGic Slide – the cutest puzzle in the forest!\\nMeet two friendly beavers who love playing with wood. They need your help to slide the logs and make one big river-wide log . \\nIt might look easy, but you’ll need to think and figure out where each log should go!\\n\\nLet’s slide some logs together with the beavers – start playing right away! ?✨",
    "publisher": "BlackMoon Design",
    "languages": [
      "No Text"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-24T17:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Construct 3"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Construct 3"
    ],
    "instructions": "Hold/Click and drag the logs right and left (the logs always go as far left/right as possible).\\nThe wood is full of resin, so it'll stick together as soon as two logs are next to each other. ",
    "sourceUrl": "https://gamedistribution.com/games/logic-slide/"
  },
  {
    "id": "85406c54ad214d95bdd1e2d413c7c43d",
    "slug": "color-dash",
    "title": "Color Dash",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/85406c54ad214d95bdd1e2d413c7c43d-512x384.jpg",
    "description": "Color Dash is a fast-paced endless runner that tests your reflexes and color matching skill! Pilot a speeding rocket and match its color to smash through colored gates. Dodge the wrong colors and react to frantic color changes to keep your run alive. Grab powerful shield and nitro power-ups to blast further and beat your personal best score in this addictive arcade adventure. How high can you score?",
    "publisher": "TapZap Studio",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-24T16:34:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "⭐ YOUR GOAL: Fly through the gates that match your rocket's color to score points.\\n⬅️ CONTROLS ➡️: Use the Arrow Keys or A/D to switch lanes. On mobile, just swipe left or right.\\n⚠️ WATCH OUT: Avoid gates that are a different color! Hitting them will cost you a life.\\n✨ POWER-UPS: Grab the Shield to protect you from a crash and the Nitro Bolt for a super-speed boost",
    "sourceUrl": "https://gamedistribution.com/games/color-dash/"
  },
  {
    "id": "e1df511140b54d12bb3e6eb04212bdaf",
    "slug": "mahjong-stack",
    "title": "Mahjong Stack",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/e1df511140b54d12bb3e6eb04212bdaf-512x384.jpg",
    "description": "Mahjong Stack is a unique tile-matching game featuring realistic 3D mahjong tiles. Unlike classic match-3, blocks appear in stacked piles. Match identical tiles and drag groups of three to the tray to clear. Use boosters to speed up progress. Dive in and enjoy!",
    "publisher": "Guangzhou Yomitoo Network Technology Co., Ltd.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-24T16:09:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "Cocos"
    ],
    "instructions": "1. After blocks finish tumbling, tap three identical ones into the bottom slot to clear.\\n2. Strategically manage blocks in limited slots.\\n3. Stuck? Use tools to smash through obstacles!",
    "sourceUrl": "https://gamedistribution.com/games/mahjong-stack/"
  },
  {
    "id": "7003abf25cb3479eb3a8e0b5a02a3db6",
    "slug": "squad-assembler",
    "title": "Squad Assembler",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/7003abf25cb3479eb3a8e0b5a02a3db6-512x512.jpg",
    "description": "Assemble a cool squad and see who wins!\\nCombine items to improve the fighters' equipment! Combine weapons and armor, buy loot boxes with new weapons!\\nYou can create cool, unique characters, each of which will have certain skills! Buy parts for your fighters, change their arms, torso, head! Create real cyborgs to defeat the enemy! Merge armor and weapons, increase the levels and characteristics of items. Hire cool heroes who will help you in tough battles.",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-24T15:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "To win the level, you need to defeat the enemy squad.\\nTo increase the level of items - combine 2 identical items.\\nControls:\\nTo buy a loot box - click the button with the image of the loot box and the price tag.\\nTo open the loot box - click on the loot box in the inventory.\\nTo create a fighter, drag the item to the equipment cell and click the \\",
    "sourceUrl": "https://gamedistribution.com/games/squad-assembler/"
  },
  {
    "id": "0eed16d8a087496fb95237dc3e2ebc38",
    "slug": "foam-and-find",
    "title": "Foam and Find",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/0eed16d8a087496fb95237dc3e2ebc38-512x512.jpg",
    "description": "Foam and Find is a relaxing hidden object game with a playful bubble twist. Explore cozy houses, each filled with charming rooms and easy-to-spot hidden items. Your tasks appear inside floating bubbles — and when you find an item, it flies into its bubble and pops with a satisfying animation. No timers, no stress — just a calm, casual experience at your own pace.",
    "publisher": "GameDev.Land",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-24T14:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "PixiJS"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "PixiJS"
    ],
    "instructions": "How to Play\\n\\n1. Choose a house to explore.\\n2. Enter a room and check the bubbles to see your tasks.\\n3. Find each hidden object in the scene.\\n4. Tap or click an object — it will float into its bubble and pop!\\n5. Complete all tasks to move to the next room.\\n6. Unlock new houses and keep exploring.\\n\\nTip: Relax and enjoy the bubble-popping fun — there’s no time limit!",
    "sourceUrl": "https://gamedistribution.com/games/foam-and-find/"
  },
  {
    "id": "1f4b8984608644199ca748d3f1bc774b",
    "slug": "number-master-run-and-merge",
    "title": "Number Master Run And Merge",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/1f4b8984608644199ca748d3f1bc774b-512x384.jpg",
    "description": "Number Master: Run And Merge is an awesome number racing game that lets you run, merge, and upgrade on a parkour platform to become a true number master! Control your number character as you run through dynamic tracks. Keep collecting more numbers and expanding. Merge with matching numbers to grow stronger. The bigger your number, the more unstoppable you become! Pick the smartest paths, hit speed zones, and keep your speed maxed out!",
    "publisher": "bestgames.com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-24T12:49:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/number-master-run-and-merge/"
  },
  {
    "id": "6b3a186391ca4daaa2020be41c05be8d",
    "slug": "paint-tiles-puzzle",
    "title": "Paint Tiles Puzzle",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/6b3a186391ca4daaa2020be41c05be8d-512x384.jpg",
    "description": "Welcome to Paint Tiles Puzzle, where creativity meets logic in a colorful puzzle adventure! This is a relaxing puzzle game that combines drawing and puzzle-solving elements. Each level presents a tile grid and your task is to fill the empty spaces with the right colors.",
    "publisher": "PuzzleGame.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-24T12:05:00.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/paint-tiles-puzzle/"
  },
  {
    "id": "7a0006022c6744788c0134eea8ee4018",
    "slug": "mr-reckless:-car-chase-simulator",
    "title": "Mr Reckless: Car Chase Simulator",
    "category": "Arcade",
    "thumbnail": "https://img.gamedistribution.com/7a0006022c6744788c0134eea8ee4018-512x384.jpg",
    "description": "Run fast, crash hard, and cheat death — in style.\\n\\nRace through a chaotic low-poly city as you dodge police, traffic, and total destruction. Use game-changing power-ups like Slow-Mo, Freeze, Nitro to escape the impossible.\\n\\nOne rule: don’t stop. How long can you stay free?",
    "publisher": "BeruGames",
    "languages": [
      "English",
      "French",
      "German",
      "Portuguese",
      "Spanish"
    ],
    "mobile": [],
    "firstActiveDate": "2025-08-24T11:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Arcade",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Desktop:\\nMove with WASD or Arrow Keys\\nCollect power-ups and dodge obstacles to stay alive",
    "sourceUrl": "https://gamedistribution.com/games/mr-reckless:-car-chase-simulator/"
  },
  {
    "id": "f32afe28e9a14ccbb3d8d7c99842b517",
    "slug": "puzzle-games:-outing-day",
    "title": "Puzzle Games: Outing Day",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/f32afe28e9a14ccbb3d8d7c99842b517-512x384.jpg",
    "description": "Welcome to Puzzle Game: Outing Day, a casual puzzle game online. Today is the day for an outing. What will happen with all the little animals? What activities will they have on their trip to the field? Come and explore the interesting things on the camp and solve puzzles with your animal partners. See if you are the cleverest child in the crowd!",
    "publisher": "Yiv.Com",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-24T11:19:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Cocos"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Landscape",
      "HTML5",
      "Cocos"
    ],
    "instructions": "Mouse click or tap to play\\n",
    "sourceUrl": "https://gamedistribution.com/games/puzzle-games:-outing-day/"
  },
  {
    "id": "609f9acfd0da4ae09e6ec61cc7a6f4f0",
    "slug": "sprunki-quiz",
    "title": "Sprunki Quiz",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/609f9acfd0da4ae09e6ec61cc7a6f4f0-512x384.jpg",
    "description": "Sprunki Quiz is a wild and wacky guessing game where you match weird names to even weirder Sprunki characters!\\nCan you tell who’s who between Simon, Oren, Pinky, Raddy, and the rest of the crew?\\nPlay in two chaotic modes:\\nGuess the Name – See the name, pick the right picture!\\nGuess the Image – Look at the picture, choose the right name!\\nIt’s fast, funny, and full of Sprunki madness.\\nWarning: extreme brainrot vibes ahead. Ready to Sprunk?",
    "publisher": "AF",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-24T06:04:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Use mouse and play",
    "sourceUrl": "https://gamedistribution.com/games/sprunki-quiz/"
  },
  {
    "id": "098ccbbe6c7f4d28868b6066b000477a",
    "slug": "alchemy-puzzle",
    "title": "Alchemy Puzzle",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/098ccbbe6c7f4d28868b6066b000477a-512x384.jpg",
    "description": "We create challenges with fun puzzles, challenge your brain and make you always smile on your lips.\\nAlchemy Puzzle will help you have moments of light entertainment, combined with puzzle play and fun real life characters.\\nIf you've ever played games: puzzlers, word games, trivia games, quiz games, brain teasers, or just want to spend time have time to relax, let try Alchemy Puzzle, It's for you.",
    "publisher": "Eyestorm Pte. LTD.",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-24T05:59:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Portrait",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Starting from simple items, create objects to pass each level and experience the fun of Alchemy Puzzle.",
    "sourceUrl": "https://gamedistribution.com/games/alchemy-puzzle/"
  },
  {
    "id": "ad3d80f7955f46c5afd41f1bfac3858c",
    "slug": "puzzlejam",
    "title": "PuzzleJam",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/ad3d80f7955f46c5afd41f1bfac3858c-1280x720.jpg",
    "description": "Puzzle Jam is a bright and fun puzzle game where you merge jellies of the same color to clear the board and complete each level!\\nEasy controls and smooth gameplay make it accessible for players of all ages . Each level brings a new challenge – find the smartest moves, use boosters, and unlock powerful combos!",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-24T05:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "Javascript"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "Javascript"
    ],
    "instructions": "Playing is simple and fun!\\n\\nOn mobile devices: tap and drag jellies with your finger to merge blocks of the same color.\\n\\nOn a computer: use the left mouse button to select and move blocks.\\n\\nYour goal is to merge matching jellies, clear the board, and complete level tasks. Fewer moves = better results!\\n\\nTake your time – there are no time limits. Think ahead, make smart combos, and use boosters to overcome tricky puzzles!",
    "sourceUrl": "https://gamedistribution.com/games/puzzlejam/"
  },
  {
    "id": "74e6969ad0f647c9872a30153f47b8fe",
    "slug": "grandma's-last-stand",
    "title": "Grandma's Last Stand",
    "category": "Racing",
    "thumbnail": "https://img.gamedistribution.com/74e6969ad0f647c9872a30153f47b8fe-512x384.jpg",
    "description": "Granny is in a hurry to get home and bake some pies. But there's one problem - first she needs to bake a few hundred zombies! They'll be chasing you in cars and motorcycles, they'll have machine guns, rocket launchers, and support drones. But you've got a pretty good arsenal too - from a revolver and machine guns to a minigun and a bazooka. Help Granny get home, roast them all!\\n\\nINSTRUCTIONS",
    "publisher": "DAВ3Games",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-23T15:44:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Racing",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Before rushing into battle, stock up on weapons. Go to the \\",
    "sourceUrl": "https://gamedistribution.com/games/grandma's-last-stand/"
  },
  {
    "id": "e57c1c2b89e348ed8bb79ca94abd7957",
    "slug": "move-the-rubber-bands:-logic-puzzle",
    "title": "Move the rubber bands: Logic puzzle",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/e57c1c2b89e348ed8bb79ca94abd7957-1280x550.jpg",
    "description": "In this game you need to put the rubber bands in their places.\\nAt the start of the level, rubber bands are scattered across the field. Your task is to move the cutters along the pins and place the cutters on the platforms of the corresponding color.\\nYour task is to solve logic puzzles. It won't always be easy to come up with a solution. Sometimes you will need to strain your logic and ability to navigate in space.",
    "publisher": "GamePush",
    "languages": [
      "English",
      "Russian"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-23T15:45:06.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Purpose of the game:\\nArrange the elastic bands on platforms of the corresponding color.\\n\\nControl:\\nPress the elastic fastener and move it to the pin you need.\\nDifferent studs have different properties. Explore them =)\\nThere are also additional mechanics that will help you, or, on the contrary, complicate the task",
    "sourceUrl": "https://gamedistribution.com/games/move-the-rubber-bands:-logic-puzzle/"
  },
  {
    "id": "bc99677144134e99bfc767ea4b03ec96",
    "slug": "sprunki-link",
    "title": "Sprunki Link",
    "category": "Puzzle",
    "thumbnail": "https://img.gamedistribution.com/bc99677144134e99bfc767ea4b03ec96-512x384.jpg",
    "description": "Sprunki Link – the wildest Sprunki-fueled tile puzzle!\\nFind and connect matching tiles featuring your favorite chaotic Sprunki characters.\\nTest your focus and logic across 15 levels of pure unhinged madness.\\nCan you collect all 45 stars, or will the Sprunki win?\\nIt’s fast, it’s silly, it’s dangerously addictive – Sprunki-style!",
    "publisher": "AF",
    "languages": [
      "English"
    ],
    "mobile": [
      "ForIOS",
      "ForAndroid"
    ],
    "firstActiveDate": "2025-08-23T14:14:59.030Z",
    "lastUpdated": "",
    "genres": [
      "Puzzle",
      "HTML5",
      "WebGL"
    ],
    "tags": [
      "Male",
      "Female",
      "Kids",
      "Teens",
      "YoungAdults",
      "Adults",
      "Seniors",
      "Landscape",
      "HTML5",
      "WebGL"
    ],
    "instructions": "Use mouse and play",
    "sourceUrl": "https://gamedistribution.com/games/sprunki-link/"
  }
];

export default games;
